/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** AWSFile Type */
  AWSFile: { input: any; output: any; }
  /** AchSourceDetail Type */
  AchSourceDetail: { input: any; output: any; }
  /** AgencyQualificationAttributeValue Type */
  AgencyQualificationAttributeValue: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date and time, represented as an ISO-8601 string */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** ProfessionalQualificationAttributeValue Type */
  ProfessionalQualificationAttributeValue: { input: any; output: any; }
  /** The tz field in PG/JS Format */
  TZ: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  account_billing_groups?: Maybe<Array<AccountBillingGroup>>;
  account_locations?: Maybe<Array<AccountLocation>>;
  account_push_registration_tokens?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  account_type: Scalars['String']['output'];
  address_city?: Maybe<Scalars['String']['output']>;
  address_first?: Maybe<Scalars['String']['output']>;
  address_second?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  administrator?: Maybe<Administrator>;
  agency?: Maybe<Agency>;
  agency_id?: Maybe<Scalars['Int']['output']>;
  announcements_already_seen: Array<Scalars['String']['output']>;
  billing_groups?: Maybe<Array<BillingGroup>>;
  calculated_group_node_ids: Array<Scalars['Int']['output']>;
  calculated_permissions: Scalars['JSON']['output'];
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['Int']['output']>;
  coordinates?: Maybe<Coordinates>;
  created_at: Scalars['DateTime']['output'];
  current_sign_in_at?: Maybe<Scalars['DateTime']['output']>;
  custom_permissions: Scalars['JSON']['output'];
  direct_locations: Array<Location>;
  email: Scalars['String']['output'];
  email_notification?: Maybe<Scalars['Boolean']['output']>;
  encrypted_password?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer in use. Use account_push_registration_tokens instead. */
  firebase_notification_key: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  group_node_ids: Array<Scalars['Int']['output']>;
  has_signed_latest_terms: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invite_last_sent_at?: Maybe<Scalars['DateTime']['output']>;
  is_saas_professional?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_sign_in_at?: Maybe<Scalars['DateTime']['output']>;
  locations?: Maybe<Array<Location>>;
  middle_name?: Maybe<Scalars['String']['output']>;
  migrated_person_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notification_settings: Scalars['JSON']['output'];
  permission_groups?: Maybe<Array<PermissionGroup>>;
  phone_number?: Maybe<Scalars['String']['output']>;
  phone_number_sms_enabled?: Maybe<Scalars['Boolean']['output']>;
  primary_locations?: Maybe<Array<Location>>;
  professional?: Maybe<Professional>;
  professional_screenings?: Maybe<Array<ProfessionalScreening>>;
  remember_created_at?: Maybe<Scalars['DateTime']['output']>;
  reset_password_sent_at?: Maybe<Scalars['DateTime']['output']>;
  reset_password_token?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported. Provided by data warehouse. */
  sign_in_count: Scalars['Int']['output'];
  sign_up_completed_at?: Maybe<Scalars['DateTime']['output']>;
  sms_notification: Scalars['Boolean']['output'];
  sms_notification_bulk: Scalars['Boolean']['output'];
  ssn_last_4?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  unsubscribe: Scalars['Boolean']['output'];
  unsubscribe_token?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user_hash?: Maybe<Scalars['String']['output']>;
};


export type AccountAccount_Push_Registration_TokensArgs = {
  account_id?: Scalars['Int']['input'];
};


export type AccountHas_Signed_Latest_TermsArgs = {
  account_id?: Scalars['Int']['input'];
  group_key: Scalars['String']['input'];
};

export type AccountBillingGroup = {
  __typename?: 'AccountBillingGroup';
  account: Account;
  account_id: Scalars['Int']['output'];
  billing_group: BillingGroup;
  billing_group_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AccountBillingGroupOrderInput = {
  account_id?: InputMaybe<Scalars['Boolean']['input']>;
  billing_group_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountBillingGroupQueryInput = {
  filter?: InputMaybe<AccountBillingGroupWhereInput>;
  orderBy?: InputMaybe<AccountBillingGroupOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AccountBillingGroupSearchInput>;
};

export type AccountBillingGroupSearchInput = {
  billing_group_ids?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AccountBillingGroupWhereInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  account_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountLocation = {
  __typename?: 'AccountLocation';
  account: Account;
  account_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  location_id: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AccountLocationOrderInput = {
  account_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountLocationQueryInput = {
  filter?: InputMaybe<AccountLocationWhereInput>;
  orderBy?: InputMaybe<AccountLocationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AccountLocationSearchInput>;
};

export type AccountLocationSearchInput = {
  has_irm_professionals?: InputMaybe<Scalars['Boolean']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AccountLocationWhereInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountOrderInput = {
  account_type?: InputMaybe<Scalars['Boolean']['input']>;
  address_city?: InputMaybe<Scalars['Boolean']['input']>;
  address_first?: InputMaybe<Scalars['Boolean']['input']>;
  address_second?: InputMaybe<Scalars['Boolean']['input']>;
  address_zip?: InputMaybe<Scalars['Boolean']['input']>;
  calculated_permissions?: InputMaybe<Scalars['Boolean']['input']>;
  company_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  current_sign_in_at?: InputMaybe<Scalars['Boolean']['input']>;
  current_sign_in_ip?: InputMaybe<Scalars['Boolean']['input']>;
  custom_permissions?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  email_notification?: InputMaybe<Scalars['Boolean']['input']>;
  encrypted_password?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invite_last_sent_at?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['Boolean']['input']>;
  last_sign_in_at?: InputMaybe<Scalars['Boolean']['input']>;
  last_sign_in_ip?: InputMaybe<Scalars['Boolean']['input']>;
  middle_name?: InputMaybe<Scalars['Boolean']['input']>;
  migrated_person_id?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  remember_created_at?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password_sent_at?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password_token?: InputMaybe<Scalars['Boolean']['input']>;
  sign_in_count?: InputMaybe<Scalars['Boolean']['input']>;
  sms_notification?: InputMaybe<Scalars['Boolean']['input']>;
  sms_notification_bulk?: InputMaybe<Scalars['Boolean']['input']>;
  ssn_last_4?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  tsv?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountQueryInput = {
  filter?: InputMaybe<AccountWhereInput>;
  orderBy?: InputMaybe<AccountOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AccountSearchInput>;
};

export type AccountSearchInput = {
  account_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_clinical_contact_for_location_id?: InputMaybe<Scalars['Int']['input']>;
  is_clinical_contact_for_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  permission_group_id?: InputMaybe<Scalars['Int']['input']>;
  permission_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  related_to_facility_account?: InputMaybe<RelatedToFacilityAccountInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AccountWhereInput = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  address_city?: InputMaybe<Scalars['String']['input']>;
  address_first?: InputMaybe<Scalars['String']['input']>;
  address_second?: InputMaybe<Scalars['String']['input']>;
  address_zip?: InputMaybe<Scalars['String']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  calculated_permissions?: InputMaybe<Scalars['JSON']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  current_sign_in_at?: InputMaybe<Scalars['DateTime']['input']>;
  custom_permissions?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_notification?: InputMaybe<Scalars['Boolean']['input']>;
  encrypted_password?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invite_last_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_sign_in_at?: InputMaybe<Scalars['DateTime']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  migrated_person_id?: InputMaybe<Scalars['Int']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  remember_created_at?: InputMaybe<Scalars['DateTime']['input']>;
  reset_password_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  reset_password_token?: InputMaybe<Scalars['String']['input']>;
  sign_in_count?: InputMaybe<Scalars['Int']['input']>;
  sms_notification?: InputMaybe<Scalars['Boolean']['input']>;
  sms_notification_bulk?: InputMaybe<Scalars['Boolean']['input']>;
  ssn_last_4?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  unsubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Administrator = {
  __typename?: 'Administrator';
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  paused?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AdministratorOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['Boolean']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  person_id?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdministratorQueryInput = {
  filter?: InputMaybe<AdministratorWhereInput>;
  orderBy?: InputMaybe<AdministratorOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AdministratorSearchInput>;
};

export type AdministratorSearchInput = {
  account_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  permission_group_id?: InputMaybe<Scalars['Int']['input']>;
  permission_group_roles?: InputMaybe<Array<Role>>;
  person_id?: InputMaybe<Scalars['Int']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdministratorWhereInput = {
  account_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  permission_group_id?: InputMaybe<Scalars['Int']['input']>;
  permission_group_roles?: InputMaybe<Array<Role>>;
  person_id?: InputMaybe<Scalars['Int']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Agency = {
  __typename?: 'Agency';
  address_city?: Maybe<Scalars['String']['output']>;
  address_first?: Maybe<Scalars['String']['output']>;
  address_second?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  agency_locations?: Maybe<Array<AgencyLocation>>;
  agency_qualifications: Array<AgencyQualification>;
  available_markets: Array<Market>;
  created_at: Scalars['DateTime']['output'];
  facility_locations_managed_count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  job_types: Array<Scalars['String']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Location>>;
  name?: Maybe<Scalars['String']['output']>;
  owned_locations: Array<Location>;
  phone_number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


export type AgencyOwned_LocationsArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AgencyChargeOverrides = {
  __typename?: 'AgencyChargeOverrides';
  agency_charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['JSON']['output']>;
  position?: Maybe<Scalars['JSON']['output']>;
  position_id?: Maybe<Scalars['Int']['output']>;
  specialty?: Maybe<Scalars['JSON']['output']>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
};

export type AgencyChargeOverridesQueryInput = {
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AgencyChargeOverridesSearchInput>;
};

export type AgencyChargeOverridesSearchInput = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AgencyLocation = {
  __typename?: 'AgencyLocation';
  agency?: Maybe<Agency>;
  agency_id?: Maybe<Scalars['Int']['output']>;
  agency_tier?: Maybe<Scalars['Int']['output']>;
  auto_publish_assignments_to_professionals?: Maybe<Scalars['Boolean']['output']>;
  auto_publish_per_diem_to_professionals?: Maybe<Scalars['Boolean']['output']>;
  bill_rate_percent?: Maybe<Scalars['Float']['output']>;
  facility_managed_agency: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  vms_fee?: Maybe<Scalars['Float']['output']>;
};

export type AgencyLocationOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_name?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyLocationPositionRateSetting = {
  __typename?: 'AgencyLocationPositionRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  agency?: Maybe<Agency>;
  agency_charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  agency_id?: Maybe<Scalars['Int']['output']>;
  agency_location_position_rate_setting?: Maybe<AgencyPositionSettings>;
  agency_location_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  agency_location_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  audits?: Maybe<Array<Audit>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  location_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  location_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  market_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  market_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<AgencyPositionSettings>;
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AgencyLocationPositionRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  agency_id?: InputMaybe<Scalars['Boolean']['input']>;
  blended_rate_markup?: InputMaybe<Scalars['Boolean']['input']>;
  charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<PositionOrderInput>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyLocationPositionRateSettingQueryInput = {
  filter?: InputMaybe<AgencyLocationPositionRateSettingWhereInput>;
  orderBy?: InputMaybe<AgencyLocationPositionRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AgencyLocationPositionRateSettingSearchInput>;
};

export type AgencyLocationPositionRateSettingSearchInput = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  has_agency_rates?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AgencyLocationPositionRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgencyLocationQueryInput = {
  filter?: InputMaybe<AgencyLocationWhereInput>;
  orderBy?: InputMaybe<AgencyLocationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AgencyLocationSearchInput>;
};

export type AgencyLocationRateSetting = {
  __typename?: 'AgencyLocationRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  agency?: Maybe<Agency>;
  agency_id?: Maybe<Scalars['Int']['output']>;
  agency_location_rate_setting?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  enable_differential_recommendations?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AgencyLocationRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  agency_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyLocationRateSettingQueryInput = {
  filter?: InputMaybe<AgencyLocationRateSettingWhereInput>;
  orderBy?: InputMaybe<AgencyLocationRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AgencyLocationRateSettingSearchInput>;
};

export type AgencyLocationRateSettingSearchInput = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AgencyLocationRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AgencyLocationSearchInput = {
  location_statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AgencyLocationWhereInput = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgencyOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyPositionSettings = {
  __typename?: 'AgencyPositionSettings';
  agency_charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  agency_release_lead_time_hours?: Maybe<Scalars['Int']['output']>;
  blended_rate_cents?: Maybe<Scalars['Int']['output']>;
  can_post_assignment?: Maybe<Scalars['Boolean']['output']>;
  can_post_job?: Maybe<Scalars['Boolean']['output']>;
  charge_on_call_hourly_rate_cents?: Maybe<Scalars['Float']['output']>;
  charge_on_call_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  charge_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  fee_percent?: Maybe<Scalars['String']['output']>;
  on_call_fee_percent?: Maybe<Scalars['String']['output']>;
  payout_on_call_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  payout_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  ten99?: Maybe<Ten99Settings>;
  w2?: Maybe<W2Settings>;
  w2_fee_percent?: Maybe<Scalars['String']['output']>;
};

export type AgencyQualification = {
  __typename?: 'AgencyQualification';
  admin_agency_qualification_attributes: Array<AgencyQualificationAttribute>;
  agency?: Maybe<Agency>;
  agency_id?: Maybe<Scalars['Int']['output']>;
  agency_qualification_attributes: Array<AgencyQualificationAttribute>;
  created_at: Scalars['DateTime']['output'];
  credential_rejected_reason?: Maybe<CredentialRejectedReason>;
  credential_rejected_reason_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  last_updated_by_admin?: Maybe<Account>;
  last_updated_by_admin_id?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  qualification?: Maybe<Qualification>;
  qualification_id?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AgencyQualificationAttribute = {
  __typename?: 'AgencyQualificationAttribute';
  agency_qualification?: Maybe<AgencyQualification>;
  agency_qualification_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  qualification_attribute?: Maybe<QualificationAttribute>;
  qualification_attribute_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  value: Scalars['AgencyQualificationAttributeValue']['output'];
};

export type AgencyQualificationAttributeOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyQualificationAttributeQueryInput = {
  filter?: InputMaybe<AgencyQualificationAttributeWhereInput>;
  orderBy?: InputMaybe<AgencyQualificationAttributeOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AgencyQualificationAttributeSearchInput>;
};

export type AgencyQualificationAttributeSearchInput = {
  qa_active?: InputMaybe<Scalars['Boolean']['input']>;
  qa_input_sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AgencyQualificationAttributeWhereInput = {
  agency_qualification_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  qualification_attribute_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AgencyQualificationOrderInput = {
  agency_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  credential_rejected_reason_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_updated_by_admin_id?: InputMaybe<Scalars['Boolean']['input']>;
  license_id?: InputMaybe<Scalars['Boolean']['input']>;
  license_status?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyQualificationQueryInput = {
  filter?: InputMaybe<AgencyQualificationWhereInput>;
  orderBy?: InputMaybe<AgencyQualificationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AgencyQualificationSearchInput>;
};

export type AgencyQualificationSearchInput = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['Int']['input']>;
  not_archived?: InputMaybe<Scalars['Boolean']['input']>;
  qualification_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  qualification_type?: InputMaybe<Scalars['String']['input']>;
  qualification_types?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AgencyQualificationWhereInput = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  credential_rejected_reason_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  kind?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by_admin_id?: InputMaybe<Scalars['Int']['input']>;
  license_id?: InputMaybe<Scalars['Int']['input']>;
  license_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgencyQueryInput = {
  filter?: InputMaybe<AgencyWhereInput>;
  orderBy?: InputMaybe<AgencyOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AgencySearchInput>;
};

export type AgencySearchInput = {
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AgencyWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  facility_managed_location?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  appName: Scalars['String']['output'];
  major: Scalars['Int']['output'];
  minor: Scalars['Int']['output'];
  patch: Scalars['Int']['output'];
};

export type ApplicationRequirement = {
  __typename?: 'ApplicationRequirement';
  base: Scalars['Boolean']['output'];
  condition: Condition;
  condition_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  medely: Scalars['Boolean']['output'];
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationRequirementOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationRequirementQueryInput = {
  filter?: InputMaybe<ApplicationRequirementWhereInput>;
  orderBy?: InputMaybe<ApplicationRequirementOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ApplicationRequirementSearchInput>;
};

export type ApplicationRequirementSearchInput = {
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationRequirementWhereInput = {
  condition_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  medely?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ApplicationVersion {
  Original = 'original',
  Prescreening = 'prescreening'
}

export type Approval = {
  __typename?: 'Approval';
  approval_groups: Array<ApprovalGroup>;
  approval_rule: ApprovalRule;
  approval_rule_id: Scalars['Int']['output'];
  approver_account?: Maybe<Account>;
  approver_account_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  rejection_reason?: Maybe<Scalars['String']['output']>;
  status: ApprovalStatus;
  tier: Scalars['Int']['output'];
};

export type ApprovalGroup = {
  __typename?: 'ApprovalGroup';
  account_ids: Array<Scalars['Int']['output']>;
  accounts: Array<Account>;
  company: Company;
  company_id: Scalars['Int']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ApprovalGroupOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApprovalGroupQueryInput = {
  filter?: InputMaybe<ApprovalGroupWhereInput>;
  orderBy?: InputMaybe<ApprovalGroupOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ApprovalGroupSearchInput>;
};

export type ApprovalGroupSearchInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApprovalGroupWhereInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ApprovalOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApprovalQueryInput = {
  filter?: InputMaybe<ApprovalWhereInput>;
  orderBy?: InputMaybe<ApprovalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ApprovalRule = {
  __typename?: 'ApprovalRule';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  percentage_over?: Maybe<Scalars['Float']['output']>;
};

export enum ApprovalStatus {
  Approved = 'approved',
  Expired = 'expired',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type ApprovalWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Assignment = {
  __typename?: 'Assignment';
  adjust_rate_calculator?: Maybe<Scalars['Boolean']['output']>;
  administrator?: Maybe<Administrator>;
  administrator_id?: Maybe<Scalars['Int']['output']>;
  adp_fee_burden_cents: Scalars['Int']['output'];
  adp_fee_burden_cents_default: Scalars['Int']['output'];
  agency_assignment_request_status_counts_for_account_id?: Maybe<AssignmentRequestStatusCounts>;
  /** @deprecated agency_assignments not used anymore */
  agency_base_hourly_rate_cents?: Maybe<Scalars['Float']['output']>;
  agency_enabled: Scalars['Boolean']['output'];
  agency_vms_fee_percent_for_account_id: Scalars['Float']['output'];
  all_conditions_met?: Maybe<Scalars['Boolean']['output']>;
  assignment_billing_groups?: Maybe<Array<AssignmentBillingGroup>>;
  assignment_bonus_tier1_travel_amount_cents?: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier1_travel_amount_tcv_cents?: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_cents?: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_tcv_cents?: Maybe<Scalars['Int']['output']>;
  assignment_locations?: Maybe<Array<AssignmentLocation>>;
  assignment_profile?: Maybe<AssignmentProfile>;
  assignment_profile_for_account_id?: Maybe<AssignmentProfile>;
  assignment_request_applied_count?: Maybe<Scalars['Int']['output']>;
  assignment_request_offer_sent_count?: Maybe<Scalars['Int']['output']>;
  assignment_request_status_counts?: Maybe<AssignmentRequestStatusCounts>;
  assignment_requests?: Maybe<Array<AssignmentRequest>>;
  attendance_policy: Scalars['Boolean']['output'];
  /** @deprecated This field is no longer maintained. Please use Tableau reports for up-to-date available professional counts. */
  available_professional_count?: Maybe<Scalars['Int']['output']>;
  available_to_professionals?: Maybe<Scalars['Boolean']['output']>;
  billable_orientation_hours?: Maybe<Scalars['Float']['output']>;
  booked_at?: Maybe<Scalars['DateTime']['output']>;
  booked_method?: Maybe<Scalars['String']['output']>;
  booked_source?: Maybe<Scalars['String']['output']>;
  call_requirements?: Maybe<Scalars['String']['output']>;
  can_accept?: Maybe<Scalars['Boolean']['output']>;
  can_apply?: Maybe<Scalars['Boolean']['output']>;
  canceled_by_professional: Scalars['Boolean']['output'];
  cancellation_fee_charge_hours?: Maybe<Scalars['Int']['output']>;
  cancellation_fee_window?: Maybe<Scalars['Int']['output']>;
  cancellation_policy?: Maybe<Scalars['String']['output']>;
  cancellation_reason?: Maybe<Scalars['String']['output']>;
  charge_base_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  charge_base_hourly_rate_cents_default?: Maybe<Scalars['Int']['output']>;
  charge_base_hourly_rate_cents_for_account_id: Scalars['Int']['output'];
  charge_base_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  charge_blended_hourly_rate_cents?: Maybe<Scalars['Float']['output']>;
  charge_callback_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_double_overtime_multiplier_default?: Maybe<Scalars['Float']['output']>;
  charge_max_daily_ot_hours?: Maybe<Scalars['Int']['output']>;
  charge_max_daily_ot_hours_default?: Maybe<Scalars['Int']['output']>;
  charge_max_daily_regular_hours?: Maybe<Scalars['Int']['output']>;
  charge_max_daily_regular_hours_default?: Maybe<Scalars['Int']['output']>;
  charge_max_weekly_regular_hours?: Maybe<Scalars['Int']['output']>;
  charge_max_weekly_regular_hours_default?: Maybe<Scalars['Int']['output']>;
  charge_on_call_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  charge_on_call_hourly_rate_cents_default?: Maybe<Scalars['Int']['output']>;
  charge_on_call_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  charge_overtime_frequency?: Maybe<Scalars['String']['output']>;
  charge_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_overtime_multiplier_default?: Maybe<Scalars['Float']['output']>;
  charge_overtime_rate?: Maybe<Scalars['Float']['output']>;
  charge_per_week_cents?: Maybe<Scalars['Int']['output']>;
  charge_per_week_cents_default?: Maybe<Scalars['Int']['output']>;
  clinical_contact?: Maybe<Account>;
  clinical_contact_account_id?: Maybe<Scalars['Int']['output']>;
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['Int']['output']>;
  completed_early?: Maybe<Scalars['Boolean']['output']>;
  compliance_burden_cents?: Maybe<Scalars['Int']['output']>;
  compliance_burden_cents_default?: Maybe<Scalars['Int']['output']>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  conditions_for_account_ids: Array<Condition>;
  contract_total_hours?: Maybe<Scalars['String']['output']>;
  covid_care: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  /** This should be only used for 'local' assignments */
  distance_in_miles?: Maybe<Scalars['Int']['output']>;
  ehr_system?: Maybe<EhrSystem>;
  ehr_system_id?: Maybe<Scalars['Int']['output']>;
  ends_date?: Maybe<Scalars['Date']['output']>;
  ends_time?: Maybe<Scalars['DateTime']['output']>;
  enforce_guaranteed_minimum_hours?: Maybe<Scalars['Boolean']['output']>;
  estimated_total_hours?: Maybe<Scalars['Float']['output']>;
  estimated_total_hours_default?: Maybe<Scalars['Float']['output']>;
  estimated_unpaid_break_time_minutes?: Maybe<Scalars['Int']['output']>;
  estimated_unpaid_break_time_per_week_cents?: Maybe<Scalars['Int']['output']>;
  existing_job_hours: Scalars['Float']['output'];
  extension_id?: Maybe<Scalars['Int']['output']>;
  extension_status?: Maybe<Scalars['String']['output']>;
  facility_cancellation_hours?: Maybe<Scalars['Int']['output']>;
  facility_number?: Maybe<Scalars['String']['output']>;
  federal_unemployment_max_burden_cents?: Maybe<Scalars['Int']['output']>;
  federal_unemployment_max_burden_cents_default?: Maybe<Scalars['Int']['output']>;
  federal_unemployment_percent_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  federal_unemployment_percent_burden_multiplier_default?: Maybe<Scalars['Float']['output']>;
  fee_percent?: Maybe<Scalars['Float']['output']>;
  fee_percent_default?: Maybe<Scalars['Float']['output']>;
  first_to_apply?: Maybe<Scalars['Boolean']['output']>;
  flexible_starts_date: Scalars['Boolean']['output'];
  float_requirements?: Maybe<Scalars['String']['output']>;
  great_pay?: Maybe<Scalars['Boolean']['output']>;
  gross_margin?: Maybe<Scalars['Float']['output']>;
  gross_margin_default?: Maybe<Scalars['Float']['output']>;
  gross_profit_cents?: Maybe<Scalars['Int']['output']>;
  gross_profit_cents_default?: Maybe<Scalars['Int']['output']>;
  guaranteed_hours_string?: Maybe<Scalars['String']['output']>;
  guaranteed_minimum_hours?: Maybe<Scalars['Int']['output']>;
  has_applied?: Maybe<Scalars['Boolean']['output']>;
  hours_per_shift?: Maybe<Scalars['Float']['output']>;
  hours_per_shift_default?: Maybe<Scalars['Float']['output']>;
  hours_per_week?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  invoices?: Maybe<Array<Invoice>>;
  is_extension?: Maybe<Scalars['Boolean']['output']>;
  is_travel?: Maybe<Scalars['Boolean']['output']>;
  is_w2?: Maybe<Scalars['Boolean']['output']>;
  is_w2_default: Scalars['Boolean']['output'];
  is_w2_for_account_id: Scalars['Boolean']['output'];
  jobs?: Maybe<Array<Job>>;
  jobs_detail?: Maybe<Scalars['String']['output']>;
  jobs_detail_raw?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  /** This should be only used for 'travel' assignments */
  less_than_300_miles_away?: Maybe<Scalars['Boolean']['output']>;
  local_only?: Maybe<Scalars['Boolean']['output']>;
  location_info?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Location>>;
  lodging_per_diem_cents?: Maybe<Scalars['Int']['output']>;
  lodging_per_diem_cents_default?: Maybe<Scalars['Int']['output']>;
  lunch_break?: Maybe<Scalars['Boolean']['output']>;
  max_lodging_per_diem_cents?: Maybe<Scalars['Int']['output']>;
  max_lodging_per_diem_cents_default?: Maybe<Scalars['Int']['output']>;
  max_mie_per_diem_cents?: Maybe<Scalars['Int']['output']>;
  max_mie_per_diem_cents_default?: Maybe<Scalars['Int']['output']>;
  medical_burden_cents?: Maybe<Scalars['Int']['output']>;
  medical_burden_cents_default?: Maybe<Scalars['Int']['output']>;
  medicare_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  medicare_burden_multiplier_default?: Maybe<Scalars['Float']['output']>;
  mie_per_diem_cents?: Maybe<Scalars['Int']['output']>;
  mileage_requirement?: Maybe<Scalars['Int']['output']>;
  min_taxable_rate_cents?: Maybe<Scalars['Int']['output']>;
  min_years_of_experience?: Maybe<Scalars['Float']['output']>;
  missing_condition_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  needs_item_url: Scalars['Boolean']['output'];
  non_billable_orientation_burden_hours?: Maybe<Scalars['Float']['output']>;
  nontaxable_amount_cents?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number_of_openings?: Maybe<Scalars['Int']['output']>;
  number_of_shifts_per_week?: Maybe<Scalars['Int']['output']>;
  number_of_weeks?: Maybe<Scalars['Int']['output']>;
  offer?: Maybe<Scalars['String']['output']>;
  on_call_fee_percent?: Maybe<Scalars['Float']['output']>;
  on_call_fee_percent_default?: Maybe<Scalars['Float']['output']>;
  on_hold: Scalars['Boolean']['output'];
  onboarding_due_date?: Maybe<Scalars['Date']['output']>;
  one_time_bonus_burden_cents?: Maybe<Scalars['Int']['output']>;
  order_number?: Maybe<Scalars['String']['output']>;
  original_assignment_id?: Maybe<Scalars['Int']['output']>;
  other_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  other_burden_multiplier_default?: Maybe<Scalars['Float']['output']>;
  patient_population?: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  pay_per_week_cents?: Maybe<Scalars['Int']['output']>;
  pay_per_week_cents_default?: Maybe<Scalars['Int']['output']>;
  pay_per_week_cents_for_account_id: Scalars['Int']['output'];
  payout_base_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  payout_base_hourly_rate_cents_default?: Maybe<Scalars['Int']['output']>;
  payout_base_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  payout_callback_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_double_overtime_multiplier_default?: Maybe<Scalars['Float']['output']>;
  payout_max_daily_ot_hours?: Maybe<Scalars['Int']['output']>;
  payout_max_daily_ot_hours_default?: Maybe<Scalars['Int']['output']>;
  payout_max_daily_regular_hours?: Maybe<Scalars['Int']['output']>;
  payout_max_daily_regular_hours_default?: Maybe<Scalars['Int']['output']>;
  payout_max_weekly_regular_hours?: Maybe<Scalars['Int']['output']>;
  payout_max_weekly_regular_hours_default?: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_cents_default?: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  payout_overtime_frequency?: Maybe<Scalars['String']['output']>;
  payout_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_overtime_multiplier_default?: Maybe<Scalars['Float']['output']>;
  payout_taxable_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  payout_taxable_hourly_rate_cents_default?: Maybe<Scalars['Int']['output']>;
  payout_taxable_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  per_diem: Scalars['Boolean']['output'];
  permanent_benefits: Scalars['JSON']['output'];
  permanent_max_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  permanent_min_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  permanent_openings?: Maybe<Scalars['Int']['output']>;
  permanent_qualifications: Scalars['JSON']['output'];
  permanent_signing_bonus_cents?: Maybe<Scalars['Int']['output']>;
  permanent_summary: Scalars['JSON']['output'];
  position_display_names?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Position>>;
  posting_field_contents?: Maybe<Scalars['JSON']['output']>;
  preferred_facility_rate_cents?: Maybe<Scalars['Int']['output']>;
  preferred_professional_rate_cents?: Maybe<Scalars['Int']['output']>;
  primary_location?: Maybe<Location>;
  professional?: Maybe<Professional>;
  professional_assignment_favorites?: Maybe<Array<ProfessionalAssignmentFavorite>>;
  professional_can_create_job: Scalars['Boolean']['output'];
  professional_id?: Maybe<Scalars['Int']['output']>;
  professional_number?: Maybe<Scalars['String']['output']>;
  recruiter?: Maybe<Administrator>;
  recruiter_id?: Maybe<Scalars['Int']['output']>;
  referral_reward_cents?: Maybe<Scalars['Int']['output']>;
  referrer_professional?: Maybe<Professional>;
  referrer_professional_id?: Maybe<Scalars['Int']['output']>;
  require_physical_signature: Scalars['Boolean']['output'];
  schedule_known?: Maybe<Scalars['Boolean']['output']>;
  schedule_type: Scalars['String']['output'];
  scrubs_provided: Scalars['Boolean']['output'];
  self_schedule: Scalars['Boolean']['output'];
  signed_addendum?: Maybe<Scalars['Boolean']['output']>;
  social_security_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  social_security_burden_multiplier_default?: Maybe<Scalars['Float']['output']>;
  specialties?: Maybe<Array<Specialty>>;
  specialty_labels?: Maybe<Scalars['String']['output']>;
  starts_date?: Maybe<Scalars['Date']['output']>;
  starts_time?: Maybe<Scalars['DateTime']['output']>;
  state_unemployment_max_burden_cents?: Maybe<Scalars['Int']['output']>;
  state_unemployment_max_burden_cents_default?: Maybe<Scalars['Int']['output']>;
  state_unemployment_percent_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  state_unemployment_percent_burden_multiplier_default?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  submittal_max?: Maybe<Scalars['Int']['output']>;
  surgery_type_display_names?: Maybe<Scalars['String']['output']>;
  surgery_types?: Maybe<Array<SurgeryType>>;
  suspicious?: Maybe<Scalars['Boolean']['output']>;
  taxable_amount_cents?: Maybe<Scalars['Float']['output']>;
  taxable_amount_cents_default?: Maybe<Scalars['Float']['output']>;
  track_unpaid_breaks: Scalars['Boolean']['output'];
  travel_reimbursement_burden_cents?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
  variable_shift_times?: Maybe<Scalars['Boolean']['output']>;
  vms_assignment?: Maybe<VmsAssignment>;
  vms_assignment_id?: Maybe<Scalars['Int']['output']>;
  vms_auto_update?: Maybe<Scalars['Boolean']['output']>;
  vms_contact_email?: Maybe<Scalars['String']['output']>;
  vms_contact_name?: Maybe<Scalars['String']['output']>;
  vms_contact_phone?: Maybe<Scalars['String']['output']>;
  vms_fee_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  vms_fee_burden_multiplier_default?: Maybe<Scalars['Float']['output']>;
  vms_fee_percent?: Maybe<Scalars['Float']['output']>;
  vms_order_url?: Maybe<Scalars['String']['output']>;
  vms_partnership?: Maybe<Scalars['Boolean']['output']>;
  w2_contract?: Maybe<Scalars['AWSFile']['output']>;
  weekly_guaranteed_minimum_hours?: Maybe<Scalars['Int']['output']>;
};


export type AssignmentAgency_Assignment_Request_Status_Counts_For_Account_IdArgs = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentAgency_Vms_Fee_Percent_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentAssignment_ProfileArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentAssignment_Profile_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentAvailable_To_ProfessionalsArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentCan_AcceptArgs = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentCan_ApplyArgs = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentCharge_Base_Hourly_Rate_Cents_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentConditions_For_Account_IdsArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentDistance_In_MilesArgs = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentExisting_Job_HoursArgs = {
  range: DateRangeInput;
};


export type AssignmentHas_AppliedArgs = {
  professional_id: Scalars['Int']['input'];
};


export type AssignmentIs_W2_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentLess_Than_300_Miles_AwayArgs = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentMissing_Condition_IdsArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type AssignmentPay_Per_Week_Cents_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentAgencyFilterInput = {
  professional_agency_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentBillingGroup = {
  __typename?: 'AssignmentBillingGroup';
  assignment: Assignment;
  assignment_id: Scalars['Int']['output'];
  billing_group: BillingGroup;
  billing_group_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AssignmentBillingGroupOrderInput = {
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  billing_group_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentBillingGroupQueryInput = {
  filter?: InputMaybe<AssignmentBillingGroupWhereInput>;
  orderBy?: InputMaybe<AssignmentBillingGroupOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AssignmentBillingGroupSearchInput>;
};

export type AssignmentBillingGroupSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentBillingGroupWhereInput = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentCalculatedFields = {
  __typename?: 'AssignmentCalculatedFields';
  facility_rate_blended_cents?: Maybe<Scalars['Int']['output']>;
  professional_rate_blended_cents?: Maybe<Scalars['Int']['output']>;
};

export type AssignmentCancellationReasons = {
  __typename?: 'AssignmentCancellationReasons';
  ten99?: Maybe<Array<Scalars['String']['output']>>;
  w2?: Maybe<Array<Scalars['String']['output']>>;
};

export type AssignmentCancellationReasonsV2 = {
  __typename?: 'AssignmentCancellationReasonsV2';
  available?: Maybe<Array<Scalars['String']['output']>>;
  booked?: Maybe<Array<Scalars['String']['output']>>;
  draft?: Maybe<Array<Scalars['String']['output']>>;
  in_progress?: Maybe<Array<Scalars['String']['output']>>;
  matched?: Maybe<Array<Scalars['String']['output']>>;
};

export type AssignmentDistanceCheckInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentDistanceLocationFilterInput = {
  compact?: InputMaybe<Scalars['Boolean']['input']>;
  location_areas?: InputMaybe<DistanceRadiusFilterInput>;
  state_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssignmentLocation = {
  __typename?: 'AssignmentLocation';
  assignment: Assignment;
  assignment_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  location_id: Scalars['Int']['output'];
  primary_location: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AssignmentLocationOrderInput = {
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  primary_location?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentLocationQueryInput = {
  filter?: InputMaybe<AssignmentLocationWhereInput>;
  orderBy?: InputMaybe<AssignmentLocationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AssignmentLocationSearchInput>;
};

export type AssignmentLocationSearchInput = {
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentLocationWhereInput = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  primary_location?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentMeta = {
  __typename?: 'AssignmentMeta';
  is_travel?: Maybe<Scalars['Boolean']['output']>;
  is_w2?: Maybe<Scalars['Boolean']['output']>;
  local_only?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignmentOrderInput = {
  adjust_rate_calculator?: InputMaybe<Scalars['Boolean']['input']>;
  administrator_id?: InputMaybe<Scalars['Boolean']['input']>;
  assignment_profile_charge_base_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  assignment_profile_charge_per_week_cents?: InputMaybe<Scalars['Boolean']['input']>;
  booked_at?: InputMaybe<Scalars['Boolean']['input']>;
  charge_base_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  charge_per_week_cents?: InputMaybe<Scalars['Boolean']['input']>;
  company_id?: InputMaybe<Scalars['Boolean']['input']>;
  completed_early?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  ends_date?: InputMaybe<Scalars['Boolean']['input']>;
  ends_time?: InputMaybe<Scalars['Boolean']['input']>;
  estimated_total_hours?: InputMaybe<Scalars['Boolean']['input']>;
  facility_rate_blended_cents?: InputMaybe<Scalars['Boolean']['input']>;
  hours_per_shift?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id?: InputMaybe<Scalars['Boolean']['input']>;
  jobs_detail?: InputMaybe<Scalars['Boolean']['input']>;
  lodging_per_diem_cents?: InputMaybe<Scalars['Boolean']['input']>;
  lunch_break?: InputMaybe<Scalars['Boolean']['input']>;
  mie_per_diem_cents?: InputMaybe<Scalars['Boolean']['input']>;
  nontaxable_amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  number_of_openings?: InputMaybe<Scalars['Boolean']['input']>;
  number_of_shifts_per_week?: InputMaybe<Scalars['Boolean']['input']>;
  number_of_weeks?: InputMaybe<Scalars['Boolean']['input']>;
  on_hold?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_due_date?: InputMaybe<Scalars['Boolean']['input']>;
  order_number?: InputMaybe<Scalars['Boolean']['input']>;
  patient_population?: InputMaybe<Scalars['Boolean']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  pay_per_week_cents?: InputMaybe<Scalars['Boolean']['input']>;
  payout_base_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  position_display_names?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_facility_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_professional_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_rate_blended_cents?: InputMaybe<Scalars['Boolean']['input']>;
  rate_calculator_id?: InputMaybe<Scalars['Boolean']['input']>;
  recruiter_id?: InputMaybe<Scalars['Boolean']['input']>;
  schedule_known?: InputMaybe<Scalars['Boolean']['input']>;
  schedule_type?: InputMaybe<Scalars['Boolean']['input']>;
  self_schedule?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_labels?: InputMaybe<Scalars['Boolean']['input']>;
  starts_date?: InputMaybe<Scalars['Boolean']['input']>;
  starts_time?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  submittal_max?: InputMaybe<Scalars['Boolean']['input']>;
  surgery_type_display_names?: InputMaybe<Scalars['Boolean']['input']>;
  suspicious?: InputMaybe<Scalars['Boolean']['input']>;
  taxable_amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  taxable_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentPanelCount = {
  __typename?: 'AssignmentPanelCount';
  count: Scalars['Int']['output'];
  location: Location;
};

export type AssignmentProfile = {
  __typename?: 'AssignmentProfile';
  active: Scalars['Boolean']['output'];
  agency_id?: Maybe<Scalars['Int']['output']>;
  assignment: Assignment;
  assignment_id: Scalars['Int']['output'];
  available_at?: Maybe<Scalars['DateTime']['output']>;
  available_to_professionals_at?: Maybe<Scalars['DateTime']['output']>;
  charge_base_hourly_rate_cents: Scalars['Int']['output'];
  charge_blended_hourly_rate_cents?: Maybe<Scalars['Float']['output']>;
  charge_callback_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_max_daily_ot_hours?: Maybe<Scalars['Float']['output']>;
  charge_max_daily_regular_hours?: Maybe<Scalars['Float']['output']>;
  charge_max_weekly_regular_hours?: Maybe<Scalars['Float']['output']>;
  charge_on_call_hourly_rate_cents: Scalars['Int']['output'];
  charge_overtime_multiplier: Scalars['Float']['output'];
  charge_per_week_cents?: Maybe<Scalars['Int']['output']>;
  charge_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  condition_ids: Array<Scalars['Int']['output']>;
  conditions: Array<Condition>;
  created_at: Scalars['DateTime']['output'];
  gross_margin: Scalars['Float']['output'];
  gross_profit_cents: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  on_call_fee_percent?: Maybe<Scalars['Float']['output']>;
  pay_per_week_cents?: Maybe<Scalars['Int']['output']>;
  payout_base_hourly_rate_cents: Scalars['Int']['output'];
  payout_callback_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_kind: Scalars['String']['output'];
  payout_max_daily_ot_hours?: Maybe<Scalars['Float']['output']>;
  payout_max_daily_regular_hours?: Maybe<Scalars['Float']['output']>;
  payout_max_weekly_regular_hours?: Maybe<Scalars['Float']['output']>;
  payout_on_call_hourly_rate_cents: Scalars['Int']['output'];
  payout_overtime_multiplier: Scalars['Float']['output'];
  payout_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  payout_taxable_hourly_rate_cents: Scalars['Int']['output'];
  professional_type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AssignmentProfileOrderInput = {
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentProfileQueryInput = {
  filter?: InputMaybe<AssignmentProfileWhereInput>;
  orderBy?: InputMaybe<AssignmentProfileOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AssignmentProfileSearchInput>;
};

export type AssignmentProfileSearchInput = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentProfileWhereInput = {
  assignment_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssignmentQueryInput = {
  filter?: InputMaybe<AssignmentWhereInput>;
  orderBy?: InputMaybe<AssignmentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AssignmentSearchInput>;
};

export type AssignmentRequest = {
  __typename?: 'AssignmentRequest';
  asap: Scalars['Boolean']['output'];
  assignment?: Maybe<Assignment>;
  assignment_id?: Maybe<Scalars['Int']['output']>;
  assignment_profile: AssignmentProfile;
  bonus_type?: Maybe<Scalars['String']['output']>;
  cam_notes?: Maybe<Scalars['String']['output']>;
  cam_reject_reason?: Maybe<Scalars['String']['output']>;
  contract_type?: Maybe<Scalars['String']['output']>;
  coordinate_distance?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  exceptions?: Maybe<Scalars['String']['output']>;
  favorited_by?: Maybe<Scalars['String']['output']>;
  first_experience_date?: Maybe<Scalars['Date']['output']>;
  has_contract?: Maybe<Scalars['Boolean']['output']>;
  has_missing_availability?: Maybe<Scalars['Boolean']['output']>;
  has_missing_education?: Maybe<Scalars['Boolean']['output']>;
  has_missing_ehr_software?: Maybe<Scalars['Boolean']['output']>;
  has_missing_experience?: Maybe<Scalars['Boolean']['output']>;
  has_missing_identity?: Maybe<Scalars['Boolean']['output']>;
  has_missing_information?: Maybe<Scalars['Boolean']['output']>;
  has_missing_references?: Maybe<Scalars['Boolean']['output']>;
  has_missing_work_history?: Maybe<Scalars['Boolean']['output']>;
  has_unexplained_work_gaps?: Maybe<Scalars['Boolean']['output']>;
  has_upload?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  interview_availability?: Maybe<Scalars['String']['output']>;
  interview_notes?: Maybe<Scalars['String']['output']>;
  is_favorite: Scalars['Boolean']['output'];
  is_favorite_any_facility: Scalars['Boolean']['output'];
  is_favorite_this_facility: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  num_shifts_worked: Scalars['Int']['output'];
  num_shifts_worked_here: Scalars['Int']['output'];
  offer_cancellation_reason?: Maybe<AssignmentRequestCancellationReasons>;
  offer_sent_date?: Maybe<Scalars['Date']['output']>;
  offer_source?: Maybe<Scalars['String']['output']>;
  phone_screening_request?: Maybe<PhoneScreeningRequest>;
  preferred_start_date?: Maybe<Scalars['Date']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  professional_position_recent_experience?: Maybe<Array<Maybe<ProfessionalRecentExperience>>>;
  professional_prev_worked_here?: Maybe<Scalars['String']['output']>;
  recommended: Scalars['Boolean']['output'];
  recruiter_notes?: Maybe<Scalars['String']['output']>;
  referrer_professional?: Maybe<Professional>;
  rejection_reason?: Maybe<Scalars['String']['output']>;
  relevant_qualification_ids?: Maybe<Array<Scalars['Int']['output']>>;
  start_date?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submitted_to_vms: Scalars['Boolean']['output'];
  submitting_cam?: Maybe<Account>;
  submitting_cam_id?: Maybe<Scalars['Int']['output']>;
  time_off_request?: Maybe<Scalars['String']['output']>;
  travel_profile_strength?: Maybe<Scalars['Int']['output']>;
  unapplied_at?: Maybe<Scalars['DateTime']['output']>;
  unapply_reason?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  upload?: Maybe<Scalars['AWSFile']['output']>;
  viewed?: Maybe<Scalars['Boolean']['output']>;
  vms_application_status?: Maybe<Scalars['String']['output']>;
  vms_application_submitted_at?: Maybe<Scalars['DateTime']['output']>;
  vms_profile_status?: Maybe<Scalars['String']['output']>;
  vms_profile_submitted_at?: Maybe<Scalars['DateTime']['output']>;
  vms_reject_reason?: Maybe<Scalars['String']['output']>;
};


export type AssignmentRequestProfessional_Position_Recent_ExperienceArgs = {
  within_past_years?: Scalars['Int']['input'];
};

export enum AssignmentRequestCancellationReasons {
  FilledByOtherAgency = 'filled_by_other_agency',
  LowPatientCensus = 'low_patient_census',
  Mistake = 'mistake',
  NoApplicants = 'no_applicants',
  TooExpensive = 'too_expensive',
  UtilizingOwnStaff = 'utilizing_own_staff',
  WishNotToWorkWithMedely = 'wish_not_to_work_with_medely'
}

export type AssignmentRequestOrderInput = {
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  phone_screening_request_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  submitted_to_vms?: InputMaybe<Scalars['Boolean']['input']>;
  travel_profile_strength?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  vms_application_status?: InputMaybe<Scalars['Boolean']['input']>;
  vms_application_submitted_at?: InputMaybe<Scalars['Boolean']['input']>;
  vms_profile_status?: InputMaybe<Scalars['Boolean']['input']>;
  vms_profile_submitted_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignmentRequestQueryInput = {
  filter?: InputMaybe<AssignmentRequestWhereInput>;
  orderBy?: InputMaybe<AssignmentRequestOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AssignmentRequestSearchInput>;
};

export type AssignmentRequestSearchInput = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  assignment_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignment_type?: InputMaybe<Scalars['String']['input']>;
  booked_by_agency?: InputMaybe<Scalars['Boolean']['input']>;
  cam_id?: InputMaybe<Scalars['Int']['input']>;
  contract_range?: InputMaybe<ContractRangeInput>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  facility_account_id?: InputMaybe<Scalars['Int']['input']>;
  health_system_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id?: InputMaybe<Scalars['Int']['input']>;
  on_hold?: InputMaybe<Scalars['Boolean']['input']>;
  permanent_placement_status?: InputMaybe<PermanentPlacementStatusInput>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_name?: InputMaybe<Scalars['String']['input']>;
  professional_type?: InputMaybe<Scalars['String']['input']>;
  profile_strength?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  recruiter_id?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vms_application_submitted_at?: InputMaybe<Scalars['DateTime']['input']>;
  vms_profile_submitted_at?: InputMaybe<Scalars['DateTime']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentRequestStatusCounts = {
  __typename?: 'AssignmentRequestStatusCounts';
  active_count?: Maybe<Scalars['Int']['output']>;
  awaiting_count?: Maybe<Scalars['Int']['output']>;
  interview_count?: Maybe<Scalars['Int']['output']>;
  offer_count?: Maybe<Scalars['Int']['output']>;
};

export type AssignmentRequestWhereInput = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  assignment_status?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  phone_screening_request_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  recruiter_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submitted_to_vms?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
  vms_application_status?: InputMaybe<Scalars['String']['input']>;
  vms_profile_status?: InputMaybe<Scalars['String']['input']>;
};

export enum AssignmentSchedule {
  Day = 'day',
  Evening = 'evening',
  Night = 'night'
}

export type AssignmentSearchInput = {
  administrator_id?: InputMaybe<Scalars['Int']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  agency_location_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  all_position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  assignment_request_status?: InputMaybe<Scalars['String']['input']>;
  booked_by_agency?: InputMaybe<Scalars['Boolean']['input']>;
  compact?: InputMaybe<Scalars['Boolean']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  contract_length_in_weeks?: InputMaybe<ContractLengthInWeeksInput>;
  contract_range?: InputMaybe<ContractRangeInput>;
  created_at?: InputMaybe<Scalars['Date']['input']>;
  default_agency_sort?: InputMaybe<Scalars['Boolean']['input']>;
  default_sort?: InputMaybe<Scalars['String']['input']>;
  distance_check?: InputMaybe<AssignmentDistanceCheckInput>;
  distance_sort?: InputMaybe<Scalars['String']['input']>;
  duration_sort?: InputMaybe<Scalars['String']['input']>;
  ends_date?: InputMaybe<Scalars['Date']['input']>;
  ends_date_from?: InputMaybe<Scalars['Date']['input']>;
  ends_date_to?: InputMaybe<Scalars['Date']['input']>;
  expiring_date?: InputMaybe<Scalars['Date']['input']>;
  favorited_by_professional_id?: InputMaybe<Scalars['Int']['input']>;
  flexible_starts_date?: InputMaybe<Scalars['Boolean']['input']>;
  has_extension?: InputMaybe<Scalars['Boolean']['input']>;
  has_pending_offers?: InputMaybe<Scalars['Boolean']['input']>;
  has_travel_stipend?: InputMaybe<Scalars['String']['input']>;
  health_system_id?: InputMaybe<Scalars['Int']['input']>;
  ignore_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ignore_location_type_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_1099?: InputMaybe<Scalars['Boolean']['input']>;
  is_extension?: InputMaybe<Scalars['Boolean']['input']>;
  is_underbooked?: InputMaybe<DateRangeInput>;
  is_w2?: InputMaybe<Scalars['Boolean']['input']>;
  local_only?: InputMaybe<Scalars['Boolean']['input']>;
  location_filter?: InputMaybe<AssignmentDistanceLocationFilterInput>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  market_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  msp_id?: InputMaybe<Scalars['Int']['input']>;
  new_applicants?: InputMaybe<Scalars['Boolean']['input']>;
  new_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  no_vms_company?: InputMaybe<Scalars['Boolean']['input']>;
  not_applied_by_pro_id?: InputMaybe<Scalars['Int']['input']>;
  not_paused?: InputMaybe<Scalars['Int']['input']>;
  on_hold?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_due_date?: InputMaybe<Scalars['Date']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  paused_or_applied_by_professional_id?: InputMaybe<Scalars['Int']['input']>;
  permanent_placement_status?: InputMaybe<PermanentPlacementFilterInput>;
  phone_screening_request_status?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['Int']['input']>;
  position_display_name?: InputMaybe<Scalars['String']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_name?: InputMaybe<Scalars['String']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_name?: InputMaybe<Scalars['String']['input']>;
  professional_pay_sort?: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  recommended_assignments?: InputMaybe<RecommendedAssignmentInput>;
  recruiter_id?: InputMaybe<Scalars['Int']['input']>;
  sales_associate_id?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Array<InputMaybe<AssignmentSchedule>>>;
  shift_length?: InputMaybe<ShiftLengthInput>;
  shift_times?: InputMaybe<Scalars['Int']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  starts_date?: InputMaybe<Scalars['Date']['input']>;
  state_abbreviation?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surgery_type_id?: InputMaybe<Scalars['Int']['input']>;
  time_of_day?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  track_unpaid_breaks?: InputMaybe<Scalars['Boolean']['input']>;
  travel?: InputMaybe<Scalars['String']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
  weekly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentWhereInput = {
  adjust_rate_calculator?: InputMaybe<Scalars['Boolean']['input']>;
  administrator_id?: InputMaybe<Scalars['Int']['input']>;
  booked_at?: InputMaybe<Scalars['DateTime']['input']>;
  charge_base_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_per_week_cents?: InputMaybe<Scalars['Int']['input']>;
  completed_early?: InputMaybe<Scalars['Boolean']['input']>;
  covid_care?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  ends_date?: InputMaybe<Scalars['DateTime']['input']>;
  ends_time?: InputMaybe<Scalars['DateTime']['input']>;
  estimated_total_hours?: InputMaybe<Scalars['Float']['input']>;
  facility_rate_blended_cents?: InputMaybe<Scalars['Float']['input']>;
  flexible_starts_date?: InputMaybe<Scalars['Boolean']['input']>;
  hours_per_shift?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  jobs_detail?: InputMaybe<Scalars['String']['input']>;
  lodging_per_diem_cents?: InputMaybe<Scalars['Int']['input']>;
  lunch_break?: InputMaybe<Scalars['Boolean']['input']>;
  mie_per_diem_cents?: InputMaybe<Scalars['Int']['input']>;
  nontaxable_amount_cents?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number_of_shifts_per_week?: InputMaybe<Scalars['Int']['input']>;
  number_of_weeks?: InputMaybe<Scalars['Int']['input']>;
  on_hold?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_due_date?: InputMaybe<Scalars['DateTime']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
  patient_population?: InputMaybe<Scalars['String']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  pay_per_week_cents?: InputMaybe<Scalars['Int']['input']>;
  payout_base_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  per_diem?: InputMaybe<Scalars['Boolean']['input']>;
  position_display_names?: InputMaybe<Scalars['String']['input']>;
  preferred_facility_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  preferred_professional_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_rate_blended_cents?: InputMaybe<Scalars['Float']['input']>;
  rate_calculator_id?: InputMaybe<Scalars['Int']['input']>;
  recruiter_id?: InputMaybe<Scalars['Int']['input']>;
  schedule_known?: InputMaybe<Scalars['Boolean']['input']>;
  schedule_type?: InputMaybe<Scalars['String']['input']>;
  self_schedule?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_labels?: InputMaybe<Scalars['String']['input']>;
  starts_date?: InputMaybe<Scalars['DateTime']['input']>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submittal_max?: InputMaybe<Scalars['Int']['input']>;
  surgery_type_display_names?: InputMaybe<Scalars['String']['input']>;
  suspicious?: InputMaybe<Scalars['Boolean']['input']>;
  taxable_amount_cents?: InputMaybe<Scalars['Float']['input']>;
  taxable_hourly_rate_cents?: InputMaybe<Scalars['Float']['input']>;
  track_unpaid_breaks?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  vms_assignment_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Audit = {
  __typename?: 'Audit';
  account?: Maybe<Account>;
  action?: Maybe<Scalars['String']['output']>;
  associated_id?: Maybe<Scalars['Int']['output']>;
  associated_type?: Maybe<Scalars['String']['output']>;
  auditable_id?: Maybe<Scalars['Int']['output']>;
  auditable_type?: Maybe<Scalars['String']['output']>;
  audited_changes?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type AuditOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuditQueryInput = {
  filter?: InputMaybe<AuditWhereInput>;
  orderBy?: InputMaybe<AuditOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type AuditWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AvailableAssignmentsMeta = {
  __typename?: 'AvailableAssignmentsMeta';
  count?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  rankingType?: Maybe<Scalars['String']['output']>;
};

export type AvailableCredit = {
  __typename?: 'AvailableCredit';
  amount_cents?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AvailableJobSort = {
  order?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  sort_type?: InputMaybe<Scalars['String']['input']>;
};

export type BackgroundCheck = {
  __typename?: 'BackgroundCheck';
  candidate_id?: Maybe<Scalars['String']['output']>;
  candidate_status?: Maybe<Scalars['String']['output']>;
  completed_on?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  report_id?: Maybe<Scalars['String']['output']>;
  report_status?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type BackgroundCheckOrderInput = {
  candidate_id?: InputMaybe<Scalars['Boolean']['input']>;
  candidate_status?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  report_id?: InputMaybe<Scalars['Boolean']['input']>;
  report_status?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BackgroundCheckQueryInput = {
  filter?: InputMaybe<BackgroundCheckWhereInput>;
  orderBy?: InputMaybe<BackgroundCheckOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type BackgroundCheckWhereInput = {
  candidate_id?: InputMaybe<Scalars['String']['input']>;
  candidate_status?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  report_id?: InputMaybe<Scalars['String']['input']>;
  report_status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BalanceSheet = {
  __typename?: 'BalanceSheet';
  close_period?: Maybe<Scalars['Int']['output']>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  expense_adjustments?: Maybe<Array<ExpenseAdjustment>>;
  finantial_transactions?: Maybe<Array<FinancialTransaction>>;
  first_datetime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  job_billings?: Maybe<Array<JobBilling>>;
  jobs?: Maybe<Array<Job>>;
  month?: Maybe<Scalars['String']['output']>;
  revenue_adjustments?: Maybe<Array<RevenueAdjustment>>;
  total_cents: Scalars['Int']['output'];
  total_currency: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  year?: Maybe<Scalars['String']['output']>;
};

export type BalanceSheetOrderInput = {
  close_period?: InputMaybe<Scalars['Boolean']['input']>;
  first_datetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BalanceSheetQueryInput = {
  filter?: InputMaybe<BalanceSheetWhereInput>;
  orderBy?: InputMaybe<BalanceSheetOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<BalanceSheetSearchInput>;
};

export type BalanceSheetSearchInput = {
  close_period?: InputMaybe<Scalars['Int']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  first_datetime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  month?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type BalanceSheetWhereInput = {
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  first_datetime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  total_cents?: InputMaybe<Scalars['Int']['input']>;
  total_currency?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BillingActivity = {
  __typename?: 'BillingActivity';
  billing_group_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  revenue_adjustments?: Maybe<Array<Maybe<RevenueAdjustment>>>;
  running_total_cents?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_cents?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BillingActivityOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingActivityQueryInput = {
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BillingActivityOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<BillingActivitySearchInput>;
};

export type BillingActivitySearchInput = {
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ends_time?: InputMaybe<Scalars['DateTime']['input']>;
  max_amount?: InputMaybe<Scalars['Int']['input']>;
  min_amount?: InputMaybe<Scalars['Int']['input']>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BillingContact = {
  __typename?: 'BillingContact';
  billing_group_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type BillingContactOrderInput = {
  first_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingContactQueryInput = {
  filter?: InputMaybe<BillingContactWhereInput>;
  orderBy?: InputMaybe<BillingContactOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type BillingContactWhereInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingGroup = {
  __typename?: 'BillingGroup';
  account_billing_groups?: Maybe<Array<AccountBillingGroup>>;
  account_summary_emails: Scalars['Boolean']['output'];
  ach_source_detail?: Maybe<Scalars['AchSourceDetail']['output']>;
  assignment_billing_groups?: Maybe<Array<AssignmentBillingGroup>>;
  auto_pay: Scalars['Boolean']['output'];
  balance_cents: Scalars['Int']['output'];
  balance_currency: Scalars['String']['output'];
  bank_last?: Maybe<Scalars['String']['output']>;
  billing: Scalars['String']['output'];
  billing_group_management_company?: Maybe<BillingGroupManagementCompany>;
  billing_group_management_company_id?: Maybe<Scalars['Int']['output']>;
  billing_group_parent?: Maybe<BillingGroupParent>;
  billing_group_parent_id?: Maybe<Scalars['Int']['output']>;
  billing_rep?: Maybe<Scalars['Int']['output']>;
  business_tax_id?: Maybe<Scalars['String']['output']>;
  charge_on_call_hourly_rate_cents: Scalars['Int']['output'];
  charge_on_call_hourly_rate_currency: Scalars['String']['output'];
  check_line_of_credit?: Maybe<Scalars['Boolean']['output']>;
  collections_late_fee_percent?: Maybe<Scalars['Float']['output']>;
  collections_rep?: Maybe<Scalars['Int']['output']>;
  collections_representative?: Maybe<Account>;
  company: Company;
  company_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  credit_insurance_limit?: Maybe<Scalars['Int']['output']>;
  current_due_cents?: Maybe<Scalars['Int']['output']>;
  duns?: Maybe<Scalars['Int']['output']>;
  eh_id?: Maybe<Scalars['String']['output']>;
  funding_sources?: Maybe<Array<FundingSource>>;
  has_dun_and_bradstreet: Scalars['Boolean']['output'];
  has_past_due?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  invoice_emails: Scalars['Boolean']['output'];
  last_credit_review?: Maybe<Scalars['DateTime']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  line_of_credit_cents: Scalars['Int']['output'];
  line_of_credit_currency: Scalars['String']['output'];
  location_billing_groups?: Maybe<Array<LocationBillingGroup>>;
  locations?: Maybe<Array<Location>>;
  msa: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  net_term?: Maybe<Scalars['Int']['output']>;
  original_user_id?: Maybe<Scalars['Int']['output']>;
  past_due_allowance_amount_cents: Scalars['Int']['output'];
  past_due_cents?: Maybe<Scalars['Int']['output']>;
  payment_due_date?: Maybe<Scalars['String']['output']>;
  payment_gateway: Scalars['Boolean']['output'];
  plaid_account_id?: Maybe<Scalars['String']['output']>;
  plaid_token?: Maybe<Scalars['String']['output']>;
  plan: Scalars['String']['output'];
  remaining_credit_cents?: Maybe<Scalars['Int']['output']>;
  statement_fee_percent?: Maybe<Scalars['Float']['output']>;
  statements?: Maybe<Array<Statement>>;
  status: Scalars['String']['output'];
  stripe_ach_credit_transfer_id?: Maybe<Scalars['String']['output']>;
  stripe_bank_account_token?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  stripe_last_4?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  total_due_cents?: Maybe<Scalars['Int']['output']>;
  track_unpaid_breaks: Scalars['Boolean']['output'];
  uid: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  vms_fee_percent?: Maybe<Scalars['Float']['output']>;
};

export type BillingGroupCreditLimitCalculation = {
  __typename?: 'BillingGroupCreditLimitCalculation';
  billing_group_id?: Maybe<Scalars['Int']['output']>;
  credit_percentage_used?: Maybe<Scalars['Float']['output']>;
  line_of_credit_cents?: Maybe<Scalars['Int']['output']>;
  remaining_credit_cents?: Maybe<Scalars['Int']['output']>;
};

export type BillingGroupCreditLimitCalculationOrderInput = {
  billing_group_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupCreditLimitCalculationQueryInput = {
  filter?: InputMaybe<BillingGroupCreditLimitCalculationWhereInput>;
  orderBy?: InputMaybe<BillingGroupCreditLimitCalculationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<BillingGroupCreditLimitCalculationSearchInput>;
};

export type BillingGroupCreditLimitCalculationSearchInput = {
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  billing_group_uid?: InputMaybe<Scalars['String']['input']>;
  payment_gateway?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupCreditLimitCalculationWhereInput = {
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingGroupManagementCompany = {
  __typename?: 'BillingGroupManagementCompany';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BillingGroupManagementCompanyOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupManagementCompanyQueryInput = {
  filter?: InputMaybe<BillingGroupManagementCompanyWhereInput>;
  orderBy?: InputMaybe<BillingGroupManagementCompanyOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<BillingGroupManagementCompanySearchInput>;
};

export type BillingGroupManagementCompanySearchInput = {
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type BillingGroupManagementCompanyWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BillingGroupOrderInput = {
  account_summary_emails?: InputMaybe<Scalars['Boolean']['input']>;
  auto_pay?: InputMaybe<Scalars['Boolean']['input']>;
  balance_cents?: InputMaybe<Scalars['Boolean']['input']>;
  balance_currency?: InputMaybe<Scalars['Boolean']['input']>;
  bank_last?: InputMaybe<Scalars['Boolean']['input']>;
  billing?: InputMaybe<Scalars['Boolean']['input']>;
  business_tax_id?: InputMaybe<Scalars['Boolean']['input']>;
  charge_on_call_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  charge_on_call_hourly_rate_currency?: InputMaybe<Scalars['Boolean']['input']>;
  check_line_of_credit?: InputMaybe<Scalars['Boolean']['input']>;
  company_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_emails?: InputMaybe<Scalars['Boolean']['input']>;
  line_of_credit_cents?: InputMaybe<Scalars['Boolean']['input']>;
  line_of_credit_currency?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  net_term?: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id?: InputMaybe<Scalars['Boolean']['input']>;
  payment_gateway?: InputMaybe<Scalars['Boolean']['input']>;
  plaid_account_id?: InputMaybe<Scalars['Boolean']['input']>;
  plaid_token?: InputMaybe<Scalars['Boolean']['input']>;
  plan?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_ach_credit_transfer_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_bank_account_token?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_last_4?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  vms_fee_percent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupParent = {
  __typename?: 'BillingGroupParent';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BillingGroupParentOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingGroupParentQueryInput = {
  filter?: InputMaybe<BillingGroupParentWhereInput>;
  orderBy?: InputMaybe<BillingGroupParentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<BillingGroupParentSearchInput>;
};

export type BillingGroupParentSearchInput = {
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type BillingGroupParentWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BillingGroupQueryInput = {
  filter?: InputMaybe<BillingGroupWhereInput>;
  orderBy?: InputMaybe<BillingGroupOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<BillingGroupSearchInput>;
};

export type BillingGroupSearchInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  has_locations?: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id?: InputMaybe<Scalars['Int']['input']>;
  location_type_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  no_vms?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  track_unpaid_breaks?: InputMaybe<Scalars['Boolean']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingGroupWhereInput = {
  account_summary_emails?: InputMaybe<Scalars['Boolean']['input']>;
  auto_pay?: InputMaybe<Scalars['Boolean']['input']>;
  balance_cents?: InputMaybe<Scalars['Int']['input']>;
  balance_currency?: InputMaybe<Scalars['String']['input']>;
  bank_last?: InputMaybe<Scalars['Int']['input']>;
  billing?: InputMaybe<Scalars['String']['input']>;
  billing_group_management_company_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_parent_id?: InputMaybe<Scalars['Int']['input']>;
  business_tax_id?: InputMaybe<Scalars['String']['input']>;
  charge_on_call_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_on_call_hourly_rate_currency?: InputMaybe<Scalars['String']['input']>;
  check_line_of_credit?: InputMaybe<Scalars['Boolean']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_emails?: InputMaybe<Scalars['Boolean']['input']>;
  line_of_credit_cents?: InputMaybe<Scalars['Int']['input']>;
  line_of_credit_currency?: InputMaybe<Scalars['String']['input']>;
  location_type_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id?: InputMaybe<Scalars['Int']['input']>;
  net_term?: InputMaybe<Scalars['Int']['input']>;
  no_vms?: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id?: InputMaybe<Scalars['Int']['input']>;
  past_due_allowance_amount_cents?: InputMaybe<Scalars['Int']['input']>;
  payment_gateway?: InputMaybe<Scalars['Boolean']['input']>;
  plaid_account_id?: InputMaybe<Scalars['String']['input']>;
  plaid_token?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  saas_primary?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_ach_credit_transfer_id?: InputMaybe<Scalars['String']['input']>;
  stripe_bank_account_token?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  stripe_last_4?: InputMaybe<Scalars['Int']['input']>;
  track_unpaid_breaks?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  vms_fee_percent?: InputMaybe<Scalars['Float']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type BlendedOrNonBlendedRateSettings = {
  __typename?: 'BlendedOrNonBlendedRateSettings';
  blended_rate_markup?: Maybe<Scalars['Float']['output']>;
  charge_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_max_daily_overtime_hours?: Maybe<Scalars['Int']['output']>;
  charge_max_daily_regular_hours?: Maybe<Scalars['Int']['output']>;
  charge_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_max_daily_overtime_hours?: Maybe<Scalars['Int']['output']>;
  payout_max_daily_regular_hours?: Maybe<Scalars['Int']['output']>;
  payout_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
};

export type BlockedTimes = {
  __typename?: 'BlockedTimes';
  current_ends_time: Scalars['DateTime']['output'];
  current_starts_time: Scalars['DateTime']['output'];
  location_id: Scalars['Int']['output'];
  professional_id: Scalars['Int']['output'];
};

export type Bookability = {
  gte_starts_time: Scalars['DateTime']['input'];
  job_id: Scalars['Int']['input'];
  lte_starts_time: Scalars['DateTime']['input'];
};

export type Break = {
  __typename?: 'Break';
  created_at: Scalars['DateTime']['output'];
  duration_minutes: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  job?: Maybe<Job>;
  job_id?: Maybe<Scalars['Int']['output']>;
  starts_time?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
  waived?: Maybe<Scalars['Boolean']['output']>;
};

export type BreakOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  duration_minutes?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  locations_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  starts_time?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BreakQueryInput = {
  filter?: InputMaybe<BreakWhereInput>;
  orderBy?: InputMaybe<BreakOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<BreakSearchInput>;
};

export type BreakSearchInput = {
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type BreakWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  waived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cancellation = {
  __typename?: 'Cancellation';
  booked_at?: Maybe<Scalars['DateTime']['output']>;
  cancellation_reason?: Maybe<CancellationReason>;
  cleared: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job?: Maybe<Job>;
  job_starts_date?: Maybe<Scalars['DateTime']['output']>;
  job_starts_time?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Location>;
  market_name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  personable?: Maybe<Personable>;
  personable_id?: Maybe<Scalars['Int']['output']>;
  personable_type?: Maybe<Scalars['String']['output']>;
  professional?: Maybe<Professional>;
  state_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  window: Scalars['String']['output'];
};

export type CancellationOrderInput = {
  booked_at?: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_reason_id?: InputMaybe<Scalars['Boolean']['input']>;
  cleared?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  job_starts_date?: InputMaybe<Scalars['Boolean']['input']>;
  job_starts_time?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Scalars['Boolean']['input']>;
  personable_id?: InputMaybe<Scalars['Boolean']['input']>;
  personable_type?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancellationQueryInput = {
  filter?: InputMaybe<CancellationWhereInput>;
  orderBy?: InputMaybe<CancellationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type CancellationReason = {
  __typename?: 'CancellationReason';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CancellationReasonOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancellationReasonQueryInput = {
  filter?: InputMaybe<CancellationReasonWhereInput>;
  orderBy?: InputMaybe<CancellationReasonOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type CancellationReasonWhereInput = {
  account_ids?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_role?: InputMaybe<Scalars['Int']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_role?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CancellationSearchInput = {
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type CancellationWhereInput = {
  booked_at?: InputMaybe<Scalars['DateTime']['input']>;
  cancellation_reason_id?: InputMaybe<Scalars['Int']['input']>;
  cleared?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  job_starts_date?: InputMaybe<Scalars['DateTime']['input']>;
  job_starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  personable_id?: InputMaybe<Scalars['Int']['input']>;
  personable_type?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  window?: InputMaybe<Scalars['String']['input']>;
};

export type CapsReport = {
  __typename?: 'CapsReport';
  id: Scalars['Int']['output'];
  professional?: Maybe<Professional>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CapsReportOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CapsReportQueryInput = {
  filter?: InputMaybe<CapsReportWhereInput>;
  orderBy?: InputMaybe<CapsReportOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<CapsReportSearchInput>;
};

export type CapsReportSearchInput = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CapsReportWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Check = {
  __typename?: 'Check';
  amount_cents: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  statement?: Maybe<Statement>;
  stripe_invoice_item_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CheckIn = {
  __typename?: 'CheckIn';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  clock_event_attachments?: Maybe<Array<ClockEventAttachment>>;
  created_at: Scalars['DateTime']['output'];
  distance?: Maybe<Scalars['Float']['output']>;
  facility_adjusted_time?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  job?: Maybe<Job>;
  job_id?: Maybe<Scalars['Int']['output']>;
  job_starts_time?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  manual_override?: Maybe<Scalars['Boolean']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CheckInOrderInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  job_starts_time?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['Boolean']['input']>;
  manual_override?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  time?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckInQueryInput = {
  filter?: InputMaybe<CheckInWhereInput>;
  orderBy?: InputMaybe<CheckInOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<CheckInSearchInput>;
};

export type CheckInSearchInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  date_to?: InputMaybe<Scalars['DateTime']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  job_starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  manual_override?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckInWhereInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  job_starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  manual_override?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckOrderInput = {
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  statement_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_invoice_item_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckOut = {
  __typename?: 'CheckOut';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  clock_event_attachments?: Maybe<Array<ClockEventAttachment>>;
  created_at: Scalars['DateTime']['output'];
  distance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  job?: Maybe<Job>;
  job_id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  manual_override?: Maybe<Scalars['Boolean']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CheckOutOrderInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['Boolean']['input']>;
  manual_override?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  time?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckOutQueryInput = {
  filter?: InputMaybe<CheckOutWhereInput>;
  orderBy?: InputMaybe<CheckOutOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<CheckOutSearchInput>;
};

export type CheckOutSearchInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  date_to?: InputMaybe<Scalars['DateTime']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  job_starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  manual_override?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckOutWhereInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  distance?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  manual_override?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckQueryInput = {
  filter?: InputMaybe<CheckWhereInput>;
  orderBy?: InputMaybe<CheckOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type CheckWhereInput = {
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  statement_id?: InputMaybe<Scalars['Int']['input']>;
  stripe_invoice_item_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClinicalContact = {
  __typename?: 'ClinicalContact';
  active?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  phone_number: Scalars['String']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type ClinicalContactOrderInput = {
  first_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClinicalContactQueryInput = {
  filter?: InputMaybe<ClinicalContactWhereInput>;
  orderBy?: InputMaybe<ClinicalContactOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ClinicalContactWhereInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ClockEventAttachment = {
  __typename?: 'ClockEventAttachment';
  clock_event_id: Scalars['Int']['output'];
  clock_event_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  file?: Maybe<Scalars['AWSFile']['output']>;
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Field no longer supported */
  reason?: Maybe<Scalars['String']['output']>;
  reasons?: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ClockEventAttachmentOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClockEventAttachmentQueryInput = {
  filter?: InputMaybe<ClockEventAttachmentWhereInput>;
  orderBy?: InputMaybe<ClockEventAttachmentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ClockEventAttachmentSearchInput>;
};

export type ClockEventAttachmentSearchInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ClockEventAttachmentWhereInput = {
  clock_event_id?: InputMaybe<Scalars['Int']['input']>;
  clock_event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Company = {
  __typename?: 'Company';
  accepted_tos?: Maybe<Scalars['Boolean']['output']>;
  account_manager?: Maybe<Administrator>;
  account_manager_id?: Maybe<Scalars['Int']['output']>;
  accounts?: Maybe<Array<Account>>;
  agency_enabled: Scalars['Boolean']['output'];
  billing_groups?: Maybe<Array<BillingGroup>>;
  created_at: Scalars['DateTime']['output'];
  detailed_notes?: Maybe<Scalars['String']['output']>;
  disable_rate_editing: Scalars['Boolean']['output'];
  disabled_at?: Maybe<Scalars['DateTime']['output']>;
  display_pro_ehr_information: Scalars['Boolean']['output'];
  dispute_submission_window_days?: Maybe<Scalars['Int']['output']>;
  enable_template_rate: Scalars['Boolean']['output'];
  has_billing_manager: Scalars['Boolean']['output'];
  has_onboarded_location: Scalars['Boolean']['output'];
  health_system?: Maybe<HealthSystem>;
  health_system_id?: Maybe<Scalars['Int']['output']>;
  hide_invoicing_during_onboarding: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  include_pro_private_info_on_exports: Scalars['Boolean']['output'];
  invoicing_fee_label?: Maybe<Scalars['String']['output']>;
  is_self_service: Scalars['Boolean']['output'];
  last_time_job_posted_at?: Maybe<Scalars['DateTime']['output']>;
  locations?: Maybe<Array<Location>>;
  logo?: Maybe<Scalars['AWSFile']['output']>;
  msp?: Maybe<Msp>;
  msp_id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  onboarding_complete: Scalars['Boolean']['output'];
  onboarding_status?: Maybe<Scalars['String']['output']>;
  original_user_id?: Maybe<Scalars['Int']['output']>;
  other_referral_source?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  referral_source?: Maybe<ReferralSource>;
  referral_source_id?: Maybe<Scalars['Int']['output']>;
  rfm: Scalars['String']['output'];
  rfrf: Scalars['Int']['output'];
  rfrm: Scalars['Int']['output'];
  rfrmm: Scalars['Int']['output'];
  saas_base_monthly_cents: Scalars['Int']['output'];
  saas_billing_group_id?: Maybe<Scalars['Int']['output']>;
  saas_credentialing_enabled: Scalars['Boolean']['output'];
  saas_per_job_flat_fee_cents: Scalars['Int']['output'];
  saas_per_seat_monthly_cents: Scalars['Int']['output'];
  saas_plan: Scalars['String']['output'];
  saas_scheduling_enabled: Scalars['Boolean']['output'];
  sales_associate?: Maybe<Administrator>;
  sales_associate_id?: Maybe<Scalars['Int']['output']>;
  sales_tier?: Maybe<Scalars['Int']['output']>;
  uid: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
  vms_type?: Maybe<VmsType>;
  vms_type_id?: Maybe<Scalars['Int']['output']>;
};

export type CompanyMedelyRequirements = {
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  detailed_notes?: InputMaybe<Scalars['Boolean']['input']>;
  disabled_at?: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_time_job_posted_at?: InputMaybe<Scalars['Boolean']['input']>;
  msp_id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete?: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  referral?: InputMaybe<Scalars['Boolean']['input']>;
  rfm?: InputMaybe<Scalars['Boolean']['input']>;
  rfrf?: InputMaybe<Scalars['Boolean']['input']>;
  rfrm?: InputMaybe<Scalars['Boolean']['input']>;
  rfrmm?: InputMaybe<Scalars['Boolean']['input']>;
  tsv?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyQueryInput = {
  filter?: InputMaybe<CompanyWhereInput>;
  orderBy?: InputMaybe<CompanyOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<CompanySearchInput>;
};

export type CompanySearchInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  fill_ratio?: InputMaybe<Scalars['Int']['input']>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  no_vms?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  saas_credentialing_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  saas_scheduling_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  detailed_notes?: InputMaybe<Scalars['String']['input']>;
  disabled_at?: InputMaybe<Scalars['DateTime']['input']>;
  enable_template_rate?: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_time_job_posted_at?: InputMaybe<Scalars['DateTime']['input']>;
  msp_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboarding_complete?: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id?: InputMaybe<Scalars['Int']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  rfm?: InputMaybe<Scalars['String']['input']>;
  rfrf?: InputMaybe<Scalars['Int']['input']>;
  rfrm?: InputMaybe<Scalars['Int']['input']>;
  rfrmm?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Condition = {
  __typename?: 'Condition';
  condition_documents?: Maybe<Array<ConditionDocument>>;
  condition_type: Scalars['String']['output'];
  display_category?: Maybe<Scalars['String']['output']>;
  display_description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  qualifications?: Maybe<Array<Qualification>>;
  requirements?: Maybe<Array<Requirement>>;
  slug: Scalars['String']['output'];
};

export type ConditionDocument = {
  __typename?: 'ConditionDocument';
  category?: Maybe<Scalars['String']['output']>;
  condition: Condition;
  condition_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  file: Scalars['AWSFile']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ConditionDocumentOrderInput = {
  condition_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConditionDocumentQueryInput = {
  filter?: InputMaybe<ConditionDocumentWhereInput>;
  orderBy?: InputMaybe<ConditionDocumentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ConditionDocumentSearchInput>;
};

export type ConditionDocumentSearchInput = {
  condition_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConditionDocumentWhereInput = {
  condition_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConditionOrderInput = {
  condition_type?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConditionQueryInput = {
  filter?: InputMaybe<ConditionWhereInput>;
  orderBy?: InputMaybe<ConditionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ConditionSearchInput>;
};

export type ConditionSearchInput = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  condition_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayable_only?: InputMaybe<Scalars['Boolean']['input']>;
  expiring_conditions?: InputMaybe<Expiring_Conditions_Input>;
  for_w2_on_boarding_only?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  missing_conditions?: InputMaybe<Missing_Conditions_Input>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  professional_can_view?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  required_conditions?: InputMaybe<Required_Conditions_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ConditionWhereInput = {
  condition_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum ContextField {
  AccountId = 'ACCOUNT_ID',
  AgencyId = 'AGENCY_ID',
  ProfessionalId = 'PROFESSIONAL_ID'
}

export type Contract = {
  __typename?: 'Contract';
  administrator_id?: Maybe<Scalars['Int']['output']>;
  assignment_id: Scalars['Int']['output'];
  contract_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  document_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  professional_id?: Maybe<Scalars['Int']['output']>;
  signed_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
  upload?: Maybe<Scalars['AWSFile']['output']>;
};

export type ContractLengthInWeeksInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min: Scalars['Int']['input'];
};

export type ContractOrderInput = {
  administrator_id?: InputMaybe<Scalars['Boolean']['input']>;
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  contract_type?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  document_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractQueryInput = {
  filter?: InputMaybe<ContractWhereInput>;
  orderBy?: InputMaybe<ProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ContractRangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractWhereInput = {
  administrator_id?: InputMaybe<Scalars['Int']['input']>;
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  contract_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  document_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  signed_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type CoordinatesInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export enum CoverageNeed {
  Emergency = 'emergency',
  Other = 'other',
  PrimaryCare = 'primary_care',
  SpecialtyCare = 'specialty_care'
}

export type CredentialRejectedReason = {
  __typename?: 'CredentialRejectedReason';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CredentialRejectedReasonOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialRejectedReasonQueryInput = {
  filter?: InputMaybe<CredentialRejectedReasonWhereInput>;
  orderBy?: InputMaybe<CredentialRejectedReasonOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type CredentialRejectedReasonWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreditNote = {
  __typename?: 'CreditNote';
  amount_cents: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  statement: Statement;
  stripe_invoice_item_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type CreditNoteOrderInput = {
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  memo?: InputMaybe<Scalars['Boolean']['input']>;
  statement_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_invoice_item_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreditNoteQueryInput = {
  filter?: InputMaybe<CreditNoteWhereInput>;
  orderBy?: InputMaybe<CreditNoteOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type CreditNoteWhereInput = {
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  memo?: InputMaybe<Scalars['String']['input']>;
  statement_id?: InputMaybe<Scalars['Int']['input']>;
  stripe_invoice_item_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurrentDataOrderInput = {
  facilityRate?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomProfessionalProfileEhrSystem = {
  __typename?: 'CustomProfessionalProfileEhrSystem';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  professional_profile: ProfessionalProfile;
  professional_profile_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CustomProfessionalProfileEhrSystemOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomProfessionalProfileEhrSystemQueryInput = {
  filter?: InputMaybe<CustomProfessionalProfileEhrSystemWhereInput>;
  orderBy?: InputMaybe<ProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type CustomProfessionalProfileEhrSystemWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  booked_assignments_count?: Maybe<Scalars['Int']['output']>;
  booked_jobs_count?: Maybe<Scalars['Int']['output']>;
  offers_count?: Maybe<Scalars['Int']['output']>;
  pending_applications_count?: Maybe<Scalars['Int']['output']>;
  professional_account_id?: Maybe<Scalars['Int']['output']>;
  requested_jobs_count?: Maybe<Scalars['Int']['output']>;
};

export type DataTest = {
  __typename?: 'DataTest';
  created_at: Scalars['DateTime']['output'];
  entity_id: Scalars['Int']['output'];
  entity_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type DataTestOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataTestQueryInput = {
  filter?: InputMaybe<DataTestWhereInput>;
  orderBy?: InputMaybe<DataTestOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DataTestSearchInput>;
};

export type DataTestSearchInput = {
  entity_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
};

export type DataTestWhereInput = {
  entity_type?: InputMaybe<Scalars['String']['input']>;
};

export type DateRangeInput = {
  from: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
};

export enum DecisionOption {
  DormantMarket = 'dormant_market',
  LowIncrementalityMarket = 'low_incrementality_market',
  Prioritize = 'prioritize',
  UnavailableMarket = 'unavailable_market'
}

export type DefaultSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type DeprecatedInvoice = {
  __typename?: 'DeprecatedInvoice';
  approved_clock_in?: Maybe<Scalars['DateTime']['output']>;
  approved_clock_out?: Maybe<Scalars['DateTime']['output']>;
  assignment?: Maybe<Assignment>;
  charge_total_cents?: Maybe<Scalars['Int']['output']>;
  charge_total_currency: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deprecatedInvoiceable?: Maybe<DeprecatedInvoiceable>;
  deprecatedInvoiceable_type?: Maybe<Scalars['String']['output']>;
  fee_cents: Scalars['Int']['output'];
  hours_double?: Maybe<Scalars['String']['output']>;
  hours_normal?: Maybe<Scalars['String']['output']>;
  hours_time_half?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceable_id?: Maybe<Scalars['Int']['output']>;
  job?: Maybe<Job>;
  notes?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  pause: Scalars['Boolean']['output'];
  pause_professional_transfer?: Maybe<Scalars['Boolean']['output']>;
  payout?: Maybe<Payout>;
  professional?: Maybe<Professional>;
  refunds?: Maybe<Array<Refund>>;
  starts_date?: Maybe<Scalars['DateTime']['output']>;
  statement?: Maybe<Statement>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_charge_id?: Maybe<Scalars['String']['output']>;
  stripe_deprecated_deprecatedInvoice_item_id?: Maybe<Scalars['String']['output']>;
  stripe_transfer_id?: Maybe<Scalars['String']['output']>;
  timecard?: Maybe<Timecard>;
  total_hours?: Maybe<Scalars['Float']['output']>;
  transfer_reversals?: Maybe<Array<TransferReversal>>;
  transfer_total_cents?: Maybe<Scalars['Int']['output']>;
  transfer_total_currency: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type DeprecatedInvoiceOrderInput = {
  approved_clock_in?: InputMaybe<Scalars['Boolean']['input']>;
  approved_clock_out?: InputMaybe<Scalars['Boolean']['input']>;
  charge_total_cents?: InputMaybe<Scalars['Boolean']['input']>;
  charge_total_currency?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  deprecatedInvoiceable_type?: InputMaybe<Scalars['Boolean']['input']>;
  fee_cents?: InputMaybe<Scalars['Boolean']['input']>;
  hours_double?: InputMaybe<Scalars['Boolean']['input']>;
  hours_normal?: InputMaybe<Scalars['Boolean']['input']>;
  hours_time_half?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceable_id?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  pause_professional_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  payout_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  starts_date?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_charge_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_deprecated_deprecatedInvoice_item_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_transfer_id?: InputMaybe<Scalars['Boolean']['input']>;
  total_hours_?: InputMaybe<Scalars['Boolean']['input']>;
  transfer_total_cents?: InputMaybe<Scalars['Boolean']['input']>;
  transfer_total_currency?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeprecatedInvoiceQueryInput = {
  filter?: InputMaybe<DeprecatedInvoiceWhereInput>;
  orderBy?: InputMaybe<DeprecatedInvoiceOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DeprecatedInvoiceSearchInput>;
};

export enum DeprecatedInvoiceSearchByInput {
  DeprecatedInvoices = 'deprecatedInvoices',
  Jobs = 'jobs',
  Professionals = 'professionals',
  Users = 'users'
}

export type DeprecatedInvoiceSearchInput = {
  ends_date?: InputMaybe<Scalars['Date']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  search_by?: InputMaybe<DeprecatedInvoiceSearchByInput>;
  starts_date?: InputMaybe<Scalars['Date']['input']>;
};

export type DeprecatedInvoiceWhereInput = {
  approved_clock_in?: InputMaybe<Scalars['DateTime']['input']>;
  approved_clock_out?: InputMaybe<Scalars['DateTime']['input']>;
  charge_total_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_total_currency?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deprecatedInvoiceable_type?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  hours_double?: InputMaybe<Scalars['String']['input']>;
  hours_normal?: InputMaybe<Scalars['String']['input']>;
  hours_time_half?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoiceable_id?: InputMaybe<Scalars['Int']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  pause_professional_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  payout_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  starts_date?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripe_charge_id?: InputMaybe<Scalars['String']['input']>;
  stripe_deprecated_deprecatedInvoice_item_id?: InputMaybe<Scalars['String']['input']>;
  stripe_transfer_id?: InputMaybe<Scalars['String']['input']>;
  total_hours_?: InputMaybe<Scalars['Float']['input']>;
  transfer_total_cents?: InputMaybe<Scalars['Int']['input']>;
  transfer_total_currency?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type DeprecatedInvoiceable = Job | Timecard;

export type DisabledReason = {
  __typename?: 'DisabledReason';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DisabledReasonOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  display_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  person_type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisabledReasonQueryInput = {
  filter?: InputMaybe<DisabledReasonWhereInput>;
  orderBy?: InputMaybe<DisabledReasonOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type DisabledReasonWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  person_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Dispute = {
  __typename?: 'Dispute';
  adjusted_clock_in?: Maybe<Scalars['DateTime']['output']>;
  adjusted_clock_out?: Maybe<Scalars['DateTime']['output']>;
  adjusted_meal_break_minutes?: Maybe<Scalars['Int']['output']>;
  adjusted_total_payout_cents?: Maybe<Scalars['Int']['output']>;
  admin_notes?: Maybe<Scalars['String']['output']>;
  assigned_to?: Maybe<Administrator>;
  assigned_to_id?: Maybe<Scalars['Int']['output']>;
  attachment?: Maybe<Scalars['AWSFile']['output']>;
  category: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  expense_adjustments?: Maybe<Array<ExpenseAdjustment>>;
  facility_notes: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invoice?: Maybe<Invoice>;
  invoice_id?: Maybe<Scalars['Int']['output']>;
  job?: Maybe<Job>;
  job_id?: Maybe<Scalars['Int']['output']>;
  original_clock_in?: Maybe<Scalars['DateTime']['output']>;
  original_clock_out?: Maybe<Scalars['DateTime']['output']>;
  original_meal_break_minutes?: Maybe<Scalars['Int']['output']>;
  original_total_payout_cents?: Maybe<Scalars['Int']['output']>;
  professional_notes?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  resolution?: Maybe<Scalars['String']['output']>;
  revenue_adjustments?: Maybe<Array<RevenueAdjustment>>;
  status: Scalars['String']['output'];
  total_adjusted_minutes?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type DisputeOrderInput = {
  adjusted_clock_in?: InputMaybe<Scalars['Boolean']['input']>;
  adjusted_clock_out?: InputMaybe<Scalars['Boolean']['input']>;
  adjusted_meal_break_minutes?: InputMaybe<Scalars['Boolean']['input']>;
  adjusted_total_payout_cents?: InputMaybe<Scalars['Boolean']['input']>;
  admin_notes?: InputMaybe<Scalars['Boolean']['input']>;
  assigned_to_id?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  facility_notes?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  original_clock_in?: InputMaybe<Scalars['Boolean']['input']>;
  original_clock_out?: InputMaybe<Scalars['Boolean']['input']>;
  original_meal_break_minutes?: InputMaybe<Scalars['Boolean']['input']>;
  original_total_payout_cents?: InputMaybe<Scalars['Boolean']['input']>;
  professional_notes?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['Boolean']['input']>;
  resolution?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_adjusted_minutes?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisputeQueryInput = {
  filter?: InputMaybe<DisputeWhereInput>;
  orderBy?: InputMaybe<DisputeOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DisputeSearchInput>;
};

export type DisputeSearchInput = {
  adjusted_clock_in?: InputMaybe<Scalars['DateTime']['input']>;
  adjusted_clock_out?: InputMaybe<Scalars['DateTime']['input']>;
  adjusted_meal_break_minutes?: InputMaybe<Scalars['Int']['input']>;
  adjusted_total_payout_cents?: InputMaybe<Scalars['Int']['input']>;
  admin_notes?: InputMaybe<Scalars['String']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  facility_notes?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  original_clock_in?: InputMaybe<Scalars['DateTime']['input']>;
  original_clock_out?: InputMaybe<Scalars['DateTime']['input']>;
  original_meal_break_minutes?: InputMaybe<Scalars['Int']['input']>;
  original_total_payout_cents?: InputMaybe<Scalars['Int']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  total_adjusted_minutes?: InputMaybe<Scalars['Int']['input']>;
};

export type DisputeShiftWitness = {
  __typename?: 'DisputeShiftWitness';
  created_at: Scalars['DateTime']['output'];
  dispute?: Maybe<Dispute>;
  dispute_id: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type DisputeShiftWitnessOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  dispute_id?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisputeShiftWitnessQueryInput = {
  filter?: InputMaybe<DisputeShiftWitnessWhereInput>;
  orderBy?: InputMaybe<DisputeShiftWitnessOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DisputeShiftWitnessSearchInput>;
};

export type DisputeShiftWitnessSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type DisputeShiftWitnessWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  dispute_id?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DisputeWhereInput = {
  adjusted_clock_in?: InputMaybe<Scalars['DateTime']['input']>;
  adjusted_clock_out?: InputMaybe<Scalars['DateTime']['input']>;
  adjusted_meal_break_minutes?: InputMaybe<Scalars['Int']['input']>;
  adjusted_total_payout_cents?: InputMaybe<Scalars['Int']['input']>;
  admin_notes?: InputMaybe<Scalars['String']['input']>;
  assigned_to_id?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  facility_notes?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  original_clock_in?: InputMaybe<Scalars['DateTime']['input']>;
  original_clock_out?: InputMaybe<Scalars['DateTime']['input']>;
  original_meal_break_minutes?: InputMaybe<Scalars['Int']['input']>;
  original_total_payout_cents?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tax_type?: InputMaybe<Scalars['String']['input']>;
  total_adjusted_minutes?: InputMaybe<Scalars['Int']['input']>;
};

export type DisputedJobBilling = {
  __typename?: 'DisputedJobBilling';
  created_at: Scalars['DateTime']['output'];
  dispute: Dispute;
  dispute_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  job_billing_id: Scalars['Int']['output'];
  job_irregularity?: Maybe<JobIrregularity>;
  job_irregularity_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type DisputedJobBillingOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  dispute_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_billing_id?: InputMaybe<Scalars['Boolean']['input']>;
  job_irregularity_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisputedJobBillingQueryInput = {
  filter?: InputMaybe<DisputedJobBillingWhereInput>;
  orderBy?: InputMaybe<DisputedJobBillingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DisputedJobBillingSearchInput>;
};

export type DisputedJobBillingSearchInput = {
  job_billing_id?: InputMaybe<Scalars['Int']['input']>;
};

export type DisputedJobBillingWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_billing_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DistanceCheckInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
};

export type DistanceRadiusFilterInput = {
  coordinates?: InputMaybe<Array<InputMaybe<CoordinatesInput>>>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};

export type Education = {
  __typename?: 'Education';
  city?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  degree_type?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  field_of_study?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  school_name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type EducationOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  degree_type?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['Boolean']['input']>;
  field_of_study?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  school_name?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducationQueryInput = {
  filter?: InputMaybe<EducationWhereInput>;
  orderBy?: InputMaybe<EducationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<EducationSearchInput>;
};

export type EducationSearchInput = {
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
};

export type EducationWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  degree_type?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  field_of_study?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  school_name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EhrSystem = {
  __typename?: 'EhrSystem';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  maestro_identifier: Scalars['JSON']['output'];
  medefis_identifier?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type EhrSystemOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EhrSystemQueryInput = {
  filter?: InputMaybe<EhrSystemWhereInput>;
  orderBy?: InputMaybe<EhrSystemOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<EhrSystemSearchInput>;
};

export type EhrSystemSearchInput = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export type EhrSystemWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
};

export type EmergencyContactOrderInput = {
  first_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmergencyContactQueryInput = {
  filter?: InputMaybe<EmergencyContactWhereInput>;
  orderBy?: InputMaybe<EmergencyContactOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<EmergencyContactSearchInput>;
};

export type EmergencyContactSearchInput = {
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type EmergencyContactWhereInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ExpenseAdjustment = {
  __typename?: 'ExpenseAdjustment';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  balance_sheet?: Maybe<BalanceSheet>;
  balance_sheet_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dispute?: Maybe<Dispute>;
  dispute_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  job?: Maybe<Job>;
  job_id?: Maybe<Scalars['Int']['output']>;
  make_payable_at?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  past_month_adjustment: Scalars['Boolean']['output'];
  payout?: Maybe<Payout>;
  payout_id?: Maybe<Scalars['Int']['output']>;
  primary_adjustment: Scalars['Boolean']['output'];
  taxable_type?: Maybe<Scalars['String']['output']>;
  timecard?: Maybe<Timecard>;
  updated_at: Scalars['DateTime']['output'];
};

export type ExpenseAdjustmentOrderInput = {
  balance_sheet_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  payout_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExpenseAdjustmentQueryInput = {
  filter?: InputMaybe<ExpenseAdjustmentWhereInput>;
  orderBy?: InputMaybe<ExpenseAdjustmentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ExpenseAdjustmentSearchInput>;
};

export type ExpenseAdjustmentSearchInput = {
  balance_sheet_id?: InputMaybe<Scalars['Int']['input']>;
  dispute_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  past_month_adjustment?: InputMaybe<Scalars['Boolean']['input']>;
  payout_id?: InputMaybe<Scalars['Int']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  taxable_type?: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseAdjustmentWhereInput = {
  balance_sheet_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  dispute_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  past_month_adjustment?: InputMaybe<Scalars['Boolean']['input']>;
  payout_id?: InputMaybe<Scalars['Int']['input']>;
  taxable_type?: InputMaybe<Scalars['String']['input']>;
  timecard_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExperienceInput = {
  calculated_months_of_experience: Scalars['Int']['input'];
  position_ids: Array<Scalars['Int']['input']>;
  years_of_experience: Scalars['Int']['input'];
};

export type ExternalAccount = {
  __typename?: 'ExternalAccount';
  account_type?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  exp_month?: Maybe<Scalars['Int']['output']>;
  exp_year?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  instant_pay_eligible?: Maybe<Scalars['Boolean']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  stripe_account?: Maybe<StripeAccount>;
  stripe_account_id?: Maybe<Scalars['Int']['output']>;
  stripe_id: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ExternalAccountOrderInput = {
  account_type?: InputMaybe<Scalars['Boolean']['input']>;
  bank_name?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  exp_month?: InputMaybe<Scalars['Boolean']['input']>;
  exp_year?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  instant_pay_eligible?: InputMaybe<Scalars['Boolean']['input']>;
  last4?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_account_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalAccountQueryInput = {
  filter?: InputMaybe<ExternalAccountWhereInput>;
  orderBy?: InputMaybe<ExternalAccountOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ExternalAccountSearchInput>;
};

export type ExternalAccountSearchInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalAccountWhereInput = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  exp_month?: InputMaybe<Scalars['Int']['input']>;
  exp_year?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  instant_pay_eligible?: InputMaybe<Scalars['Boolean']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
  stripe_account_id?: InputMaybe<Scalars['Int']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FacilityConnection = {
  __typename?: 'FacilityConnection';
  created_at: Scalars['DateTime']['output'];
  facility?: Maybe<User>;
  facility_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type FacilityConnectionOrderInput = {
  facility_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FacilityConnectionQueryInput = {
  filter?: InputMaybe<FacilityConnectionWhereInput>;
  orderBy?: InputMaybe<ProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type FacilityConnectionWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  facility_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type FacilityManagedAgency = {
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type FavoritesPanelRow = {
  __typename?: 'FavoritesPanelRow';
  is_blocked: Scalars['Boolean']['output'];
  is_favorited: Scalars['Boolean']['output'];
  job_id: Scalars['Int']['output'];
  location_id: Scalars['Int']['output'];
  location_name: Scalars['String']['output'];
  positions: Array<Position>;
  professional_id: Scalars['Int']['output'];
  professional_name: Scalars['String']['output'];
  starts_date: Scalars['Date']['output'];
  starts_time: Scalars['DateTime']['output'];
};

export type FinancialTransaction = {
  __typename?: 'FinancialTransaction';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  amount_left_cents: Scalars['Int']['output'];
  amount_left_currency: Scalars['String']['output'];
  balance_sheet?: Maybe<BalanceSheet>;
  balance_sheet_id?: Maybe<Scalars['Int']['output']>;
  billing_group?: Maybe<BillingGroup>;
  billing_group_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  data_source: Scalars['String']['output'];
  facility_notes?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemized_transactions?: Maybe<Array<ItemizedTransaction>>;
  kind?: Maybe<Scalars['String']['output']>;
  original_financial_transaction_id?: Maybe<Scalars['Int']['output']>;
  revenue_date: Scalars['DateTime']['output'];
  transaction_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
  yaypay_external_id?: Maybe<Scalars['String']['output']>;
};

export type FinancialTransactionOrderInput = {
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  amount_left_cents?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  original_financial_transaction_id?: InputMaybe<Scalars['Boolean']['input']>;
  transaction_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTransactionQueryInput = {
  filter?: InputMaybe<FinancialTransactionWhereInput>;
  orderBy?: InputMaybe<FinancialTransactionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<FinancialTransactionSearchInput>;
};

export type FinancialTransactionSearchInput = {
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_left_cents?: InputMaybe<Scalars['Int']['input']>;
  balance_sheet_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  can_refund?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  ends_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  original_financial_transaction_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  starts_date?: InputMaybe<Scalars['Date']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
  unapplied?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTransactionWhereInput = {
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_currency?: InputMaybe<Scalars['String']['input']>;
  amount_left_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_left_currency?: InputMaybe<Scalars['String']['input']>;
  balance_sheet_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  original_financial_transaction_id?: InputMaybe<Scalars['Int']['input']>;
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};

export type ForLocations = {
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  for_job?: InputMaybe<Scalars['Boolean']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ForLocationsJobsInput = {
  location_ids: Array<Scalars['Int']['input']>;
};

export type ForPositionLocations = {
  for_job?: InputMaybe<Scalars['Boolean']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type ForTimeTrackingInput = {
  ends_time?: InputMaybe<Scalars['DateTime']['input']>;
  for_type?: InputMaybe<ForTimeTrackingInputType>;
  location_ids: Array<InputMaybe<Scalars['Int']['input']>>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ForTimeTrackingInputType {
  AssignmentShift = 'assignment_shift',
  PerDiem = 'per_diem'
}

export type FundingSource = {
  __typename?: 'FundingSource';
  account_type?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  billing_group?: Maybe<BillingGroup>;
  brand?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  exp_month?: Maybe<Scalars['Int']['output']>;
  exp_year?: Maybe<Scalars['Int']['output']>;
  hosted_verification_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instant_pay_eligible: Scalars['Boolean']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  personable?: Maybe<Personable>;
  personable_id?: Maybe<Scalars['Int']['output']>;
  personable_type?: Maybe<Scalars['String']['output']>;
  professional?: Maybe<Professional>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type FundingSourceOrderInput = {
  account_type?: InputMaybe<Scalars['Boolean']['input']>;
  bank_name?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  exp_month?: InputMaybe<Scalars['Boolean']['input']>;
  exp_year?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last4?: InputMaybe<Scalars['Boolean']['input']>;
  personable_id?: InputMaybe<Scalars['Boolean']['input']>;
  personable_type?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FundingSourceQueryInput = {
  filter?: InputMaybe<FundingSourceWhereInput>;
  orderBy?: InputMaybe<FundingSourceOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type FundingSourceWhereInput = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  exp_month?: InputMaybe<Scalars['Int']['input']>;
  exp_year?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last4?: InputMaybe<Scalars['String']['input']>;
  personable_id?: InputMaybe<Scalars['Int']['input']>;
  personable_type?: InputMaybe<Scalars['String']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetBlockedTimesInput = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  is_w2?: InputMaybe<Scalars['Int']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  job_times: Job_Time_Ranges;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  professional_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type HealthSystem = {
  __typename?: 'HealthSystem';
  companies?: Maybe<Array<Company>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users?: Maybe<Array<User>>;
};

export type HealthSystemOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HealthSystemQueryInput = {
  filter?: InputMaybe<HealthSystemWhereInput>;
  orderBy?: InputMaybe<HealthSystemOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type HealthSystemWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HospitalMarkUp = {
  __typename?: 'HospitalMarkUp';
  location_type_markup?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<State>>;
};

export type InterviewAvailability = {
  __typename?: 'InterviewAvailability';
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  start?: Maybe<Scalars['DateTime']['output']>;
  starts_time?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type InterviewAvailabilityOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  starts_time?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InterviewAvailabilityQueryInput = {
  filter?: InputMaybe<InterviewAvailabilityWhereInput>;
  orderBy?: InputMaybe<InterviewAvailabilityOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<InterviewAvailabilitySearchInput>;
};

export type InterviewAvailabilitySearchInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  start_gte?: InputMaybe<Scalars['DateTime']['input']>;
  start_lte?: InputMaybe<Scalars['DateTime']['input']>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type InterviewAvailabilityWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  agency_id?: Maybe<Scalars['Int']['output']>;
  amount_due_cents?: Maybe<Scalars['Int']['output']>;
  assignment?: Maybe<Assignment>;
  assignment_id?: Maybe<Scalars['Int']['output']>;
  balance_cents: Scalars['Int']['output'];
  balance_currency: Scalars['String']['output'];
  billing_group?: Maybe<BillingGroup>;
  billing_group_id?: Maybe<Scalars['Int']['output']>;
  billing_id?: Maybe<Scalars['String']['output']>;
  child_invoice_links?: Maybe<Array<InvoicesLink>>;
  created_at: Scalars['DateTime']['output'];
  days_late?: Maybe<Scalars['Int']['output']>;
  disputes?: Maybe<Array<Dispute>>;
  due_date?: Maybe<Scalars['Date']['output']>;
  ends_time?: Maybe<Scalars['DateTime']['output']>;
  failed_count?: Maybe<Scalars['Int']['output']>;
  failed_reason?: Maybe<Scalars['String']['output']>;
  fee_percent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  invoice_locked_balance_sheet_id?: Maybe<Scalars['Int']['output']>;
  invoice_paid_balance_sheet_id?: Maybe<Scalars['Int']['output']>;
  invoice_type?: Maybe<Scalars['String']['output']>;
  itemized_transactions?: Maybe<Array<ItemizedTransaction>>;
  job_count?: Maybe<Scalars['Int']['output']>;
  jobs?: Maybe<Array<Job>>;
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  paid_date?: Maybe<Scalars['DateTime']['output']>;
  parent_invoice_links?: Maybe<Array<InvoicesLink>>;
  processing_fee_cents: Scalars['Int']['output'];
  processing_fee_currency: Scalars['String']['output'];
  processing_fee_stripe_invoice_item_id?: Maybe<Scalars['String']['output']>;
  revenue_adjustments?: Maybe<Array<RevenueAdjustment>>;
  starts_time: Scalars['DateTime']['output'];
  statement?: Maybe<Statement>;
  statement_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_invoice_id?: Maybe<Scalars['String']['output']>;
  stripe_invoice_number?: Maybe<Scalars['String']['output']>;
  stripe_invoice_url?: Maybe<Scalars['String']['output']>;
  stripe_payment_intents?: Maybe<Array<StripePaymentIntent>>;
  sub_total_cents: Scalars['Int']['output'];
  sub_total_currency: Scalars['String']['output'];
  timecard_ids?: Maybe<Array<Scalars['Int']['output']>>;
  total_breaks_hours?: Maybe<Scalars['Float']['output']>;
  total_callback_hours?: Maybe<Scalars['Float']['output']>;
  total_cents: Scalars['Int']['output'];
  total_currency: Scalars['String']['output'];
  total_double_hours?: Maybe<Scalars['Float']['output']>;
  total_hours?: Maybe<Scalars['Float']['output']>;
  total_on_call_hours?: Maybe<Scalars['Float']['output']>;
  total_overtime_hours?: Maybe<Scalars['Float']['output']>;
  total_regular_hours?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
  voucher_id?: Maybe<Scalars['String']['output']>;
  voucher_processing_status?: Maybe<Scalars['String']['output']>;
};

export type InvoiceOrderInput = {
  approved_clock_in?: InputMaybe<Scalars['Boolean']['input']>;
  approved_clock_out?: InputMaybe<Scalars['Boolean']['input']>;
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  charge_total_cents?: InputMaybe<Scalars['Boolean']['input']>;
  charge_total_currency?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  due_date?: InputMaybe<Scalars['Boolean']['input']>;
  ends_time?: InputMaybe<Scalars['Boolean']['input']>;
  failed_count?: InputMaybe<Scalars['Boolean']['input']>;
  failed_reason?: InputMaybe<Scalars['Boolean']['input']>;
  fee_cents?: InputMaybe<Scalars['Boolean']['input']>;
  hours_double?: InputMaybe<Scalars['Boolean']['input']>;
  hours_normal?: InputMaybe<Scalars['Boolean']['input']>;
  hours_time_half?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceable_id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceable_type?: InputMaybe<Scalars['Boolean']['input']>;
  market?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  pause_professional_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  starts_time?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_charge_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_invoice_item_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_transfer_id?: InputMaybe<Scalars['Boolean']['input']>;
  total_cents?: InputMaybe<Scalars['Boolean']['input']>;
  total_hours_?: InputMaybe<Scalars['Boolean']['input']>;
  transfer_total_cents?: InputMaybe<Scalars['Boolean']['input']>;
  transfer_total_currency?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceQueryInput = {
  filter?: InputMaybe<InvoiceWhereInput>;
  orderBy?: InputMaybe<InvoiceOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<InvoiceSearchInput>;
};

export enum InvoiceSearchByInput {
  Invoices = 'invoices',
  Jobs = 'jobs',
  Professionals = 'professionals',
  Users = 'users'
}

export type InvoiceSearchInput = {
  account_manager_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  billing_group_uid?: InputMaybe<Scalars['String']['input']>;
  billing_id?: InputMaybe<Scalars['String']['input']>;
  days_late?: InputMaybe<Scalars['Int']['input']>;
  ends_date?: InputMaybe<Scalars['Date']['input']>;
  ends_time?: InputMaybe<Scalars['Date']['input']>;
  failed_payments?: InputMaybe<Scalars['Boolean']['input']>;
  failing_payments?: InputMaybe<Scalars['Boolean']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  hide_locked?: InputMaybe<Scalars['Boolean']['input']>;
  hide_zero_value_invoices?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_type?: InputMaybe<Scalars['String']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  no_breaks?: InputMaybe<Scalars['Boolean']['input']>;
  open_payment_gateway?: InputMaybe<Scalars['Boolean']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  search_by?: InputMaybe<InvoiceSearchByInput>;
  starts_date?: InputMaybe<Scalars['Date']['input']>;
  starts_time?: InputMaybe<Scalars['Date']['input']>;
  statement_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  total_cents?: InputMaybe<Scalars['Int']['input']>;
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  voucher_id?: InputMaybe<Scalars['String']['input']>;
};

export enum InvoiceStatus {
  Approved = 'approved',
  Disputed = 'disputed',
  Due = 'due',
  Paid = 'paid',
  PastDue = 'past_due',
  Pending = 'pending',
  Void = 'void'
}

export type InvoiceStatusBillingGroupCountsInput = {
  billing_group_ids: Array<Scalars['Int']['input']>;
  statuses: Array<InvoiceStatus>;
};

export type InvoiceStatusBillingGroupCountsResult = {
  __typename?: 'InvoiceStatusBillingGroupCountsResult';
  billing_group_id: Scalars['Int']['output'];
  invoice_count: Scalars['Int']['output'];
};

export type InvoiceWhereInput = {
  approved_clock_in?: InputMaybe<Scalars['DateTime']['input']>;
  approved_clock_out?: InputMaybe<Scalars['DateTime']['input']>;
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  billing_id?: InputMaybe<Scalars['String']['input']>;
  charge_total_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_total_currency?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  ends_time?: InputMaybe<Scalars['Date']['input']>;
  failed_count?: InputMaybe<Scalars['Int']['input']>;
  failed_reason?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  hours_double?: InputMaybe<Scalars['String']['input']>;
  hours_normal?: InputMaybe<Scalars['String']['input']>;
  hours_time_half?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_type?: InputMaybe<Scalars['String']['input']>;
  invoiceable_id?: InputMaybe<Scalars['Int']['input']>;
  invoiceable_type?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  pause_professional_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  starts_time?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  statement_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_charge_id?: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_item_id?: InputMaybe<Scalars['String']['input']>;
  stripe_transfer_id?: InputMaybe<Scalars['String']['input']>;
  timecard_id?: InputMaybe<Scalars['Int']['input']>;
  total_cents?: InputMaybe<Scalars['Int']['input']>;
  total_hours_?: InputMaybe<Scalars['Float']['input']>;
  transfer_total_cents?: InputMaybe<Scalars['Int']['input']>;
  transfer_total_currency?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  voucher_id?: InputMaybe<Scalars['String']['input']>;
};

export type Invoiceable = Job | Timecard;

export type InvoicesLink = {
  __typename?: 'InvoicesLink';
  child_invoice_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  parent_invoice_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type InvoicesTotals = {
  __typename?: 'InvoicesTotals';
  filtered_breaks_hours?: Maybe<Scalars['Float']['output']>;
  filtered_callback_hours?: Maybe<Scalars['Float']['output']>;
  filtered_double_hours?: Maybe<Scalars['Float']['output']>;
  filtered_on_call_hours?: Maybe<Scalars['Float']['output']>;
  filtered_overtime_hours?: Maybe<Scalars['Float']['output']>;
  filtered_regular_hours?: Maybe<Scalars['Float']['output']>;
  filtered_total_hours?: Maybe<Scalars['Float']['output']>;
};

export type ItemizedTransaction = {
  __typename?: 'ItemizedTransaction';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  balance_sheet_id: Scalars['Int']['output'];
  billing_group_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  financial_transaction?: Maybe<FinancialTransaction>;
  financial_transaction_id?: Maybe<Scalars['Int']['output']>;
  from_source?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoice?: Maybe<Invoice>;
  invoice_id?: Maybe<Scalars['Int']['output']>;
  labels?: Maybe<Scalars['JSON']['output']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reversed_itemized_transaction_id?: Maybe<Scalars['Int']['output']>;
  to_source?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ItemizedTransactionOrderInput = {
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  financial_transaction_id?: InputMaybe<Scalars['Boolean']['input']>;
  from_source?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemizedTransactionQueryInput = {
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ItemizedTransactionWhereInput>;
  orderBy?: InputMaybe<ItemizedTransactionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ItemizedTransactionSearchInput>;
};

export type ItemizedTransactionSearchInput = {
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_currency?: InputMaybe<Scalars['String']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  financial_transaction_id?: InputMaybe<Scalars['Int']['input']>;
  from_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  to_source?: InputMaybe<Scalars['String']['input']>;
};

export type ItemizedTransactionWhereInput = {
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_currency?: InputMaybe<Scalars['String']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  financial_transaction_id?: InputMaybe<Scalars['Int']['input']>;
  from_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  to_source?: InputMaybe<Scalars['String']['input']>;
};

export type Job = {
  __typename?: 'Job';
  active_job_profile?: Maybe<JobProfile>;
  adjust_rate_calculator?: Maybe<Scalars['Boolean']['output']>;
  admin_notes?: Maybe<Scalars['String']['output']>;
  agency_enabled: Scalars['Boolean']['output'];
  agency_job_profile?: Maybe<JobProfile>;
  agency_requested_by_facility: Scalars['Boolean']['output'];
  agency_vms_fee_percent?: Maybe<Scalars['Float']['output']>;
  approval_requestee_notes?: Maybe<Scalars['String']['output']>;
  approval_status?: Maybe<ApprovalStatus>;
  approval_violated_parameters?: Maybe<Scalars['JSON']['output']>;
  approvals: Array<Approval>;
  approved_clock_in?: Maybe<Scalars['DateTime']['output']>;
  approved_clock_out?: Maybe<Scalars['DateTime']['output']>;
  assignment?: Maybe<Assignment>;
  assignment_id?: Maybe<Scalars['Int']['output']>;
  attachment?: Maybe<Scalars['AWSFile']['output']>;
  available_for_agency_to_book_non_favorites: Scalars['Boolean']['output'];
  available_professional_count?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use plural balance_sheets */
  balance_sheet?: Maybe<BalanceSheet>;
  balance_sheets?: Maybe<Array<BalanceSheet>>;
  billing_group?: Maybe<BillingGroup>;
  billing_group_id?: Maybe<Scalars['Int']['output']>;
  bonus_one_time?: Maybe<Scalars['Int']['output']>;
  bonus_one_time_cents?: Maybe<Scalars['Int']['output']>;
  bonus_one_time_cents_for_account_id?: Maybe<Scalars['Int']['output']>;
  bonus_one_time_payout?: Maybe<Scalars['Int']['output']>;
  bonus_one_time_payout_cents?: Maybe<Scalars['Int']['output']>;
  booked_at?: Maybe<Scalars['DateTime']['output']>;
  breaks?: Maybe<Array<Break>>;
  callback_ends_time?: Maybe<Scalars['DateTime']['output']>;
  callback_starts_time?: Maybe<Scalars['DateTime']['output']>;
  can_book_job?: Maybe<Scalars['Boolean']['output']>;
  canceled_by_location?: Maybe<Scalars['Boolean']['output']>;
  canceled_by_professional?: Maybe<Scalars['Boolean']['output']>;
  cancellation_fee_charge_hours?: Maybe<Scalars['Int']['output']>;
  cancellation_fee_window?: Maybe<Scalars['Int']['output']>;
  cancellation_reason_id?: Maybe<Scalars['Int']['output']>;
  charge_base_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  charge_base_hourly_rate_currency: Scalars['String']['output'];
  charge_bonus_cents?: Maybe<Scalars['Int']['output']>;
  charge_callback_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_max_daily_ot_hours: Scalars['Int']['output'];
  charge_max_daily_regular_hours: Scalars['Int']['output'];
  charge_max_weekly_regular_hours: Scalars['Int']['output'];
  charge_on_call_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  charge_on_call_hourly_rate_currency: Scalars['String']['output'];
  charge_overtime_frequency?: Maybe<Scalars['String']['output']>;
  charge_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  check_ins?: Maybe<Array<CheckIn>>;
  check_outs?: Maybe<Array<CheckOut>>;
  cleared_no_show: Scalars['Boolean']['output'];
  clinical_contact?: Maybe<Account>;
  clinical_contact_account_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated not currently populated, use location object */
  clock_in_early_window?: Maybe<Scalars['Int']['output']>;
  /** @deprecated to be removed in favor of maximum_late_clock_out_grace_period_minutes */
  clock_out_late_window?: Maybe<Scalars['Int']['output']>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  condition_ids?: Maybe<Array<Scalars['Int']['output']>>;
  covid_care: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Account>;
  created_by_account_id?: Maybe<Scalars['Int']['output']>;
  current_ends_time?: Maybe<Scalars['DateTime']['output']>;
  current_starts_time?: Maybe<Scalars['DateTime']['output']>;
  custom_onboarding_docs?: Maybe<Array<Maybe<ConditionDocument>>>;
  detail?: Maybe<Scalars['String']['output']>;
  did_user_modify_time?: Maybe<Scalars['Boolean']['output']>;
  direct_post: Scalars['Boolean']['output'];
  dispute_review_approval_deadline?: Maybe<Scalars['DateTime']['output']>;
  disputes?: Maybe<Array<Dispute>>;
  distance_in_miles?: Maybe<Scalars['Int']['output']>;
  enable_geo_fence?: Maybe<Scalars['Boolean']['output']>;
  ends_date?: Maybe<Scalars['Date']['output']>;
  ends_time?: Maybe<Scalars['DateTime']['output']>;
  ends_time_?: Maybe<Scalars['DateTime']['output']>;
  estimated_rate_cents?: Maybe<Scalars['Int']['output']>;
  estimated_unpaid_break_time_minutes?: Maybe<Scalars['Int']['output']>;
  expense_adjustment_total_cents?: Maybe<Scalars['Int']['output']>;
  expense_adjustments: Array<ExpenseAdjustment>;
  extended_by_location: Scalars['Boolean']['output'];
  extended_by_professional: Scalars['Boolean']['output'];
  facility_number?: Maybe<Scalars['String']['output']>;
  favorite_ids: Array<Scalars['String']['output']>;
  geo_fence_radius?: Maybe<Scalars['Int']['output']>;
  great_pay?: Maybe<Scalars['Boolean']['output']>;
  guaranteed_minimum_hours?: Maybe<Scalars['Int']['output']>;
  has_agency_profile?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  invoices?: Maybe<Array<Invoice>>;
  is_w2?: Maybe<Scalars['Boolean']['output']>;
  job_audits?: Maybe<Array<Audit>>;
  /** @deprecated use plural job_billings */
  job_billing?: Maybe<JobBilling>;
  job_billing_sums?: Maybe<JobBillingSum>;
  /** @deprecated use job_billing_sums with invoice_id */
  job_billing_sums_for_invoice?: Maybe<JobBillingSum>;
  /** @deprecated use job_billing_sums with payout_id */
  job_billing_sums_for_payout?: Maybe<JobBillingSum>;
  job_billings: Array<JobBilling>;
  job_irregularities: Array<JobIrregularity>;
  job_price_differentials?: Maybe<Array<JobPriceDifferential>>;
  job_profile_for_account_id?: Maybe<JobProfile>;
  job_profiles?: Maybe<Array<JobProfile>>;
  /** @deprecated use JobProfile. see https://medely.atlassian.net/browse/PLAT2-1109 */
  job_publishing_group?: Maybe<JobPublishingGroup>;
  job_publishing_group_id?: Maybe<Scalars['Int']['output']>;
  job_rate_tracked_events?: Maybe<Array<JobRateTrackedEvent>>;
  job_track?: Maybe<JobTrack>;
  job_type: JobTypeList;
  kind: JobKind;
  last_cancellation?: Maybe<LastCancellation>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  market_id?: Maybe<Scalars['Int']['output']>;
  market_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated in favor of 'marketplace_job_profile' */
  marketplace_bonus_one_time_cents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated deprecated in favor of 'marketplace_job_profile' */
  marketplace_charge_base_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  marketplace_job_profile?: Maybe<JobProfile>;
  /** @deprecated deprecated in favor of 'marketplace_job_profile' */
  marketplace_payout_base_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated removing. this was a job_publishing_groups relic and job_publishing_groups is going away */
  max_possible_bonus_one_time_cents?: Maybe<Scalars['Int']['output']>;
  max_possible_charge_base_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  min_agency_rate?: Maybe<Scalars['Int']['output']>;
  missed_clock_out?: Maybe<Scalars['Boolean']['output']>;
  missing_condition_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  new_to_facility: Scalars['Boolean']['output'];
  offer_source?: Maybe<Scalars['String']['output']>;
  on_call_ends_time?: Maybe<Scalars['DateTime']['output']>;
  on_call_starts_time?: Maybe<Scalars['DateTime']['output']>;
  optional_condition_ids: Array<Scalars['Int']['output']>;
  override_minimum?: Maybe<Scalars['Boolean']['output']>;
  override_professional_specialty_requirement?: Maybe<Scalars['Boolean']['output']>;
  override_rates?: Maybe<Scalars['Boolean']['output']>;
  parking_reimbursement_cents?: Maybe<Scalars['Int']['output']>;
  patient_population?: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  /** @deprecated use plural payouts */
  payout?: Maybe<Payout>;
  payout_base_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  payout_base_hourly_rate_cents_for_account_id?: Maybe<Scalars['Int']['output']>;
  payout_base_hourly_rate_currency: Scalars['String']['output'];
  payout_bonus_cents?: Maybe<Scalars['Int']['output']>;
  payout_callback_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_facility_bonus_cents?: Maybe<Scalars['Int']['output']>;
  payout_max_daily_ot_hours: Scalars['Int']['output'];
  payout_max_daily_regular_hours: Scalars['Int']['output'];
  payout_max_weekly_regular_hours: Scalars['Int']['output'];
  payout_on_call_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_currency: Scalars['String']['output'];
  payout_overtime_frequency?: Maybe<Scalars['String']['output']>;
  payout_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_taxable_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  payout_taxable_hourly_rate_currency: Scalars['String']['output'];
  payouts?: Maybe<Array<Payout>>;
  pool?: Maybe<Pool>;
  pool_id?: Maybe<Scalars['Int']['output']>;
  position_display_names?: Maybe<Scalars['String']['output']>;
  position_ids?: Maybe<Array<Scalars['Int']['output']>>;
  positions?: Maybe<Array<Position>>;
  posting_field_contents?: Maybe<Scalars['JSON']['output']>;
  primary_publishing_group_member: Scalars['Boolean']['output'];
  pro_confirmed_at?: Maybe<Scalars['DateTime']['output']>;
  professional?: Maybe<Professional>;
  professional_can_adjust_times?: Maybe<Scalars['Boolean']['output']>;
  professional_can_cancel?: Maybe<Scalars['Boolean']['output']>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  professional_number?: Maybe<Scalars['String']['output']>;
  professional_submitted_time?: Maybe<Scalars['DateTime']['output']>;
  rate_calculator?: Maybe<RateCalculator>;
  rate_currency?: Maybe<Scalars['String']['output']>;
  release_audience: Scalars['String']['output'];
  release_audiences: Array<ReleaseAudience>;
  release_to_marketplace_strategy: Scalars['String']['output'];
  release_to_platform: Scalars['Int']['output'];
  released_to_professionals?: Maybe<Scalars['Boolean']['output']>;
  requested_by_facility?: Maybe<Scalars['Boolean']['output']>;
  require_upload_on_clock_out?: Maybe<Scalars['Boolean']['output']>;
  requires_sca_onboarding_condition?: Maybe<Scalars['Boolean']['output']>;
  reserved_for_favorites_only: Scalars['Boolean']['output'];
  revenue_adjustment_total_cents?: Maybe<Scalars['Int']['output']>;
  revenue_adjustments?: Maybe<Array<RevenueAdjustment>>;
  revenue_date?: Maybe<Scalars['Date']['output']>;
  review?: Maybe<Review>;
  scrubs_provided: Scalars['Boolean']['output'];
  shift_type: Scalars['String']['output'];
  specialties?: Maybe<Array<Specialty>>;
  specialty_labels?: Maybe<Scalars['String']['output']>;
  starts_date?: Maybe<Scalars['Date']['output']>;
  starts_time?: Maybe<Scalars['DateTime']['output']>;
  starts_time_?: Maybe<Scalars['DateTime']['output']>;
  state_?: Maybe<Scalars['String']['output']>;
  status?: Maybe<JobStatus>;
  surgery_type_display_names?: Maybe<Scalars['String']['output']>;
  surgery_types?: Maybe<Array<SurgeryType>>;
  suspicious?: Maybe<Scalars['Boolean']['output']>;
  timecard?: Maybe<Timecard>;
  timecard_id?: Maybe<Scalars['Int']['output']>;
  total_payout_bonus_cents?: Maybe<Scalars['Int']['output']>;
  track_unpaid_breaks: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_in_cancellation_window?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};


export type JobAgency_Job_ProfileArgs = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobAgency_Requested_By_FacilityArgs = {
  agency_id: Scalars['Int']['input'];
};


export type JobAvailable_For_Agency_To_Book_Non_FavoritesArgs = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobBonus_One_Time_Cents_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobCan_Book_JobArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobCustom_Onboarding_DocsArgs = {
  account_id?: InputMaybe<Scalars['String']['input']>;
};


export type JobDistance_In_MilesArgs = {
  professional_id: Scalars['Int']['input'];
};


export type JobJob_Billing_SumsArgs = {
  billing_id?: InputMaybe<Scalars['String']['input']>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  payout_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJob_Billing_Sums_For_InvoiceArgs = {
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJob_Billing_Sums_For_PayoutArgs = {
  payout_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJob_Profile_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobMissing_Condition_IdsArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobPayout_Base_Hourly_Rate_Cents_For_Account_IdArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobReleased_To_ProfessionalsArgs = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobRequested_By_FacilityArgs = {
  professional_id: Scalars['Int']['input'];
};

export type JobBilling = {
  __typename?: 'JobBilling';
  balance_sheet?: Maybe<BalanceSheet>;
  balance_sheet_id?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  charge_callback_amount_cents: Scalars['Int']['output'];
  charge_callback_hours?: Maybe<Scalars['Float']['output']>;
  charge_daily_overtime_amount_cents: Scalars['Int']['output'];
  charge_daily_overtime_hours?: Maybe<Scalars['Float']['output']>;
  charge_double_amount_cents: Scalars['Int']['output'];
  charge_double_hours?: Maybe<Scalars['Float']['output']>;
  charge_overtime_amount_cents: Scalars['Int']['output'];
  charge_overtime_hours?: Maybe<Scalars['Float']['output']>;
  charge_regular_amount_cents: Scalars['Int']['output'];
  charge_regular_hours?: Maybe<Scalars['Float']['output']>;
  charge_total_amount_cents: Scalars['Int']['output'];
  charge_total_amount_currency: Scalars['String']['output'];
  charge_weekly_overtime_amount_cents: Scalars['Int']['output'];
  charge_weekly_overtime_hours?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  disputed_job_billings: Array<DisputedJobBilling>;
  expense_adjustment_total_cents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  invoice?: Maybe<Invoice>;
  invoice_id?: Maybe<Scalars['Int']['output']>;
  job?: Maybe<Job>;
  job_id?: Maybe<Scalars['Int']['output']>;
  job_status?: Maybe<Scalars['String']['output']>;
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  make_chargeable_at?: Maybe<Scalars['DateTime']['output']>;
  make_payable_at?: Maybe<Scalars['DateTime']['output']>;
  original_job_billing_id?: Maybe<Scalars['Int']['output']>;
  past_month_adjustment?: Maybe<Scalars['Boolean']['output']>;
  payout?: Maybe<Payout>;
  payout_callback_amount_cents: Scalars['Int']['output'];
  payout_callback_hours?: Maybe<Scalars['Float']['output']>;
  payout_daily_overtime_amount_cents: Scalars['Int']['output'];
  payout_daily_overtime_hours?: Maybe<Scalars['Float']['output']>;
  payout_double_amount_cents: Scalars['Int']['output'];
  payout_double_hours?: Maybe<Scalars['Float']['output']>;
  payout_id?: Maybe<Scalars['Int']['output']>;
  payout_overtime_amount_cents: Scalars['Int']['output'];
  payout_overtime_hours?: Maybe<Scalars['Float']['output']>;
  payout_regular_amount_cents: Scalars['Int']['output'];
  payout_regular_hours?: Maybe<Scalars['Float']['output']>;
  payout_total_amount_cents: Scalars['Int']['output'];
  payout_total_amount_currency: Scalars['String']['output'];
  payout_weekly_overtime_amount_cents: Scalars['Int']['output'];
  payout_weekly_overtime_hours?: Maybe<Scalars['Float']['output']>;
  revenue_adjustment_total_cents?: Maybe<Scalars['Int']['output']>;
  total_breaks_hours?: Maybe<Scalars['Float']['output']>;
  total_breaks_minutes?: Maybe<Scalars['Int']['output']>;
  total_hours?: Maybe<Scalars['Float']['output']>;
  total_on_call_hours?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobBillingOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  payout_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobBillingQueryInput = {
  filter?: InputMaybe<JobBillingWhereInput>;
  orderBy?: InputMaybe<JobBillingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<JobBillingSearchInput>;
};

export type JobBillingSearchInput = {
  job_status?: InputMaybe<Scalars['String']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export type JobBillingSum = {
  __typename?: 'JobBillingSum';
  charge_callback_amount_cents?: Maybe<Scalars['Int']['output']>;
  charge_callback_hours?: Maybe<Scalars['Float']['output']>;
  charge_daily_overtime_amount_cents?: Maybe<Scalars['Int']['output']>;
  charge_daily_overtime_hours?: Maybe<Scalars['Float']['output']>;
  charge_double_amount_cents?: Maybe<Scalars['Int']['output']>;
  charge_double_hours?: Maybe<Scalars['Float']['output']>;
  charge_overtime_amount_cents?: Maybe<Scalars['Int']['output']>;
  charge_overtime_hours?: Maybe<Scalars['Float']['output']>;
  charge_regular_amount_cents?: Maybe<Scalars['Int']['output']>;
  charge_regular_hours?: Maybe<Scalars['Float']['output']>;
  charge_total_amount_cents?: Maybe<Scalars['Int']['output']>;
  charge_weekly_overtime_amount_cents?: Maybe<Scalars['Int']['output']>;
  charge_weekly_overtime_hours?: Maybe<Scalars['Float']['output']>;
  payout_callback_amount_cents?: Maybe<Scalars['Float']['output']>;
  payout_callback_hours?: Maybe<Scalars['Float']['output']>;
  payout_daily_overtime_amount_cents?: Maybe<Scalars['Int']['output']>;
  payout_daily_overtime_hours?: Maybe<Scalars['Float']['output']>;
  payout_double_amount_cents?: Maybe<Scalars['Float']['output']>;
  payout_double_hours?: Maybe<Scalars['Float']['output']>;
  payout_overtime_amount_cents?: Maybe<Scalars['Float']['output']>;
  payout_overtime_hours?: Maybe<Scalars['Float']['output']>;
  payout_regular_amount_cents?: Maybe<Scalars['Float']['output']>;
  payout_regular_hours?: Maybe<Scalars['Float']['output']>;
  payout_total_amount_cents?: Maybe<Scalars['Int']['output']>;
  payout_weekly_overtime_amount_cents?: Maybe<Scalars['Int']['output']>;
  payout_weekly_overtime_hours?: Maybe<Scalars['Float']['output']>;
  total_breaks_hours?: Maybe<Scalars['Float']['output']>;
  total_breaks_minutes?: Maybe<Scalars['Int']['output']>;
  total_hours?: Maybe<Scalars['Float']['output']>;
  total_on_call_hours?: Maybe<Scalars['Float']['output']>;
};

export type JobBillingWhereInput = {
  balance_sheet_id?: InputMaybe<Scalars['Int']['input']>;
  charge_total_amount_cents?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  job_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  payout_id?: InputMaybe<Scalars['Int']['input']>;
  payout_total_amount_cents?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum JobComputedStatus {
  Active = 'active',
  Booked = 'booked',
  Canceled = 'canceled',
  CanceledWithFee = 'canceled_with_fee',
  ClockedIn = 'clocked_in',
  ClockedOut = 'clocked_out',
  Completed = 'completed',
  Disputed = 'disputed',
  Draft = 'draft',
  HeldForDisputeReview = 'held_for_dispute_review',
  LateCancellation = 'late_cancellation',
  MissedShift = 'missed_shift',
  NoShow = 'no_show',
  Open = 'open',
  StaffRequested = 'staff_requested',
  Unavailable = 'unavailable',
  Unfilled = 'unfilled',
  Void = 'void'
}

export type JobIrregularity = {
  __typename?: 'JobIrregularity';
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  approved_by_account_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  irregularity_type: Scalars['String']['output'];
  job: Job;
  job_id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type JobIrregularityOrderInput = {
  approved_at?: InputMaybe<Scalars['Boolean']['input']>;
  approved_by_account_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  irregularity_type?: InputMaybe<Scalars['String']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobIrregularityQueryInput = {
  filter?: InputMaybe<JobIrregularityWhereInput>;
  orderBy?: InputMaybe<JobIrregularityOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<JobIrregularitySearchInput>;
};

export type JobIrregularitySearchInput = {
  approved_at?: InputMaybe<Scalars['DateTime']['input']>;
  approved_by_account_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  irregularity_type?: InputMaybe<Scalars['String']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type JobIrregularityWhereInput = {
  approved_at?: InputMaybe<Scalars['DateTime']['input']>;
  approved_by_account_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  irregularity_type?: InputMaybe<Scalars['String']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum JobKind {
  Orientation = 'orientation',
  Standard = 'standard',
  TimeOff = 'time_off'
}

export type JobOrderInput = {
  adjust_rate_calculator?: InputMaybe<Scalars['Boolean']['input']>;
  admin_notes?: InputMaybe<Scalars['Boolean']['input']>;
  approved_clock_in?: InputMaybe<Scalars['Boolean']['input']>;
  approved_clock_out?: InputMaybe<Scalars['Boolean']['input']>;
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  bonus_one_time?: InputMaybe<Scalars['Boolean']['input']>;
  bonus_one_time_cents?: InputMaybe<Scalars['Boolean']['input']>;
  bonus_one_time_payout?: InputMaybe<Scalars['Boolean']['input']>;
  bonus_one_time_payout_cents?: InputMaybe<Scalars['Boolean']['input']>;
  booked_at?: InputMaybe<Scalars['Boolean']['input']>;
  canceled_by_location?: InputMaybe<Scalars['Boolean']['input']>;
  canceled_by_professional?: InputMaybe<Scalars['Boolean']['input']>;
  charge_base_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  charge_bonus_cents?: InputMaybe<Scalars['Boolean']['input']>;
  charge_on_call_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  cleared_no_show?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  detail?: InputMaybe<Scalars['Boolean']['input']>;
  ends_date?: InputMaybe<Scalars['Boolean']['input']>;
  ends_time?: InputMaybe<Scalars['Boolean']['input']>;
  ends_time_?: InputMaybe<Scalars['Boolean']['input']>;
  estimated_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  extended_by_location?: InputMaybe<Scalars['Boolean']['input']>;
  extended_by_professional?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id?: InputMaybe<Scalars['Boolean']['input']>;
  job_track_id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  location_name?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Boolean']['input']>;
  market_name?: InputMaybe<Scalars['Boolean']['input']>;
  override_minimum?: InputMaybe<Scalars['Boolean']['input']>;
  override_professional_specialty_requirement?: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents?: InputMaybe<Scalars['Boolean']['input']>;
  patient_population?: InputMaybe<Scalars['Boolean']['input']>;
  payout_base_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  payout_bonus_cents?: InputMaybe<Scalars['Boolean']['input']>;
  payout_on_call_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  position_display_names?: InputMaybe<Scalars['Boolean']['input']>;
  primary_phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  professional_can_cancel?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  rate_calculator_id?: InputMaybe<Scalars['Boolean']['input']>;
  rate_currency?: InputMaybe<Scalars['Boolean']['input']>;
  release_to_platform?: InputMaybe<Scalars['Boolean']['input']>;
  scheduler_default_sort?: InputMaybe<Scalars['Boolean']['input']>;
  scheduler_location_view?: InputMaybe<Scalars['Boolean']['input']>;
  scheduler_position_view?: InputMaybe<Scalars['Boolean']['input']>;
  scheduler_staff_view?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_labels?: InputMaybe<Scalars['Boolean']['input']>;
  starts_date?: InputMaybe<Scalars['Boolean']['input']>;
  starts_time?: InputMaybe<Scalars['Boolean']['input']>;
  starts_time_?: InputMaybe<Scalars['Boolean']['input']>;
  state_?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  surgery_type_display_names?: InputMaybe<Scalars['Boolean']['input']>;
  suspicious?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  updated_in_cancellation_window?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobPriceDifferential = {
  __typename?: 'JobPriceDifferential';
  helper_text?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job: Job;
  label?: Maybe<Scalars['String']['output']>;
  recommendation_used: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  value_cents: Scalars['Int']['output'];
};

export type JobPriceDifferentialOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  recommendation_used?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  value_cents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobPriceDifferentialQueryInput = {
  filter?: InputMaybe<JobPriceDifferentialWhereInput>;
  orderBy?: InputMaybe<JobPriceDifferentialOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<JobPriceDifferentialSearchInput>;
};

export type JobPriceDifferentialSearchInput = {
  job_id?: InputMaybe<Scalars['Int']['input']>;
  recommendation_used?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  value_cents?: InputMaybe<Scalars['Int']['input']>;
};

export type JobPriceDifferentialWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  recommendation_used?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  value_cents?: InputMaybe<Scalars['Int']['input']>;
};

export type JobProfile = {
  __typename?: 'JobProfile';
  active: Scalars['Boolean']['output'];
  agency_id?: Maybe<Scalars['Int']['output']>;
  agency_vms_fee_percent?: Maybe<Scalars['Float']['output']>;
  available_for_booking_by_favorite_professionals_at?: Maybe<Scalars['DateTime']['output']>;
  available_for_booking_by_professionals_at?: Maybe<Scalars['DateTime']['output']>;
  bonus_one_time_cents: Scalars['Int']['output'];
  charge_base_hourly_rate_cents: Scalars['Int']['output'];
  charge_callback_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_max_daily_ot_hours?: Maybe<Scalars['Float']['output']>;
  charge_max_daily_regular_hours?: Maybe<Scalars['Float']['output']>;
  charge_max_weekly_regular_hours?: Maybe<Scalars['Float']['output']>;
  charge_on_call_hourly_rate_cents: Scalars['Int']['output'];
  charge_overtime_multiplier: Scalars['Float']['output'];
  charge_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  condition_ids: Array<Scalars['Int']['output']>;
  conditions: Array<Condition>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job: Job;
  job_id: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  marketplace: Scalars['Boolean']['output'];
  offer_group_available_for_booking_by_favorite_professionals_at?: Maybe<Scalars['DateTime']['output']>;
  offer_group_available_for_booking_by_professionals_at?: Maybe<Scalars['DateTime']['output']>;
  override_rates: Scalars['Boolean']['output'];
  payout_base_hourly_rate_cents: Scalars['Int']['output'];
  payout_callback_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_double_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  payout_facility_bonus_cents: Scalars['Int']['output'];
  payout_kind: Scalars['String']['output'];
  payout_max_daily_ot_hours?: Maybe<Scalars['Float']['output']>;
  payout_max_daily_regular_hours?: Maybe<Scalars['Float']['output']>;
  payout_max_weekly_regular_hours?: Maybe<Scalars['Float']['output']>;
  payout_on_call_hourly_rate_cents: Scalars['Int']['output'];
  payout_overtime_multiplier: Scalars['Float']['output'];
  payout_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  payout_taxable_hourly_rate_cents: Scalars['Int']['output'];
  professional_type: Scalars['String']['output'];
  published_to_professionals_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobProfileOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobProfileQueryInput = {
  filter?: InputMaybe<JobProfileWhereInput>;
  orderBy?: InputMaybe<JobProfileOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<JobProfileSearchInput>;
};

export type JobProfileSearchInput = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
};

export type JobProfileWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type JobPublishingGroup = {
  __typename?: 'JobPublishingGroup';
  id: Scalars['Int']['output'];
  publish_to_marketplace_offset_hours?: Maybe<Scalars['Int']['output']>;
};

export type JobPublishingGroupOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobPublishingGroupQueryInput = {
  filter?: InputMaybe<JobPublishingGroupWhereInput>;
  orderBy?: InputMaybe<JobPublishingGroupOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<JobPublishingGroupSearchInput>;
};

export type JobPublishingGroupSearchInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type JobPublishingGroupWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type JobQueryInput = {
  filter?: InputMaybe<JobWhereInput>;
  orderBy?: InputMaybe<JobOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<JobSearchInput>;
};

export type JobRateTrackedEvent = {
  __typename?: 'JobRateTrackedEvent';
  charge_min_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  charge_posted_hourly_rate_cents: Scalars['Int']['output'];
  charge_recommended_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  job: Job;
  price_differentials?: Maybe<Scalars['JSON']['output']>;
};

export type JobRateTrackedEventOrderInput = {
  charge_min_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  charge_posted_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  charge_recommended_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobRateTrackedEventQueryInput = {
  filter?: InputMaybe<JobRateTrackedEventWhereInput>;
  orderBy?: InputMaybe<JobRateTrackedEventOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<JobRateTrackedEventSearchInput>;
};

export type JobRateTrackedEventSearchInput = {
  charge_min_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_posted_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_recommended_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
};

export type JobRateTrackedEventWhereInput = {
  charge_min_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_posted_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_recommended_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum JobSchedule {
  Day = 'day',
  Evening = 'evening',
  Night = 'night'
}

export enum JobSearchByInput {
  Jobs = 'jobs',
  Professionals = 'professionals',
  Users = 'users'
}

export type JobSearchInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  account_manager_id?: InputMaybe<Scalars['Int']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  all_position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  available_job_sort?: InputMaybe<AvailableJobSort>;
  billing_group_plan?: InputMaybe<Scalars['String']['input']>;
  block_all?: InputMaybe<Scalars['Boolean']['input']>;
  blocked_times?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  booked_by_agency?: InputMaybe<Scalars['Boolean']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  computed_statuses?: InputMaybe<Array<InputMaybe<JobComputedStatus>>>;
  daily_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  default_agency_sort?: InputMaybe<Scalars['Boolean']['input']>;
  distance_check?: InputMaybe<DistanceCheckInput>;
  draft_ready_for_publishing?: InputMaybe<Scalars['Boolean']['input']>;
  duration_sort?: InputMaybe<Scalars['String']['input']>;
  ends_date?: InputMaybe<Scalars['Date']['input']>;
  ends_time_from?: InputMaybe<Scalars['DateTime']['input']>;
  ends_time_to?: InputMaybe<Scalars['DateTime']['input']>;
  filter_specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first_job_booked?: InputMaybe<Scalars['Boolean']['input']>;
  first_job_posted?: InputMaybe<Scalars['Boolean']['input']>;
  has_approvals_for_account_id?: InputMaybe<Scalars['Int']['input']>;
  has_pay_boost?: InputMaybe<Scalars['Boolean']['input']>;
  ignore_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  job_type?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<JobKind>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  location_type_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  no_breaks?: InputMaybe<Scalars['Boolean']['input']>;
  not_draft?: InputMaybe<Scalars['Boolean']['input']>;
  not_void?: InputMaybe<Scalars['Boolean']['input']>;
  pay_sort?: InputMaybe<Scalars['String']['input']>;
  payout_id?: InputMaybe<Scalars['Int']['input']>;
  payout_kind?: InputMaybe<Scalars['String']['input']>;
  pool_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pro_can_book_sort_id?: InputMaybe<Scalars['Int']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_account_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_available_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id_requested_by_facility?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  release_audiences?: InputMaybe<Array<InputMaybe<ReleaseAudience>>>;
  saas_check?: InputMaybe<SaasCheckInput>;
  sales_associate_id?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Array<InputMaybe<JobSchedule>>>;
  scheduler_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  search_by?: InputMaybe<JobSearchByInput>;
  shift_hours?: InputMaybe<Scalars['Int']['input']>;
  shift_length?: InputMaybe<ShiftLengthInput>;
  shift_type?: InputMaybe<Scalars['String']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  starts_date?: InputMaybe<Scalars['Date']['input']>;
  starts_or_ends_date?: InputMaybe<Scalars['Date']['input']>;
  starts_or_ends_time?: InputMaybe<StartsOrEndsTimeInput>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  starts_time_from?: InputMaybe<Scalars['DateTime']['input']>;
  starts_time_to?: InputMaybe<Scalars['DateTime']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  time_of_day?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  track_unpaid_breaks?: InputMaybe<Scalars['Boolean']['input']>;
  used_favorites?: InputMaybe<Scalars['Boolean']['input']>;
  validate_favorite_only_professional_id?: InputMaybe<Scalars['Int']['input']>;
  validate_favorite_professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum JobStatus {
  Active = 'active',
  Booked = 'booked',
  Canceled = 'canceled',
  CanceledWithFee = 'canceled_with_fee',
  ClockedIn = 'clocked_in',
  ClockedOut = 'clocked_out',
  Completed = 'completed',
  Disputed = 'disputed',
  Draft = 'draft',
  HeldForDisputeReview = 'held_for_dispute_review',
  LateCancellation = 'late_cancellation',
  MissedShift = 'missed_shift',
  NoShow = 'no_show',
  Open = 'open',
  Unavailable = 'unavailable',
  Unfilled = 'unfilled',
  Void = 'void'
}

export type JobStatusLocationCountsInput = {
  location_ids: Array<Scalars['Int']['input']>;
  statuses: Array<JobStatus>;
};

export type JobStatusLocationCountsResult = {
  __typename?: 'JobStatusLocationCountsResult';
  job_count: Scalars['Int']['output'];
  location_id: Scalars['Int']['output'];
};

export type JobSurgeryType = {
  __typename?: 'JobSurgeryType';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job?: Maybe<Job>;
  surgeryType?: Maybe<SurgeryType>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobSurgeryTypeQueryInput = {
  filter?: InputMaybe<JobSurgeryTypeWhereInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type JobSurgeryTypeWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type JobTemplate = {
  __typename?: 'JobTemplate';
  charge_base_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  covid_care?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patient_population?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Position>>;
  posting_field_contents?: Maybe<Scalars['JSON']['output']>;
  specialties?: Maybe<Array<Specialty>>;
  surgery_types?: Maybe<Array<SurgeryType>>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobTemplateOrderInput = {
  charge_base_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  covid_care?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  detail?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  patient_population?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobTemplateQueryInput = {
  filter?: InputMaybe<JobTemplateWhereInput>;
  orderBy?: InputMaybe<JobTemplateOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type JobTemplateWhereInput = {
  covid_care?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['Int']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  patient_population?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type JobTrack = {
  __typename?: 'JobTrack';
  complete?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job?: Maybe<Job>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type JobTrackOrderInput = {
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobTrackQueryInput = {
  filter?: InputMaybe<JobTrackWhereInput>;
  orderBy?: InputMaybe<JobTrackOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type JobTrackWhereInput = {
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum JobTypeList {
  CallBack = 'call_back',
  OnCall = 'on_call',
  Regular = 'regular',
  TimeOff = 'time_off'
}

export type JobWhereInput = {
  adjust_rate_calculator?: InputMaybe<Scalars['Boolean']['input']>;
  admin_notes?: InputMaybe<Scalars['String']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  approved_clock_in?: InputMaybe<Scalars['DateTime']['input']>;
  approved_clock_out?: InputMaybe<Scalars['DateTime']['input']>;
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  bonus_one_time?: InputMaybe<Scalars['Int']['input']>;
  bonus_one_time_payout?: InputMaybe<Scalars['Int']['input']>;
  bonus_one_time_payout_cents?: InputMaybe<Scalars['Int']['input']>;
  booked_at?: InputMaybe<Scalars['DateTime']['input']>;
  canceled_by_location?: InputMaybe<Scalars['Boolean']['input']>;
  canceled_by_professional?: InputMaybe<Scalars['Boolean']['input']>;
  charge_base_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_bonus_cents?: InputMaybe<Scalars['Int']['input']>;
  charge_on_call_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  cleared_no_show?: InputMaybe<Scalars['Boolean']['input']>;
  covid_care?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  ends_date?: InputMaybe<Scalars['Date']['input']>;
  ends_time?: InputMaybe<Scalars['DateTime']['input']>;
  ends_time_?: InputMaybe<Scalars['DateTime']['input']>;
  estimated_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  extended_by_location?: InputMaybe<Scalars['Boolean']['input']>;
  extended_by_professional?: InputMaybe<Scalars['Boolean']['input']>;
  facility_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  is_w2?: InputMaybe<Scalars['Boolean']['input']>;
  job_billing_id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_track_id?: InputMaybe<Scalars['Int']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  market_name?: InputMaybe<Scalars['String']['input']>;
  override_minimum?: InputMaybe<Scalars['Boolean']['input']>;
  override_professional_specialty_requirement?: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents?: InputMaybe<Scalars['Int']['input']>;
  patient_population?: InputMaybe<Scalars['String']['input']>;
  payout_base_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  payout_bonus_cents?: InputMaybe<Scalars['Int']['input']>;
  payout_on_call_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  position_display_names?: InputMaybe<Scalars['String']['input']>;
  primary_phone_number?: InputMaybe<Scalars['String']['input']>;
  primary_publishing_group_member?: InputMaybe<Scalars['Boolean']['input']>;
  professional_can_cancel?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_number?: InputMaybe<Scalars['String']['input']>;
  rate_calculator_id?: InputMaybe<Scalars['Int']['input']>;
  rate_currency?: InputMaybe<Scalars['String']['input']>;
  release_audience?: InputMaybe<Scalars['String']['input']>;
  release_to_platform?: InputMaybe<Scalars['Int']['input']>;
  specialty_labels?: InputMaybe<Scalars['String']['input']>;
  starts_date?: InputMaybe<Scalars['Date']['input']>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  starts_time_?: InputMaybe<Scalars['DateTime']['input']>;
  state_?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  surgery_type_display_names?: InputMaybe<Scalars['String']['input']>;
  suspicious?: InputMaybe<Scalars['Boolean']['input']>;
  timecard_id?: InputMaybe<Scalars['Int']['input']>;
  track_unpaid_breaks?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_in_cancellation_window?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type JobsBoard = {
  __typename?: 'JobsBoard';
  active_job: Scalars['Boolean']['output'];
  board: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job_type: Scalars['String']['output'];
  jobs_board_positions?: Maybe<Array<JobsBoardPosition>>;
  kind?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Market>;
  market_id?: Maybe<Scalars['Int']['output']>;
  position_names?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Position>>;
  requirements_description?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  salary: Scalars['String']['output'];
  state: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type JobsBoardOrderInput = {
  active_job?: InputMaybe<Scalars['Boolean']['input']>;
  board?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_type?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  position_names?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['Boolean']['input']>;
  salary?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  zip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobsBoardPosition = {
  __typename?: 'JobsBoardPosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  jobs_board?: Maybe<JobsBoard>;
  position?: Maybe<Position>;
  updated_at: Scalars['DateTime']['output'];
};

export type JobsBoardPositionQueryInput = {
  filter?: InputMaybe<JobsBoardPositionWhereInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type JobsBoardPositionWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type JobsBoardQueryInput = {
  filter?: InputMaybe<JobsBoardWhereInput>;
  orderBy?: InputMaybe<JobsBoardOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<JobsBoardSearchInput>;
};

export type JobsBoardSearchInput = {
  active_job?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  market_id?: InputMaybe<Scalars['String']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type JobsBoardWhereInput = {
  active_job?: InputMaybe<Scalars['Boolean']['input']>;
  board?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_type?: InputMaybe<Scalars['String']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  position_names?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type JobsTotals = {
  __typename?: 'JobsTotals';
  filtered_break_hours?: Maybe<Scalars['Float']['output']>;
  filtered_double_hours?: Maybe<Scalars['Float']['output']>;
  filtered_overtime_hours?: Maybe<Scalars['Float']['output']>;
  filtered_regular_hours?: Maybe<Scalars['Float']['output']>;
  filtered_total_hours?: Maybe<Scalars['Float']['output']>;
};

export type LastCancellation = {
  __typename?: 'LastCancellation';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  other_reason?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type LastWeekJobDetails = {
  __typename?: 'LastWeekJobDetails';
  median_booked_jobs_time_in_minutes: Scalars['Int']['output'];
  posted_jobs_count: Scalars['Int']['output'];
};

export type LineOfCredit = {
  __typename?: 'LineOfCredit';
  amount?: Maybe<Scalars['Int']['output']>;
  amount_cents?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type LineOfCreditOrderInput = {
  amount?: InputMaybe<Scalars['Boolean']['input']>;
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LineOfCreditQueryInput = {
  filter?: InputMaybe<LineOfCreditWhereInput>;
  orderBy?: InputMaybe<LineOfCreditOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type LineOfCreditWhereInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  amount_cents?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListMeta = {
  __typename?: 'ListMeta';
  count?: Maybe<Scalars['Int']['output']>;
};

export type LocalRateRule = {
  __typename?: 'LocalRateRule';
  applies_to: Scalars['String']['output'];
  force_draft?: Maybe<Scalars['Boolean']['output']>;
  health_system_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  local_okay: Scalars['Boolean']['output'];
  location_id?: Maybe<Scalars['Int']['output']>;
  mileage_cutoff?: Maybe<Scalars['Int']['output']>;
  msp_id?: Maybe<Scalars['Int']['output']>;
  offset_amount_cents?: Maybe<Scalars['Int']['output']>;
  offset_percentage?: Maybe<Scalars['Float']['output']>;
  rate_origin?: Maybe<Scalars['String']['output']>;
  vms_type_id?: Maybe<Scalars['Int']['output']>;
};

export type LocalRateRuleOrderInput = {
  applies_to?: InputMaybe<Scalars['Boolean']['input']>;
  force_draft?: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  local_okay?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  mileage_cutoff?: InputMaybe<Scalars['Boolean']['input']>;
  msp_id?: InputMaybe<Scalars['Boolean']['input']>;
  rate_origin?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalRateRuleQueryInput = {
  filter?: InputMaybe<LocalRateRuleWhereInput>;
  orderBy?: InputMaybe<LocalRateRuleOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<LocalRateRuleSearchInput>;
};

export type LocalRateRuleSearchInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type LocalRateRuleWhereInput = {
  applies_to?: InputMaybe<Scalars['String']['input']>;
  force_draft?: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  local_okay?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  mileage_cutoff?: InputMaybe<Scalars['Int']['input']>;
  msp_id?: InputMaybe<Scalars['Int']['input']>;
  offset_amount_cents?: InputMaybe<Scalars['Int']['input']>;
  offset_percentage?: InputMaybe<Scalars['Int']['input']>;
  rate_origin?: InputMaybe<Scalars['String']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Location = {
  __typename?: 'Location';
  about?: Maybe<Scalars['String']['output']>;
  account_locations?: Maybe<Array<AccountLocation>>;
  account_manager?: Maybe<Administrator>;
  account_manager_id?: Maybe<Scalars['Int']['output']>;
  accounts?: Maybe<Array<Account>>;
  additional_check_in_instructions?: Maybe<Scalars['String']['output']>;
  address_city?: Maybe<Scalars['String']['output']>;
  address_first?: Maybe<Scalars['String']['output']>;
  address_second?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  agencies?: Maybe<Array<Agency>>;
  agency_location_for_account_id?: Maybe<AgencyLocation>;
  agency_locations?: Maybe<Array<AgencyLocation>>;
  allow_assignments: Scalars['Boolean']['output'];
  allow_per_diem_jobs: Scalars['Boolean']['output'];
  allow_reserved_for_favorites: Scalars['Boolean']['output'];
  allow_weekly_overtime_settings: Scalars['Boolean']['output'];
  approval_free_late_clock_out_grace_period_minutes: Scalars['Int']['output'];
  available_credit?: Maybe<AvailableCredit>;
  billing_groups?: Maybe<Array<BillingGroup>>;
  cancellation_fee_charge_hours?: Maybe<Scalars['Int']['output']>;
  cancellation_fee_window?: Maybe<Scalars['Int']['output']>;
  clinical_account_manager?: Maybe<Administrator>;
  clinical_account_manager_id?: Maybe<Scalars['Int']['output']>;
  clinical_contacts?: Maybe<Array<ClinicalContact>>;
  clock_in_early_window: Scalars['Int']['output'];
  /** @deprecated to be removed in favor of maximum_late_clock_out_grace_period_minutes */
  clock_out_late_window?: Maybe<Scalars['Int']['output']>;
  common_shift_length_hours: Scalars['Int']['output'];
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['Int']['output']>;
  coordinates?: Maybe<Coordinates>;
  coverage_needs?: Maybe<Array<Maybe<CoverageNeed>>>;
  covid_requirement?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  detailed_notes?: Maybe<Scalars['String']['output']>;
  drug_screening_required?: Maybe<Scalars['Boolean']['output']>;
  ehr_details?: Maybe<Scalars['String']['output']>;
  ehr_system?: Maybe<EhrSystem>;
  ehr_system_id?: Maybe<Scalars['Int']['output']>;
  enable_geo_fence: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  facility_can_adjust_times?: Maybe<Scalars['Boolean']['output']>;
  facility_managed_agency_enabled: Scalars['Boolean']['output'];
  full_address?: Maybe<Scalars['String']['output']>;
  geo_fence_radius?: Maybe<Scalars['Int']['output']>;
  guaranteed_minimum_hours?: Maybe<Scalars['Int']['output']>;
  has_job_booked_or_completed_by_agency_pro: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  ignore_signature_when_creating_meal_break: Scalars['Boolean']['output'];
  in_geo_fence_range?: Maybe<Scalars['Boolean']['output']>;
  job_count?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  last_time_job_posted?: Maybe<Scalars['DateTime']['output']>;
  late_clock_in_irregularities_enabled: Scalars['Boolean']['output'];
  location_billing_groups?: Maybe<Array<LocationBillingGroup>>;
  location_confirmation_job_irregularities_enabled: Scalars['Boolean']['output'];
  location_position_rate_settings: Array<LocationPositionRateSetting>;
  location_positions?: Maybe<Array<LocationPosition>>;
  location_rate_settings: Array<LocationRateSetting>;
  location_size?: Maybe<LocationSize>;
  location_type: LocationType;
  location_type_id: Scalars['Int']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  manager_accounts?: Maybe<Array<Account>>;
  market?: Maybe<Market>;
  market_id?: Maybe<Scalars['Int']['output']>;
  maximum_late_clock_out_grace_period_minutes: Scalars['Int']['output'];
  meal_break_details?: Maybe<Scalars['String']['output']>;
  medication_management_details?: Maybe<Scalars['String']['output']>;
  mileage_requirement?: Maybe<Scalars['Int']['output']>;
  min_years_of_experience?: Maybe<Scalars['Float']['output']>;
  missed_clock_out_irregularities_enabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  need_regularity?: Maybe<NeedRegularity>;
  need_size?: Maybe<NeedSize>;
  non_billable_orientation_burden_hours: Scalars['Int']['output'];
  offboard_reason?: Maybe<Scalars['String']['output']>;
  offboarded_at?: Maybe<Scalars['DateTime']['output']>;
  offboarded_by_account_id?: Maybe<Scalars['Int']['output']>;
  original_user_id?: Maybe<Scalars['Int']['output']>;
  parking_cost_cents: Scalars['Int']['output'];
  parking_free: Scalars['Boolean']['output'];
  parking_instructions?: Maybe<Scalars['String']['output']>;
  parking_reimbursed: Scalars['Boolean']['output'];
  parking_reimbursement_cents: Scalars['Int']['output'];
  parking_reimbursement_currency: Scalars['String']['output'];
  parking_validated: Scalars['Boolean']['output'];
  permanent_placement_enabled: Scalars['Boolean']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  pool_invited_count: Scalars['Int']['output'];
  positions?: Maybe<Array<Position>>;
  primary_account_id?: Maybe<Scalars['Int']['output']>;
  primary_billing_group?: Maybe<BillingGroup>;
  primary_billing_group_id?: Maybe<Scalars['Int']['output']>;
  pro_pool_enabled: Scalars['Boolean']['output'];
  professional_can_adjust_times: Scalars['Boolean']['output'];
  professional_weekly_overtime_settings: ProfessionalWeeklyOvertimeSetting;
  require_facility_timecard_system_photo_on_clock_in: Scalars['Boolean']['output'];
  require_facility_timecard_system_photo_on_clock_out: Scalars['Boolean']['output'];
  require_shift_confirmation?: Maybe<Scalars['Boolean']['output']>;
  require_upload_on_clock_out: Scalars['Boolean']['output'];
  requirements: Array<Requirement>;
  sales_associate?: Maybe<Administrator>;
  sales_associate_id?: Maybe<Scalars['Int']['output']>;
  scrub_colors?: Maybe<Array<Maybe<ScrubColors>>>;
  scrubs_provided: Scalars['Boolean']['output'];
  /** @deprecated renamed with suffice _minutes */
  start_clock_in_early_window: Scalars['Int']['output'];
  start_clock_in_early_window_minutes: Scalars['Int']['output'];
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  supplies_ppe_details?: Maybe<Scalars['String']['output']>;
  timezone_lookup?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vms_user?: Maybe<VmsUser>;
  vms_user_id?: Maybe<Scalars['Int']['output']>;
};


export type LocationAgency_Location_For_Account_IdArgs = {
  agency_id?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationIn_Geo_Fence_RangeArgs = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type LocationAssignmentIssueCountsInput = {
  search: LocationAssignmentIssueCountsSearchInput;
};

export type LocationAssignmentIssueCountsSearchInput = {
  location_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  range: DateRangeInput;
};

export type LocationBillingGroup = {
  __typename?: 'LocationBillingGroup';
  billing_group: BillingGroup;
  billing_group_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  location_id: Scalars['Int']['output'];
  primary_billing_group: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LocationBillingGroupOrderInput = {
  billing_group_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  primary_billing_group?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationBillingGroupQueryInput = {
  filter?: InputMaybe<LocationBillingGroupWhereInput>;
  orderBy?: InputMaybe<LocationBillingGroupOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<LocationBillingGroupSearchInput>;
};

export type LocationBillingGroupSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type LocationBillingGroupWhereInput = {
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  primary_billing_group?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationBlockReason = {
  __typename?: 'LocationBlockReason';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  relationships?: Maybe<Array<Relationship>>;
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LocationBlockReasonOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationBlockReasonQueryInput = {
  filter?: InputMaybe<LocationBlockReasonWhereInput>;
  orderBy?: InputMaybe<LocationBlockReasonOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type LocationBlockReasonWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationConditionInput = {
  is_w2?: Scalars['Boolean']['input'];
  location_id: Scalars['Int']['input'];
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  specialty_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LocationGroup = {
  __typename?: 'LocationGroup';
  account_ids: Array<Scalars['Int']['output']>;
  calculated_descendant_ids: Array<Scalars['Int']['output']>;
  child_group_ids: Array<Scalars['Int']['output']>;
  company_id: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location_ids: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type LocationGroupOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationGroupQueryInput = {
  filter?: InputMaybe<LocationGroupWhereInput>;
  orderBy?: InputMaybe<LocationGroupOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<LocationGroupSearchInput>;
};

export type LocationGroupSearchInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationGroupWhereInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  group_node_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LocationOrderInput = {
  about?: InputMaybe<Scalars['Boolean']['input']>;
  account_manager_id?: InputMaybe<Scalars['Boolean']['input']>;
  address_city?: InputMaybe<Scalars['Boolean']['input']>;
  address_first?: InputMaybe<Scalars['Boolean']['input']>;
  address_second?: InputMaybe<Scalars['Boolean']['input']>;
  address_zip?: InputMaybe<Scalars['Boolean']['input']>;
  allow_assignments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_per_diem_jobs?: InputMaybe<Scalars['Boolean']['input']>;
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_fee_charge_hours?: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_fee_window?: InputMaybe<Scalars['Boolean']['input']>;
  company_id?: InputMaybe<Scalars['Boolean']['input']>;
  company_name?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  detailed_notes?: InputMaybe<Scalars['Boolean']['input']>;
  drug_screening_required?: InputMaybe<Scalars['Boolean']['input']>;
  facility_managed_agency?: InputMaybe<Scalars['Boolean']['input']>;
  guaranteed_minimum_hours?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_count?: InputMaybe<Scalars['Boolean']['input']>;
  last_time_job_posted?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Boolean']['input']>;
  market_name?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  non_billable_orientation_burden_hours?: InputMaybe<Scalars['Boolean']['input']>;
  original_user_id?: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents?: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_currency?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  primary_account_id?: InputMaybe<Scalars['Boolean']['input']>;
  primary_billing_group_id?: InputMaybe<Scalars['Boolean']['input']>;
  sales_associate_id?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  state_name?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  timezone_lookup?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationPosition = {
  __typename?: 'LocationPosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location: Location;
  location_id: Scalars['Int']['output'];
  position: Position;
  position_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LocationPositionOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationPositionQueryInput = {
  filter?: InputMaybe<LocationPositionWhereInput>;
  orderBy?: InputMaybe<LocationPositionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<LocationPositionSearchInput>;
};

export type LocationPositionRateSetting = {
  __typename?: 'LocationPositionRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  audits?: Maybe<Array<Audit>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  location_position_rate_setting?: Maybe<PositionSettings>;
  location_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  location_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  market_location_type_position_rate_settings_active?: Maybe<Scalars['Boolean']['output']>;
  market_location_type_position_rate_settings_id?: Maybe<Scalars['Int']['output']>;
  market_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  market_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<PositionSettings>;
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  state_location_type_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_location_type_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type LocationPositionRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  position_name?: InputMaybe<Scalars['Boolean']['input']>;
  specialty?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_name?: InputMaybe<Scalars['Boolean']['input']>;
  ten99_blended_rate_markup?: InputMaybe<Scalars['Boolean']['input']>;
  ten99_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  w2_local_blended_rate_markup?: InputMaybe<Scalars['Boolean']['input']>;
  w2_local_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  w2_travel_blended_rate_markup?: InputMaybe<Scalars['Boolean']['input']>;
  w2_travel_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationPositionRateSettingQueryInput = {
  filter?: InputMaybe<LocationPositionRateSettingWhereInput>;
  orderBy?: InputMaybe<LocationPositionRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<LocationPositionRateSettingSearchInput>;
};

export type LocationPositionRateSettingSearchInput = {
  below_market_rate?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at_from?: InputMaybe<Scalars['Date']['input']>;
};

export type LocationPositionRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  for_job?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  max_only?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationPositionSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type LocationPositionWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  uniq_for_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationQueryInput = {
  filter?: InputMaybe<LocationWhereInput>;
  orderBy?: InputMaybe<LocationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<LocationSearchInput>;
};

export type LocationRateSetting = {
  __typename?: 'LocationRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  enable_differential_recommendations?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  location_rate_setting?: Maybe<Scalars['JSON']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type LocationRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationRateSettingQueryInput = {
  filter?: InputMaybe<LocationRateSettingWhereInput>;
  orderBy?: InputMaybe<LocationRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<LocationRateSettingSearchInput>;
};

export type LocationRateSettingSearchInput = {
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type LocationRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationSearchInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  account_manager_id?: InputMaybe<Scalars['Int']['input']>;
  address_first?: InputMaybe<Scalars['String']['input']>;
  administrator_id?: InputMaybe<Scalars['Int']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fill_ratio?: InputMaybe<Scalars['Int']['input']>;
  has_agencies?: InputMaybe<Scalars['Boolean']['input']>;
  has_approved_agencies?: InputMaybe<Scalars['Boolean']['input']>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  market_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  near_location?: InputMaybe<NearLocationInput>;
  no_vms?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  sales_associate_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum LocationSize {
  Size_1_9 = 'size_1_9',
  Size_10_49 = 'size_10_49',
  Size_50_100 = 'size_50_100',
  Size_100Plus = 'size_100_plus'
}

export type LocationType = {
  __typename?: 'LocationType';
  active?: Maybe<Scalars['Boolean']['output']>;
  admin_only: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  location_type_positions?: Maybe<Array<LocationTypePosition>>;
  positions?: Maybe<Array<Position>>;
  rank: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LocationTypeOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationTypePosition = {
  __typename?: 'LocationTypePosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location_type?: Maybe<LocationType>;
  position?: Maybe<Position>;
  updated_at: Scalars['DateTime']['output'];
};

export type LocationTypePositionOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationTypePositionQueryInput = {
  filter?: InputMaybe<LocationTypePositionWhereInput>;
  orderBy?: InputMaybe<LocationTypePositionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type LocationTypePositionSettings = {
  __typename?: 'LocationTypePositionSettings';
  agency_charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  agency_release_lead_time_hours?: Maybe<Scalars['Int']['output']>;
  can_post_assignment?: Maybe<Scalars['Boolean']['output']>;
  can_post_job?: Maybe<Scalars['Boolean']['output']>;
  charge_on_call_hourly_rate_cents?: Maybe<Scalars['Float']['output']>;
  charge_on_call_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  fee_percent?: Maybe<Scalars['String']['output']>;
  location_type_markup?: Maybe<Scalars['Float']['output']>;
  on_call_fee_percent?: Maybe<Scalars['String']['output']>;
  payout_on_call_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  ten99?: Maybe<Ten99Settings>;
  track_unpaid_breaks?: Maybe<Scalars['Boolean']['output']>;
  use_agency_charge_rate_cents?: Maybe<Scalars['Boolean']['output']>;
  w2?: Maybe<W2Settings>;
  w2_fee_percent?: Maybe<Scalars['String']['output']>;
};

export type LocationTypePositionWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationTypeQueryInput = {
  filter?: InputMaybe<LocationTypeWhereInput>;
  orderBy?: InputMaybe<LocationTypeOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type LocationTypeWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_without_admin_only?: InputMaybe<Scalars['Boolean']['input']>;
  admin_only?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationWhereInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  account_manager_id?: InputMaybe<Scalars['Int']['input']>;
  address_city?: InputMaybe<Scalars['String']['input']>;
  address_first?: InputMaybe<Scalars['String']['input']>;
  address_second?: InputMaybe<Scalars['String']['input']>;
  address_zip?: InputMaybe<Scalars['String']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  allow_per_diem_jobs?: InputMaybe<Scalars['Boolean']['input']>;
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  cancellation_fee_charge_hours?: InputMaybe<Scalars['Int']['input']>;
  cancellation_fee_window?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  coordinates?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  detailed_notes?: InputMaybe<Scalars['String']['input']>;
  drug_screening_required?: InputMaybe<Scalars['Boolean']['input']>;
  facility_managed_agency_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  guaranteed_minimum_hours?: InputMaybe<Scalars['Int']['input']>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_time_job_posted?: InputMaybe<Scalars['DateTime']['input']>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  msp_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  no_vms?: InputMaybe<Scalars['Boolean']['input']>;
  non_billable_orientation_burden_hours?: InputMaybe<Scalars['Int']['input']>;
  original_user_id?: InputMaybe<Scalars['Int']['input']>;
  parking_free?: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursed?: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents?: InputMaybe<Scalars['Int']['input']>;
  parking_reimbursement_currency?: InputMaybe<Scalars['String']['input']>;
  parking_validated?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  primary_account_id?: InputMaybe<Scalars['Int']['input']>;
  primary_billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  sales_associate_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone_lookup?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
  vms_user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Market = {
  __typename?: 'Market';
  created_at: Scalars['DateTime']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locations?: Maybe<Array<Location>>;
  market_locations?: Maybe<Array<MarketLocation>>;
  name?: Maybe<Scalars['String']['output']>;
  position_names?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Position>>;
  professionals?: Maybe<Array<Professional>>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['TZ']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users?: Maybe<Array<User>>;
};

export type MarketLocation = {
  __typename?: 'MarketLocation';
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  market: Market;
  updated_at: Scalars['DateTime']['output'];
  zip_code: Scalars['String']['output'];
};

export type MarketLocationOrderInput = {
  city?: InputMaybe<Scalars['Boolean']['input']>;
  county?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  zip_code?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketLocationQueryInput = {
  filter?: InputMaybe<MarketLocationWhereInput>;
  orderBy?: InputMaybe<MarketLocationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<MarketLocationSearchInput>;
};

export type MarketLocationSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type MarketLocationTypePositionRateSetting = {
  __typename?: 'MarketLocationTypePositionRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  active_non_markup_settings?: Maybe<LocationTypePositionSettings>;
  audits?: Maybe<Array<Audit>>;
  blended_settings_charge_rate?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location_type?: Maybe<LocationType>;
  location_type_id?: Maybe<Scalars['Int']['output']>;
  market?: Maybe<Market>;
  market_id?: Maybe<Scalars['Int']['output']>;
  market_location_type_position_rate_setting?: Maybe<LocationTypePositionSettings>;
  market_location_type_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  market_location_type_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  market_position_rate_setting?: Maybe<LocationTypePositionSettings>;
  market_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  market_position_rate_setting_id_active?: Maybe<Scalars['Boolean']['output']>;
  non_blended_settings_charge_rate?: Maybe<Scalars['JSON']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<LocationTypePositionSettings>;
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  state_location_type_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_location_type_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  with_markup_settings?: Maybe<LocationTypePositionSettings>;
};

export type MarketLocationTypePositionRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_markup?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_name?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Boolean']['input']>;
  market_name?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  position_name?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_name?: InputMaybe<Scalars['Boolean']['input']>;
  ten99_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  w2_local_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  w2_travel_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketLocationTypePositionRateSettingQueryInput = {
  filter?: InputMaybe<MarketLocationTypePositionRateSettingWhereInput>;
  orderBy?: InputMaybe<MarketLocationTypePositionRateSettingOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<MarketLocationTypePositionRateSettingSearchInput>;
};

export type MarketLocationTypePositionRateSettingSearchInput = {
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  location_type_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  market_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at_from?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarketLocationTypePositionRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  for_job?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarketLocationTypeRateSetting = {
  __typename?: 'MarketLocationTypeRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location_type?: Maybe<LocationType>;
  location_type_id?: Maybe<Scalars['Int']['output']>;
  market?: Maybe<Market>;
  market_id?: Maybe<Scalars['Int']['output']>;
  market_location_type_rate_setting?: Maybe<Scalars['JSON']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type MarketLocationTypeRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_name?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Boolean']['input']>;
  market_name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketLocationTypeRateSettingQueryInput = {
  filter?: InputMaybe<MarketLocationTypeRateSettingWhereInput>;
  orderBy?: InputMaybe<MarketLocationTypeRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<MarketLocationTypeRateSettingSearchInput>;
};

export type MarketLocationTypeRateSettingSearchInput = {
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketLocationTypeRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketLocationWhereInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type MarketOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  display_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  position_names?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  state_name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketPositionRateSetting = {
  __typename?: 'MarketPositionRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  agency_charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  audits?: Maybe<Array<Audit>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_rate_review?: Maybe<Scalars['Date']['output']>;
  market?: Maybe<Market>;
  market_id?: Maybe<Scalars['Int']['output']>;
  market_position_rate_setting?: Maybe<PositionSettings>;
  market_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  market_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  professional_rate: Array<Scalars['Int']['output']>;
  recommended_rate_setting?: Maybe<MarketPositionRecommendedRateSetting>;
  settings?: Maybe<PositionSettings>;
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  state_location_type_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_location_type_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  with_markup_settings?: Maybe<PositionSettings>;
};

export type MarketPositionRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_rate_review?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  market_name?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  position_name?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_name?: InputMaybe<Scalars['Boolean']['input']>;
  ten99_blended_rate_markup?: InputMaybe<Scalars['Boolean']['input']>;
  ten99_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  w2_local_blended_rate_markup?: InputMaybe<Scalars['Boolean']['input']>;
  w2_local_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  w2_travel_blended_rate_markup?: InputMaybe<Scalars['Boolean']['input']>;
  w2_travel_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketPositionRateSettingQueryInput = {
  filter?: InputMaybe<MarketPositionRateSettingWhereInput>;
  orderBy?: InputMaybe<MarketPositionRateSettingOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<MarketPositionRateSettingSearchInput>;
};

export type MarketPositionRateSettingSearchInput = {
  below_state_rate?: InputMaybe<Scalars['Boolean']['input']>;
  has_agency_rates?: InputMaybe<Scalars['Boolean']['input']>;
  last_rate_review_from?: InputMaybe<Scalars['Date']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type MarketPositionRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  for_job?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarketPositionRecommendedRateSetting = {
  __typename?: 'MarketPositionRecommendedRateSetting';
  holiday_differential_cents: Scalars['Int']['output'];
  overnight_differential_cents: Scalars['Int']['output'];
  short_lead_time_0_to_6_hours_differential_cents: Scalars['Int']['output'];
  short_lead_time_6_to_12_hours_differential_cents: Scalars['Int']['output'];
  short_lead_time_12_to_24_hours_differential_cents: Scalars['Int']['output'];
  weekend_differential_cents: Scalars['Int']['output'];
};

export type MarketQueryInput = {
  filter?: InputMaybe<MarketWhereInput>;
  orderBy?: InputMaybe<MarketOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<MarketSearchInput>;
};

export type MarketRateSetting = {
  __typename?: 'MarketRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  market?: Maybe<Market>;
  market_id?: Maybe<Scalars['Int']['output']>;
  market_rate_setting?: Maybe<Scalars['JSON']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type MarketRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketRateSettingQueryInput = {
  filter?: InputMaybe<MarketRateSettingWhereInput>;
  orderBy?: InputMaybe<MarketRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<MarketRateSettingSearchInput>;
};

export type MarketRateSettingSearchInput = {
  market_id?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketSearchInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position_names?: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  state_zip_codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  zip_codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MarketWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position_names?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  state_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarketsProfessional = {
  __typename?: 'MarketsProfessional';
  market_id: Scalars['Int']['output'];
  professional_id?: Maybe<Scalars['Int']['output']>;
};

export type MarketsProfessionalOrderInput = {
  market_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketsProfessionalQueryInput = {
  filter?: InputMaybe<MarketsProfessionalWhereInput>;
  orderBy?: InputMaybe<MarketsProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<MarketsProfessionalSearchInput>;
};

export type MarketsProfessionalSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type MarketsProfessionalWhereInput = {
  market_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export type MetabaseEmbed = {
  __typename?: 'MetabaseEmbed';
  signed_token?: Maybe<Scalars['String']['output']>;
};

export type MetabaseEmbedQueryInput = {
  dashboard_id: Scalars['Int']['input'];
  date_range?: InputMaybe<DateRangeInput>;
  location_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<MetabaseTypes>>>;
};

export enum MetabaseTypes {
  Agency = 'agency',
  Medely = 'medely'
}

export type MostRecentShiftOrderInput = {
  location_ids: Array<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Msp = {
  __typename?: 'Msp';
  companies?: Maybe<Array<Company>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users?: Maybe<Array<User>>;
};

export type MspOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MspQueryInput = {
  filter?: InputMaybe<MspWhereInput>;
  orderBy?: InputMaybe<MspOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type MspWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type NearLocationInput = {
  location_id?: InputMaybe<Scalars['Int']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};

export enum NeedRegularity {
  AlmostDaily = 'almost_daily',
  FewTimesQuarter = 'few_times_quarter',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export enum NeedSize {
  Workers_0_5 = 'workers_0_5',
  Workers_6_10 = 'workers_6_10',
  Workers_11_20 = 'workers_11_20',
  Workers_20Plus = 'workers_20_plus'
}

export type NetTerm = {
  __typename?: 'NetTerm';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  number_of_days?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type NetTermOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  number_of_days?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NetTermQueryInput = {
  filter?: InputMaybe<NetTermWhereInput>;
  orderBy?: InputMaybe<NetTermOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type NetTermWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  number_of_days?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Note = {
  __typename?: 'Note';
  author?: Maybe<Administrator>;
  author_id?: Maybe<Scalars['Int']['output']>;
  billingGroup?: Maybe<BillingGroup>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<Location>;
  professional?: Maybe<Professional>;
  recipient?: Maybe<Recipient>;
  recipient_id?: Maybe<Scalars['Int']['output']>;
  recipient_name?: Maybe<Scalars['String']['output']>;
  recipient_type?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type NoteOrderInput = {
  author_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  recipient_id?: InputMaybe<Scalars['Boolean']['input']>;
  recipient_name?: InputMaybe<Scalars['Boolean']['input']>;
  recipient_type?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NoteQueryInput = {
  filter?: InputMaybe<NoteWhereInput>;
  orderBy?: InputMaybe<NoteOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type NoteWhereInput = {
  author_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recipient_id?: InputMaybe<Scalars['Int']['input']>;
  recipient_name?: InputMaybe<Scalars['String']['input']>;
  recipient_type?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NursysEnrollment = {
  __typename?: 'NursysEnrollment';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional?: Maybe<Professional>;
  professional_error?: Maybe<Scalars['String']['output']>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type NursysEnrollmentOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_error?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NursysEnrollmentQueryInput = {
  filter?: InputMaybe<NursysEnrollmentWhereInput>;
  orderBy?: InputMaybe<ProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type NursysEnrollmentWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  facility_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_error?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type OnboardingFlowDecision = {
  __typename?: 'OnboardingFlowDecision';
  decision: DecisionOption;
};

export type OnboardingPqaStatusInput = {
  location_id: Scalars['Int']['input'];
  statuses: Array<Scalars['String']['input']>;
};

export type OnboardingStatus = {
  __typename?: 'OnboardingStatus';
  complete: Scalars['Int']['output'];
  credentialing: Scalars['Int']['output'];
  not_accepted: Scalars['Int']['output'];
  orientation: Scalars['Int']['output'];
};

export type OpenShifts = {
  __typename?: 'OpenShifts';
  /** @deprecated use total_amount_v2 */
  total_amount: Scalars['Int']['output'];
};

export type OrientationShift = {
  __typename?: 'OrientationShift';
  id?: Maybe<Scalars['Int']['output']>;
  scheduled_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum PaylocityStatus {
  Active = 'active',
  NotInPaylocity = 'not_in_paylocity',
  Terminated = 'terminated'
}

export type Payment = {
  __typename?: 'Payment';
  account_type?: Maybe<Scalars['String']['output']>;
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  arrival_date?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  failed_count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  last_error_message?: Maybe<Scalars['String']['output']>;
  last_payment_attempt_at?: Maybe<Scalars['DateTime']['output']>;
  locked: Scalars['Boolean']['output'];
  payout?: Maybe<Payout>;
  payout_id: Scalars['Int']['output'];
  processed_on?: Maybe<Scalars['DateTime']['output']>;
  provider: Scalars['String']['output'];
  provider_payment_delivery_method: Scalars['String']['output'];
  provider_status?: Maybe<Scalars['String']['output']>;
  provider_transaction_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type PaymentOrderInput = {
  account_type?: InputMaybe<Scalars['Boolean']['input']>;
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency?: InputMaybe<Scalars['Boolean']['input']>;
  arrival_date?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  failed_count?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_error_message?: InputMaybe<Scalars['Boolean']['input']>;
  last_payment_attempt_at?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  payout_id?: InputMaybe<Scalars['Boolean']['input']>;
  processed_on?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['Boolean']['input']>;
  provider_payment_delivery_method?: InputMaybe<Scalars['Boolean']['input']>;
  provider_status?: InputMaybe<Scalars['Boolean']['input']>;
  provider_transaction_id?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentQueryInput = {
  filter?: InputMaybe<PaymentWhereInput>;
  orderBy?: InputMaybe<PaymentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type PaymentWhereInput = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_currency?: InputMaybe<Scalars['String']['input']>;
  arrival_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  failed_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_error_message?: InputMaybe<Scalars['String']['input']>;
  last_payment_attempt_at?: InputMaybe<Scalars['DateTime']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  payout_id?: InputMaybe<Scalars['Int']['input']>;
  processed_on?: InputMaybe<Scalars['DateTime']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_payment_delivery_method?: InputMaybe<Scalars['String']['input']>;
  provider_status?: InputMaybe<Scalars['String']['input']>;
  provider_transaction_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Payout = {
  __typename?: 'Payout';
  account_type?: Maybe<Scalars['String']['output']>;
  adp_id?: Maybe<Scalars['String']['output']>;
  agency_estimated_pay_date?: Maybe<Scalars['DateTime']['output']>;
  agency_payout_status: Scalars['String']['output'];
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  arrival_date?: Maybe<Scalars['DateTime']['output']>;
  assignment?: Maybe<Assignment>;
  assignment_id?: Maybe<Scalars['Int']['output']>;
  aws_signature_url?: Maybe<Scalars['AWSFile']['output']>;
  created_at: Scalars['DateTime']['output'];
  ends_time?: Maybe<Scalars['DateTime']['output']>;
  expense_adjustments: Array<ExpenseAdjustment>;
  failed_count?: Maybe<Scalars['Int']['output']>;
  failed_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job_billings: Array<JobBilling>;
  jobs?: Maybe<Array<Job>>;
  kind?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pause: Scalars['Boolean']['output'];
  pay_by_date?: Maybe<Scalars['DateTime']['output']>;
  payments?: Maybe<Array<Payment>>;
  processed_on?: Maybe<Scalars['DateTime']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  signature_url?: Maybe<Scalars['String']['output']>;
  source_type?: Maybe<Scalars['String']['output']>;
  starts_time?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  stripe_transfer_id?: Maybe<Scalars['String']['output']>;
  timecard_ids?: Maybe<Array<Scalars['Int']['output']>>;
  updated_at: Scalars['DateTime']['output'];
  w2_submit_by_time?: Maybe<Scalars['DateTime']['output']>;
};

export type PayoutOrderInput = {
  account_type?: InputMaybe<Scalars['Boolean']['input']>;
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency?: InputMaybe<Scalars['Boolean']['input']>;
  arrival_date?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  date_range?: InputMaybe<Scalars['Boolean']['input']>;
  ends_time?: InputMaybe<Scalars['Boolean']['input']>;
  failed_count?: InputMaybe<Scalars['Boolean']['input']>;
  failed_reason?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  processed_on?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  source_type?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  w2_submit_by_time?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayoutQueryInput = {
  filter?: InputMaybe<PayoutWhereInput>;
  orderBy?: InputMaybe<PayoutOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PayoutSearchInput>;
};

export type PayoutSearchInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  agency_payout_statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_from_date?: InputMaybe<Scalars['Date']['input']>;
  created_to_date?: InputMaybe<Scalars['Date']['input']>;
  ends_date_after?: InputMaybe<Scalars['Date']['input']>;
  ends_time_from?: InputMaybe<Scalars['Date']['input']>;
  ends_time_to?: InputMaybe<Scalars['Date']['input']>;
  failed_payouts?: InputMaybe<Scalars['Boolean']['input']>;
  failing_payouts?: InputMaybe<Scalars['Boolean']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  hide_zero_value_payouts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  starts_date_before?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  w2_submit_by_time?: InputMaybe<Scalars['Boolean']['input']>;
  w2_submit_by_time_from?: InputMaybe<Scalars['DateTime']['input']>;
  w2_submit_by_time_to?: InputMaybe<Scalars['DateTime']['input']>;
  w2_submit_from_date?: InputMaybe<Scalars['Date']['input']>;
  w2_submit_to_date?: InputMaybe<Scalars['Date']['input']>;
};

export type PayoutWhereInput = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_currency?: InputMaybe<Scalars['String']['input']>;
  arrival_date?: InputMaybe<Scalars['DateTime']['input']>;
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  failed_count?: InputMaybe<Scalars['Int']['input']>;
  failed_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  processed_on?: InputMaybe<Scalars['DateTime']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  source_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PermanentPlacementFilterInput = {
  canceled: Scalars['Boolean']['input'];
  hired: Scalars['Boolean']['input'];
  offer_sent: Scalars['Boolean']['input'];
  open: Scalars['Boolean']['input'];
};

export type PermanentPlacementStatusInput = {
  bookmarked: Scalars['Boolean']['input'];
  interviewed: Scalars['Boolean']['input'];
  not_viewed: Scalars['Boolean']['input'];
  offer_sent: Scalars['Boolean']['input'];
};

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  account_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  permissions: Scalars['JSON']['output'];
  role: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PermissionGroupOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type PermissionGroupQueryInput = {
  filter?: InputMaybe<PermissionGroupWhereInput>;
  orderBy?: InputMaybe<PermissionGroupOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PermissionGroupSearchInput>;
};

export type PermissionGroupSearchInput = {
  facility_role?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  professional_role?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionGroupWhereInput = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Person = {
  __typename?: 'Person';
  address_city?: Maybe<Scalars['String']['output']>;
  address_first?: Maybe<Scalars['String']['output']>;
  address_second?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  administrator?: Maybe<Administrator>;
  created_at: Scalars['DateTime']['output'];
  current_sign_in_at?: Maybe<Scalars['DateTime']['output']>;
  current_sign_in_ip?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  email_notification: Scalars['Boolean']['output'];
  encrypted_password: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_sign_in_at?: Maybe<Scalars['DateTime']['output']>;
  last_sign_in_ip?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  professional?: Maybe<Professional>;
  remember_created_at?: Maybe<Scalars['DateTime']['output']>;
  reset_password_sent_at?: Maybe<Scalars['DateTime']['output']>;
  reset_password_token?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  role_record?: Maybe<Scalars['String']['output']>;
  sign_in_count: Scalars['Int']['output'];
  sms_notification: Scalars['Boolean']['output'];
  sms_notification_bulk: Scalars['Boolean']['output'];
  ssn_last_4?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
};

export type PersonDisabledReason = {
  __typename?: 'PersonDisabledReason';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  disabled_reason?: Maybe<DisabledReason>;
  id?: Maybe<Scalars['Int']['output']>;
  personable?: Maybe<Personable>;
  personable_id?: Maybe<Scalars['Int']['output']>;
  personable_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PersonDisabledReasonOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  disabled_reason_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  personable_id?: InputMaybe<Scalars['Boolean']['input']>;
  personable_type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonDisabledReasonQueryInput = {
  filter?: InputMaybe<PersonDisabledReasonWhereInput>;
  orderBy?: InputMaybe<PersonDisabledReasonOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type PersonDisabledReasonWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  disabled_reason_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  personable_id?: InputMaybe<Scalars['Int']['input']>;
  personable_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonOrderInput = {
  address_city?: InputMaybe<Scalars['Boolean']['input']>;
  address_first?: InputMaybe<Scalars['Boolean']['input']>;
  address_second?: InputMaybe<Scalars['Boolean']['input']>;
  address_zip?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  current_sign_in_at?: InputMaybe<Scalars['Boolean']['input']>;
  current_sign_in_ip?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  encrypted_password?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_sign_in_at?: InputMaybe<Scalars['Boolean']['input']>;
  last_sign_in_ip?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  remember_created_at?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password_sent_at?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password_token?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['Boolean']['input']>;
  role_record?: InputMaybe<Scalars['Boolean']['input']>;
  sign_in_count?: InputMaybe<Scalars['Boolean']['input']>;
  ssn_last_4?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonQueryInput = {
  filter?: InputMaybe<PersonWhereInput>;
  orderBy?: InputMaybe<PersonOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type PersonWhereInput = {
  address_city?: InputMaybe<Scalars['String']['input']>;
  address_first?: InputMaybe<Scalars['String']['input']>;
  address_second?: InputMaybe<Scalars['String']['input']>;
  address_zip?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  current_sign_in_at?: InputMaybe<Scalars['DateTime']['input']>;
  current_sign_in_ip?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  encrypted_password?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_sign_in_at?: InputMaybe<Scalars['DateTime']['input']>;
  last_sign_in_ip?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  remember_created_at?: InputMaybe<Scalars['DateTime']['input']>;
  reset_password_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  reset_password_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_record?: InputMaybe<Scalars['String']['input']>;
  sign_in_count?: InputMaybe<Scalars['Int']['input']>;
  ssn_last_4?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
};

export type Personable = BillingGroup | Location | Professional;

export type PhoneScreeningRequest = {
  __typename?: 'PhoneScreeningRequest';
  assignment_request?: Maybe<AssignmentRequest>;
  assignment_request_id?: Maybe<Scalars['Int']['output']>;
  conference_sid?: Maybe<Scalars['String']['output']>;
  confirmed_phone_screening_time?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  interviewer_account_id?: Maybe<Scalars['String']['output']>;
  interviewer_name?: Maybe<Scalars['String']['output']>;
  masked_interviewer_phone_number?: Maybe<Scalars['String']['output']>;
  masked_professional_phone_number?: Maybe<Scalars['String']['output']>;
  masked_professional_phone_number_sid?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phone_screening_times?: Maybe<Array<Scalars['DateTime']['output']>>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type PhoneScreeningRequestOrderInput = {
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  assignment_request_id?: InputMaybe<Scalars['Boolean']['input']>;
  conference_sid?: InputMaybe<Scalars['Boolean']['input']>;
  confirmed_phone_screening_time?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  facility_contact_phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  interviewer_name?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Boolean']['input']>;
  masked_interviewer_phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  masked_professional_phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  masked_professional_phone_number_sid?: InputMaybe<Scalars['Boolean']['input']>;
  phone_screening_times?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhoneScreeningRequestQueryInput = {
  filter?: InputMaybe<PhoneScreeningRequestWhereInput>;
  orderBy?: InputMaybe<PhoneScreeningRequestOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PhoneScreeningSearchInput>;
};

export type PhoneScreeningRequestWhereInput = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  assignment_request_id?: InputMaybe<Scalars['Int']['input']>;
  conference_sid?: InputMaybe<Scalars['String']['input']>;
  confirmed_phone_screening_time?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  facility_contact_phone_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  interviewer_account_id?: InputMaybe<Scalars['Int']['input']>;
  interviewer_name?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  masked_interviewer_phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  masked_professional_phone_number?: InputMaybe<Scalars['String']['input']>;
  masked_professional_phone_number_sid?: InputMaybe<Scalars['String']['input']>;
  phone_screening_times?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PhoneScreeningSearchInput = {
  date_from?: InputMaybe<Scalars['Date']['input']>;
  date_to?: InputMaybe<Scalars['Date']['input']>;
  interviewer_account_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Pool = {
  __typename?: 'Pool';
  created_at: Scalars['DateTime']['output'];
  ehr_system?: Maybe<EhrSystem>;
  id: Scalars['Int']['output'];
  location: Location;
  onboarding_status: OnboardingStatus;
  orientation_shifts?: Maybe<Array<PoolOrientationShift>>;
  positions: Array<Position>;
  professionals: Array<Professional>;
  requires_pro_review?: Maybe<Scalars['Boolean']['output']>;
  shift_needs: PoolShiftNeeds;
  specialties?: Maybe<Array<Specialty>>;
  status: PoolStatus;
  updated_at: Scalars['DateTime']['output'];
};

export type PoolInviteTodo = {
  __typename?: 'PoolInviteTodo';
  location_id: Scalars['Int']['output'];
  location_name: Scalars['String']['output'];
  plan: Scalars['String']['output'];
  professional_qualification_id: Scalars['Int']['output'];
};

export type PoolOnboardingTodo = {
  __typename?: 'PoolOnboardingTodo';
  location_id: Scalars['Int']['output'];
  location_name: Scalars['String']['output'];
};

export type PoolOrderByInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PoolOrientationShift = {
  __typename?: 'PoolOrientationShift';
  id: Scalars['Int']['output'];
  pay_rate_cents: Scalars['Int']['output'];
  pool: Pool;
  shift_type: PoolOrientationShiftType;
  shifts_required: Scalars['Int']['output'];
};

export enum PoolOrientationShiftType {
  Combined = 'combined',
  GeneralOrientation = 'general_orientation',
  InUnit = 'in_unit',
  Shadow = 'shadow'
}

export type PoolOrientationTodo = {
  __typename?: 'PoolOrientationTodo';
  location_id: Scalars['Int']['output'];
  location_name: Scalars['String']['output'];
  pool_id: Scalars['Int']['output'];
  position_names: Array<Scalars['String']['output']>;
  shift_type: Scalars['String']['output'];
};

export type PoolProfessionalInput = {
  id: Scalars['Int']['input'];
  location_id: Scalars['Int']['input'];
};

export type PoolQueryInput = {
  filter?: InputMaybe<PoolWhereInput>;
  orderBy?: InputMaybe<PoolOrderByInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PoolSearchInput>;
};

export type PoolSearchInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum PoolShiftNeeds {
  Needs_1_5 = 'needs_1_5',
  Needs_6_10 = 'needs_6_10',
  Needs_11_20 = 'needs_11_20',
  Needs_20Plus = 'needs_20_plus'
}

export enum PoolStatus {
  Active = 'active',
  Deleted = 'deleted'
}

export type PoolWhereInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Position = {
  __typename?: 'Position';
  active: Scalars['Boolean']['output'];
  assignments?: Maybe<Array<Assignment>>;
  created_at: Scalars['DateTime']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  high_risk: Scalars['Boolean']['output'];
  hospital_mark_up: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  incrementality?: Maybe<Scalars['String']['output']>;
  invoices?: Maybe<Array<Invoice>>;
  job_templates?: Maybe<Array<JobTemplate>>;
  jobs?: Maybe<Array<Maybe<Job>>>;
  kind?: Maybe<Scalars['String']['output']>;
  lead_description?: Maybe<Scalars['String']['output']>;
  lead_question?: Maybe<Scalars['String']['output']>;
  license_names?: Maybe<Scalars['String']['output']>;
  location_positions?: Maybe<Array<LocationPosition>>;
  locations?: Maybe<Array<Location>>;
  markets?: Maybe<Array<Market>>;
  name?: Maybe<Scalars['String']['output']>;
  nested_jobs?: Maybe<Array<Job>>;
  professional_description?: Maybe<Scalars['String']['output']>;
  professional_question?: Maybe<Scalars['String']['output']>;
  professionals?: Maybe<Array<Professional>>;
  qualifications_group?: Maybe<QualificationsGroup>;
  qualifications_group_id?: Maybe<Scalars['Int']['output']>;
  recommended_position_ids: Array<Scalars['Int']['output']>;
  recommended_positions: Array<Position>;
  requirements_description?: Maybe<Scalars['String']['output']>;
  requires_specialty: Scalars['Boolean']['output'];
  responsibilities?: Maybe<Scalars['String']['output']>;
  sequence: Scalars['Int']['output'];
  specialties?: Maybe<Array<Specialty>>;
  specialty_list?: Maybe<Scalars['String']['output']>;
  state_hospital_mark_up?: Maybe<Array<Maybe<HospitalMarkUp>>>;
  updated_at: Scalars['DateTime']['output'];
};


export type PositionIncrementalityArgs = {
  market_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type PositionJobsArgs = {
  gte_starts_date: Scalars['Date']['input'];
  location_id: Array<InputMaybe<Scalars['Int']['input']>>;
  lte_starts_date: Scalars['Date']['input'];
};

export type PositionOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  display_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  license_names?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  professional_description?: InputMaybe<Scalars['Boolean']['input']>;
  professional_question?: InputMaybe<Scalars['Boolean']['input']>;
  qualifications_group_id?: InputMaybe<Scalars['Boolean']['input']>;
  responsibilities?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_list?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PositionPostingField = {
  __typename?: 'PositionPostingField';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position?: Maybe<Position>;
  position_id: Scalars['Int']['output'];
  posting_field: PostingField;
  posting_field_id: Scalars['Int']['output'];
};

export type PositionPostingFieldOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  posting_field_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PositionPostingFieldQueryInput = {
  filter?: InputMaybe<PositionPostingFieldWhereInput>;
  orderBy?: InputMaybe<PositionPostingFieldOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PositionPostingFieldSearchInput>;
};

export type PositionPostingFieldSearchInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  posting_field_id?: InputMaybe<Scalars['Int']['input']>;
};

export type PositionPostingFieldWhereInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  posting_field_id?: InputMaybe<Scalars['Int']['input']>;
};

export type PositionQueryInput = {
  filter?: InputMaybe<PositionWhereInput>;
  orderBy?: InputMaybe<PositionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PositionSearchInput>;
};

export type PositionSearchInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  for_job?: InputMaybe<Scalars['Boolean']['input']>;
  for_locations?: InputMaybe<ForLocations>;
  for_locations_jobs?: InputMaybe<ForLocationsJobsInput>;
  for_time_tracking?: InputMaybe<ForTimeTrackingInput>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  recommended_for_location_ids_sort?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recommended_for_location_type_id_sort?: InputMaybe<Scalars['Int']['input']>;
};

export type PositionSettings = {
  __typename?: 'PositionSettings';
  agency_charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  agency_release_lead_time_hours?: Maybe<Scalars['Int']['output']>;
  can_post_assignment?: Maybe<Scalars['Boolean']['output']>;
  can_post_job?: Maybe<Scalars['Boolean']['output']>;
  charge_on_call_hourly_rate_cents?: Maybe<Scalars['Float']['output']>;
  charge_on_call_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  fee_percent?: Maybe<Scalars['String']['output']>;
  on_call_fee_percent?: Maybe<Scalars['String']['output']>;
  payout_on_call_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  payout_on_call_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  ten99?: Maybe<Ten99Settings>;
  track_unpaid_breaks?: Maybe<Scalars['Boolean']['output']>;
  use_agency_charge_rate_cents?: Maybe<Scalars['Boolean']['output']>;
  w2?: Maybe<W2Settings>;
  w2_fee_percent?: Maybe<Scalars['String']['output']>;
};

export type PositionSpecialty = {
  __typename?: 'PositionSpecialty';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position?: Maybe<Position>;
  specialty?: Maybe<Specialty>;
  updated_at: Scalars['DateTime']['output'];
};

export type PositionSpecialtyOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PositionSpecialtyQueryInput = {
  filter?: InputMaybe<PositionSpecialtyWhereInput>;
  orderBy?: InputMaybe<PositionSpecialtyOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type PositionSpecialtyWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PositionWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  license_names?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  professional_description?: InputMaybe<Scalars['String']['input']>;
  professional_question?: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  qualifications_group_id?: InputMaybe<Scalars['Int']['input']>;
  responsibilities?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  specialty_list?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostingField = {
  __typename?: 'PostingField';
  constraints?: Maybe<Scalars['JSON']['output']>;
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  field_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  show_on_assignment: Scalars['Boolean']['output'];
  show_on_per_diem: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type PostingFieldOrderInput = {
  description?: InputMaybe<Scalars['Boolean']['input']>;
  field_type?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  show_on_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  show_on_per_diem?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostingFieldQueryInput = {
  filter?: InputMaybe<PostingFieldWhereInput>;
  orderBy?: InputMaybe<PostingFieldOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PostingFieldSearchInput>;
};

export type PostingFieldSearchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  field_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  show_on_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  show_on_per_diem?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type PostingFieldWhereInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  field_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  show_on_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  show_on_per_diem?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProPoolDashboard = {
  __typename?: 'ProPoolDashboard';
  billing_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  location_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Maybe<ProPoolDashboardListItem>>>;
  status?: Maybe<Scalars['String']['output']>;
  unsatisfied_conditions?: Maybe<Array<Maybe<ProPoolDashboardListItem>>>;
};

export type ProPoolDashboardInput = {
  filter?: InputMaybe<ProfessionalWhereInput>;
  orderBy?: InputMaybe<ProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProPoolDashboardSearchInput>;
};

export type ProPoolDashboardListItem = {
  __typename?: 'ProPoolDashboardListItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ProPoolDashboardSearchInput = {
  all_positions_satisfied?: InputMaybe<Scalars['Boolean']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  credential_types?: InputMaybe<Array<Scalars['Int']['input']>>;
  is_w2?: InputMaybe<Scalars['Boolean']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  pool_status?: InputMaybe<Scalars['String']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  qualification_status?: InputMaybe<Scalars['String']['input']>;
  show_rejected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Professional = {
  __typename?: 'Professional';
  account: Account;
  account_id: Scalars['Int']['output'];
  adp_file_number?: Maybe<Scalars['String']['output']>;
  all_time_total_earnings_cents?: Maybe<Scalars['Int']['output']>;
  application_status: Scalars['String']['output'];
  application_version: ApplicationVersion;
  archive_reason?: Maybe<Scalars['String']['output']>;
  assignments?: Maybe<Array<Assignment>>;
  available?: Maybe<Scalars['Boolean']['output']>;
  background_check_authorized: Scalars['Boolean']['output'];
  background_check_pqs: Array<ProfessionalQualification>;
  /** @deprecated BackgroundChecks have been migrated to professional qualifications */
  background_checks?: Maybe<Array<BackgroundCheck>>;
  balance_cents: Scalars['Int']['output'];
  balance_currency: Scalars['String']['output'];
  bank_last?: Maybe<Scalars['String']['output']>;
  booked_total_cents?: Maybe<Scalars['Int']['output']>;
  business_tax_id?: Maybe<Scalars['String']['output']>;
  calendly_invitee_uuid?: Maybe<Scalars['String']['output']>;
  can_accept_assignment_offer?: Maybe<Scalars['Boolean']['output']>;
  can_book_job: Scalars['Boolean']['output'];
  cancellation_ratio?: Maybe<Scalars['Float']['output']>;
  capsReports?: Maybe<Array<CapsReport>>;
  /** @deprecated use professionals.cohort_reminder instead */
  cohort?: Maybe<Scalars['String']['output']>;
  cohort_reminder?: Maybe<Scalars['String']['output']>;
  completed_video: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  credentials_status?: Maybe<Scalars['String']['output']>;
  deactivation_reason?: Maybe<Scalars['String']['output']>;
  detailed_notes?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['Date']['output']>;
  drug_screening_completed: Scalars['Boolean']['output'];
  ehr_labels: Array<Scalars['String']['output']>;
  emergency_contacts?: Maybe<Array<EmergencyContact>>;
  enable_rescreening_automation: Scalars['Boolean']['output'];
  external_payroll_id?: Maybe<Scalars['String']['output']>;
  has_active_assignments_here?: Maybe<Scalars['Boolean']['output']>;
  has_active_funding_source?: Maybe<Scalars['Boolean']['output']>;
  has_active_jobs_here?: Maybe<Scalars['Boolean']['output']>;
  has_documents_for_job: Scalars['Boolean']['output'];
  has_item?: Maybe<Scalars['Boolean']['output']>;
  has_item_url?: Maybe<Scalars['Boolean']['output']>;
  has_markets?: Maybe<Scalars['Boolean']['output']>;
  has_upload_pdf: Scalars['Boolean']['output'];
  hours_need_updating: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  in_nursys_list: Scalars['Boolean']['output'];
  in_range_for_job: Scalars['Boolean']['output'];
  invite_code?: Maybe<Scalars['String']['output']>;
  is_any_favorite?: Maybe<Scalars['Boolean']['output']>;
  is_blocked?: Maybe<Scalars['Boolean']['output']>;
  is_favorite?: Maybe<Scalars['Boolean']['output']>;
  is_ready_to_work?: Maybe<Scalars['Boolean']['output']>;
  jobs?: Maybe<Array<Job>>;
  /** @deprecated use professionals.kinds instead */
  kind: Scalars['String']['output'];
  kinds: Array<Scalars['String']['output']>;
  last_seen_w2_interest_at?: Maybe<Scalars['DateTime']['output']>;
  last_updated_preferred_hours_at?: Maybe<Scalars['DateTime']['output']>;
  late_clockin_ratio?: Maybe<Scalars['Float']['output']>;
  markets?: Maybe<Array<Market>>;
  migrated_lead_id?: Maybe<Scalars['Int']['output']>;
  migrated_staff_id?: Maybe<Scalars['Int']['output']>;
  most_recent_shift?: Maybe<RecentShift>;
  name?: Maybe<Scalars['String']['output']>;
  new_to_medely: Scalars['Boolean']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Note>>;
  nursysEnrollments?: Maybe<Array<NursysEnrollment>>;
  on_assignment_for_location_id?: Maybe<Scalars['Boolean']['output']>;
  orientation_shifts?: Maybe<Array<Maybe<OrientationShift>>>;
  other_referral_source?: Maybe<Scalars['String']['output']>;
  paylocity_external_id?: Maybe<Scalars['String']['output']>;
  paylocity_status?: Maybe<PaylocityStatus>;
  pending_review_condition_ids: Array<Scalars['Int']['output']>;
  phone_interviewed?: Maybe<Scalars['Boolean']['output']>;
  phone_screen_date_and_time?: Maybe<Scalars['DateTime']['output']>;
  plaid_token?: Maybe<Scalars['String']['output']>;
  pool_onboarding_status: Scalars['String']['output'];
  position_experience: Scalars['Int']['output'];
  positions: Array<Position>;
  positions_onboarding_complete?: Maybe<Scalars['Boolean']['output']>;
  possible_duplicate?: Maybe<Scalars['Boolean']['output']>;
  preferred_hours_per_week?: Maybe<Scalars['Int']['output']>;
  preferred_job_types?: Maybe<Scalars['String']['output']>;
  professional_assignment_favorites?: Maybe<Array<ProfessionalAssignmentFavorite>>;
  professional_assignment_id?: Maybe<Scalars['Int']['output']>;
  professional_positions: Array<ProfessionalPosition>;
  professional_qualifications?: Maybe<Array<ProfessionalQualification>>;
  professional_qualifications_for_pool?: Maybe<Array<ProfessionalQualification>>;
  professional_saas_details?: Maybe<Array<ProfessionalSaasDetail>>;
  professional_screenings?: Maybe<Array<ProfessionalScreening>>;
  profile_completed: Scalars['Boolean']['output'];
  profile_strength: Scalars['Int']['output'];
  publishable_key?: Maybe<Scalars['String']['output']>;
  quick_note?: Maybe<Scalars['String']['output']>;
  recruiter?: Maybe<Administrator>;
  recruiter_id?: Maybe<Scalars['Int']['output']>;
  referral_source?: Maybe<ReferralSource>;
  referral_source_id?: Maybe<Scalars['Int']['output']>;
  reject_reason?: Maybe<Scalars['String']['output']>;
  requested_for_job_id: Scalars['Boolean']['output'];
  required_item_image?: Maybe<Scalars['Boolean']['output']>;
  resume?: Maybe<Scalars['AWSFile']['output']>;
  rfm?: Maybe<Scalars['String']['output']>;
  rfmf?: Maybe<Scalars['Int']['output']>;
  rfmr?: Maybe<Scalars['Int']['output']>;
  satisfied_condition_ids?: Maybe<Array<Scalars['Int']['output']>>;
  satisfied_conditions: Array<Condition>;
  screening_recruiter?: Maybe<Administrator>;
  screening_recruiter_id?: Maybe<Scalars['Int']['output']>;
  shifts_completed?: Maybe<Scalars['Int']['output']>;
  shifts_completed_here?: Maybe<Scalars['Int']['output']>;
  signup_assignment_id?: Maybe<Scalars['Int']['output']>;
  specialties: Array<Specialty>;
  split_pay_phase?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  stripe_accounts?: Maybe<Array<StripeAccount>>;
  stripe_bank_account_token?: Maybe<Scalars['String']['output']>;
  stripe_external_account_id?: Maybe<Scalars['String']['output']>;
  tax_classification_id?: Maybe<Scalars['Int']['output']>;
  travel_email_notification?: Maybe<Scalars['Boolean']['output']>;
  travel_email_preferences: Scalars['String']['output'];
  travel_state_names?: Maybe<Scalars['String']['output']>;
  travel_states?: Maybe<Array<State>>;
  universal_background_checks?: Maybe<Array<Maybe<UniversalBackgroundCheck>>>;
  unsubscribe_token?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  w2_eligible: Scalars['Boolean']['output'];
  w2_enabled: Scalars['Boolean']['output'];
  w2_interest?: Maybe<Scalars['Boolean']['output']>;
  w2_onboarding_complete?: Maybe<Scalars['Boolean']['output']>;
  welcome_box_sent?: Maybe<Scalars['Boolean']['output']>;
  work_gaps?: Maybe<Array<WorkGap>>;
  work_histories?: Maybe<Array<WorkHistory>>;
  years_experience?: Maybe<Scalars['Int']['output']>;
};


export type ProfessionalAvailableArgs = {
  gte_starts_time: Scalars['DateTime']['input'];
  location_id?: InputMaybe<Scalars['Int']['input']>;
  lte_starts_time: Scalars['DateTime']['input'];
};


export type ProfessionalCan_Accept_Assignment_OfferArgs = {
  assignment_id: Scalars['Int']['input'];
};


export type ProfessionalCan_Book_JobArgs = {
  job_id: Scalars['Int']['input'];
};


export type ProfessionalCohort_ReminderArgs = {
  job_id: Scalars['Int']['input'];
};


export type ProfessionalHas_Active_Assignments_HereArgs = {
  location_ids: Array<Scalars['Int']['input']>;
};


export type ProfessionalHas_Active_Jobs_HereArgs = {
  location_ids: Array<Scalars['Int']['input']>;
};


export type ProfessionalHas_Documents_For_JobArgs = {
  job_id: Scalars['Int']['input'];
};


export type ProfessionalIn_Range_For_JobArgs = {
  job_id: Scalars['Int']['input'];
};


export type ProfessionalIs_BlockedArgs = {
  location_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type ProfessionalIs_FavoriteArgs = {
  location_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type ProfessionalMost_Recent_ShiftArgs = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids: Array<Scalars['Int']['input']>;
};


export type ProfessionalOn_Assignment_For_Location_IdArgs = {
  gte_starts_time: Scalars['DateTime']['input'];
  location_id: Scalars['Int']['input'];
  lte_starts_time: Scalars['DateTime']['input'];
};


export type ProfessionalOrientation_ShiftsArgs = {
  pool_id: Scalars['Int']['input'];
};


export type ProfessionalPosition_ExperienceArgs = {
  position_id: Scalars['Int']['input'];
};


export type ProfessionalProfessional_Qualifications_For_PoolArgs = {
  pool_id: Scalars['Int']['input'];
};


export type ProfessionalRequested_For_Job_IdArgs = {
  job_id: Scalars['Int']['input'];
};


export type ProfessionalShifts_Completed_HereArgs = {
  location_ids: Array<Scalars['Int']['input']>;
};

export type ProfessionalAssignmentFavorite = {
  __typename?: 'ProfessionalAssignmentFavorite';
  assignment: Assignment;
  assignment_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional?: Maybe<Professional>;
  professional_id: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalAssignmentFavoriteOrderInput = {
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalAssignmentFavoriteQueryInput = {
  filter?: InputMaybe<ProfessionalAssignmentFavoriteWhereInput>;
  orderBy?: InputMaybe<ProfessionalAssignmentFavoriteOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProfessionalAssignmentFavoriteSearchInput>;
};

export type ProfessionalAssignmentFavoriteSearchInput = {
  assignment_starts_date?: InputMaybe<Scalars['Date']['input']>;
  assignment_statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_assignment_request_statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalAssignmentFavoriteWhereInput = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalBlockReason = {
  __typename?: 'ProfessionalBlockReason';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  relationships?: Maybe<Array<Relationship>>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalBlockReasonOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalBlockReasonQueryInput = {
  filter?: InputMaybe<ProfessionalBlockReasonWhereInput>;
  orderBy?: InputMaybe<ProfessionalBlockReasonOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalBlockReasonWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalDistanceCheckInput = {
  coordinates?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalJobs = {
  __typename?: 'ProfessionalJobs';
  favorite?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Scalars['String']['output']>;
  total_hours?: Maybe<Scalars['Float']['output']>;
};

export type ProfessionalLimitWeeklyOvertimeInput = {
  ends_time: Scalars['DateTime']['input'];
  location_id: Scalars['Int']['input'];
  only_per_diem?: InputMaybe<Scalars['Boolean']['input']>;
  starts_time: Scalars['DateTime']['input'];
};

export type ProfessionalLocations = {
  location_ids: Array<InputMaybe<Scalars['Int']['input']>>;
  professional_id: Scalars['Int']['input'];
};

export type ProfessionalOrderInput = {
  account_id?: InputMaybe<Scalars['Boolean']['input']>;
  adp_file_number?: InputMaybe<Scalars['Boolean']['input']>;
  application_status?: InputMaybe<Scalars['Boolean']['input']>;
  background_check_authorized?: InputMaybe<Scalars['Boolean']['input']>;
  balance_cents?: InputMaybe<Scalars['Boolean']['input']>;
  balance_currency?: InputMaybe<Scalars['Boolean']['input']>;
  bank_last?: InputMaybe<Scalars['Boolean']['input']>;
  bookability?: InputMaybe<Bookability>;
  business_tax_id?: InputMaybe<Scalars['Boolean']['input']>;
  completed_video?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  credentials_status?: InputMaybe<Scalars['Boolean']['input']>;
  detailed_notes?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['Boolean']['input']>;
  drug_screening_completed?: InputMaybe<Scalars['Boolean']['input']>;
  has_item?: InputMaybe<Scalars['Boolean']['input']>;
  hours_need_updating?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invite_code?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  last_name_first_name?: InputMaybe<Scalars['Boolean']['input']>;
  last_updated_preferred_hours_at?: InputMaybe<Scalars['Boolean']['input']>;
  migrated_lead_id?: InputMaybe<Scalars['Boolean']['input']>;
  migrated_staff_id?: InputMaybe<Scalars['Boolean']['input']>;
  most_recent_shift_date?: InputMaybe<MostRecentShiftOrderInput>;
  nickname?: InputMaybe<Scalars['Boolean']['input']>;
  paylocity_external_id?: InputMaybe<Scalars['Boolean']['input']>;
  phone_screen_date_and_time?: InputMaybe<Scalars['Boolean']['input']>;
  plaid_token?: InputMaybe<Scalars['Boolean']['input']>;
  position_experience?: InputMaybe<Array<Scalars['Int']['input']>>;
  preferred_hours_per_week?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_job_types?: InputMaybe<Scalars['Boolean']['input']>;
  professional_assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  profile_completed?: InputMaybe<Scalars['Boolean']['input']>;
  profile_strength?: InputMaybe<Scalars['Boolean']['input']>;
  publishable_key?: InputMaybe<Scalars['Boolean']['input']>;
  recruiter_id?: InputMaybe<Scalars['Boolean']['input']>;
  rfm?: InputMaybe<Scalars['Boolean']['input']>;
  rfmf?: InputMaybe<Scalars['Boolean']['input']>;
  rfmr?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_bank_account_token?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_external_account_id?: InputMaybe<Scalars['Boolean']['input']>;
  tax_classification_id?: InputMaybe<Scalars['Boolean']['input']>;
  travel_email_notification?: InputMaybe<Scalars['Boolean']['input']>;
  travel_email_preferences?: InputMaybe<Scalars['Boolean']['input']>;
  tsv?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['Boolean']['input']>;
  unsatisfied_conditions?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  w2_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  w2_onboarding_complete?: InputMaybe<Scalars['Boolean']['input']>;
  welcome_box_sent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalPoolQueryInput = {
  filter?: InputMaybe<ProfessionalWhereInput>;
  orderBy?: InputMaybe<ProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProfessionalPoolSearchInput>;
};

export type ProfessionalPoolSearchInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adp_file_number?: InputMaybe<Scalars['String']['input']>;
  all_positions_onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  applied_to_assignment?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['Date']['input']>;
  created_at_from?: InputMaybe<Scalars['Date']['input']>;
  created_at_to?: InputMaybe<Scalars['Date']['input']>;
  credential_kind?: InputMaybe<Scalars['String']['input']>;
  credential_required?: InputMaybe<Scalars['Boolean']['input']>;
  credential_status?: InputMaybe<Scalars['Int']['input']>;
  credential_types?: InputMaybe<Array<Scalars['Int']['input']>>;
  credentials_status?: InputMaybe<Scalars['String']['input']>;
  distance_check?: InputMaybe<ProfessionalDistanceCheckInput>;
  ehr_system_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  experience?: InputMaybe<ExperienceInput>;
  has_recent_shift?: InputMaybe<Scalars['Boolean']['input']>;
  invited_only?: InputMaybe<Scalars['Boolean']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_id: Scalars['Int']['input'];
  market_id?: InputMaybe<Scalars['Int']['input']>;
  market_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  onboarding_pqa_status?: InputMaybe<OnboardingPqaStatusInput>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids_all?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids_onboarded?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  prior_to_onboarding?: InputMaybe<Scalars['Int']['input']>;
  pro_pool_credentialing_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  professional_type?: InputMaybe<Scalars['String']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  union_pros_invited_to_locations?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ProfessionalPosition = {
  __typename?: 'ProfessionalPosition';
  calculated_months_of_experience?: Maybe<Scalars['Int']['output']>;
  completed_onboarding_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  has_recent_experience: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  position: Position;
  position_id: Scalars['Int']['output'];
  professional: Professional;
  professional_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  years_of_experience?: Maybe<Scalars['Int']['output']>;
};


export type ProfessionalPositionHas_Recent_ExperienceArgs = {
  within_past_years?: Scalars['Int']['input'];
};

export type ProfessionalPositionOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalPositionQueryInput = {
  filter?: InputMaybe<ProfessionalPositionWhereInput>;
  orderBy?: InputMaybe<ProfessionalPositionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProfessionalPositionSearchInput>;
};

export type ProfessionalPositionSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalPositionWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalProfile = {
  __typename?: 'ProfessionalProfile';
  custom_professional_profile_ehr_systems?: Maybe<Array<CustomProfessionalProfileEhrSystem>>;
  educations?: Maybe<Array<Education>>;
  ehr_systems?: Maybe<Array<EhrSystem>>;
  id: Scalars['Int']['output'];
  professional?: Maybe<Professional>;
  professional_profile_ehr_systems?: Maybe<Array<ProfessionalProfileEhrSystem>>;
  professional_references?: Maybe<Array<ProfessionalReference>>;
  work_gaps?: Maybe<Array<WorkGap>>;
  work_histories?: Maybe<Array<WorkHistory>>;
};

export type ProfessionalProfileEhrSystem = {
  __typename?: 'ProfessionalProfileEhrSystem';
  created_at: Scalars['DateTime']['output'];
  ehr_system?: Maybe<EhrSystem>;
  ehr_system_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  professional_id?: Maybe<Scalars['Int']['output']>;
  professional_profile?: Maybe<ProfessionalProfile>;
  professional_profile_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalProfileEhrSystemOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalProfileEhrSystemQueryInput = {
  filter?: InputMaybe<ProfessionalProfileEhrSystemWhereInput>;
  orderBy?: InputMaybe<ProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalProfileEhrSystemWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  ehr_system_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalProfileOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalProfileQueryInput = {
  filter?: InputMaybe<ProfessionalProfileWhereInput>;
  orderBy?: InputMaybe<ProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalProfileWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_type?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalQualification = {
  __typename?: 'ProfessionalQualification';
  additional_rejection_context?: Maybe<Scalars['String']['output']>;
  admin_professional_qualification_attributes?: Maybe<Array<Maybe<ProfessionalQualificationAttribute>>>;
  created_at: Scalars['DateTime']['output'];
  credential_rejected_reason?: Maybe<CredentialRejectedReason>;
  credential_rejected_reason_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  last_updated_by_admin?: Maybe<Account>;
  last_updated_by_admin_id?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  professional: Professional;
  professional_id: Scalars['Int']['output'];
  professional_qualification_attributes?: Maybe<Array<ProfessionalQualificationAttribute>>;
  qualification: Qualification;
  qualification_id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalQualificationAttribute = {
  __typename?: 'ProfessionalQualificationAttribute';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  professional_qualification: ProfessionalQualification;
  professional_qualification_id: Scalars['Int']['output'];
  qualification_attribute?: Maybe<QualificationAttribute>;
  qualification_attribute_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  value: Scalars['ProfessionalQualificationAttributeValue']['output'];
};

export type ProfessionalQualificationAttributeOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalQualificationAttributeQueryInput = {
  filter?: InputMaybe<ProfessionalQualificationAttributeWhereInput>;
  orderBy?: InputMaybe<ProfessionalQualificationAttributeOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProfessionalQualificationAttributeSearchInput>;
};

export type ProfessionalQualificationAttributeSearchInput = {
  qa_active?: InputMaybe<Scalars['Boolean']['input']>;
  qa_input_sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProfessionalQualificationAttributeWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_qualification_id?: InputMaybe<Scalars['Int']['input']>;
  qualification_attribute_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalQualificationOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  credential_rejected_reason_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_updated_by_admin_id?: InputMaybe<Scalars['Boolean']['input']>;
  license_id?: InputMaybe<Scalars['Boolean']['input']>;
  license_status?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalQualificationQueryInput = {
  filter?: InputMaybe<ProfessionalQualificationWhereInput>;
  orderBy?: InputMaybe<ProfessionalQualificationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProfessionalQualificationSearchInput>;
};

export type ProfessionalQualificationSearchInput = {
  condition_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  expiring_professional_qualifications?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  not_archived?: InputMaybe<Scalars['Boolean']['input']>;
  not_uploaded_in_error?: InputMaybe<Scalars['Boolean']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_status?: InputMaybe<Scalars['String']['input']>;
  qualification_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  qualification_positions?: InputMaybe<QualificationPositionInput>;
  qualification_type?: InputMaybe<Scalars['String']['input']>;
  qualification_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  skills_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uploaded_by_saas_professional?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalQualificationWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  credential_rejected_reason_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by_admin_id?: InputMaybe<Scalars['Int']['input']>;
  license_id?: InputMaybe<Scalars['Int']['input']>;
  license_status?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalQueryInput = {
  filter?: InputMaybe<ProfessionalWhereInput>;
  orderBy?: InputMaybe<ProfessionalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProfessionalSearchInput>;
};

export type ProfessionalRecentExperience = {
  __typename?: 'ProfessionalRecentExperience';
  has_experience?: Maybe<Scalars['Boolean']['output']>;
  position_id?: Maybe<Scalars['Int']['output']>;
};

export type ProfessionalReference = {
  __typename?: 'ProfessionalReference';
  comments?: Maybe<Scalars['String']['output']>;
  contact_me: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  current_position?: Maybe<Scalars['Boolean']['output']>;
  date_obtained?: Maybe<Scalars['Date']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_valid: Scalars['Boolean']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  professional_profile?: Maybe<ProfessionalProfile>;
  professional_profile_id?: Maybe<Scalars['Int']['output']>;
  questions?: Maybe<Array<ReferenceQuestion>>;
  receive_emails: Scalars['Boolean']['output'];
  rehire_eligibility?: Maybe<Scalars['Boolean']['output']>;
  sent_times?: Maybe<Array<Scalars['DateTime']['output']>>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
  work_history?: Maybe<WorkHistory>;
  work_history_id?: Maybe<Scalars['Int']['output']>;
};

export type ProfessionalReferenceOrderInput = {
  end_date?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Boolean']['input']>;
  work_history_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalReferenceQueryInput = {
  filter?: InputMaybe<ProfessionalReferenceWhereInput>;
  orderBy?: InputMaybe<ProfessionalReferenceOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProfessionalReferenceSearchInput>;
};

export type ProfessionalReferenceSearchInput = {
  assignment_request_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalReferenceWhereInput = {
  assignment_request_id?: InputMaybe<Scalars['Int']['input']>;
  contact_me?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  date_obtained?: InputMaybe<Scalars['Date']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_valid?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Int']['input']>;
  rehire_eligibility?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  work_history_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalSaasDetail = {
  __typename?: 'ProfessionalSaasDetail';
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['Int']['output']>;
  employment_type: Scalars['String']['output'];
  hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  joined_at?: Maybe<Scalars['DateTime']['output']>;
  max_weekly_hours?: Maybe<Scalars['Float']['output']>;
  offboarded_at?: Maybe<Scalars['DateTime']['output']>;
  offboarded_reason?: Maybe<Scalars['String']['output']>;
  professional?: Maybe<Professional>;
  professional_id: Scalars['Int']['output'];
  shift_types?: Maybe<Scalars['JSON']['output']>;
};

export type ProfessionalSaasDetailOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalSaasDetailQueryInput = {
  filter?: InputMaybe<ProfessionalSaasDetailWhereInput>;
  orderBy?: InputMaybe<ProfessionalSaasDetailOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalSaasDetailWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalScreening = {
  __typename?: 'ProfessionalScreening';
  calendly_event_uuid?: Maybe<Scalars['String']['output']>;
  calendly_invitee_uuid?: Maybe<Scalars['String']['output']>;
  canceled_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  no_show: Scalars['Boolean']['output'];
  professional: Professional;
  professional_id: Scalars['Int']['output'];
  reason: ReasonType;
  scheduled_time?: Maybe<Scalars['DateTime']['output']>;
  screener_account: Account;
  screener_account_id: Scalars['Int']['output'];
  screening_type: ScreeningType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ProfessionalScreeningOrderInput = {
  calendly_event_uuid?: InputMaybe<Scalars['Boolean']['input']>;
  calendly_invitee_uuid?: InputMaybe<Scalars['Boolean']['input']>;
  canceled_at?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  no_show?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_time?: InputMaybe<Scalars['Boolean']['input']>;
  screener_account_id?: InputMaybe<Scalars['Boolean']['input']>;
  screening_type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalScreeningQueryInput = {
  filter?: InputMaybe<ProfessionalScreeningWhereInput>;
  orderBy?: InputMaybe<ProfessionalScreeningOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProfessionalScreeningSearchInput>;
};

export type ProfessionalScreeningSearchInput = {
  calendly_event_uuid?: InputMaybe<Scalars['String']['input']>;
  calendly_invitee_uuid?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  is_canceled?: InputMaybe<Scalars['Boolean']['input']>;
  no_show?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  scheduled_time?: InputMaybe<Scalars['DateTime']['input']>;
  screener_account_id?: InputMaybe<Scalars['Int']['input']>;
  screening_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalScreeningWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  screener_account_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalSearchInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_or_incomplete?: InputMaybe<Scalars['Boolean']['input']>;
  adp_file_number?: InputMaybe<Scalars['String']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  all_positions_onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  applied_to_assignment?: InputMaybe<Scalars['Int']['input']>;
  archive_reason?: InputMaybe<Scalars['String']['input']>;
  assignment_request_status?: InputMaybe<Scalars['String']['input']>;
  available_for_agency_assignment_id?: InputMaybe<Scalars['Int']['input']>;
  awaiting_caps?: InputMaybe<Scalars['Boolean']['input']>;
  background_check_status?: InputMaybe<Scalars['String']['input']>;
  blocked_by_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contract_range?: InputMaybe<ContractRangeInput>;
  created_at?: InputMaybe<Scalars['Date']['input']>;
  created_at_from?: InputMaybe<Scalars['Date']['input']>;
  created_at_to?: InputMaybe<Scalars['Date']['input']>;
  credential_kind?: InputMaybe<Scalars['String']['input']>;
  credential_required?: InputMaybe<Scalars['Boolean']['input']>;
  credential_status?: InputMaybe<Scalars['Int']['input']>;
  credential_types?: InputMaybe<Array<Scalars['Int']['input']>>;
  credentials_status?: InputMaybe<Scalars['String']['input']>;
  ehr_system_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<ExperienceInput>;
  expiring_credentials?: InputMaybe<Scalars['Int']['input']>;
  favorited_by_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  favorited_or_blocked_by_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  has_balance?: InputMaybe<Scalars['Boolean']['input']>;
  has_booked_jobs?: InputMaybe<Scalars['Boolean']['input']>;
  has_compact_license?: InputMaybe<Scalars['Boolean']['input']>;
  has_onboarded_positions?: InputMaybe<Scalars['Boolean']['input']>;
  has_recent_shift?: InputMaybe<Scalars['Boolean']['input']>;
  has_rn_state_license?: InputMaybe<Scalars['Int']['input']>;
  ignore_caps?: InputMaybe<Scalars['Boolean']['input']>;
  ignore_dl?: InputMaybe<Scalars['Boolean']['input']>;
  in_pool_for_location?: InputMaybe<Scalars['Int']['input']>;
  in_range_favorited_by_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  in_range_for_job?: InputMaybe<Scalars['Int']['input']>;
  in_range_for_job_or_incomplete?: InputMaybe<Scalars['Int']['input']>;
  in_workforce_for_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  irm_for_company_id?: InputMaybe<Scalars['Int']['input']>;
  irm_for_location_id?: InputMaybe<Scalars['Int']['input']>;
  is_agency_staff?: InputMaybe<Scalars['Boolean']['input']>;
  is_agency_staff_for_location_id?: InputMaybe<Scalars['Int']['input']>;
  is_facility_managed_agency?: InputMaybe<FacilityManagedAgency>;
  is_medely_internal?: InputMaybe<Scalars['Boolean']['input']>;
  is_saas_for_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_saas_professional?: InputMaybe<Scalars['Boolean']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit_weekly_overtime?: InputMaybe<ProfessionalLimitWeeklyOvertimeInput>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  market_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  market_state_id?: InputMaybe<Scalars['Int']['input']>;
  no_recruiter?: InputMaybe<Scalars['Boolean']['input']>;
  not_favorited_or_blocked_by_location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  on_1099_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  on_w2_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_pqa_status?: InputMaybe<OnboardingPqaStatusInput>;
  paylocity_external_id?: InputMaybe<Scalars['String']['input']>;
  phone_interviewed?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids_all?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  prior_to_onboarding?: InputMaybe<Scalars['Int']['input']>;
  pro_pool_credentialing_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  professional_type?: InputMaybe<Scalars['String']['input']>;
  profile_approved?: InputMaybe<Scalars['Boolean']['input']>;
  profile_approved_since?: InputMaybe<Scalars['Date']['input']>;
  profile_strength?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  qualification_status?: InputMaybe<Scalars['String']['input']>;
  recruiter_id?: InputMaybe<Scalars['Int']['input']>;
  referral_source_id?: InputMaybe<Scalars['Int']['input']>;
  reject_reason?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  requested_for_job_id?: InputMaybe<Scalars['Int']['input']>;
  required_qualifications?: InputMaybe<Scalars['Boolean']['input']>;
  screening_recruiter_id?: InputMaybe<Scalars['Int']['input']>;
  signup_assignment?: InputMaybe<Scalars['Int']['input']>;
  signup_assignment_id?: InputMaybe<Scalars['Int']['input']>;
  sms_notification?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_state_id?: InputMaybe<Scalars['Int']['input']>;
  travel_position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  travel_state_id?: InputMaybe<Scalars['Int']['input']>;
  union_pros_invited_to_locations?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  welcome_box_sent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalSkillsAssessmentsAnswer = {
  __typename?: 'ProfessionalSkillsAssessmentsAnswer';
  id?: Maybe<Scalars['Int']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  skills_question?: Maybe<SkillsQuestion>;
  skills_question_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProfessionalSkillsAssessmentsAnswerOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalSkillsAssessmentsAnswerQueryInput = {
  filter?: InputMaybe<ProfessionalSkillsAssessmentsAnswerWhereInput>;
  orderBy?: InputMaybe<ProfessionalSkillsAssessmentsAnswerOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ProfessionalSkillsAssessmentsAnswerSearchInput>;
};

export type ProfessionalSkillsAssessmentsAnswerSearchInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  skills_assessment_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalSkillsAssessmentsAnswerWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ProfessionalSpecialty = {
  __typename?: 'ProfessionalSpecialty';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalSpecialtyOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalSpecialtyQueryInput = {
  filter?: InputMaybe<ProfessionalSpecialtyWhereInput>;
  orderBy?: InputMaybe<ProfessionalSpecialtyOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalSpecialtyWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalTodos = {
  __typename?: 'ProfessionalTodos';
  active_jobs_requesting_to_work_facility_ids?: Maybe<Array<Scalars['Int']['output']>>;
  active_jobs_requesting_to_work_ids?: Maybe<Array<Scalars['Int']['output']>>;
  assignment_offers?: Maybe<Array<Scalars['Int']['output']>>;
  assignments_missing_conditions?: Maybe<Array<Scalars['Int']['output']>>;
  available_for_extensions?: Maybe<Array<Scalars['Int']['output']>>;
  booked_jobs_count?: Maybe<Scalars['Int']['output']>;
  campaigns_status: Array<Scalars['JSON']['output']>;
  days_until_debit_card_expires?: Maybe<Scalars['Int']['output']>;
  disputes_waiting_on_professional?: Maybe<Array<Scalars['Int']['output']>>;
  expired_or_missing_credentials_count?: Maybe<Scalars['Int']['output']>;
  extension_offers?: Maybe<Array<Scalars['Int']['output']>>;
  finished_jobs_count?: Maybe<Scalars['Int']['output']>;
  has_invalid_credentials?: Maybe<Scalars['Boolean']['output']>;
  has_position_with_completed_onboarding?: Maybe<Scalars['Boolean']['output']>;
  incomplete_skill_assessments_count?: Maybe<Scalars['Int']['output']>;
  missing_direct_deposit?: Maybe<Scalars['Boolean']['output']>;
  missing_premier_credentials?: Maybe<Scalars['Boolean']['output']>;
  missing_ssn_for_assignment?: Maybe<Scalars['Boolean']['output']>;
  missing_w2_per_diem_onboarding?: Maybe<Scalars['Boolean']['output']>;
  needs_emergency_contact?: Maybe<Scalars['Boolean']['output']>;
  needs_payment_info?: Maybe<Scalars['Boolean']['output']>;
  next_shift?: Maybe<Scalars['JSON']['output']>;
  notifications_turned_on?: Maybe<Scalars['Boolean']['output']>;
  offers_count?: Maybe<Scalars['Int']['output']>;
  pending_pro_pool_invites: Array<PoolInviteTodo>;
  pending_pro_pool_onboarding: Array<PoolOnboardingTodo>;
  pending_pro_pool_orientation: Array<PoolOrientationTodo>;
  permanent_placement_offers?: Maybe<Array<Scalars['Int']['output']>>;
  professional_account_id?: Maybe<Scalars['Int']['output']>;
  profile_completeness?: Maybe<Scalars['String']['output']>;
  rescreening: Scalars['Boolean']['output'];
  sms_turned_on?: Maybe<Scalars['Boolean']['output']>;
  unsigned_addendum_assignment_ids?: Maybe<Array<Scalars['Int']['output']>>;
  unsigned_timesheet_ids?: Maybe<Array<Scalars['Int']['output']>>;
  w2_interest_card?: Maybe<Scalars['Boolean']['output']>;
};

export type ProfessionalTravelAssignmentState = {
  __typename?: 'ProfessionalTravelAssignmentState';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalTravelAssignmentStateOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalTravelAssignmentStateQueryInput = {
  filter?: InputMaybe<ProfessionalTravelAssignmentStateWhereInput>;
  orderBy?: InputMaybe<ProfessionalTravelAssignmentStateOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalTravelAssignmentStateWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfessionalTravelPosition = {
  __typename?: 'ProfessionalTravelPosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProfessionalTravelPositionOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalTravelPositionQueryInput = {
  filter?: InputMaybe<ProfessionalTravelPositionWhereInput>;
  orderBy?: InputMaybe<ProfessionalTravelPositionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ProfessionalTravelPositionWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ProfessionalWeeklyOvertimeSetting {
  AllowAll = 'allow_all',
  AllowSelect = 'allow_select',
  BlockAll = 'block_all'
}

export type ProfessionalWhereInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  adp_file_number?: InputMaybe<Scalars['String']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  application_status?: InputMaybe<Scalars['String']['input']>;
  background_check_authorized?: InputMaybe<Scalars['Boolean']['input']>;
  balance_cents?: InputMaybe<Scalars['Int']['input']>;
  balance_currency?: InputMaybe<Scalars['String']['input']>;
  bank_last?: InputMaybe<Scalars['String']['input']>;
  business_tax_id?: InputMaybe<Scalars['String']['input']>;
  completed_video?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  credentials_status?: InputMaybe<Scalars['String']['input']>;
  detailed_notes?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  drug_screening_completed?: InputMaybe<Scalars['Boolean']['input']>;
  has_item?: InputMaybe<Scalars['Boolean']['input']>;
  hours_need_updating?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invite_code?: InputMaybe<Scalars['String']['input']>;
  irm_for_company_id?: InputMaybe<Scalars['Int']['input']>;
  irm_for_location_id?: InputMaybe<Scalars['Int']['input']>;
  is_agency_staff?: InputMaybe<Scalars['Boolean']['input']>;
  is_medely_internal?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last_updated_preferred_hours_at?: InputMaybe<Scalars['DateTime']['input']>;
  migrated_lead_id?: InputMaybe<Scalars['Int']['input']>;
  migrated_staff_id?: InputMaybe<Scalars['Int']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  paylocity_external_id?: InputMaybe<Scalars['String']['input']>;
  phone_interviewed?: InputMaybe<Scalars['Boolean']['input']>;
  plaid_token?: InputMaybe<Scalars['String']['input']>;
  possible_duplicate?: InputMaybe<Scalars['Boolean']['input']>;
  preferred_hours_per_week?: InputMaybe<Scalars['Int']['input']>;
  preferred_job_types?: InputMaybe<Scalars['String']['input']>;
  professional_assignment_id?: InputMaybe<Scalars['Int']['input']>;
  profile_completed?: InputMaybe<Scalars['Boolean']['input']>;
  profile_strength?: InputMaybe<Scalars['Int']['input']>;
  publishable_key?: InputMaybe<Scalars['String']['input']>;
  recruiter_id?: InputMaybe<Scalars['Int']['input']>;
  rfm?: InputMaybe<Scalars['String']['input']>;
  rfmf?: InputMaybe<Scalars['Int']['input']>;
  rfmr?: InputMaybe<Scalars['Int']['input']>;
  screener_account_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_bank_account_token?: InputMaybe<Scalars['String']['input']>;
  stripe_external_account_id?: InputMaybe<Scalars['String']['input']>;
  tax_classification_id?: InputMaybe<Scalars['Int']['input']>;
  travel_email_notification?: InputMaybe<Scalars['Boolean']['input']>;
  travel_email_preferences?: InputMaybe<Scalars['String']['input']>;
  unsubscribe_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  w2_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  w2_onboarding_complete?: InputMaybe<Scalars['Boolean']['input']>;
  welcome_box_sent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalsJobsInput = {
  ends_date: Scalars['Date']['input'];
  location_ids: Array<InputMaybe<Scalars['Int']['input']>>;
  starts_date: Scalars['Date']['input'];
};

export type ProfileStats = {
  __typename?: 'ProfileStats';
  do_not_sends_count?: Maybe<Scalars['Int']['output']>;
  favorites_count?: Maybe<Scalars['Int']['output']>;
  jobs_completed_count?: Maybe<Scalars['Int']['output']>;
  late_cancellations_count?: Maybe<Scalars['Int']['output']>;
  no_shows_count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Qualification = {
  __typename?: 'Qualification';
  admin_view_only: Scalars['Boolean']['output'];
  conditions?: Maybe<Array<Condition>>;
  default_verification_title?: Maybe<Scalars['String']['output']>;
  display_category?: Maybe<Scalars['String']['output']>;
  display_description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  input_source: Scalars['String']['output'];
  instructions?: Maybe<Scalars['JSON']['output']>;
  long_name: Scalars['String']['output'];
  qualification_attributes?: Maybe<Array<QualificationAttribute>>;
  qualification_automations?: Maybe<Array<QualificationAutomation>>;
  qualification_type: Scalars['String']['output'];
  short_name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  targets: Array<Scalars['String']['output']>;
};

export type QualificationAttribute = {
  __typename?: 'QualificationAttribute';
  active: Scalars['Boolean']['output'];
  data: Scalars['JSON']['output'];
  field_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  input_source: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qualification?: Maybe<Qualification>;
  qualification_automation_attributes?: Maybe<Array<QualificationAutomationAttribute>>;
  required: Scalars['Boolean']['output'];
  required_for_approval: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type QualificationAttributeOption = {
  __typename?: 'QualificationAttributeOption';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type QualificationAttributeOrderInput = {
  field_type?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QualificationAttributeQueryInput = {
  filter?: InputMaybe<QualificationAttributeWhereInput>;
  orderBy?: InputMaybe<QualificationAttributeOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<QualificationAttributeSearchInput>;
};

export type QualificationAttributeSearchInput = {
  input_sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QualificationAttributeWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  qualification_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QualificationAutomation = {
  __typename?: 'QualificationAutomation';
  backend_only: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  loading_text?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  qualification?: Maybe<Qualification>;
  qualification_automation_attributes?: Maybe<Array<QualificationAutomationAttribute>>;
  service_class: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type QualificationAutomationAttribute = {
  __typename?: 'QualificationAutomationAttribute';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  qualification_attribute?: Maybe<QualificationAttribute>;
  qualification_automation?: Maybe<QualificationAutomation>;
  required?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type QualificationAutomationAttributeOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  qualification_attribute_id?: InputMaybe<Scalars['Boolean']['input']>;
  qualification_automation_id?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QualificationAutomationAttributeQueryInput = {
  filter?: InputMaybe<QualificationAutomationAttributeWhereInput>;
  orderBy?: InputMaybe<QualificationAutomationAttributeOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<QualificationAutomationAttributeSearchInput>;
};

export type QualificationAutomationAttributeSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QualificationAutomationAttributeWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  qualification_attribute_id?: InputMaybe<Scalars['Int']['input']>;
  qualification_automation_id?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QualificationAutomationOrderInput = {
  backend_only?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  qualification_id?: InputMaybe<Scalars['Boolean']['input']>;
  service_class?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QualificationAutomationQueryInput = {
  filter?: InputMaybe<QualificationAutomationWhereInput>;
  orderBy?: InputMaybe<QualificationAutomationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<QualificationAutomationSearchInput>;
};

export type QualificationAutomationSearchInput = {
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QualificationAutomationWhereInput = {
  backend_only?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  qualification_id?: InputMaybe<Scalars['Int']['input']>;
  service_class?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QualificationOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  long_name?: InputMaybe<Scalars['Boolean']['input']>;
  qualification_type?: InputMaybe<Scalars['String']['input']>;
};

export type QualificationPositionInput = {
  for_application: Scalars['Boolean']['input'];
  for_on_boarding: Scalars['Boolean']['input'];
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type QualificationQueryInput = {
  filter?: InputMaybe<QualificationWhereInput>;
  orderBy?: InputMaybe<QualificationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<QualificationSearchInput>;
};

export type QualificationSearchInput = {
  available_to_agency?: InputMaybe<Scalars['Int']['input']>;
  available_to_professional?: InputMaybe<Scalars['Int']['input']>;
  condition_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclude_slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  missing_conditions?: InputMaybe<Missing_Conditions_Input>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  qualification_types?: InputMaybe<Array<Scalars['String']['input']>>;
  required_conditions?: InputMaybe<Required_Conditions_Input>;
  targets?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QualificationWhereInput = {
  admin_view_only?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  input_source?: InputMaybe<Scalars['String']['input']>;
  qualification_type?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QualificationsGroup = {
  __typename?: 'QualificationsGroup';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type QualificationsGroupOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QualificationsGroupQueryInput = {
  filter?: InputMaybe<QualificationsGroupWhereInput>;
  orderBy?: InputMaybe<QualificationsGroupOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type QualificationsGroupWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Query = {
  __typename?: 'Query';
  _accountBillingGroupsMeta?: Maybe<ListMeta>;
  _accountLocationsMeta?: Maybe<ListMeta>;
  _accountsMeta?: Maybe<ListMeta>;
  _administratorsMeta?: Maybe<ListMeta>;
  _agenciesMeta?: Maybe<ListMeta>;
  _agencyChargeOverridesMeta?: Maybe<ListMeta>;
  _agencyLocationPositionRateSettingsMeta?: Maybe<ListMeta>;
  _agencyLocationRateSettingsMeta?: Maybe<ListMeta>;
  _agencyLocationsMeta?: Maybe<ListMeta>;
  _agencyQualificationAttributesMeta?: Maybe<ListMeta>;
  _agencyQualificationsMeta?: Maybe<ListMeta>;
  _applicationRequirementsMeta?: Maybe<ListMeta>;
  _approvalGroupsMeta?: Maybe<ListMeta>;
  _approvalsMeta?: Maybe<ListMeta>;
  _assignmentBillingGroupsMeta?: Maybe<ListMeta>;
  _assignmentLocationsMeta?: Maybe<ListMeta>;
  _assignmentMeta?: Maybe<AssignmentMeta>;
  _assignmentProfilesMeta?: Maybe<ListMeta>;
  _assignmentRequestsMeta?: Maybe<ListMeta>;
  _assignmentsMeta?: Maybe<ListMeta>;
  _assignmentsPreviewsMeta?: Maybe<ListMeta>;
  _auditsMeta?: Maybe<ListMeta>;
  _availableAssignmentsMeta?: Maybe<AvailableAssignmentsMeta>;
  _availableJobsMeta?: Maybe<ListMeta>;
  _availablePlacementsMeta?: Maybe<AvailableAssignmentsMeta>;
  _backgroundChecksMeta?: Maybe<ListMeta>;
  _balanceSheetsMeta?: Maybe<ListMeta>;
  _billingActivitiesMeta?: Maybe<ListMeta>;
  _billingContactsMeta?: Maybe<ListMeta>;
  _billingGroupCreditLimitCalculationsMeta?: Maybe<ListMeta>;
  _billingGroupManagementCompaniesMeta?: Maybe<ListMeta>;
  _billingGroupParentsMeta?: Maybe<ListMeta>;
  _billingGroupsMeta?: Maybe<ListMeta>;
  _breaksMeta?: Maybe<ListMeta>;
  _cancellationReasonsMeta?: Maybe<ListMeta>;
  _cancellationsMeta?: Maybe<ListMeta>;
  _capsReportsMeta?: Maybe<ListMeta>;
  _checkInsMeta?: Maybe<ListMeta>;
  _checkOutsMeta?: Maybe<ListMeta>;
  _checksMeta?: Maybe<ListMeta>;
  _clinicalContactsMeta?: Maybe<ListMeta>;
  _companiesMeta?: Maybe<ListMeta>;
  _conditionDocumentsMeta?: Maybe<ListMeta>;
  _conditionsMeta?: Maybe<ListMeta>;
  _contractsMeta?: Maybe<ListMeta>;
  _credentialRejectedReasonsMeta?: Maybe<ListMeta>;
  _creditNotesMeta?: Maybe<ListMeta>;
  _customProfessionalProfileEhrSystemsMeta?: Maybe<ListMeta>;
  _dataTestsMeta?: Maybe<ListMeta>;
  _deprecatedInvoicesMeta?: Maybe<ListMeta>;
  _disabledReasonsMeta?: Maybe<ListMeta>;
  _disputeShiftWitnessesMeta?: Maybe<ListMeta>;
  _disputedJobBillingsMeta?: Maybe<ListMeta>;
  _disputesMeta?: Maybe<ListMeta>;
  _educationsMeta?: Maybe<ListMeta>;
  _ehrSystemsMeta?: Maybe<ListMeta>;
  _emergencyContactsMeta?: Maybe<ListMeta>;
  _expenseAdjustmentsMeta?: Maybe<ListMeta>;
  _externalAccountsMeta?: Maybe<ListMeta>;
  _facilityConnectionsMeta?: Maybe<ListMeta>;
  _financialTransactionsMeta?: Maybe<ListMeta>;
  _fundingSourcesMeta?: Maybe<ListMeta>;
  _gatewayInvoicesMeta?: Maybe<ListMeta>;
  _gatewayStatementsMeta?: Maybe<ListMeta>;
  _getProPoolDashboardMeta?: Maybe<ListMeta>;
  _healthSystemsMeta?: Maybe<ListMeta>;
  _interviewAvailabilitiesMeta?: Maybe<ListMeta>;
  _invoicesMeta?: Maybe<ListMeta>;
  _itemizedTransactionsMeta?: Maybe<ListMeta>;
  _jobBillingsMeta?: Maybe<ListMeta>;
  _jobIrregularitiesMeta?: Maybe<ListMeta>;
  _jobPriceDifferentialsMeta?: Maybe<ListMeta>;
  _jobProfilesMeta?: Maybe<ListMeta>;
  /** @deprecated use JobProfile */
  _jobPublishingGroupsMeta?: Maybe<ListMeta>;
  _jobRateTrackedEventsMeta?: Maybe<ListMeta>;
  _jobSurgeryTypesMeta?: Maybe<ListMeta>;
  _jobTemplatesMeta?: Maybe<ListMeta>;
  _jobTracksMeta?: Maybe<ListMeta>;
  _jobsBoardPositionsMeta?: Maybe<ListMeta>;
  _jobsBoardsMeta?: Maybe<ListMeta>;
  _jobsMeta?: Maybe<ListMeta>;
  _lineOfCreditsMeta?: Maybe<ListMeta>;
  _localRateRulesMeta?: Maybe<ListMeta>;
  _locationBillingGroupsMeta?: Maybe<ListMeta>;
  _locationBlockReasonsMeta?: Maybe<ListMeta>;
  _locationGroupsMeta?: Maybe<ListMeta>;
  _locationPositionRateSettingsMeta?: Maybe<ListMeta>;
  _locationPositionsMeta?: Maybe<ListMeta>;
  _locationRateSettingsMeta?: Maybe<ListMeta>;
  _locationTypePositionsMeta?: Maybe<ListMeta>;
  _locationTypesMeta?: Maybe<ListMeta>;
  _locationsMeta?: Maybe<ListMeta>;
  _marketLocationTypePositionRateSettingsMeta?: Maybe<ListMeta>;
  _marketLocationTypeRateSettingsMeta?: Maybe<ListMeta>;
  _marketLocationsMeta?: Maybe<ListMeta>;
  _marketPositionRateSettingsMeta?: Maybe<ListMeta>;
  _marketRateSettingsMeta?: Maybe<ListMeta>;
  _marketsMeta?: Maybe<ListMeta>;
  _marketsProfessionalsMeta?: Maybe<ListMeta>;
  _mspsMeta?: Maybe<ListMeta>;
  _netTermsMeta?: Maybe<ListMeta>;
  _notesMeta?: Maybe<ListMeta>;
  _nursysEnrollmentsMeta?: Maybe<ListMeta>;
  _paymentsMeta?: Maybe<ListMeta>;
  _payoutsMeta?: Maybe<ListMeta>;
  _peopleMeta?: Maybe<ListMeta>;
  _permanentPlacementsMeta?: Maybe<AvailableAssignmentsMeta>;
  _permanentRequestsMeta?: Maybe<ListMeta>;
  _permissionGroupsMeta?: Maybe<ListMeta>;
  _personDisabledReasonsMeta?: Maybe<ListMeta>;
  _phoneScreeningRequestsMeta?: Maybe<ListMeta>;
  _poolProfessionalsMeta?: Maybe<ListMeta>;
  _poolsMeta?: Maybe<ListMeta>;
  _positionPostingFieldsMeta?: Maybe<ListMeta>;
  _positionSpecialtiesMeta?: Maybe<ListMeta>;
  _positionsMeta?: Maybe<ListMeta>;
  _postingFieldsMeta?: Maybe<ListMeta>;
  _professionalAssignmentFavoritesMeta?: Maybe<ListMeta>;
  _professionalBlockReasonsMeta?: Maybe<ListMeta>;
  _professionalPositionsMeta?: Maybe<ListMeta>;
  _professionalProfileEhrSystemsMeta?: Maybe<ListMeta>;
  _professionalProfilesMeta?: Maybe<ListMeta>;
  _professionalQualificationAttributesMeta?: Maybe<ListMeta>;
  _professionalQualificationsMeta?: Maybe<ListMeta>;
  _professionalReferencesMeta?: Maybe<ListMeta>;
  _professionalSaasDetailsMeta?: Maybe<ListMeta>;
  _professionalScreeningsMeta?: Maybe<ListMeta>;
  _professionalSkillsAssessmentsAnswersMeta?: Maybe<ListMeta>;
  _professionalSpecialtiesMeta?: Maybe<ListMeta>;
  _professionalTravelAssignmentStatesMeta?: Maybe<ListMeta>;
  _professionalTravelPositionsMeta?: Maybe<ListMeta>;
  _professionalsMeta?: Maybe<ListMeta>;
  _qualificationAttributesMeta?: Maybe<ListMeta>;
  _qualificationAutomationAttributesMeta?: Maybe<ListMeta>;
  _qualificationAutomationsMeta?: Maybe<ListMeta>;
  _qualificationsGroupsMeta?: Maybe<ListMeta>;
  _qualificationsMeta?: Maybe<ListMeta>;
  _questionnaireResponsesMeta?: Maybe<ListMeta>;
  _questionnairesMeta?: Maybe<ListMeta>;
  _rateCalculatorsMeta?: Maybe<ListMeta>;
  _rateSettingsMeta?: Maybe<ListMeta>;
  _referralSourcesMeta?: Maybe<ListMeta>;
  _refundsMeta?: Maybe<ListMeta>;
  _relationshipsMeta?: Maybe<ListMeta>;
  _requirementsMeta?: Maybe<ListMeta>;
  _revenueAdjustmentsMeta?: Maybe<ListMeta>;
  _reviewsMeta?: Maybe<ListMeta>;
  _skillsAssessmentBaksMeta?: Maybe<ListMeta>;
  _skillsAssessmentResponseBaksMeta?: Maybe<ListMeta>;
  _skillsAssessmentSkillsQuestionsMeta?: Maybe<ListMeta>;
  _skillsAssessmentsMeta?: Maybe<ListMeta>;
  _skillsQuestionsMeta?: Maybe<ListMeta>;
  _socialProofMarketActivityMeta?: Maybe<ListMeta>;
  _specialtiesMeta?: Maybe<ListMeta>;
  _staffBlockReasonsMeta?: Maybe<ListMeta>;
  _stateLocationTypePositionRateSettingsMeta?: Maybe<ListMeta>;
  _stateLocationTypeRateSettingsMeta?: Maybe<ListMeta>;
  _statePositionRateSettingsMeta?: Maybe<ListMeta>;
  _stateRateSettingsMeta?: Maybe<ListMeta>;
  _statementsMeta?: Maybe<ListMeta>;
  _statesMeta?: Maybe<ListMeta>;
  _stripeAccountsMeta?: Maybe<ListMeta>;
  _stripePaymentIntentsMeta?: Maybe<ListMeta>;
  _stripeRepresentativesMeta?: Maybe<ListMeta>;
  _surgeryTypesMeta?: Maybe<ListMeta>;
  _taxClassificationsMeta?: Maybe<ListMeta>;
  _taxFormsMeta?: Maybe<ListMeta>;
  _timecardsMeta?: Maybe<ListMeta>;
  _transferReversalsMeta?: Maybe<ListMeta>;
  _uniqueAgencyChargeOverridesMeta?: Maybe<ListMeta>;
  _universalBackgroundChecksMeta?: Maybe<ListMeta>;
  _userPositionRateSettingsMeta?: Maybe<ListMeta>;
  _userPositionsMeta?: Maybe<ListMeta>;
  _userRateSettingsMeta?: Maybe<ListMeta>;
  _usersMeta?: Maybe<ListMeta>;
  _vmsAssignmentsMeta?: Maybe<ListMeta>;
  _vmsPositionsMeta?: Maybe<ListMeta>;
  _vmsTypesMeta?: Maybe<ListMeta>;
  _vmsUsersMeta?: Maybe<ListMeta>;
  _wageLogsMeta?: Maybe<ListMeta>;
  _workGapsMeta?: Maybe<ListMeta>;
  _workHistoriesMeta?: Maybe<ListMeta>;
  account?: Maybe<Account>;
  accountBillingGroup?: Maybe<AccountBillingGroup>;
  accountBillingGroups?: Maybe<Array<AccountBillingGroup>>;
  accountLocation?: Maybe<AccountLocation>;
  accountLocations?: Maybe<Array<AccountLocation>>;
  accountRequestPermissions?: Maybe<Scalars['JSON']['output']>;
  accounts?: Maybe<Array<Account>>;
  administrator?: Maybe<Administrator>;
  administrators?: Maybe<Array<Administrator>>;
  agencies?: Maybe<Array<Agency>>;
  agency?: Maybe<Agency>;
  agencyChargeOverrides: Array<AgencyChargeOverrides>;
  agencyLocation?: Maybe<AgencyLocation>;
  agencyLocationPositionRateSetting?: Maybe<AgencyLocationPositionRateSetting>;
  agencyLocationPositionRateSettings?: Maybe<Array<AgencyLocationPositionRateSetting>>;
  agencyLocationRateSetting?: Maybe<AgencyLocationRateSetting>;
  agencyLocationRateSettings?: Maybe<Array<AgencyLocationRateSetting>>;
  agencyLocations?: Maybe<Array<AgencyLocation>>;
  agencyQualification?: Maybe<AgencyQualification>;
  agencyQualificationAttribute?: Maybe<AgencyQualificationAttribute>;
  agencyQualificationAttributes?: Maybe<Array<AgencyQualificationAttribute>>;
  agencyQualifications?: Maybe<Array<AgencyQualification>>;
  appVersion?: Maybe<AppVersion>;
  appVersions: Array<AppVersion>;
  applicationRequirement?: Maybe<ApplicationRequirement>;
  applicationRequirements?: Maybe<Array<ApplicationRequirement>>;
  approval?: Maybe<Approval>;
  approvalGroup?: Maybe<ApprovalGroup>;
  approvalGroups: Array<ApprovalGroup>;
  approvals: Array<Approval>;
  assignment?: Maybe<Assignment>;
  assignmentBillingGroup?: Maybe<AssignmentBillingGroup>;
  assignmentBillingGroups?: Maybe<Array<AssignmentBillingGroup>>;
  assignmentCancellationReasons?: Maybe<AssignmentCancellationReasons>;
  assignmentCancellationReasonsV2?: Maybe<AssignmentCancellationReasonsV2>;
  assignmentLocation?: Maybe<AssignmentLocation>;
  assignmentLocations?: Maybe<Array<AssignmentLocation>>;
  assignmentPreview?: Maybe<Assignment>;
  assignmentProfile?: Maybe<AssignmentProfile>;
  assignmentProfiles?: Maybe<Array<AssignmentProfile>>;
  assignmentRequest?: Maybe<AssignmentRequest>;
  assignmentRequests?: Maybe<Array<AssignmentRequest>>;
  assignments?: Maybe<Array<Assignment>>;
  assignmentsEndingSoon?: Maybe<Array<AssignmentPanelCount>>;
  assignmentsPreviews?: Maybe<Array<Assignment>>;
  assignmentsStartingSoon?: Maybe<Array<AssignmentPanelCount>>;
  audit?: Maybe<Audit>;
  audits: Array<Audit>;
  availableAssignment?: Maybe<Assignment>;
  availableAssignments?: Maybe<Array<Assignment>>;
  availableJob?: Maybe<Job>;
  availableJobs?: Maybe<Array<Job>>;
  availablePlacement?: Maybe<Assignment>;
  availablePlacements?: Maybe<Array<Assignment>>;
  backgroundCheck?: Maybe<BackgroundCheck>;
  backgroundChecks?: Maybe<Array<BackgroundCheck>>;
  balanceSheet?: Maybe<BalanceSheet>;
  balanceSheets?: Maybe<Array<BalanceSheet>>;
  billingActivities?: Maybe<Array<BillingActivity>>;
  billingContact?: Maybe<BillingContact>;
  billingContacts?: Maybe<Array<BillingContact>>;
  billingGroup?: Maybe<BillingGroup>;
  billingGroupCreditLimitCalculation?: Maybe<BillingGroupCreditLimitCalculation>;
  billingGroupCreditLimitCalculations?: Maybe<Array<BillingGroupCreditLimitCalculation>>;
  billingGroupManagementCompanies?: Maybe<Array<BillingGroupManagementCompany>>;
  billingGroupManagementCompany?: Maybe<BillingGroupManagementCompany>;
  billingGroupParent?: Maybe<BillingGroupParent>;
  billingGroupParents?: Maybe<Array<BillingGroupParent>>;
  billingGroups?: Maybe<Array<BillingGroup>>;
  blockedJobs?: Maybe<Array<Job>>;
  break?: Maybe<Break>;
  breaks?: Maybe<Array<Break>>;
  cancellation?: Maybe<Cancellation>;
  cancellationReason?: Maybe<CancellationReason>;
  cancellationReasons?: Maybe<Array<CancellationReason>>;
  cancellations?: Maybe<Array<Cancellation>>;
  capsReport?: Maybe<CapsReport>;
  capsReports?: Maybe<Array<CapsReport>>;
  check?: Maybe<Check>;
  checkIn?: Maybe<CheckIn>;
  checkIns?: Maybe<Array<CheckIn>>;
  checkOut?: Maybe<CheckOut>;
  checkOuts?: Maybe<Array<CheckOut>>;
  checks?: Maybe<Array<Check>>;
  clinicalContact?: Maybe<ClinicalContact>;
  clinicalContacts?: Maybe<Array<ClinicalContact>>;
  clockEventAttachment?: Maybe<ClockEventAttachment>;
  clockEventAttachments?: Maybe<Array<ClockEventAttachment>>;
  companies?: Maybe<Array<Company>>;
  company?: Maybe<Company>;
  condition?: Maybe<Condition>;
  conditionDocument?: Maybe<ConditionDocument>;
  conditionDocuments?: Maybe<Array<ConditionDocument>>;
  conditions?: Maybe<Array<Condition>>;
  contract?: Maybe<Contract>;
  contracts?: Maybe<Array<Contract>>;
  credentialRejectedReason?: Maybe<CredentialRejectedReason>;
  credentialRejectedReasons?: Maybe<Array<CredentialRejectedReason>>;
  creditNote?: Maybe<CreditNote>;
  creditNotes?: Maybe<Array<CreditNote>>;
  customProfessionalProfileEhrSystem?: Maybe<CustomProfessionalProfileEhrSystem>;
  customProfessionalProfileEhrSystems?: Maybe<Array<CustomProfessionalProfileEhrSystem>>;
  dashboardStats?: Maybe<DashboardStats>;
  dataTest?: Maybe<DataTest>;
  dataTests?: Maybe<Array<Maybe<DataTest>>>;
  deprecatedInvoice?: Maybe<DeprecatedInvoice>;
  deprecatedInvoices?: Maybe<Array<DeprecatedInvoice>>;
  disabledReason?: Maybe<DisabledReason>;
  disabledReasons?: Maybe<Array<DisabledReason>>;
  dispute?: Maybe<Dispute>;
  disputeShiftWitness?: Maybe<DisputeShiftWitness>;
  disputeShiftWitnesses?: Maybe<Array<DisputeShiftWitness>>;
  disputedJobBilling?: Maybe<DisputedJobBilling>;
  disputedJobBillings?: Maybe<Array<Maybe<DisputedJobBilling>>>;
  disputes?: Maybe<Array<Dispute>>;
  education?: Maybe<Education>;
  educations?: Maybe<Array<Education>>;
  ehrSystem?: Maybe<EhrSystem>;
  ehrSystems?: Maybe<Array<EhrSystem>>;
  emergencyContact?: Maybe<EmergencyContact>;
  emergencyContacts?: Maybe<Array<EmergencyContact>>;
  expenseAdjustment?: Maybe<ExpenseAdjustment>;
  expenseAdjustments?: Maybe<Array<ExpenseAdjustment>>;
  externalAccount?: Maybe<ExternalAccount>;
  externalAccounts?: Maybe<Array<ExternalAccount>>;
  facilityConnection?: Maybe<FacilityConnection>;
  facilityConnections?: Maybe<Array<FacilityConnection>>;
  favoritesPanelRows: Array<FavoritesPanelRow>;
  financialTransaction?: Maybe<FinancialTransaction>;
  financialTransactions?: Maybe<Array<FinancialTransaction>>;
  fundingSource?: Maybe<FundingSource>;
  fundingSources?: Maybe<Array<FundingSource>>;
  gatewayBillingGroup?: Maybe<BillingGroup>;
  gatewayBillingGroupCreditLimitCalculation?: Maybe<BillingGroupCreditLimitCalculation>;
  gatewayConditionDocuments?: Maybe<Array<ConditionDocument>>;
  gatewayInvoice?: Maybe<Invoice>;
  gatewayInvoices?: Maybe<Array<Invoice>>;
  gatewayProfessionalReferences?: Maybe<Array<ProfessionalReference>>;
  gatewayStatement?: Maybe<Statement>;
  gatewayStatements?: Maybe<Array<Statement>>;
  getBlockedTimes?: Maybe<Array<BlockedTimes>>;
  getProPoolDashboard?: Maybe<Array<Maybe<ProPoolDashboard>>>;
  healthSystem?: Maybe<HealthSystem>;
  healthSystems?: Maybe<Array<HealthSystem>>;
  interviewAvailabilities?: Maybe<Array<InterviewAvailability>>;
  interviewAvailability?: Maybe<InterviewAvailability>;
  invoice?: Maybe<Invoice>;
  invoiceStatusBillingGroupCounts: Array<InvoiceStatusBillingGroupCountsResult>;
  invoices?: Maybe<Array<Invoice>>;
  invoicesTotals?: Maybe<InvoicesTotals>;
  itemizedTransaction?: Maybe<ItemizedTransaction>;
  itemizedTransactions?: Maybe<Array<Maybe<ItemizedTransaction>>>;
  job?: Maybe<Job>;
  jobBilling?: Maybe<JobBilling>;
  jobBillings?: Maybe<Array<JobBilling>>;
  jobCount?: Maybe<ListMeta>;
  jobIrregularities?: Maybe<Array<JobIrregularity>>;
  jobIrregularity?: Maybe<JobIrregularity>;
  jobPriceDifferential?: Maybe<JobPriceDifferential>;
  jobPriceDifferentials?: Maybe<Array<JobPriceDifferential>>;
  jobProfile?: Maybe<JobProfile>;
  jobProfiles?: Maybe<Array<JobProfile>>;
  /** @deprecated use JobProfile */
  jobPublishingGroup?: Maybe<JobPublishingGroup>;
  /** @deprecated use JobProfile */
  jobPublishingGroups?: Maybe<Array<JobPublishingGroup>>;
  jobRateTrackedEvent?: Maybe<JobRateTrackedEvent>;
  jobRateTrackedEvents?: Maybe<Array<JobRateTrackedEvent>>;
  jobStatusLocationCounts: Array<JobStatusLocationCountsResult>;
  jobSurgeryType?: Maybe<JobSurgeryType>;
  jobSurgeryTypes?: Maybe<Array<JobSurgeryType>>;
  jobTemplate?: Maybe<JobTemplate>;
  jobTemplates?: Maybe<Array<JobTemplate>>;
  jobTrack?: Maybe<JobTrack>;
  jobTracks?: Maybe<Array<JobTrack>>;
  jobs?: Maybe<Array<Job>>;
  jobsAwaitingApproval?: Maybe<Array<Job>>;
  jobsBoard?: Maybe<JobsBoard>;
  jobsBoardPosition?: Maybe<JobsBoardPosition>;
  jobsBoardPositions?: Maybe<Array<JobsBoardPosition>>;
  jobsBoards?: Maybe<Array<JobsBoard>>;
  jobsByPosition?: Maybe<Array<Position>>;
  jobsTotals?: Maybe<JobsTotals>;
  jobsWithoutPayout?: Maybe<Array<Job>>;
  lastWeekJobsDetails?: Maybe<LastWeekJobDetails>;
  lineOfCredit?: Maybe<LineOfCredit>;
  lineOfCredits?: Maybe<Array<LineOfCredit>>;
  localRateRule?: Maybe<LocalRateRule>;
  localRateRules?: Maybe<Array<LocalRateRule>>;
  location?: Maybe<Location>;
  locationAssignmentIssueCounts: Array<AssignmentPanelCount>;
  locationBillingGroup?: Maybe<LocationBillingGroup>;
  locationBillingGroups?: Maybe<Array<LocationBillingGroup>>;
  locationBlockReason?: Maybe<LocationBlockReason>;
  locationBlockReasons?: Maybe<Array<LocationBlockReason>>;
  locationConditions?: Maybe<Array<Condition>>;
  locationGroup?: Maybe<LocationGroup>;
  locationGroups?: Maybe<Array<LocationGroup>>;
  locationPosition?: Maybe<LocationPosition>;
  locationPositionRateSetting?: Maybe<LocationPositionRateSetting>;
  locationPositionRateSettings?: Maybe<Array<LocationPositionRateSetting>>;
  locationPositions?: Maybe<Array<LocationPosition>>;
  locationRateSetting?: Maybe<LocationRateSetting>;
  locationRateSettings?: Maybe<Array<LocationRateSetting>>;
  locationType?: Maybe<LocationType>;
  locationTypePosition?: Maybe<LocationTypePosition>;
  locationTypePositions?: Maybe<Array<LocationTypePosition>>;
  locationTypes?: Maybe<Array<LocationType>>;
  locations?: Maybe<Array<Location>>;
  market?: Maybe<Market>;
  marketLocation?: Maybe<MarketLocation>;
  marketLocationTypePositionRateSetting?: Maybe<MarketLocationTypePositionRateSetting>;
  marketLocationTypePositionRateSettings?: Maybe<Array<MarketLocationTypePositionRateSetting>>;
  marketLocationTypeRateSetting?: Maybe<MarketLocationTypeRateSetting>;
  marketLocationTypeRateSettings?: Maybe<Array<MarketLocationTypeRateSetting>>;
  marketLocations?: Maybe<Array<MarketLocation>>;
  marketPositionRateSetting?: Maybe<MarketPositionRateSetting>;
  marketPositionRateSettings?: Maybe<Array<MarketPositionRateSetting>>;
  marketRateSetting?: Maybe<MarketRateSetting>;
  marketRateSettings?: Maybe<Array<MarketRateSetting>>;
  markets?: Maybe<Array<Market>>;
  marketsProfessional?: Maybe<MarketsProfessional>;
  marketsProfessionals?: Maybe<Array<MarketsProfessional>>;
  me?: Maybe<Account>;
  metabaseEmbedUrl?: Maybe<MetabaseEmbed>;
  msp?: Maybe<Msp>;
  msps?: Maybe<Array<Msp>>;
  netTerm?: Maybe<NetTerm>;
  netTerms?: Maybe<Array<NetTerm>>;
  newApplicantCount?: Maybe<Array<AssignmentPanelCount>>;
  note?: Maybe<Note>;
  notes?: Maybe<Array<Note>>;
  nursysEnrollment?: Maybe<NursysEnrollment>;
  nursysEnrollments?: Maybe<Array<NursysEnrollment>>;
  onboardingFlowDecision: OnboardingFlowDecision;
  payment?: Maybe<Payment>;
  payments?: Maybe<Array<Payment>>;
  payout?: Maybe<Payout>;
  payouts?: Maybe<Array<Payout>>;
  people?: Maybe<Array<Person>>;
  permanentPlacement?: Maybe<Assignment>;
  permanentPlacements?: Maybe<Array<Assignment>>;
  permanentRequest?: Maybe<AssignmentRequest>;
  permanentRequests?: Maybe<Array<AssignmentRequest>>;
  permissionGroup?: Maybe<PermissionGroup>;
  permissionGroups?: Maybe<Array<PermissionGroup>>;
  person?: Maybe<Person>;
  personDisabledReason?: Maybe<PersonDisabledReason>;
  personDisabledReasons?: Maybe<Array<PersonDisabledReason>>;
  phoneScreeningRequest?: Maybe<PhoneScreeningRequest>;
  phoneScreeningRequests?: Maybe<Array<PhoneScreeningRequest>>;
  pool?: Maybe<Pool>;
  poolProfessional?: Maybe<Professional>;
  poolProfessionals?: Maybe<Array<Maybe<Professional>>>;
  pools: Array<Maybe<Pool>>;
  position?: Maybe<Position>;
  positionPostingField?: Maybe<PositionPostingField>;
  positionPostingFields?: Maybe<Array<PositionPostingField>>;
  positionSpecialties?: Maybe<Array<PositionSpecialty>>;
  positionSpecialty?: Maybe<PositionSpecialty>;
  positions?: Maybe<Array<Position>>;
  postingField?: Maybe<PostingField>;
  postingFields?: Maybe<Array<PostingField>>;
  professional?: Maybe<Professional>;
  professionalAssignmentFavorite?: Maybe<ProfessionalAssignmentFavorite>;
  professionalAssignmentFavorites?: Maybe<Array<ProfessionalAssignmentFavorite>>;
  professionalBlockReason?: Maybe<ProfessionalBlockReason>;
  professionalBlockReasons?: Maybe<Array<ProfessionalBlockReason>>;
  professionalPosition?: Maybe<ProfessionalPosition>;
  professionalPositions?: Maybe<Array<ProfessionalPosition>>;
  professionalProfile?: Maybe<ProfessionalProfile>;
  professionalProfileEhrSystem?: Maybe<ProfessionalProfileEhrSystem>;
  professionalProfileEhrSystems?: Maybe<Array<ProfessionalProfileEhrSystem>>;
  professionalProfiles?: Maybe<Array<ProfessionalProfile>>;
  professionalQualification?: Maybe<ProfessionalQualification>;
  professionalQualificationAttribute?: Maybe<ProfessionalQualificationAttribute>;
  professionalQualificationAttributes?: Maybe<Array<ProfessionalQualificationAttribute>>;
  professionalQualifications?: Maybe<Array<ProfessionalQualification>>;
  professionalReference?: Maybe<ProfessionalReference>;
  professionalReferences?: Maybe<Array<ProfessionalReference>>;
  professionalSaasDetail?: Maybe<ProfessionalSaasDetail>;
  professionalSaasDetails?: Maybe<Array<ProfessionalSaasDetail>>;
  professionalScreening?: Maybe<ProfessionalScreening>;
  professionalScreenings?: Maybe<Array<Maybe<ProfessionalScreening>>>;
  professionalSkillsAssessmentsAnswer?: Maybe<ProfessionalSkillsAssessmentsAnswer>;
  professionalSkillsAssessmentsAnswers?: Maybe<Array<ProfessionalSkillsAssessmentsAnswer>>;
  professionalSpecialties?: Maybe<Array<ProfessionalSpecialty>>;
  professionalSpecialty?: Maybe<ProfessionalSpecialty>;
  professionalTodos?: Maybe<ProfessionalTodos>;
  professionalTravelAssignmentState?: Maybe<ProfessionalTravelAssignmentState>;
  professionalTravelAssignmentStates?: Maybe<Array<ProfessionalTravelAssignmentState>>;
  professionalTravelPosition?: Maybe<ProfessionalTravelPosition>;
  professionalTravelPositions?: Maybe<Array<ProfessionalTravelPosition>>;
  professionals?: Maybe<Array<Professional>>;
  professionalsJobs?: Maybe<Array<ProfessionalJobs>>;
  profileStats?: Maybe<ProfileStats>;
  qualification?: Maybe<Qualification>;
  qualificationAttribute?: Maybe<QualificationAttribute>;
  qualificationAttributeOptions?: Maybe<Array<QualificationAttributeOption>>;
  qualificationAttributes?: Maybe<Array<QualificationAttribute>>;
  qualificationAutomation?: Maybe<QualificationAutomation>;
  qualificationAutomationAttribute?: Maybe<QualificationAutomationAttribute>;
  qualificationAutomationAttributes?: Maybe<Array<QualificationAutomationAttribute>>;
  qualificationAutomations?: Maybe<Array<QualificationAutomation>>;
  qualifications?: Maybe<Array<Qualification>>;
  qualificationsGroup?: Maybe<QualificationsGroup>;
  qualificationsGroups?: Maybe<Array<QualificationsGroup>>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireResponse?: Maybe<QuestionnaireResponse>;
  questionnaireResponses?: Maybe<Array<QuestionnaireResponse>>;
  questionnaires?: Maybe<Array<Questionnaire>>;
  rateCalculator?: Maybe<RateCalculator>;
  rateCalculators?: Maybe<Array<RateCalculator>>;
  rateSetting?: Maybe<RateSetting>;
  rateSettings?: Maybe<Array<RateSetting>>;
  referralSource?: Maybe<ReferralSource>;
  referralSources?: Maybe<Array<ReferralSource>>;
  refund?: Maybe<Refund>;
  refunds?: Maybe<Array<Refund>>;
  relationship?: Maybe<Relationship>;
  relationships?: Maybe<Array<Relationship>>;
  requirement?: Maybe<Requirement>;
  requirements?: Maybe<Array<Requirement>>;
  revenueAdjustment?: Maybe<RevenueAdjustment>;
  revenueAdjustments?: Maybe<Array<RevenueAdjustment>>;
  review?: Maybe<Review>;
  reviews?: Maybe<Array<Review>>;
  schedulerOverview: SchedulerOverview;
  signUpLocationType?: Maybe<LocationType>;
  signUpLocationTypes?: Maybe<Array<LocationType>>;
  skillsAssessment?: Maybe<SkillsAssessment>;
  skillsAssessmentBak?: Maybe<SkillsAssessmentBak>;
  skillsAssessmentBaks?: Maybe<Array<SkillsAssessmentBak>>;
  skillsAssessmentResponseBak?: Maybe<SkillsAssessmentResponseBak>;
  skillsAssessmentResponseBaks?: Maybe<Array<SkillsAssessmentResponseBak>>;
  skillsAssessmentSkillsQuestion?: Maybe<SkillsAssessmentSkillsQuestion>;
  skillsAssessmentSkillsQuestions?: Maybe<Array<SkillsAssessmentSkillsQuestion>>;
  skillsAssessments?: Maybe<Array<SkillsAssessment>>;
  skillsQuestion?: Maybe<SkillsQuestion>;
  skillsQuestions?: Maybe<Array<SkillsQuestion>>;
  socialProofMarketActivities?: Maybe<Array<SocialProofMarketActivity>>;
  socialProofMarketActivity?: Maybe<SocialProofMarketActivity>;
  specialties?: Maybe<Array<Specialty>>;
  specialty?: Maybe<Specialty>;
  staffBlockReason?: Maybe<StaffBlockReason>;
  staffBlockReasons?: Maybe<Array<StaffBlockReason>>;
  state?: Maybe<State>;
  stateLocationTypePositionRateSetting?: Maybe<StateLocationTypePositionRateSetting>;
  stateLocationTypePositionRateSettings?: Maybe<Array<StateLocationTypePositionRateSetting>>;
  stateLocationTypeRateSetting?: Maybe<StateLocationTypeRateSetting>;
  stateLocationTypeRateSettings?: Maybe<Array<StateLocationTypeRateSetting>>;
  statePositionRateSetting?: Maybe<StatePositionRateSetting>;
  statePositionRateSettings?: Maybe<Array<StatePositionRateSetting>>;
  stateRateSetting?: Maybe<StateRateSetting>;
  stateRateSettings?: Maybe<Array<StateRateSetting>>;
  statement?: Maybe<Statement>;
  statements?: Maybe<Array<Statement>>;
  states?: Maybe<Array<State>>;
  stripeAccount?: Maybe<StripeAccount>;
  stripeAccounts?: Maybe<Array<StripeAccount>>;
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
  stripePaymentIntents?: Maybe<Array<StripePaymentIntent>>;
  stripeRepresentative?: Maybe<StripeRepresentative>;
  stripeRepresentatives?: Maybe<Array<StripeRepresentative>>;
  surgeryType?: Maybe<SurgeryType>;
  surgeryTypes?: Maybe<Array<SurgeryType>>;
  taxClassification?: Maybe<TaxClassification>;
  taxClassifications?: Maybe<Array<TaxClassification>>;
  taxForm?: Maybe<TaxForm>;
  taxForms?: Maybe<Array<TaxForm>>;
  timecard?: Maybe<Timecard>;
  timecards?: Maybe<Array<Timecard>>;
  timecardsTotals?: Maybe<TimecardsTotals>;
  transferReversal?: Maybe<TransferReversal>;
  transferReversals?: Maybe<Array<TransferReversal>>;
  unexplainedWorkGaps: Array<UnexplainedWorkGap>;
  uniqueAgencyChargeOverrides: Array<UniqueAgencyChargeOverrides>;
  universalBackgroundCheck?: Maybe<UniversalBackgroundCheck>;
  universalBackgroundChecks?: Maybe<Array<UniversalBackgroundCheck>>;
  unpaidTimecardAdjustments?: Maybe<Array<ExpenseAdjustment>>;
  user?: Maybe<User>;
  userPosition?: Maybe<UserPosition>;
  userPositionRateSetting?: Maybe<UserPositionRateSetting>;
  userPositionRateSettings?: Maybe<Array<UserPositionRateSetting>>;
  userPositions?: Maybe<Array<UserPosition>>;
  userRateSetting?: Maybe<UserRateSetting>;
  userRateSettings?: Maybe<Array<UserRateSetting>>;
  users?: Maybe<Array<User>>;
  validateJobTimes?: Maybe<Array<Scalars['DateTime']['output']>>;
  vmsAssignment?: Maybe<VmsAssignment>;
  vmsAssignments?: Maybe<Array<VmsAssignment>>;
  vmsPosition?: Maybe<VmsPosition>;
  vmsPositions?: Maybe<Array<VmsPosition>>;
  vmsType?: Maybe<VmsType>;
  vmsTypes?: Maybe<Array<VmsType>>;
  vmsUser?: Maybe<VmsUser>;
  vmsUsers?: Maybe<Array<VmsUser>>;
  wageLog?: Maybe<WageLog>;
  wageLogs: Array<WageLog>;
  weeklyTimecardsTotals: Array<WeeklyTimecardsTotals>;
  workGap?: Maybe<WorkGap>;
  workGaps?: Maybe<Array<WorkGap>>;
  workHistories?: Maybe<Array<WorkHistory>>;
  workHistory?: Maybe<WorkHistory>;
};


export type Query_AccountBillingGroupsMetaArgs = {
  input?: InputMaybe<AccountBillingGroupQueryInput>;
};


export type Query_AccountLocationsMetaArgs = {
  input?: InputMaybe<AccountLocationQueryInput>;
};


export type Query_AccountsMetaArgs = {
  input?: InputMaybe<AccountQueryInput>;
};


export type Query_AdministratorsMetaArgs = {
  input?: InputMaybe<AdministratorQueryInput>;
};


export type Query_AgenciesMetaArgs = {
  input?: InputMaybe<AgencyQueryInput>;
};


export type Query_AgencyChargeOverridesMetaArgs = {
  input?: InputMaybe<AgencyChargeOverridesQueryInput>;
};


export type Query_AgencyLocationPositionRateSettingsMetaArgs = {
  input?: InputMaybe<AgencyLocationPositionRateSettingQueryInput>;
};


export type Query_AgencyLocationRateSettingsMetaArgs = {
  input?: InputMaybe<AgencyLocationRateSettingQueryInput>;
};


export type Query_AgencyLocationsMetaArgs = {
  input?: InputMaybe<AgencyLocationQueryInput>;
};


export type Query_AgencyQualificationAttributesMetaArgs = {
  input?: InputMaybe<AgencyQualificationAttributeQueryInput>;
};


export type Query_AgencyQualificationsMetaArgs = {
  input?: InputMaybe<AgencyQualificationQueryInput>;
};


export type Query_ApplicationRequirementsMetaArgs = {
  input?: InputMaybe<ApplicationRequirementQueryInput>;
};


export type Query_ApprovalGroupsMetaArgs = {
  input?: InputMaybe<ApprovalGroupQueryInput>;
};


export type Query_ApprovalsMetaArgs = {
  input?: InputMaybe<ApprovalQueryInput>;
};


export type Query_AssignmentBillingGroupsMetaArgs = {
  input?: InputMaybe<AssignmentBillingGroupQueryInput>;
};


export type Query_AssignmentLocationsMetaArgs = {
  input?: InputMaybe<AssignmentLocationQueryInput>;
};


export type Query_AssignmentMetaArgs = {
  id: Scalars['Int']['input'];
};


export type Query_AssignmentProfilesMetaArgs = {
  input?: InputMaybe<AssignmentProfileQueryInput>;
};


export type Query_AssignmentRequestsMetaArgs = {
  input?: InputMaybe<AssignmentRequestQueryInput>;
};


export type Query_AssignmentsMetaArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type Query_AssignmentsPreviewsMetaArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type Query_AuditsMetaArgs = {
  input?: InputMaybe<AuditQueryInput>;
};


export type Query_AvailableAssignmentsMetaArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type Query_AvailableJobsMetaArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type Query_AvailablePlacementsMetaArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type Query_BackgroundChecksMetaArgs = {
  input?: InputMaybe<BackgroundCheckQueryInput>;
};


export type Query_BalanceSheetsMetaArgs = {
  input?: InputMaybe<BalanceSheetQueryInput>;
};


export type Query_BillingActivitiesMetaArgs = {
  input?: InputMaybe<BillingActivityQueryInput>;
};


export type Query_BillingContactsMetaArgs = {
  input?: InputMaybe<BillingContactQueryInput>;
};


export type Query_BillingGroupCreditLimitCalculationsMetaArgs = {
  input?: InputMaybe<BillingGroupCreditLimitCalculationQueryInput>;
};


export type Query_BillingGroupManagementCompaniesMetaArgs = {
  input?: InputMaybe<BillingGroupManagementCompanyQueryInput>;
};


export type Query_BillingGroupParentsMetaArgs = {
  input?: InputMaybe<BillingGroupParentQueryInput>;
};


export type Query_BillingGroupsMetaArgs = {
  input?: InputMaybe<BillingGroupQueryInput>;
};


export type Query_BreaksMetaArgs = {
  input?: InputMaybe<BreakQueryInput>;
};


export type Query_CancellationReasonsMetaArgs = {
  input?: InputMaybe<CancellationReasonQueryInput>;
};


export type Query_CancellationsMetaArgs = {
  input?: InputMaybe<CancellationQueryInput>;
};


export type Query_CapsReportsMetaArgs = {
  input?: InputMaybe<CapsReportQueryInput>;
};


export type Query_CheckInsMetaArgs = {
  input?: InputMaybe<CheckInQueryInput>;
};


export type Query_CheckOutsMetaArgs = {
  input?: InputMaybe<CheckOutQueryInput>;
};


export type Query_ChecksMetaArgs = {
  input?: InputMaybe<CheckQueryInput>;
};


export type Query_ClinicalContactsMetaArgs = {
  input?: InputMaybe<ClinicalContactQueryInput>;
};


export type Query_CompaniesMetaArgs = {
  input?: InputMaybe<CompanyQueryInput>;
};


export type Query_ConditionDocumentsMetaArgs = {
  input?: InputMaybe<ConditionDocumentQueryInput>;
};


export type Query_ConditionsMetaArgs = {
  input?: InputMaybe<ConditionQueryInput>;
};


export type Query_ContractsMetaArgs = {
  input?: InputMaybe<CreditNoteQueryInput>;
};


export type Query_CredentialRejectedReasonsMetaArgs = {
  input?: InputMaybe<CredentialRejectedReasonQueryInput>;
};


export type Query_CreditNotesMetaArgs = {
  input?: InputMaybe<CreditNoteQueryInput>;
};


export type Query_CustomProfessionalProfileEhrSystemsMetaArgs = {
  input?: InputMaybe<CustomProfessionalProfileEhrSystemQueryInput>;
};


export type Query_DataTestsMetaArgs = {
  input?: InputMaybe<DataTestQueryInput>;
};


export type Query_DeprecatedInvoicesMetaArgs = {
  input?: InputMaybe<DeprecatedInvoiceQueryInput>;
};


export type Query_DisabledReasonsMetaArgs = {
  input?: InputMaybe<DisabledReasonQueryInput>;
};


export type Query_DisputeShiftWitnessesMetaArgs = {
  input?: InputMaybe<DisputeShiftWitnessQueryInput>;
};


export type Query_DisputedJobBillingsMetaArgs = {
  input?: InputMaybe<DisputedJobBillingQueryInput>;
};


export type Query_DisputesMetaArgs = {
  input?: InputMaybe<DisputeQueryInput>;
};


export type Query_EducationsMetaArgs = {
  input?: InputMaybe<EducationQueryInput>;
};


export type Query_EhrSystemsMetaArgs = {
  input?: InputMaybe<EhrSystemQueryInput>;
};


export type Query_EmergencyContactsMetaArgs = {
  input?: InputMaybe<EmergencyContactQueryInput>;
};


export type Query_ExpenseAdjustmentsMetaArgs = {
  input?: InputMaybe<ExpenseAdjustmentQueryInput>;
};


export type Query_ExternalAccountsMetaArgs = {
  input?: InputMaybe<ExternalAccountQueryInput>;
};


export type Query_FacilityConnectionsMetaArgs = {
  input?: InputMaybe<FacilityConnectionQueryInput>;
};


export type Query_FinancialTransactionsMetaArgs = {
  input?: InputMaybe<FinancialTransactionQueryInput>;
};


export type Query_FundingSourcesMetaArgs = {
  input?: InputMaybe<FundingSourceQueryInput>;
};


export type Query_GatewayInvoicesMetaArgs = {
  input?: InputMaybe<InvoiceQueryInput>;
};


export type Query_GatewayStatementsMetaArgs = {
  input?: InputMaybe<StatementQueryInput>;
};


export type Query_GetProPoolDashboardMetaArgs = {
  input?: InputMaybe<ProPoolDashboardInput>;
};


export type Query_HealthSystemsMetaArgs = {
  input?: InputMaybe<HealthSystemQueryInput>;
};


export type Query_InterviewAvailabilitiesMetaArgs = {
  input?: InputMaybe<InterviewAvailabilityQueryInput>;
};


export type Query_InvoicesMetaArgs = {
  input?: InputMaybe<InvoiceQueryInput>;
};


export type Query_ItemizedTransactionsMetaArgs = {
  input?: InputMaybe<ItemizedTransactionQueryInput>;
};


export type Query_JobBillingsMetaArgs = {
  input?: InputMaybe<JobBillingQueryInput>;
};


export type Query_JobIrregularitiesMetaArgs = {
  input?: InputMaybe<JobIrregularityQueryInput>;
};


export type Query_JobPriceDifferentialsMetaArgs = {
  input?: InputMaybe<JobPriceDifferentialQueryInput>;
};


export type Query_JobProfilesMetaArgs = {
  input?: InputMaybe<JobProfileQueryInput>;
};


export type Query_JobPublishingGroupsMetaArgs = {
  input?: InputMaybe<JobPublishingGroupQueryInput>;
};


export type Query_JobRateTrackedEventsMetaArgs = {
  input?: InputMaybe<JobRateTrackedEventQueryInput>;
};


export type Query_JobSurgeryTypesMetaArgs = {
  input?: InputMaybe<JobSurgeryTypeQueryInput>;
};


export type Query_JobTemplatesMetaArgs = {
  input?: InputMaybe<JobTemplateQueryInput>;
};


export type Query_JobTracksMetaArgs = {
  input?: InputMaybe<JobTrackQueryInput>;
};


export type Query_JobsBoardPositionsMetaArgs = {
  input?: InputMaybe<JobsBoardPositionQueryInput>;
};


export type Query_JobsBoardsMetaArgs = {
  input?: InputMaybe<JobsBoardQueryInput>;
};


export type Query_JobsMetaArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type Query_LineOfCreditsMetaArgs = {
  input?: InputMaybe<LineOfCreditQueryInput>;
};


export type Query_LocalRateRulesMetaArgs = {
  input?: InputMaybe<LocalRateRuleQueryInput>;
};


export type Query_LocationBillingGroupsMetaArgs = {
  input?: InputMaybe<LocationBillingGroupQueryInput>;
};


export type Query_LocationBlockReasonsMetaArgs = {
  input?: InputMaybe<LocationBlockReasonQueryInput>;
};


export type Query_LocationGroupsMetaArgs = {
  input?: InputMaybe<LocationGroupQueryInput>;
};


export type Query_LocationPositionRateSettingsMetaArgs = {
  input?: InputMaybe<LocationPositionRateSettingQueryInput>;
};


export type Query_LocationPositionsMetaArgs = {
  input?: InputMaybe<LocationPositionQueryInput>;
};


export type Query_LocationRateSettingsMetaArgs = {
  input?: InputMaybe<LocationRateSettingQueryInput>;
};


export type Query_LocationTypePositionsMetaArgs = {
  input?: InputMaybe<LocationTypePositionQueryInput>;
};


export type Query_LocationTypesMetaArgs = {
  input?: InputMaybe<LocationTypeQueryInput>;
};


export type Query_LocationsMetaArgs = {
  input?: InputMaybe<LocationQueryInput>;
};


export type Query_MarketLocationTypePositionRateSettingsMetaArgs = {
  input?: InputMaybe<MarketLocationTypePositionRateSettingQueryInput>;
};


export type Query_MarketLocationTypeRateSettingsMetaArgs = {
  input?: InputMaybe<MarketLocationTypeRateSettingQueryInput>;
};


export type Query_MarketLocationsMetaArgs = {
  input?: InputMaybe<MarketLocationQueryInput>;
};


export type Query_MarketPositionRateSettingsMetaArgs = {
  input?: InputMaybe<MarketPositionRateSettingQueryInput>;
};


export type Query_MarketRateSettingsMetaArgs = {
  input?: InputMaybe<MarketRateSettingQueryInput>;
};


export type Query_MarketsMetaArgs = {
  input?: InputMaybe<MarketQueryInput>;
};


export type Query_MarketsProfessionalsMetaArgs = {
  input?: InputMaybe<MarketsProfessionalQueryInput>;
};


export type Query_MspsMetaArgs = {
  input?: InputMaybe<MspQueryInput>;
};


export type Query_NetTermsMetaArgs = {
  input?: InputMaybe<NetTermQueryInput>;
};


export type Query_NotesMetaArgs = {
  input?: InputMaybe<NoteQueryInput>;
};


export type Query_NursysEnrollmentsMetaArgs = {
  input?: InputMaybe<NursysEnrollmentQueryInput>;
};


export type Query_PaymentsMetaArgs = {
  input?: InputMaybe<PaymentQueryInput>;
};


export type Query_PayoutsMetaArgs = {
  input?: InputMaybe<PayoutQueryInput>;
};


export type Query_PeopleMetaArgs = {
  input?: InputMaybe<PersonQueryInput>;
};


export type Query_PermanentPlacementsMetaArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type Query_PermanentRequestsMetaArgs = {
  input?: InputMaybe<AssignmentRequestQueryInput>;
};


export type Query_PermissionGroupsMetaArgs = {
  input?: InputMaybe<PermissionGroupQueryInput>;
};


export type Query_PersonDisabledReasonsMetaArgs = {
  input?: InputMaybe<PersonDisabledReasonQueryInput>;
};


export type Query_PhoneScreeningRequestsMetaArgs = {
  input?: InputMaybe<PhoneScreeningRequestQueryInput>;
};


export type Query_PoolProfessionalsMetaArgs = {
  input?: InputMaybe<ProfessionalPoolQueryInput>;
};


export type Query_PoolsMetaArgs = {
  input?: InputMaybe<PoolQueryInput>;
};


export type Query_PositionPostingFieldsMetaArgs = {
  input?: InputMaybe<PositionPostingFieldQueryInput>;
};


export type Query_PositionSpecialtiesMetaArgs = {
  input?: InputMaybe<PositionSpecialtyQueryInput>;
};


export type Query_PositionsMetaArgs = {
  input?: InputMaybe<PositionQueryInput>;
};


export type Query_PostingFieldsMetaArgs = {
  input?: InputMaybe<PostingFieldQueryInput>;
};


export type Query_ProfessionalAssignmentFavoritesMetaArgs = {
  input?: InputMaybe<ProfessionalAssignmentFavoriteQueryInput>;
};


export type Query_ProfessionalBlockReasonsMetaArgs = {
  input?: InputMaybe<ProfessionalBlockReasonQueryInput>;
};


export type Query_ProfessionalPositionsMetaArgs = {
  input?: InputMaybe<ProfessionalPositionQueryInput>;
};


export type Query_ProfessionalProfileEhrSystemsMetaArgs = {
  input?: InputMaybe<ProfessionalProfileEhrSystemQueryInput>;
};


export type Query_ProfessionalProfilesMetaArgs = {
  input?: InputMaybe<ProfessionalProfileQueryInput>;
};


export type Query_ProfessionalQualificationAttributesMetaArgs = {
  input?: InputMaybe<ProfessionalQualificationAttributeQueryInput>;
};


export type Query_ProfessionalQualificationsMetaArgs = {
  input?: InputMaybe<ProfessionalQualificationQueryInput>;
};


export type Query_ProfessionalReferencesMetaArgs = {
  input?: InputMaybe<ProfessionalReferenceQueryInput>;
};


export type Query_ProfessionalSaasDetailsMetaArgs = {
  input?: InputMaybe<ProfessionalSaasDetailQueryInput>;
};


export type Query_ProfessionalScreeningsMetaArgs = {
  input?: InputMaybe<ProfessionalScreeningQueryInput>;
};


export type Query_ProfessionalSkillsAssessmentsAnswersMetaArgs = {
  input?: InputMaybe<ProfessionalSkillsAssessmentsAnswerQueryInput>;
};


export type Query_ProfessionalSpecialtiesMetaArgs = {
  input?: InputMaybe<ProfessionalSpecialtyQueryInput>;
};


export type Query_ProfessionalTravelAssignmentStatesMetaArgs = {
  input?: InputMaybe<ProfessionalTravelAssignmentStateQueryInput>;
};


export type Query_ProfessionalTravelPositionsMetaArgs = {
  input?: InputMaybe<ProfessionalTravelPositionQueryInput>;
};


export type Query_ProfessionalsMetaArgs = {
  input?: InputMaybe<ProfessionalQueryInput>;
};


export type Query_QualificationAttributesMetaArgs = {
  input?: InputMaybe<QualificationAttributeQueryInput>;
};


export type Query_QualificationAutomationAttributesMetaArgs = {
  input?: InputMaybe<QualificationAutomationAttributeQueryInput>;
};


export type Query_QualificationAutomationsMetaArgs = {
  input?: InputMaybe<QualificationAutomationQueryInput>;
};


export type Query_QualificationsGroupsMetaArgs = {
  input?: InputMaybe<QualificationsGroupQueryInput>;
};


export type Query_QualificationsMetaArgs = {
  input?: InputMaybe<QualificationQueryInput>;
};


export type Query_QuestionnaireResponsesMetaArgs = {
  input?: InputMaybe<QuestionnaireResponseQueryInput>;
};


export type Query_QuestionnairesMetaArgs = {
  input?: InputMaybe<QuestionnaireQueryInput>;
};


export type Query_RateCalculatorsMetaArgs = {
  input?: InputMaybe<RateCalculatorQueryInput>;
};


export type Query_RateSettingsMetaArgs = {
  input?: InputMaybe<RateSettingQueryInput>;
};


export type Query_ReferralSourcesMetaArgs = {
  input?: InputMaybe<ReferralSourceQueryInput>;
};


export type Query_RefundsMetaArgs = {
  input?: InputMaybe<RefundQueryInput>;
};


export type Query_RelationshipsMetaArgs = {
  input?: InputMaybe<RelationshipQueryInput>;
};


export type Query_RequirementsMetaArgs = {
  input?: InputMaybe<RequirementQueryInput>;
};


export type Query_RevenueAdjustmentsMetaArgs = {
  input?: InputMaybe<RevenueAdjustmentQueryInput>;
};


export type Query_ReviewsMetaArgs = {
  input?: InputMaybe<ReviewQueryInput>;
};


export type Query_SkillsAssessmentBaksMetaArgs = {
  input?: InputMaybe<SkillsAssessmentBakQueryInput>;
};


export type Query_SkillsAssessmentResponseBaksMetaArgs = {
  input?: InputMaybe<SkillsAssessmentResponseBakQueryInput>;
};


export type Query_SkillsAssessmentSkillsQuestionsMetaArgs = {
  input?: InputMaybe<SkillsAssessmentSkillsQuestionQueryInput>;
};


export type Query_SkillsAssessmentsMetaArgs = {
  input?: InputMaybe<SkillsAssessmentQueryInput>;
};


export type Query_SkillsQuestionsMetaArgs = {
  input?: InputMaybe<SkillsQuestionQueryInput>;
};


export type Query_SocialProofMarketActivityMetaArgs = {
  input?: InputMaybe<SocialProofMarketActivityQueryInput>;
};


export type Query_SpecialtiesMetaArgs = {
  input?: InputMaybe<SpecialtyQueryInput>;
};


export type Query_StaffBlockReasonsMetaArgs = {
  input?: InputMaybe<StaffBlockReasonQueryInput>;
};


export type Query_StateLocationTypePositionRateSettingsMetaArgs = {
  input?: InputMaybe<StateLocationTypePositionRateSettingQueryInput>;
};


export type Query_StateLocationTypeRateSettingsMetaArgs = {
  input?: InputMaybe<StateLocationTypeRateSettingQueryInput>;
};


export type Query_StatePositionRateSettingsMetaArgs = {
  input?: InputMaybe<StatePositionRateSettingQueryInput>;
};


export type Query_StateRateSettingsMetaArgs = {
  input?: InputMaybe<StateRateSettingQueryInput>;
};


export type Query_StatementsMetaArgs = {
  input?: InputMaybe<StatementQueryInput>;
};


export type Query_StatesMetaArgs = {
  input?: InputMaybe<StateQueryInput>;
};


export type Query_StripeAccountsMetaArgs = {
  input?: InputMaybe<StripeAccountQueryInput>;
};


export type Query_StripePaymentIntentsMetaArgs = {
  input?: InputMaybe<StripePaymentIntentQueryInput>;
};


export type Query_StripeRepresentativesMetaArgs = {
  input?: InputMaybe<StripeRepresentativeQueryInput>;
};


export type Query_SurgeryTypesMetaArgs = {
  input?: InputMaybe<SurgeryTypeQueryInput>;
};


export type Query_TaxClassificationsMetaArgs = {
  input?: InputMaybe<TaxClassificationQueryInput>;
};


export type Query_TaxFormsMetaArgs = {
  input?: InputMaybe<TaxFormQueryInput>;
};


export type Query_TimecardsMetaArgs = {
  input?: InputMaybe<TimecardQueryInput>;
};


export type Query_TransferReversalsMetaArgs = {
  input?: InputMaybe<TransferReversalQueryInput>;
};


export type Query_UniqueAgencyChargeOverridesMetaArgs = {
  input?: InputMaybe<AgencyChargeOverridesQueryInput>;
};


export type Query_UniversalBackgroundChecksMetaArgs = {
  input?: InputMaybe<UniversalBackgroundCheckQueryInput>;
};


export type Query_UserPositionRateSettingsMetaArgs = {
  input?: InputMaybe<UserPositionRateSettingQueryInput>;
};


export type Query_UserPositionsMetaArgs = {
  input?: InputMaybe<UserPositionQueryInput>;
};


export type Query_UserRateSettingsMetaArgs = {
  input?: InputMaybe<UserRateSettingQueryInput>;
};


export type Query_UsersMetaArgs = {
  input?: InputMaybe<UserQueryInput>;
};


export type Query_VmsAssignmentsMetaArgs = {
  input?: InputMaybe<VmsAssignmentQueryInput>;
};


export type Query_VmsPositionsMetaArgs = {
  input?: InputMaybe<VmsPositionQueryInput>;
};


export type Query_VmsTypesMetaArgs = {
  input?: InputMaybe<VmsTypeQueryInput>;
};


export type Query_VmsUsersMetaArgs = {
  input?: InputMaybe<VmsUserQueryInput>;
};


export type Query_WageLogsMetaArgs = {
  input?: InputMaybe<WageLogQueryInput>;
};


export type Query_WorkGapsMetaArgs = {
  input?: InputMaybe<WorkGapQueryInput>;
};


export type Query_WorkHistoriesMetaArgs = {
  input?: InputMaybe<WorkHistoryQueryInput>;
};


export type QueryAccountArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAccountBillingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountBillingGroupsArgs = {
  input?: InputMaybe<AccountBillingGroupQueryInput>;
};


export type QueryAccountLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountLocationsArgs = {
  input?: InputMaybe<AccountLocationQueryInput>;
};


export type QueryAccountsArgs = {
  input?: InputMaybe<AccountQueryInput>;
};


export type QueryAdministratorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdministratorsArgs = {
  input?: InputMaybe<AdministratorQueryInput>;
};


export type QueryAgenciesArgs = {
  input?: InputMaybe<AgencyQueryInput>;
};


export type QueryAgencyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyChargeOverridesArgs = {
  input?: InputMaybe<AgencyChargeOverridesQueryInput>;
};


export type QueryAgencyLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyLocationPositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAgencyLocationPositionRateSettingsArgs = {
  input?: InputMaybe<AgencyLocationPositionRateSettingQueryInput>;
};


export type QueryAgencyLocationRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAgencyLocationRateSettingsArgs = {
  input?: InputMaybe<AgencyLocationRateSettingQueryInput>;
};


export type QueryAgencyLocationsArgs = {
  input?: InputMaybe<AgencyLocationQueryInput>;
};


export type QueryAgencyQualificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyQualificationAttributeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyQualificationAttributesArgs = {
  input?: InputMaybe<AgencyQualificationAttributeQueryInput>;
};


export type QueryAgencyQualificationsArgs = {
  input?: InputMaybe<AgencyQualificationQueryInput>;
};


export type QueryAppVersionArgs = {
  appName: Scalars['String']['input'];
};


export type QueryApplicationRequirementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApplicationRequirementsArgs = {
  input?: InputMaybe<ApplicationRequirementQueryInput>;
};


export type QueryApprovalArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApprovalGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApprovalGroupsArgs = {
  input?: InputMaybe<ApprovalGroupQueryInput>;
};


export type QueryApprovalsArgs = {
  input?: InputMaybe<ApprovalQueryInput>;
};


export type QueryAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentBillingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentBillingGroupsArgs = {
  input?: InputMaybe<AssignmentBillingGroupQueryInput>;
};


export type QueryAssignmentCancellationReasonsArgs = {
  location_id: Scalars['Int']['input'];
};


export type QueryAssignmentCancellationReasonsV2Args = {
  location_id: Scalars['Int']['input'];
};


export type QueryAssignmentLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentLocationsArgs = {
  input?: InputMaybe<AssignmentLocationQueryInput>;
};


export type QueryAssignmentPreviewArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentProfileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentProfilesArgs = {
  input?: InputMaybe<AssignmentProfileQueryInput>;
};


export type QueryAssignmentRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssignmentRequestsArgs = {
  input?: InputMaybe<AssignmentRequestQueryInput>;
};


export type QueryAssignmentsArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type QueryAssignmentsPreviewsArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type QueryAuditArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAuditsArgs = {
  input?: InputMaybe<AuditQueryInput>;
};


export type QueryAvailableAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAvailableAssignmentsArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type QueryAvailableJobArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAvailableJobsArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type QueryAvailablePlacementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAvailablePlacementsArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type QueryBackgroundCheckArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBackgroundChecksArgs = {
  input?: InputMaybe<BackgroundCheckQueryInput>;
};


export type QueryBalanceSheetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBalanceSheetsArgs = {
  input?: InputMaybe<BalanceSheetQueryInput>;
};


export type QueryBillingActivitiesArgs = {
  input?: InputMaybe<BillingActivityQueryInput>;
};


export type QueryBillingContactArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBillingContactsArgs = {
  input?: InputMaybe<BillingContactQueryInput>;
};


export type QueryBillingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBillingGroupCreditLimitCalculationArgs = {
  input?: InputMaybe<BillingGroupCreditLimitCalculationQueryInput>;
};


export type QueryBillingGroupCreditLimitCalculationsArgs = {
  input?: InputMaybe<BillingGroupCreditLimitCalculationQueryInput>;
};


export type QueryBillingGroupManagementCompaniesArgs = {
  input?: InputMaybe<BillingGroupManagementCompanyQueryInput>;
};


export type QueryBillingGroupManagementCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBillingGroupParentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBillingGroupParentsArgs = {
  input?: InputMaybe<BillingGroupParentQueryInput>;
};


export type QueryBillingGroupsArgs = {
  input?: InputMaybe<BillingGroupQueryInput>;
};


export type QueryBlockedJobsArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type QueryBreakArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBreaksArgs = {
  input?: InputMaybe<BreakQueryInput>;
};


export type QueryCancellationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCancellationReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCancellationReasonsArgs = {
  input?: InputMaybe<CancellationReasonQueryInput>;
};


export type QueryCancellationsArgs = {
  input?: InputMaybe<CancellationQueryInput>;
};


export type QueryCapsReportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCapsReportsArgs = {
  input?: InputMaybe<CapsReportQueryInput>;
};


export type QueryCheckArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckInArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckInsArgs = {
  input?: InputMaybe<CheckInQueryInput>;
};


export type QueryCheckOutArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckOutsArgs = {
  input?: InputMaybe<CheckOutQueryInput>;
};


export type QueryChecksArgs = {
  input?: InputMaybe<CheckQueryInput>;
};


export type QueryClinicalContactArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClinicalContactsArgs = {
  input?: InputMaybe<ClinicalContactQueryInput>;
};


export type QueryClockEventAttachmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClockEventAttachmentsArgs = {
  input?: InputMaybe<ClockEventAttachmentQueryInput>;
};


export type QueryCompaniesArgs = {
  input?: InputMaybe<CompanyQueryInput>;
};


export type QueryCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryConditionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryConditionDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryConditionDocumentsArgs = {
  input?: InputMaybe<ConditionDocumentQueryInput>;
};


export type QueryConditionsArgs = {
  input?: InputMaybe<ConditionQueryInput>;
};


export type QueryContractArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContractsArgs = {
  input?: InputMaybe<ContractQueryInput>;
};


export type QueryCredentialRejectedReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCredentialRejectedReasonsArgs = {
  input?: InputMaybe<CredentialRejectedReasonQueryInput>;
};


export type QueryCreditNoteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCreditNotesArgs = {
  input?: InputMaybe<CreditNoteQueryInput>;
};


export type QueryCustomProfessionalProfileEhrSystemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomProfessionalProfileEhrSystemsArgs = {
  input?: InputMaybe<CustomProfessionalProfileEhrSystemQueryInput>;
};


export type QueryDataTestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDataTestsArgs = {
  input?: InputMaybe<DataTestQueryInput>;
};


export type QueryDeprecatedInvoiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDeprecatedInvoicesArgs = {
  input?: InputMaybe<DeprecatedInvoiceQueryInput>;
};


export type QueryDisabledReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisabledReasonsArgs = {
  input?: InputMaybe<DisabledReasonQueryInput>;
};


export type QueryDisputeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisputeShiftWitnessArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisputeShiftWitnessesArgs = {
  input?: InputMaybe<DisputeShiftWitnessQueryInput>;
};


export type QueryDisputedJobBillingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisputedJobBillingsArgs = {
  input?: InputMaybe<DisputedJobBillingQueryInput>;
};


export type QueryDisputesArgs = {
  input?: InputMaybe<DisputeQueryInput>;
};


export type QueryEducationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEducationsArgs = {
  input?: InputMaybe<EducationQueryInput>;
};


export type QueryEhrSystemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEhrSystemsArgs = {
  input?: InputMaybe<EhrSystemQueryInput>;
};


export type QueryEmergencyContactArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEmergencyContactsArgs = {
  input?: InputMaybe<EmergencyContactQueryInput>;
};


export type QueryExpenseAdjustmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExpenseAdjustmentsArgs = {
  input?: InputMaybe<ExpenseAdjustmentQueryInput>;
};


export type QueryExternalAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExternalAccountsArgs = {
  input?: InputMaybe<ExternalAccountQueryInput>;
};


export type QueryFacilityConnectionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFacilityConnectionsArgs = {
  input?: InputMaybe<FacilityConnectionQueryInput>;
};


export type QueryFinancialTransactionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFinancialTransactionsArgs = {
  input?: InputMaybe<FinancialTransactionQueryInput>;
};


export type QueryFundingSourceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFundingSourcesArgs = {
  input?: InputMaybe<FundingSourceQueryInput>;
};


export type QueryGatewayBillingGroupArgs = {
  uid: Scalars['String']['input'];
};


export type QueryGatewayBillingGroupCreditLimitCalculationArgs = {
  uid: Scalars['UUID']['input'];
};


export type QueryGatewayConditionDocumentsArgs = {
  input?: InputMaybe<ConditionDocumentQueryInput>;
};


export type QueryGatewayInvoiceArgs = {
  billing_id: Scalars['String']['input'];
};


export type QueryGatewayInvoicesArgs = {
  input?: InputMaybe<InvoiceQueryInput>;
};


export type QueryGatewayProfessionalReferencesArgs = {
  input?: InputMaybe<ProfessionalReferenceQueryInput>;
};


export type QueryGatewayStatementArgs = {
  billing_id: Scalars['String']['input'];
};


export type QueryGatewayStatementsArgs = {
  input?: InputMaybe<StatementQueryInput>;
};


export type QueryGetBlockedTimesArgs = {
  input: GetBlockedTimesInput;
};


export type QueryGetProPoolDashboardArgs = {
  input?: InputMaybe<ProPoolDashboardInput>;
};


export type QueryHealthSystemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryHealthSystemsArgs = {
  input?: InputMaybe<HealthSystemQueryInput>;
};


export type QueryInterviewAvailabilitiesArgs = {
  input?: InputMaybe<InterviewAvailabilityQueryInput>;
};


export type QueryInterviewAvailabilityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvoiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvoiceStatusBillingGroupCountsArgs = {
  input: InvoiceStatusBillingGroupCountsInput;
};


export type QueryInvoicesArgs = {
  input?: InputMaybe<InvoiceQueryInput>;
};


export type QueryInvoicesTotalsArgs = {
  input?: InputMaybe<InvoiceQueryInput>;
};


export type QueryItemizedTransactionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryItemizedTransactionsArgs = {
  input?: InputMaybe<ItemizedTransactionQueryInput>;
};


export type QueryJobArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobBillingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobBillingsArgs = {
  input?: InputMaybe<JobBillingQueryInput>;
};


export type QueryJobCountArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type QueryJobIrregularitiesArgs = {
  input?: InputMaybe<JobIrregularityQueryInput>;
};


export type QueryJobIrregularityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobPriceDifferentialArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobPriceDifferentialsArgs = {
  input?: InputMaybe<JobPriceDifferentialQueryInput>;
};


export type QueryJobProfileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobProfilesArgs = {
  input?: InputMaybe<JobProfileQueryInput>;
};


export type QueryJobPublishingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobPublishingGroupsArgs = {
  input?: InputMaybe<JobPublishingGroupQueryInput>;
};


export type QueryJobRateTrackedEventArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobRateTrackedEventsArgs = {
  input?: InputMaybe<JobRateTrackedEventQueryInput>;
};


export type QueryJobStatusLocationCountsArgs = {
  input: JobStatusLocationCountsInput;
};


export type QueryJobSurgeryTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobSurgeryTypesArgs = {
  input?: InputMaybe<JobSurgeryTypeQueryInput>;
};


export type QueryJobTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobTemplatesArgs = {
  input?: InputMaybe<JobTemplateQueryInput>;
};


export type QueryJobTrackArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobTracksArgs = {
  input?: InputMaybe<JobTrackQueryInput>;
};


export type QueryJobsArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type QueryJobsAwaitingApprovalArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type QueryJobsBoardArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobsBoardPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryJobsBoardPositionsArgs = {
  input?: InputMaybe<JobsBoardPositionQueryInput>;
};


export type QueryJobsBoardsArgs = {
  input?: InputMaybe<JobsBoardQueryInput>;
};


export type QueryJobsByPositionArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type QueryJobsTotalsArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type QueryJobsWithoutPayoutArgs = {
  input?: InputMaybe<JobQueryInput>;
};


export type QueryLineOfCreditArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLineOfCreditsArgs = {
  input?: InputMaybe<LineOfCreditQueryInput>;
};


export type QueryLocalRateRuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocalRateRulesArgs = {
  input?: InputMaybe<LocalRateRuleQueryInput>;
};


export type QueryLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationAssignmentIssueCountsArgs = {
  input: LocationAssignmentIssueCountsInput;
};


export type QueryLocationBillingGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationBillingGroupsArgs = {
  input?: InputMaybe<LocationBillingGroupQueryInput>;
};


export type QueryLocationBlockReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationBlockReasonsArgs = {
  input?: InputMaybe<LocationBlockReasonQueryInput>;
};


export type QueryLocationConditionsArgs = {
  input: LocationConditionInput;
};


export type QueryLocationGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationGroupsArgs = {
  input?: InputMaybe<LocationGroupQueryInput>;
};


export type QueryLocationPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationPositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationPositionRateSettingsArgs = {
  input?: InputMaybe<LocationPositionRateSettingQueryInput>;
};


export type QueryLocationPositionsArgs = {
  input?: InputMaybe<LocationPositionQueryInput>;
};


export type QueryLocationRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationRateSettingsArgs = {
  input?: InputMaybe<LocationRateSettingQueryInput>;
};


export type QueryLocationTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationTypePositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationTypePositionsArgs = {
  input?: InputMaybe<LocationTypePositionQueryInput>;
};


export type QueryLocationTypesArgs = {
  input?: InputMaybe<LocationTypeQueryInput>;
};


export type QueryLocationsArgs = {
  input?: InputMaybe<LocationQueryInput>;
};


export type QueryMarketArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMarketLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMarketLocationTypePositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketLocationTypePositionRateSettingsArgs = {
  input?: InputMaybe<MarketLocationTypePositionRateSettingQueryInput>;
};


export type QueryMarketLocationTypeRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketLocationTypeRateSettingsArgs = {
  input?: InputMaybe<MarketLocationTypeRateSettingQueryInput>;
};


export type QueryMarketLocationsArgs = {
  input?: InputMaybe<MarketLocationQueryInput>;
};


export type QueryMarketPositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketPositionRateSettingsArgs = {
  input?: InputMaybe<MarketPositionRateSettingQueryInput>;
};


export type QueryMarketRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketRateSettingsArgs = {
  input?: InputMaybe<MarketRateSettingQueryInput>;
};


export type QueryMarketsArgs = {
  input?: InputMaybe<MarketQueryInput>;
};


export type QueryMarketsProfessionalArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMarketsProfessionalsArgs = {
  input?: InputMaybe<MarketsProfessionalQueryInput>;
};


export type QueryMetabaseEmbedUrlArgs = {
  input?: InputMaybe<MetabaseEmbedQueryInput>;
};


export type QueryMspArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMspsArgs = {
  input?: InputMaybe<MspQueryInput>;
};


export type QueryNetTermArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNetTermsArgs = {
  input?: InputMaybe<NetTermQueryInput>;
};


export type QueryNoteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotesArgs = {
  input?: InputMaybe<NoteQueryInput>;
};


export type QueryNursysEnrollmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNursysEnrollmentsArgs = {
  input?: InputMaybe<NursysEnrollmentQueryInput>;
};


export type QueryPaymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPaymentsArgs = {
  input?: InputMaybe<PaymentQueryInput>;
};


export type QueryPayoutArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPayoutsArgs = {
  input?: InputMaybe<PayoutQueryInput>;
};


export type QueryPeopleArgs = {
  input?: InputMaybe<PersonQueryInput>;
};


export type QueryPermanentPlacementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPermanentPlacementsArgs = {
  input?: InputMaybe<AssignmentQueryInput>;
};


export type QueryPermanentRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPermanentRequestsArgs = {
  input?: InputMaybe<AssignmentRequestQueryInput>;
};


export type QueryPermissionGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPermissionGroupsArgs = {
  input?: InputMaybe<PermissionGroupQueryInput>;
};


export type QueryPersonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonDisabledReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonDisabledReasonsArgs = {
  input?: InputMaybe<PersonDisabledReasonQueryInput>;
};


export type QueryPhoneScreeningRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPhoneScreeningRequestsArgs = {
  input?: InputMaybe<PhoneScreeningRequestQueryInput>;
};


export type QueryPoolArgs = {
  id: Scalars['Int']['input'];
  location_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPoolProfessionalArgs = {
  id: Scalars['Int']['input'];
  location_id: Scalars['Int']['input'];
};


export type QueryPoolProfessionalsArgs = {
  input?: InputMaybe<ProfessionalPoolQueryInput>;
};


export type QueryPoolsArgs = {
  input: PoolQueryInput;
};


export type QueryPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPositionPostingFieldArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPositionPostingFieldsArgs = {
  input?: InputMaybe<PositionPostingFieldQueryInput>;
};


export type QueryPositionSpecialtiesArgs = {
  input?: InputMaybe<PositionSpecialtyQueryInput>;
};


export type QueryPositionSpecialtyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPositionsArgs = {
  input?: InputMaybe<PositionQueryInput>;
};


export type QueryPostingFieldArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPostingFieldsArgs = {
  input?: InputMaybe<PostingFieldQueryInput>;
};


export type QueryProfessionalArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalAssignmentFavoriteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalAssignmentFavoritesArgs = {
  input?: InputMaybe<ProfessionalAssignmentFavoriteQueryInput>;
};


export type QueryProfessionalBlockReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalBlockReasonsArgs = {
  input?: InputMaybe<ProfessionalBlockReasonQueryInput>;
};


export type QueryProfessionalPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalPositionsArgs = {
  input?: InputMaybe<ProfessionalPositionQueryInput>;
};


export type QueryProfessionalProfileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalProfileEhrSystemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalProfileEhrSystemsArgs = {
  input?: InputMaybe<ProfessionalProfileEhrSystemQueryInput>;
};


export type QueryProfessionalProfilesArgs = {
  input?: InputMaybe<ProfessionalProfileQueryInput>;
};


export type QueryProfessionalQualificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalQualificationAttributeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalQualificationAttributesArgs = {
  input?: InputMaybe<ProfessionalQualificationAttributeQueryInput>;
};


export type QueryProfessionalQualificationsArgs = {
  input?: InputMaybe<ProfessionalQualificationQueryInput>;
};


export type QueryProfessionalReferenceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalReferencesArgs = {
  input?: InputMaybe<ProfessionalReferenceQueryInput>;
};


export type QueryProfessionalSaasDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalSaasDetailsArgs = {
  input?: InputMaybe<ProfessionalSaasDetailQueryInput>;
};


export type QueryProfessionalScreeningArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalScreeningsArgs = {
  input?: InputMaybe<ProfessionalScreeningQueryInput>;
};


export type QueryProfessionalSkillsAssessmentsAnswerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalSkillsAssessmentsAnswersArgs = {
  input?: InputMaybe<ProfessionalSkillsAssessmentsAnswerQueryInput>;
};


export type QueryProfessionalSpecialtiesArgs = {
  input?: InputMaybe<ProfessionalSpecialtyQueryInput>;
};


export type QueryProfessionalSpecialtyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalTravelAssignmentStateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalTravelAssignmentStatesArgs = {
  input?: InputMaybe<ProfessionalTravelAssignmentStateQueryInput>;
};


export type QueryProfessionalTravelPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProfessionalTravelPositionsArgs = {
  input?: InputMaybe<ProfessionalTravelPositionQueryInput>;
};


export type QueryProfessionalsArgs = {
  input?: InputMaybe<ProfessionalQueryInput>;
};


export type QueryProfessionalsJobsArgs = {
  input: ProfessionalsJobsInput;
};


export type QueryQualificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationAttributeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationAttributeOptionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationAttributesArgs = {
  input?: InputMaybe<QualificationAttributeQueryInput>;
};


export type QueryQualificationAutomationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationAutomationAttributeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationAutomationAttributesArgs = {
  input?: InputMaybe<QualificationAutomationAttributeQueryInput>;
};


export type QueryQualificationAutomationsArgs = {
  input?: InputMaybe<QualificationAutomationQueryInput>;
};


export type QueryQualificationsArgs = {
  input?: InputMaybe<QualificationQueryInput>;
};


export type QueryQualificationsGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQualificationsGroupsArgs = {
  input?: InputMaybe<QualificationsGroupQueryInput>;
};


export type QueryQuestionnaireArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuestionnaireResponseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuestionnaireResponsesArgs = {
  input?: InputMaybe<QuestionnaireResponseQueryInput>;
};


export type QueryQuestionnairesArgs = {
  input?: InputMaybe<QuestionnaireQueryInput>;
};


export type QueryRateCalculatorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRateCalculatorsArgs = {
  input?: InputMaybe<RateCalculatorQueryInput>;
};


export type QueryRateSettingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRateSettingsArgs = {
  input?: InputMaybe<RateSettingQueryInput>;
};


export type QueryReferralSourceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryReferralSourcesArgs = {
  input?: InputMaybe<ReferralSourceQueryInput>;
};


export type QueryRefundArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRefundsArgs = {
  input?: InputMaybe<RefundQueryInput>;
};


export type QueryRelationshipArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRelationshipsArgs = {
  input?: InputMaybe<RelationshipQueryInput>;
};


export type QueryRequirementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRequirementsArgs = {
  input?: InputMaybe<RequirementQueryInput>;
};


export type QueryRevenueAdjustmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRevenueAdjustmentsArgs = {
  input?: InputMaybe<RevenueAdjustmentQueryInput>;
};


export type QueryReviewArgs = {
  id: Scalars['Int']['input'];
};


export type QueryReviewsArgs = {
  input?: InputMaybe<ReviewQueryInput>;
};


export type QuerySchedulerOverviewArgs = {
  input?: InputMaybe<SchedulerOverviewInput>;
};


export type QuerySignUpLocationTypeArgs = {
  input?: InputMaybe<LocationTypeQueryInput>;
};


export type QuerySignUpLocationTypesArgs = {
  input?: InputMaybe<LocationTypeQueryInput>;
};


export type QuerySkillsAssessmentArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsAssessmentBakArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsAssessmentBaksArgs = {
  input?: InputMaybe<SkillsAssessmentBakQueryInput>;
};


export type QuerySkillsAssessmentResponseBakArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsAssessmentResponseBaksArgs = {
  input?: InputMaybe<SkillsAssessmentResponseBakQueryInput>;
};


export type QuerySkillsAssessmentSkillsQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsAssessmentSkillsQuestionsArgs = {
  input?: InputMaybe<SkillsAssessmentSkillsQuestionQueryInput>;
};


export type QuerySkillsAssessmentsArgs = {
  input?: InputMaybe<SkillsAssessmentQueryInput>;
};


export type QuerySkillsQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkillsQuestionsArgs = {
  input?: InputMaybe<SkillsQuestionQueryInput>;
};


export type QuerySocialProofMarketActivitiesArgs = {
  input?: InputMaybe<SocialProofMarketActivityQueryInput>;
};


export type QuerySpecialtiesArgs = {
  input?: InputMaybe<SpecialtyQueryInput>;
};


export type QuerySpecialtyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStaffBlockReasonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStaffBlockReasonsArgs = {
  input?: InputMaybe<StaffBlockReasonQueryInput>;
};


export type QueryStateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStateLocationTypePositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStateLocationTypePositionRateSettingsArgs = {
  input?: InputMaybe<StateLocationTypePositionRateSettingQueryInput>;
};


export type QueryStateLocationTypeRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStateLocationTypeRateSettingsArgs = {
  input?: InputMaybe<StateLocationTypeRateSettingQueryInput>;
};


export type QueryStatePositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStatePositionRateSettingsArgs = {
  input?: InputMaybe<StatePositionRateSettingQueryInput>;
};


export type QueryStateRateSettingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStateRateSettingsArgs = {
  input?: InputMaybe<StateRateSettingQueryInput>;
};


export type QueryStatementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStatementsArgs = {
  input?: InputMaybe<StatementQueryInput>;
};


export type QueryStatesArgs = {
  input?: InputMaybe<StateQueryInput>;
};


export type QueryStripeAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStripeAccountsArgs = {
  input?: InputMaybe<StripeAccountQueryInput>;
};


export type QueryStripePaymentIntentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStripePaymentIntentsArgs = {
  input?: InputMaybe<StripePaymentIntentQueryInput>;
};


export type QueryStripeRepresentativeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStripeRepresentativesArgs = {
  input?: InputMaybe<StripeRepresentativeQueryInput>;
};


export type QuerySurgeryTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySurgeryTypesArgs = {
  input?: InputMaybe<SurgeryTypeQueryInput>;
};


export type QueryTaxClassificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTaxClassificationsArgs = {
  input?: InputMaybe<TaxClassificationQueryInput>;
};


export type QueryTaxFormArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTaxFormsArgs = {
  input?: InputMaybe<TaxFormQueryInput>;
};


export type QueryTimecardArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTimecardsArgs = {
  input?: InputMaybe<TimecardQueryInput>;
};


export type QueryTimecardsTotalsArgs = {
  input?: InputMaybe<TimecardQueryInput>;
};


export type QueryTransferReversalArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTransferReversalsArgs = {
  input?: InputMaybe<TransferReversalQueryInput>;
};


export type QueryUniqueAgencyChargeOverridesArgs = {
  input?: InputMaybe<AgencyChargeOverridesQueryInput>;
};


export type QueryUniversalBackgroundCheckArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUniversalBackgroundChecksArgs = {
  input?: InputMaybe<UniversalBackgroundCheckQueryInput>;
};


export type QueryUnpaidTimecardAdjustmentsArgs = {
  input?: InputMaybe<ExpenseAdjustmentQueryInput>;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserPositionRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserPositionRateSettingsArgs = {
  input?: InputMaybe<UserPositionRateSettingQueryInput>;
};


export type QueryUserPositionsArgs = {
  input?: InputMaybe<UserPositionQueryInput>;
};


export type QueryUserRateSettingArgs = {
  id: Scalars['Int']['input'];
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserRateSettingsArgs = {
  input?: InputMaybe<UserRateSettingQueryInput>;
};


export type QueryUsersArgs = {
  input?: InputMaybe<UserQueryInput>;
};


export type QueryValidateJobTimesArgs = {
  input: ValidateJobTimesInput;
};


export type QueryVmsAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVmsAssignmentsArgs = {
  input?: InputMaybe<VmsAssignmentQueryInput>;
};


export type QueryVmsPositionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVmsPositionsArgs = {
  input?: InputMaybe<VmsPositionQueryInput>;
};


export type QueryVmsTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVmsTypesArgs = {
  input?: InputMaybe<VmsTypeQueryInput>;
};


export type QueryVmsUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVmsUsersArgs = {
  input?: InputMaybe<VmsUserQueryInput>;
};


export type QueryWageLogArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWageLogsArgs = {
  input?: InputMaybe<WageLogQueryInput>;
};


export type QueryWeeklyTimecardsTotalsArgs = {
  input?: InputMaybe<WeeklyTimecardsTotalsInput>;
};


export type QueryWorkGapArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWorkGapsArgs = {
  input?: InputMaybe<WorkGapQueryInput>;
};


export type QueryWorkHistoriesArgs = {
  input?: InputMaybe<WorkHistoryQueryInput>;
};


export type QueryWorkHistoryArgs = {
  id: Scalars['Int']['input'];
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type QuestionnaireOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  license_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireQueryInput = {
  filter?: InputMaybe<QuestionnaireWhereInput>;
  orderBy?: InputMaybe<QuestionnaireOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type QuestionnaireResponse = {
  __typename?: 'QuestionnaireResponse';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questions?: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type QuestionnaireResponseOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireResponseQueryInput = {
  filter?: InputMaybe<QuestionnaireResponseWhereInput>;
  orderBy?: InputMaybe<QuestionnaireResponseOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<QuestionnaireResponseSearchInput>;
};

export type QuestionnaireResponseSearchInput = {
  credential_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  license_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireResponseWhereInput = {
  credential_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  license_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RateCalculator = {
  __typename?: 'RateCalculator';
  base_rate_cents?: Maybe<Scalars['Int']['output']>;
  base_rate_facility_cents?: Maybe<Scalars['Int']['output']>;
  charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  fee_percent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  payout_rate_cents?: Maybe<Scalars['Int']['output']>;
  rate_differential: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RateCalculatorOrderInput = {
  base_rate?: InputMaybe<Scalars['Boolean']['input']>;
  base_rate_facility?: InputMaybe<Scalars['Boolean']['input']>;
  charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  fee_percent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rate_differential?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateCalculatorQueryInput = {
  filter?: InputMaybe<RateCalculatorWhereInput>;
  orderBy?: InputMaybe<RateCalculatorOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type RateCalculatorWhereInput = {
  base_rate?: InputMaybe<Scalars['Int']['input']>;
  base_rate_facility?: InputMaybe<Scalars['Int']['input']>;
  charge_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  fee_percent?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  rate_differential?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RateSetting = {
  __typename?: 'RateSetting';
  active: Scalars['Boolean']['output'];
  charge_on_call_hourly_rate_cents: Scalars['Int']['output'];
  charge_on_call_hourly_rate_currency: Scalars['String']['output'];
  charge_overtime_frequency?: Maybe<Scalars['String']['output']>;
  charge_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  charge_rate_cents: Scalars['Int']['output'];
  compliance_burden_cents: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  federal_unemployment_max_burden_cents: Scalars['Int']['output'];
  federal_unemployment_percent_burden_multiplier: Scalars['Float']['output'];
  fee_percent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  market?: Maybe<Market>;
  market_name?: Maybe<Scalars['String']['output']>;
  medicare_burden_multiplier: Scalars['Float']['output'];
  on_call_fee_percent?: Maybe<Scalars['Float']['output']>;
  on_call_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  other_burden_multiplier: Scalars['Float']['output'];
  payout_on_call_hourly_rate_cents: Scalars['Int']['output'];
  payout_on_call_hourly_rate_currency: Scalars['String']['output'];
  payout_overtime_frequency?: Maybe<Scalars['String']['output']>;
  payout_overtime_multiplier?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Position>;
  position_name?: Maybe<Scalars['String']['output']>;
  rate_double?: Maybe<Scalars['Int']['output']>;
  rate_time_half?: Maybe<Scalars['Float']['output']>;
  social_security_burden_multiplier: Scalars['Float']['output'];
  specialty?: Maybe<Specialty>;
  state?: Maybe<State>;
  state_unemployment_max_burden_cents: Scalars['Int']['output'];
  state_unemployment_percent_burden_multiplier: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  w2_fee_percent: Scalars['Float']['output'];
};

export type RateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  facility_rate?: InputMaybe<Scalars['Boolean']['input']>;
  fee_percent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Boolean']['input']>;
  market_name?: InputMaybe<Scalars['Boolean']['input']>;
  on_call_hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  payout_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  position_name?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rate_double?: InputMaybe<Scalars['Boolean']['input']>;
  rate_time_half?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateSettingQueryInput = {
  filter?: InputMaybe<RateSettingWhereInput>;
  orderBy?: InputMaybe<RateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<RateSettingSearchInput>;
};

export type RateSettingSearchInput = {
  location_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  charge_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  facility_rate?: InputMaybe<Scalars['Int']['input']>;
  fee_percent?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  market_name?: InputMaybe<Scalars['String']['input']>;
  on_call_hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  payout_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  rate_double?: InputMaybe<Scalars['Int']['input']>;
  rate_time_half?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  w2_fee_percent?: InputMaybe<Scalars['Float']['input']>;
};

export type Reason = LocationBlockReason | ProfessionalBlockReason;

export enum ReasonType {
  Application = 'application',
  ReScreening = 're_screening'
}

export type RecentShift = {
  __typename?: 'RecentShift';
  id: Scalars['Int']['output'];
  starts_date: Scalars['Date']['output'];
};

export type Recipient = BillingGroup | FinancialTransaction | Location | Professional;

export type RecommendedAssignmentInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ReferenceQuestion = {
  __typename?: 'ReferenceQuestion';
  answer?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type ReferralSource = {
  __typename?: 'ReferralSource';
  admin_only: Scalars['Boolean']['output'];
  applies_to_facilities: Scalars['Boolean']['output'];
  applies_to_professionals: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  professionals?: Maybe<Array<Professional>>;
  updated_at: Scalars['DateTime']['output'];
};

export type ReferralSourceOrderInput = {
  admin_only?: InputMaybe<Scalars['Boolean']['input']>;
  applies_to_facilities?: InputMaybe<Scalars['Boolean']['input']>;
  applies_to_professionals?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReferralSourceQueryInput = {
  filter?: InputMaybe<ReferralSourceWhereInput>;
  orderBy?: InputMaybe<ReferralSourceOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type ReferralSourceWhereInput = {
  admin_only?: InputMaybe<Scalars['Boolean']['input']>;
  applies_to_facilities?: InputMaybe<Scalars['Boolean']['input']>;
  applies_to_professionals?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  without_admin_only?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Refund = {
  __typename?: 'Refund';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  invoice?: Maybe<Invoice>;
  kind?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type RefundOrderInput = {
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefundQueryInput = {
  filter?: InputMaybe<RefundWhereInput>;
  orderBy?: InputMaybe<RefundOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type RefundWhereInput = {
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_currency?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RelatedToFacilityAccountInput = {
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Relationship = {
  __typename?: 'Relationship';
  comments?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  location?: Maybe<Location>;
  locationBlockReason?: Maybe<LocationBlockReason>;
  professional?: Maybe<Professional>;
  professionalBlockReason?: Maybe<ProfessionalBlockReason>;
  reason?: Maybe<Reason>;
  reason_id?: Maybe<Scalars['Int']['output']>;
  reason_type?: Maybe<Scalars['String']['output']>;
  requestee?: Maybe<Requestee>;
  requestee_id?: Maybe<Scalars['Int']['output']>;
  requestee_type?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<Requester>;
  requester_id?: Maybe<Scalars['Int']['output']>;
  requester_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type RelationshipOrderInput = {
  comments?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  reason_id?: InputMaybe<Scalars['Boolean']['input']>;
  reason_type?: InputMaybe<Scalars['Boolean']['input']>;
  requestee_id?: InputMaybe<Scalars['Boolean']['input']>;
  requestee_type?: InputMaybe<Scalars['Boolean']['input']>;
  requester_id?: InputMaybe<Scalars['Boolean']['input']>;
  requester_type?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RelationshipQueryInput = {
  filter?: InputMaybe<RelationshipWhereInput>;
  orderBy?: InputMaybe<RelationshipOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<RelationshipSearchInput>;
};

export type RelationshipSearchInput = {
  billing_type?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  exclude_deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_soft_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  location_block_reason_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_block_reason_id?: InputMaybe<Scalars['Int']['input']>;
  professional_locations_relationship?: InputMaybe<ProfessionalLocations>;
  reason_id?: InputMaybe<Scalars['Int']['input']>;
  reason_type?: InputMaybe<Scalars['String']['input']>;
  requestee_id?: InputMaybe<Scalars['Int']['input']>;
  requestee_type?: InputMaybe<Scalars['String']['input']>;
  requester_id?: InputMaybe<Scalars['Int']['input']>;
  requester_type?: InputMaybe<Scalars['String']['input']>;
  to_date?: InputMaybe<Scalars['Date']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RelationshipWhereInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  professional_type?: InputMaybe<Scalars['String']['input']>;
  reason_id?: InputMaybe<Scalars['Int']['input']>;
  reason_type?: InputMaybe<Scalars['String']['input']>;
  requestee_id?: InputMaybe<Scalars['Int']['input']>;
  requestee_type?: InputMaybe<Scalars['String']['input']>;
  requester_id?: InputMaybe<Scalars['Int']['input']>;
  requester_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ReleaseAudience {
  Agency = 'agency',
  Marketplace = 'marketplace',
  Saas = 'saas'
}

export type Requestee = Location | Professional;

export type Requester = Location | Professional;

export type Requirement = {
  __typename?: 'Requirement';
  add_to_booked_jobs: Scalars['Boolean']['output'];
  base?: Maybe<Scalars['Boolean']['output']>;
  cohort_eligibility: Scalars['String']['output'];
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['Int']['output']>;
  condition: Condition;
  condition_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job_kind?: Maybe<JobKind>;
  job_type?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  location_id?: Maybe<Scalars['Int']['output']>;
  medely: Scalars['Boolean']['output'];
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  required: Scalars['Boolean']['output'];
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vms_type?: Maybe<VmsType>;
  vms_type_id?: Maybe<Scalars['Int']['output']>;
};

export type RequirementOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequirementQueryInput = {
  filter?: InputMaybe<RequirementWhereInput>;
  orderBy?: InputMaybe<RequirementOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<RequirementSearchInput>;
};

export type RequirementSearchInput = {
  company_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  company_medely_requirements?: InputMaybe<CompanyMedelyRequirements>;
  company_requirements?: InputMaybe<Scalars['Boolean']['input']>;
  include_company_only?: InputMaybe<Scalars['Boolean']['input']>;
  kind_requirements?: InputMaybe<Scalars['Boolean']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location_requirements?: InputMaybe<Scalars['Boolean']['input']>;
  medely_requirements?: InputMaybe<Scalars['Boolean']['input']>;
  position_requirements?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  specialty_requirements?: InputMaybe<Scalars['Boolean']['input']>;
  state_requirements?: InputMaybe<Scalars['Boolean']['input']>;
  vms_requirements?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequirementWhereInput = {
  cohort_eligibility?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  condition_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  job_type?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  medely?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RevenueAdjustment = {
  __typename?: 'RevenueAdjustment';
  adjustment_type?: Maybe<Scalars['String']['output']>;
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  balance_sheet?: Maybe<BalanceSheet>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dispute?: Maybe<Dispute>;
  dispute_id?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  invoice?: Maybe<Invoice>;
  job?: Maybe<Job>;
  job_id?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  past_month_adjustment: Scalars['Boolean']['output'];
  primary_adjustment: Scalars['Boolean']['output'];
  start_date?: Maybe<Scalars['DateTime']['output']>;
  timecard?: Maybe<Timecard>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type RevenueAdjustmentOrderInput = {
  adjustment_type?: InputMaybe<Scalars['Boolean']['input']>;
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency?: InputMaybe<Scalars['Boolean']['input']>;
  balance_sheet_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  past_month_adjustment?: InputMaybe<Scalars['Boolean']['input']>;
  primary_adjustment?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RevenueAdjustmentQueryInput = {
  filter?: InputMaybe<RevenueAdjustmentWhereInput>;
  orderBy?: InputMaybe<RevenueAdjustmentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<RevenueAdjustmentSearchInput>;
};

export type RevenueAdjustmentSearchInput = {
  adjustment_type?: InputMaybe<Scalars['String']['input']>;
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_currency?: InputMaybe<Scalars['String']['input']>;
  balance_sheet_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  dispute_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  past_month_adjustment?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RevenueAdjustmentWhereInput = {
  adjustment_type?: InputMaybe<Scalars['String']['input']>;
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_currency?: InputMaybe<Scalars['String']['input']>;
  balance_sheet_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  dispute_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  past_month_adjustment?: InputMaybe<Scalars['Boolean']['input']>;
  timecard_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Review = {
  __typename?: 'Review';
  blocked: Scalars['Boolean']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  comments_?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job?: Maybe<Job>;
  rating?: Maybe<Scalars['Float']['output']>;
  /** @deprecated this is an incorrect join on reviewee_id, consumers should use a combination of reviewee_type and reviewee_id */
  reviewee?: Maybe<Account>;
  reviewee_id?: Maybe<Scalars['Int']['output']>;
  reviewee_type?: Maybe<Scalars['String']['output']>;
  /** @deprecated this is an incorrect join on reviewer_id, consumers should use a combination of reviewer_type and reviewer_id */
  reviewer?: Maybe<Account>;
  reviewer_id?: Maybe<Scalars['Int']['output']>;
  reviewer_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ReviewOrderInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['Boolean']['input']>;
  comments_?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Boolean']['input']>;
  reviewee_id?: InputMaybe<Scalars['Boolean']['input']>;
  reviewee_role?: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_id?: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_role?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewQueryInput = {
  filter?: InputMaybe<ReviewWhereInput>;
  orderBy?: InputMaybe<ReviewOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<ReviewSearchInput>;
};

export type ReviewSearchInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reviews_for_type?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewWhereInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  comments_?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  professional_reviewee_id?: InputMaybe<Scalars['Int']['input']>;
  professional_reviewer_id?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  reviewee_id?: InputMaybe<Scalars['Int']['input']>;
  reviewee_role?: InputMaybe<Scalars['String']['input']>;
  reviewer_id?: InputMaybe<Scalars['Int']['input']>;
  reviewer_role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Role {
  AccountManager = 'account_manager',
  Admin = 'admin',
  Credentialist = 'credentialist',
  Recruiter = 'recruiter',
  SalesAdmin = 'sales_admin',
  SalesAssociate = 'sales_associate',
  SalesRecruiter = 'sales_recruiter',
  SupportAdmin = 'support_admin',
  SupportAgent = 'support_agent'
}

export type SaasCheckInput = {
  is_saas_professional?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduledHours = {
  __typename?: 'ScheduledHours';
  assignments_count: Scalars['Int']['output'];
  irm_count: Scalars['Int']['output'];
  per_diem_count: Scalars['Int']['output'];
  total_amount: Scalars['Int']['output'];
};

export type ScheduledShifts = {
  __typename?: 'ScheduledShifts';
  assignments_count: Scalars['Int']['output'];
  irm_count: Scalars['Int']['output'];
  per_diem_count: Scalars['Int']['output'];
  total_amount: Scalars['Int']['output'];
};

export type SchedulerOverview = {
  __typename?: 'SchedulerOverview';
  open_shifts: OpenShifts;
  scheduled_hours: ScheduledHours;
  scheduled_shifts: ScheduledShifts;
};

export type SchedulerOverviewInput = {
  search: SchedulerOverviewSearchInput;
};

export type SchedulerOverviewSearchInput = {
  ends_time?: InputMaybe<Scalars['DateTime']['input']>;
  location_ids: Array<Scalars['Int']['input']>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  starts_time_for_day_view?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ScreeningType {
  Phone = 'phone',
  Written = 'written'
}

export enum ScrubColors {
  Any = 'any',
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Green = 'green',
  Grey = 'grey',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

export type ShiftLengthInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type SkillsAssessment = {
  __typename?: 'SkillsAssessment';
  id: Scalars['Int']['output'];
  skills_questions?: Maybe<Array<SkillsQuestion>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SkillsAssessmentBak = {
  __typename?: 'SkillsAssessmentBak';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  specialty?: Maybe<Specialty>;
  typeform_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type SkillsAssessmentBakOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Boolean']['input']>;
  typeform_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentBakQueryInput = {
  filter?: InputMaybe<SkillsAssessmentBakWhereInput>;
  orderBy?: InputMaybe<SkillsAssessmentBakOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type SkillsAssessmentBakWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  typeform_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SkillsAssessmentOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentQueryInput = {
  filter?: InputMaybe<SkillsAssessmentWhereInput>;
  orderBy?: InputMaybe<SkillsAssessmentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type SkillsAssessmentResponseBak = {
  __typename?: 'SkillsAssessmentResponseBak';
  answers?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  last_completed_at?: Maybe<Scalars['DateTime']['output']>;
  professioanl_id?: Maybe<Scalars['Int']['output']>;
  professional?: Maybe<Professional>;
  questions?: Maybe<Scalars['JSON']['output']>;
  skills_assessment_bak?: Maybe<SkillsAssessmentBak>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  webhook_pending?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillsAssessmentResponseBakOrderInput = {
  answers?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  expiration_date?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_completed_at?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  questions?: InputMaybe<Scalars['Boolean']['input']>;
  skills_assessment_bak_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  webhook_pending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentResponseBakQueryInput = {
  filter?: InputMaybe<SkillsAssessmentResponseBakWhereInput>;
  orderBy?: InputMaybe<SkillsAssessmentResponseBakOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type SkillsAssessmentResponseBakWhereInput = {
  answers?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_completed_at?: InputMaybe<Scalars['DateTime']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  skills_assessment_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  webhook_pending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentSkillsQuestion = {
  __typename?: 'SkillsAssessmentSkillsQuestion';
  id: Scalars['Int']['output'];
  skills_assessment?: Maybe<SkillsAssessment>;
  skills_assessment_id?: Maybe<Scalars['Int']['output']>;
  skills_question?: Maybe<SkillsQuestion>;
  skills_question_id?: Maybe<Scalars['Int']['output']>;
};

export type SkillsAssessmentSkillsQuestionOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsAssessmentSkillsQuestionQueryInput = {
  filter?: InputMaybe<SkillsAssessmentSkillsQuestionWhereInput>;
  orderBy?: InputMaybe<SkillsAssessmentSkillsQuestionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type SkillsAssessmentSkillsQuestionWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SkillsAssessmentWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SkillsQuestion = {
  __typename?: 'SkillsQuestion';
  category?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  field_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type SkillsQuestionOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillsQuestionQueryInput = {
  filter?: InputMaybe<SkillsQuestionWhereInput>;
  orderBy?: InputMaybe<SkillsQuestionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type SkillsQuestionWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SocialProofMarketActivity = {
  __typename?: 'SocialProofMarketActivity';
  max_pay_amount_cents: Scalars['Int']['output'];
  min_pay_amount_cents: Scalars['Int']['output'];
  shifts_count: Scalars['Int']['output'];
};


export type SocialProofMarketActivityMax_Pay_Amount_CentsArgs = {
  market_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SocialProofMarketActivityMin_Pay_Amount_CentsArgs = {
  market_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SocialProofMarketActivityShifts_CountArgs = {
  market_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SocialProofMarketActivityQueryInput = {
  filter?: InputMaybe<SocialProofMarketActivityWhereInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SocialProofMarketActivityWhereInput>;
};

export type SocialProofMarketActivityWhereInput = {
  market_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Specialty = {
  __typename?: 'Specialty';
  active: Scalars['Boolean']['output'];
  assignments?: Maybe<Array<Assignment>>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  job_templates?: Maybe<Array<JobTemplate>>;
  jobs?: Maybe<Array<Job>>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position_list?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Position>>;
  rate_differential?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type SpecialtyOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  position_list?: InputMaybe<Scalars['Boolean']['input']>;
  position_name?: InputMaybe<Scalars['Boolean']['input']>;
  rate_differential?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpecialtyQueryInput = {
  filter?: InputMaybe<SpecialtyWhereInput>;
  orderBy?: InputMaybe<SpecialtyOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SpecialtySearchInput>;
};

export type SpecialtySearchInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  for_locations?: InputMaybe<ForPositionLocations>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialtyWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_list?: InputMaybe<Scalars['String']['input']>;
  rate_differential?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StaffBlockReason = {
  __typename?: 'StaffBlockReason';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  relationships?: Maybe<Array<Relationship>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StaffBlockReasonOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffBlockReasonQueryInput = {
  filter?: InputMaybe<StaffBlockReasonWhereInput>;
  orderBy?: InputMaybe<StaffBlockReasonOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type StaffBlockReasonWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StartsOrEndsTimeInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type State = {
  __typename?: 'State';
  abbreviation?: Maybe<Scalars['String']['output']>;
  accounts?: Maybe<Array<Account>>;
  active: Scalars['Boolean']['output'];
  covid_requirement?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  display_by_hourly: Scalars['Boolean']['output'];
  google_place_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  market_names?: Maybe<Scalars['String']['output']>;
  markets?: Maybe<Array<Market>>;
  minimum_rate_cents: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nlc: Scalars['Boolean']['output'];
  overtime_hours_frequency?: Maybe<Scalars['String']['output']>;
  overtime_hours_threshold: Scalars['Int']['output'];
  popular_travel_state: Scalars['Boolean']['output'];
  rectangle_image?: Maybe<Scalars['AWSFile']['output']>;
  square_image?: Maybe<Scalars['AWSFile']['output']>;
  states?: Maybe<Array<State>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StateLocationTypePositionRateSetting = {
  __typename?: 'StateLocationTypePositionRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  active_non_markup_settings?: Maybe<LocationTypePositionSettings>;
  audits?: Maybe<Array<Audit>>;
  blended_settings_charge_rate?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location_type?: Maybe<LocationType>;
  location_type_id?: Maybe<Scalars['Int']['output']>;
  non_blended_settings_charge_rate?: Maybe<Scalars['JSON']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<LocationTypePositionSettings>;
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  state_location_type_position_rate_setting?: Maybe<LocationTypePositionSettings>;
  state_location_type_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_location_type_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  with_markup_settings?: Maybe<LocationTypePositionSettings>;
};

export type StateLocationTypePositionRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_markup?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_name?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  position_name?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_name?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  state_name?: InputMaybe<Scalars['Boolean']['input']>;
  ten99_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  w2_local_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  w2_travel_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StateLocationTypePositionRateSettingQueryInput = {
  filter?: InputMaybe<StateLocationTypePositionRateSettingWhereInput>;
  orderBy?: InputMaybe<StateLocationTypePositionRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<StateLocationTypePositionRateSettingSearchInput>;
};

export type StateLocationTypePositionRateSettingSearchInput = {
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  location_type_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  state_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at_from?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateLocationTypePositionRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  for_job?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateLocationTypeRateSetting = {
  __typename?: 'StateLocationTypeRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location_type?: Maybe<LocationType>;
  location_type_id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  state_location_type_rate_setting?: Maybe<Scalars['JSON']['output']>;
  state_rate_settings_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StateLocationTypeRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_name?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  state_name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StateLocationTypeRateSettingQueryInput = {
  filter?: InputMaybe<StateLocationTypeRateSettingWhereInput>;
  orderBy?: InputMaybe<StateLocationTypeRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<StateLocationTypeRateSettingSearchInput>;
};

export type StateLocationTypeRateSettingSearchInput = {
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at_from?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateLocationTypeRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  location_type_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
};

export type StateOrderInput = {
  abbreviation?: InputMaybe<Scalars['Boolean']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  covid_requirement?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  display_by_hourly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  market_names?: InputMaybe<Scalars['Boolean']['input']>;
  minimum_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  nlc?: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_frequency?: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_threshold?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatePositionRateSetting = {
  __typename?: 'StatePositionRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  audits?: Maybe<Array<Audit>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<PositionSettings>;
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting?: Maybe<PositionSettings>;
  state_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StatePositionRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_name?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_name?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  state_name?: InputMaybe<Scalars['Boolean']['input']>;
  ten99_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  w2_local_blended_rate_markup?: InputMaybe<Scalars['Boolean']['input']>;
  w2_local_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  w2_travel_blended_rate_markup?: InputMaybe<Scalars['Boolean']['input']>;
  w2_travel_charge_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatePositionRateSettingQueryInput = {
  filter?: InputMaybe<StatePositionRateSettingWhereInput>;
  orderBy?: InputMaybe<StatePositionRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<StatePositionRateSettingSearchInput>;
};

export type StatePositionRateSettingSearchInput = {
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at_from?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatePositionRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  for_job?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateQueryInput = {
  filter?: InputMaybe<StateWhereInput>;
  orderBy?: InputMaybe<StateOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type StateRateSetting = {
  __typename?: 'StateRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StateRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  state_name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StateRateSettingQueryInput = {
  filter?: InputMaybe<StateRateSettingWhereInput>;
  orderBy?: InputMaybe<StateRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<StateRateSettingSearchInput>;
};

export type StateRateSettingSearchInput = {
  state_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at_from?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StateRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
};

export type StateWhereInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_states?: InputMaybe<Scalars['Boolean']['input']>;
  covid_requirement?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_by_hourly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  market_names?: InputMaybe<Scalars['String']['input']>;
  minimum_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nlc?: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_frequency?: InputMaybe<Scalars['String']['input']>;
  overtime_hours_threshold?: InputMaybe<Scalars['Int']['input']>;
  popular_travel_state?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Statement = {
  __typename?: 'Statement';
  amount_due_cents: Scalars['Int']['output'];
  amount_due_currency: Scalars['String']['output'];
  billing_group?: Maybe<BillingGroup>;
  billing_group_id?: Maybe<Scalars['Int']['output']>;
  billing_id?: Maybe<Scalars['String']['output']>;
  close_time?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  due_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  invoices?: Maybe<Array<Invoice>>;
  paid_date?: Maybe<Scalars['DateTime']['output']>;
  pay_period_end?: Maybe<Scalars['DateTime']['output']>;
  pay_period_start?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_cents: Scalars['Int']['output'];
  total_currency: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type StatementOrderInput = {
  amount_due_cents?: InputMaybe<Scalars['Boolean']['input']>;
  amount_due_currency?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  due_date?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  paid_date?: InputMaybe<Scalars['Boolean']['input']>;
  pay_period_end?: InputMaybe<Scalars['Boolean']['input']>;
  pay_period_start?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  total_cents?: InputMaybe<Scalars['Boolean']['input']>;
  total_currency?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatementQueryInput = {
  filter?: InputMaybe<StatementWhereInput>;
  orderBy?: InputMaybe<StatementOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<StatementSearchInput>;
};

export enum StatementSearchByInput {
  Statements = 'statements',
  Users = 'users'
}

export type StatementSearchInput = {
  account_manager_id?: InputMaybe<Scalars['Int']['input']>;
  billing_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  billing_group_uid?: InputMaybe<Scalars['String']['input']>;
  billing_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  open_payment_gateway?: InputMaybe<Scalars['Boolean']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  paid_date?: InputMaybe<Scalars['DateTime']['input']>;
  past_due?: InputMaybe<Scalars['Boolean']['input']>;
  pay_period_end?: InputMaybe<Scalars['Date']['input']>;
  pay_period_start?: InputMaybe<Scalars['Date']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  search_by?: InputMaybe<StatementSearchByInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  total_cents?: InputMaybe<Scalars['Int']['input']>;
  total_currency?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StatementWhereInput = {
  amount_due_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_due_currency?: InputMaybe<Scalars['String']['input']>;
  billing_group_id?: InputMaybe<Scalars['Int']['input']>;
  billing_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  paid_date?: InputMaybe<Scalars['DateTime']['input']>;
  past_due?: InputMaybe<Scalars['Boolean']['input']>;
  pay_period_end?: InputMaybe<Scalars['Date']['input']>;
  pay_period_start?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_cents?: InputMaybe<Scalars['Int']['input']>;
  total_currency?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  active?: Maybe<Scalars['Boolean']['output']>;
  address_city?: Maybe<Scalars['String']['output']>;
  address_first?: Maybe<Scalars['String']['output']>;
  address_second?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  agency_id?: Maybe<Scalars['Int']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Coordinates>;
  created_at: Scalars['DateTime']['output'];
  external_accounts?: Maybe<Array<ExternalAccount>>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  representative?: Maybe<StripeRepresentative>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  stripe_id: Scalars['String']['output'];
  tax_classification: TaxClassification;
  tax_classification_id: Scalars['Int']['output'];
  tax_form_preference?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type StripeAccountOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address_city?: InputMaybe<Scalars['Boolean']['input']>;
  address_first?: InputMaybe<Scalars['Boolean']['input']>;
  address_second?: InputMaybe<Scalars['Boolean']['input']>;
  address_zip?: InputMaybe<Scalars['Boolean']['input']>;
  company_name?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id?: InputMaybe<Scalars['Boolean']['input']>;
  tax_classification_id?: InputMaybe<Scalars['Boolean']['input']>;
  tax_form_preference?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeAccountQueryInput = {
  filter?: InputMaybe<StripeAccountWhereInput>;
  orderBy?: InputMaybe<StripeAccountOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<StripeAccountSearchInput>;
};

export type StripeAccountSearchInput = {
  account_id?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address_city?: InputMaybe<Scalars['String']['input']>;
  address_first?: InputMaybe<Scalars['String']['input']>;
  address_second?: InputMaybe<Scalars['String']['input']>;
  address_zip?: InputMaybe<Scalars['String']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  tax_classification_id?: InputMaybe<Scalars['Int']['input']>;
  tax_form_preference?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeAccountWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address_city?: InputMaybe<Scalars['String']['input']>;
  address_first?: InputMaybe<Scalars['String']['input']>;
  address_second?: InputMaybe<Scalars['String']['input']>;
  address_zip?: InputMaybe<Scalars['String']['input']>;
  agency_id?: InputMaybe<Scalars['Int']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  tax_classification_id?: InputMaybe<Scalars['Int']['input']>;
  tax_form_preference?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  amount_cents?: Maybe<Scalars['Int']['output']>;
  completed_at?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  failed_at?: Maybe<Scalars['String']['output']>;
  failure_reason?: Maybe<Scalars['String']['output']>;
  funding_source?: Maybe<FundingSource>;
  id: Scalars['Int']['output'];
  processing_at?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['String']['output'];
};

export type StripePaymentIntentOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripePaymentIntentQueryInput = {
  filter?: InputMaybe<StripePaymentIntentWhereInput>;
  orderBy?: InputMaybe<StripePaymentIntentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<StripePaymentIntentSearchInput>;
};

export type StripePaymentIntentSearchInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type StripePaymentIntentWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type StripeRepresentative = {
  __typename?: 'StripeRepresentative';
  address_city: Scalars['String']['output'];
  address_first: Scalars['String']['output'];
  address_second?: Maybe<Scalars['String']['output']>;
  address_zip: Scalars['String']['output'];
  dob: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  ssn_last_4: Scalars['String']['output'];
  state: State;
  state_id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type StripeRepresentativeOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeRepresentativeQueryInput = {
  filter?: InputMaybe<StripeRepresentativeWhereInput>;
  orderBy?: InputMaybe<StripeRepresentativeOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<StripeRepresentativeSearchInput>;
};

export type StripeRepresentativeSearchInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type StripeRepresentativeWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SurgeryType = {
  __typename?: 'SurgeryType';
  active: Scalars['Boolean']['output'];
  assignments?: Maybe<Array<Assignment>>;
  created_at: Scalars['DateTime']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job_surgery_types?: Maybe<Array<JobSurgeryType>>;
  job_templates?: Maybe<Array<JobTemplate>>;
  jobs?: Maybe<Array<Job>>;
  name?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type SurgeryTypeOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  display_name?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SurgeryTypeQueryInput = {
  filter?: InputMaybe<SurgeryTypeWhereInput>;
  orderBy?: InputMaybe<SurgeryTypeOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type SurgeryTypeWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxClassification = {
  __typename?: 'TaxClassification';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type TaxClassificationOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxClassificationQueryInput = {
  filter?: InputMaybe<TaxClassificationWhereInput>;
  orderBy?: InputMaybe<TaxClassificationOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type TaxClassificationWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxForm = {
  __typename?: 'TaxForm';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  stripe_account: StripeAccount;
  stripe_account_id: Scalars['Int']['output'];
  tax_form?: Maybe<Scalars['AWSFile']['output']>;
  updated_at: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type TaxFormOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxFormQueryInput = {
  filter?: InputMaybe<TaxFormWhereInput>;
  orderBy?: InputMaybe<TaxFormOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<TaxFormSearchInput>;
};

export type TaxFormSearchInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxFormWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Ten99Settings = {
  __typename?: 'Ten99Settings';
  blended_rates?: Maybe<BlendedOrNonBlendedRateSettings>;
  charge_max_weekly_regular_hours?: Maybe<Scalars['Int']['output']>;
  charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  charge_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  margin_percent_1099?: Maybe<Scalars['String']['output']>;
  non_blended_rates?: Maybe<BlendedOrNonBlendedRateSettings>;
  payout_max_weekly_regular_hours?: Maybe<Scalars['Int']['output']>;
  payout_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  use_blended_rate?: Maybe<Scalars['Boolean']['output']>;
};

export type Timecard = {
  __typename?: 'Timecard';
  approve_by: Scalars['DateTime']['output'];
  assignment?: Maybe<Assignment>;
  assignment_id?: Maybe<Scalars['Int']['output']>;
  availableJobs: Array<Job>;
  aws_signature_url?: Maybe<Scalars['AWSFile']['output']>;
  created_at: Scalars['DateTime']['output'];
  ends_time: Scalars['DateTime']['output'];
  expense_adjustments?: Maybe<Array<ExpenseAdjustment>>;
  id: Scalars['Int']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  invoice_ids?: Maybe<Array<Scalars['Int']['output']>>;
  job_count?: Maybe<Scalars['Int']['output']>;
  job_count_including_oncall: Scalars['Int']['output'];
  jobs: Array<Job>;
  payout_ids?: Maybe<Array<Scalars['Int']['output']>>;
  payout_kind?: Maybe<Scalars['String']['output']>;
  primary_payout_id?: Maybe<Scalars['Int']['output']>;
  professional: Professional;
  professional_id: Scalars['Int']['output'];
  saas_company_id?: Maybe<Scalars['Int']['output']>;
  signature_url?: Maybe<Scalars['String']['output']>;
  starts_time: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  submit_by: Scalars['DateTime']['output'];
  total_breaks_hours?: Maybe<Scalars['Float']['output']>;
  total_callback_hours?: Maybe<Scalars['Float']['output']>;
  total_double_hours?: Maybe<Scalars['Float']['output']>;
  total_hours?: Maybe<Scalars['Float']['output']>;
  total_hours_including_oncall: Scalars['Float']['output'];
  total_on_call_hours?: Maybe<Scalars['Float']['output']>;
  total_overtime_hours?: Maybe<Scalars['Float']['output']>;
  total_regular_hours?: Maybe<Scalars['Float']['output']>;
  total_scheduled_hours: Scalars['Float']['output'];
  total_worked_hours: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type TimecardOrderInput = {
  approve_by?: InputMaybe<Scalars['Boolean']['input']>;
  assignment_id?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  ends_time?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  starts_time?: InputMaybe<Scalars['Boolean']['input']>;
  submit_by?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimecardQueryInput = {
  filter?: InputMaybe<TimecardWhereInput>;
  orderBy?: InputMaybe<TimecardOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<TimecardSearchInput>;
};

export type TimecardSearchInput = {
  ends_time_from?: InputMaybe<Scalars['Date']['input']>;
  ends_time_to?: InputMaybe<Scalars['Date']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  job_statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_id?: InputMaybe<Scalars['Int']['input']>;
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  no_breaks?: InputMaybe<Scalars['Boolean']['input']>;
  primary_payout_id?: InputMaybe<Scalars['Int']['input']>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  saas_only?: InputMaybe<Scalars['Boolean']['input']>;
  starts_time_from?: InputMaybe<Scalars['Date']['input']>;
  starts_time_to?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TimecardWhereInput = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  ends_time?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  primary_payout_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  starts_time?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submit_by?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimecardsTotals = {
  __typename?: 'TimecardsTotals';
  filtered_breaks_hours?: Maybe<Scalars['Float']['output']>;
  filtered_callback_hours?: Maybe<Scalars['Float']['output']>;
  filtered_double_hours?: Maybe<Scalars['Float']['output']>;
  filtered_on_call_hours?: Maybe<Scalars['Float']['output']>;
  filtered_overtime_hours?: Maybe<Scalars['Float']['output']>;
  filtered_regular_hours?: Maybe<Scalars['Float']['output']>;
  filtered_total_hours?: Maybe<Scalars['Float']['output']>;
};

export type TransferReversal = {
  __typename?: 'TransferReversal';
  amount_cents: Scalars['Int']['output'];
  amount_currency: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  invoice?: Maybe<Invoice>;
  kind?: Maybe<Scalars['String']['output']>;
  payout?: Maybe<Payout>;
  professional?: Maybe<Professional>;
  reason?: Maybe<Scalars['String']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type TransferReversalOrderInput = {
  amount_cents?: InputMaybe<Scalars['Boolean']['input']>;
  amount_currency?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  payout_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransferReversalQueryInput = {
  filter?: InputMaybe<TransferReversalWhereInput>;
  orderBy?: InputMaybe<TransferReversalOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type TransferReversalWhereInput = {
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  amount_currency?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  payout_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UnexplainedWorkGap = {
  __typename?: 'UnexplainedWorkGap';
  earlier_end_date: Scalars['Date']['output'];
  earlier_experience_id: Scalars['Int']['output'];
  earlier_experience_type: Scalars['String']['output'];
  later_experience_id: Scalars['Int']['output'];
  later_experience_type: Scalars['String']['output'];
  later_start_date: Scalars['Date']['output'];
  professional_id: Scalars['Int']['output'];
};

export type UniqueAgencyChargeOverrides = {
  __typename?: 'UniqueAgencyChargeOverrides';
  agency_charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['JSON']['output']>;
  position_id?: Maybe<Scalars['Int']['output']>;
  specialty?: Maybe<Scalars['JSON']['output']>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
};

export type UniversalBackgroundCheck = {
  __typename?: 'UniversalBackgroundCheck';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  order_number?: Maybe<Scalars['String']['output']>;
  order_status?: Maybe<Scalars['String']['output']>;
  order_url?: Maybe<Scalars['String']['output']>;
  professional?: Maybe<Professional>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type UniversalBackgroundCheckOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  order_number?: InputMaybe<Scalars['Boolean']['input']>;
  order_status?: InputMaybe<Scalars['Boolean']['input']>;
  order_url?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UniversalBackgroundCheckQueryInput = {
  filter?: InputMaybe<UniversalBackgroundCheckWhereInput>;
  orderBy?: InputMaybe<UniversalBackgroundCheckOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type UniversalBackgroundCheckWhereInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order_number?: InputMaybe<Scalars['String']['input']>;
  order_status?: InputMaybe<Scalars['String']['input']>;
  order_url?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  about?: Maybe<Scalars['String']['output']>;
  account_manager?: Maybe<Administrator>;
  account_summary_emails?: Maybe<Scalars['Boolean']['output']>;
  allow_assignments?: Maybe<Scalars['Boolean']['output']>;
  allow_per_diem_jobs?: Maybe<Scalars['Boolean']['output']>;
  auto_pay?: Maybe<Scalars['Boolean']['output']>;
  balance_cents?: Maybe<Scalars['Int']['output']>;
  balance_currency?: Maybe<Scalars['String']['output']>;
  billable_orientation_hours?: Maybe<Scalars['Float']['output']>;
  billing?: Maybe<Scalars['String']['output']>;
  billing_contacts?: Maybe<Array<BillingContact>>;
  billing_email?: Maybe<Scalars['String']['output']>;
  billing_id?: Maybe<Scalars['String']['output']>;
  blocked_by_list?: Maybe<Scalars['String']['output']>;
  blocks_list?: Maybe<Scalars['String']['output']>;
  business_name?: Maybe<Scalars['String']['output']>;
  business_phone_number?: Maybe<Scalars['String']['output']>;
  business_tax_id?: Maybe<Scalars['String']['output']>;
  cancellation_fee_charge_hours?: Maybe<Scalars['Int']['output']>;
  cancellation_fee_window?: Maybe<Scalars['Int']['output']>;
  cancellations?: Maybe<Array<Cancellation>>;
  charge_on_call_hourly_rate_cents?: Maybe<Scalars['Int']['output']>;
  charge_on_call_hourly_rate_currency?: Maybe<Scalars['String']['output']>;
  check_line_of_credit?: Maybe<Scalars['Boolean']['output']>;
  clinical_contacts?: Maybe<Array<ClinicalContact>>;
  company?: Maybe<Scalars['String']['output']>;
  covid_requirement?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  detailed_notes?: Maybe<Scalars['String']['output']>;
  disabled_at?: Maybe<Scalars['DateTime']['output']>;
  disabled_reason_names?: Maybe<Scalars['String']['output']>;
  disabled_reasons?: Maybe<Array<DisabledReason>>;
  drug_screening_required?: Maybe<Scalars['Boolean']['output']>;
  facility_cancellation_hours?: Maybe<Scalars['Int']['output']>;
  facility_group?: Maybe<Scalars['String']['output']>;
  favorites?: Maybe<Array<Professional>>;
  fill_rate_ratio?: Maybe<Scalars['Int']['output']>;
  fill_ratio?: Maybe<Scalars['String']['output']>;
  guaranteed_minimum_hours?: Maybe<Scalars['Int']['output']>;
  health_system?: Maybe<HealthSystem>;
  health_system_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  interview_availabilities?: Maybe<Array<InterviewAvailability>>;
  invite_last_sent_at?: Maybe<Scalars['DateTime']['output']>;
  invoice_emails?: Maybe<Scalars['Boolean']['output']>;
  invoices?: Maybe<Array<Invoice>>;
  itemized_transactions?: Maybe<Array<ItemizedTransaction>>;
  job_count?: Maybe<Scalars['Int']['output']>;
  jobs?: Maybe<Array<Job>>;
  last_time_job_posted?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  line_of_credit_cents?: Maybe<Scalars['Int']['output']>;
  location_type?: Maybe<LocationType>;
  longitude?: Maybe<Scalars['Float']['output']>;
  main_rate_setting?: Maybe<RateSetting>;
  manage_facilities?: Maybe<Array<User>>;
  manage_facilities_list?: Maybe<Scalars['String']['output']>;
  managed_by_facilities?: Maybe<Array<User>>;
  market?: Maybe<Market>;
  msp?: Maybe<Msp>;
  msp_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  net_term?: Maybe<Scalars['Int']['output']>;
  non_billable_orientation_burden_hours?: Maybe<Scalars['Float']['output']>;
  onboarding_complete?: Maybe<Scalars['Boolean']['output']>;
  overtime_hours_frequency?: Maybe<Scalars['Int']['output']>;
  overtime_hours_threshold?: Maybe<Scalars['Int']['output']>;
  parking_cost_cents?: Maybe<Scalars['Int']['output']>;
  parking_free?: Maybe<Scalars['Boolean']['output']>;
  parking_instructions?: Maybe<Scalars['String']['output']>;
  parking_reimbursed?: Maybe<Scalars['Boolean']['output']>;
  parking_reimbursement_cents?: Maybe<Scalars['Int']['output']>;
  parking_validated?: Maybe<Scalars['Boolean']['output']>;
  payment_gateway?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<Person>;
  plan?: Maybe<Scalars['String']['output']>;
  position_display_names?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Position>>;
  primary_first_name?: Maybe<Scalars['String']['output']>;
  primary_last_name?: Maybe<Scalars['String']['output']>;
  primary_phone_number?: Maybe<Scalars['String']['output']>;
  primary_phone_sms?: Maybe<Scalars['Boolean']['output']>;
  professionals?: Maybe<Array<Professional>>;
  provider?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  relationships?: Maybe<Array<Relationship>>;
  require_physical_signature?: Maybe<Scalars['Boolean']['output']>;
  revenue_adjustments?: Maybe<Array<RevenueAdjustment>>;
  rfm?: Maybe<Scalars['String']['output']>;
  rfmf?: Maybe<Scalars['Int']['output']>;
  rfmm?: Maybe<Scalars['Int']['output']>;
  rfmr?: Maybe<Scalars['Int']['output']>;
  sales_associate?: Maybe<Administrator>;
  scrubs_provided?: Maybe<Scalars['Boolean']['output']>;
  secondary_email?: Maybe<Scalars['String']['output']>;
  secondary_first_name?: Maybe<Scalars['String']['output']>;
  secondary_last_name?: Maybe<Scalars['String']['output']>;
  secondary_phone_number?: Maybe<Scalars['String']['output']>;
  secondary_phone_sms?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  source_other?: Maybe<Scalars['String']['output']>;
  ssn_last_4?: Maybe<Scalars['String']['output']>;
  statement_fee_percent?: Maybe<Scalars['Float']['output']>;
  stripe_ach_credit_transfer_id?: Maybe<Scalars['String']['output']>;
  stripe_bank_account_token?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  timezone_lookup?: Maybe<Scalars['TZ']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  unsubscribe?: Maybe<Scalars['Boolean']['output']>;
  unsubscribe_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_positions?: Maybe<UserPosition>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  vms_facility_name?: Maybe<Scalars['String']['output']>;
  vms_fee_percent?: Maybe<Scalars['Float']['output']>;
  vms_type?: Maybe<VmsType>;
  vms_type_id?: Maybe<Scalars['Int']['output']>;
  vms_user?: Maybe<VmsUser>;
};

export type UserOrderInput = {
  about?: InputMaybe<Scalars['Boolean']['input']>;
  account_manager_id?: InputMaybe<Scalars['Boolean']['input']>;
  allow_assignments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_per_diem_jobs?: InputMaybe<Scalars['Boolean']['input']>;
  auto_pay?: InputMaybe<Scalars['Boolean']['input']>;
  billing?: InputMaybe<Scalars['Boolean']['input']>;
  blocked_by_list?: InputMaybe<Scalars['Boolean']['input']>;
  blocks_list?: InputMaybe<Scalars['Boolean']['input']>;
  business_name?: InputMaybe<Scalars['Boolean']['input']>;
  business_phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  business_tax_id?: InputMaybe<Scalars['Boolean']['input']>;
  check_line_of_credit?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['Boolean']['input']>;
  covid_requirement?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  detailed_notes?: InputMaybe<Scalars['Boolean']['input']>;
  disabled_at?: InputMaybe<Scalars['Boolean']['input']>;
  disabled_reason_names?: InputMaybe<Scalars['Boolean']['input']>;
  drug_screening_required?: InputMaybe<Scalars['Boolean']['input']>;
  facility_group?: InputMaybe<Scalars['Boolean']['input']>;
  facility_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  fill_rate_ratio?: InputMaybe<Scalars['Boolean']['input']>;
  funding_source_id?: InputMaybe<Scalars['Boolean']['input']>;
  health_system_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invite_last_sent_at?: InputMaybe<Scalars['Boolean']['input']>;
  last_time_job_posted?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Boolean']['input']>;
  line_of_credit_id?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['Boolean']['input']>;
  manage_facilities_list?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Boolean']['input']>;
  msp_id?: InputMaybe<Scalars['Boolean']['input']>;
  net_term_id?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete?: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_frequency?: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_threshold?: InputMaybe<Scalars['Boolean']['input']>;
  parking_cost_cents?: InputMaybe<Scalars['Boolean']['input']>;
  parking_instructions?: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents?: InputMaybe<Scalars['Boolean']['input']>;
  person_id?: InputMaybe<Scalars['Boolean']['input']>;
  plan?: InputMaybe<Scalars['Boolean']['input']>;
  position_display_names?: InputMaybe<Scalars['Boolean']['input']>;
  primary_first_name?: InputMaybe<Scalars['Boolean']['input']>;
  primary_last_name?: InputMaybe<Scalars['Boolean']['input']>;
  primary_phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  primary_phone_sms?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['Boolean']['input']>;
  referral?: InputMaybe<Scalars['Boolean']['input']>;
  sales_associate_id?: InputMaybe<Scalars['Boolean']['input']>;
  secondary_email?: InputMaybe<Scalars['Boolean']['input']>;
  secondary_first_name?: InputMaybe<Scalars['Boolean']['input']>;
  secondary_last_name?: InputMaybe<Scalars['Boolean']['input']>;
  secondary_phone_number?: InputMaybe<Scalars['Boolean']['input']>;
  secondary_phone_sms?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['Boolean']['input']>;
  source_other?: InputMaybe<Scalars['Boolean']['input']>;
  ssn_last_4?: InputMaybe<Scalars['Boolean']['input']>;
  statement_fee_percent?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_bank_account_token?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPosition = {
  __typename?: 'UserPosition';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserPositionOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPositionQueryInput = {
  filter?: InputMaybe<UserPositionWhereInput>;
  orderBy?: InputMaybe<UserPositionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type UserPositionRateSetting = {
  __typename?: 'UserPositionRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  market_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  market_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  specialty?: Maybe<Specialty>;
  specialty_id?: Maybe<Scalars['Int']['output']>;
  state_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  state_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_position_rate_setting_active?: Maybe<Scalars['Boolean']['output']>;
  user_position_rate_setting_id?: Maybe<Scalars['Int']['output']>;
};

export type UserPositionRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<PositionOrderInput>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPositionRateSettingQueryInput = {
  filter?: InputMaybe<UserPositionRateSettingWhereInput>;
  orderBy?: InputMaybe<UserPositionRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<UserPositionRateSettingSearchInput>;
};

export type UserPositionRateSettingSearchInput = {
  below_market_rate?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPositionRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  for_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  for_job?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  specialty_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPositionWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQueryInput = {
  filter?: InputMaybe<UserWhereInput>;
  orderBy?: InputMaybe<UserOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<UserSearchInput>;
};

export type UserRateSetting = {
  __typename?: 'UserRateSetting';
  active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserRateSettingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserRateSettingQueryInput = {
  filter?: InputMaybe<UserRateSettingWhereInput>;
  orderBy?: InputMaybe<UserRateSettingOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<UserRateSettingSearchInput>;
};

export type UserRateSettingSearchInput = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserRateSettingWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  include_parents?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSearchInput = {
  account_manager_id?: InputMaybe<Scalars['Int']['input']>;
  facility_type_id?: InputMaybe<Scalars['Int']['input']>;
  fill_ratio?: InputMaybe<Scalars['Int']['input']>;
  has_user_balance?: InputMaybe<Scalars['Boolean']['input']>;
  health_sytem_id?: InputMaybe<Scalars['String']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  market_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msp_id?: InputMaybe<Scalars['String']['input']>;
  no_vms_user?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_complete?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Maximal length: `150`
   *
   */
  q?: InputMaybe<Scalars['String']['input']>;
  sales_associate_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id?: InputMaybe<Scalars['String']['input']>;
};

export type UserWhereInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  account_manager_id?: InputMaybe<Scalars['Int']['input']>;
  allow_assignments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_per_diem_jobs?: InputMaybe<Scalars['Boolean']['input']>;
  auto_pay?: InputMaybe<Scalars['Boolean']['input']>;
  billing?: InputMaybe<Scalars['String']['input']>;
  blocked_by_list?: InputMaybe<Scalars['String']['input']>;
  blocks_list?: InputMaybe<Scalars['String']['input']>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  business_phone_number?: InputMaybe<Scalars['String']['input']>;
  business_tax_id?: InputMaybe<Scalars['String']['input']>;
  check_line_of_credit?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  covid_requirement?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  detailed_notes?: InputMaybe<Scalars['String']['input']>;
  disabled_at?: InputMaybe<Scalars['DateTime']['input']>;
  disabled_reason_names?: InputMaybe<Scalars['String']['input']>;
  drug_screening_required?: InputMaybe<Scalars['Boolean']['input']>;
  facility_group?: InputMaybe<Scalars['String']['input']>;
  facility_type_id?: InputMaybe<Scalars['Int']['input']>;
  fill_rate_ratio?: InputMaybe<Scalars['Int']['input']>;
  funding_source_id?: InputMaybe<Scalars['Int']['input']>;
  health_system_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invite_last_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  last_time_job_posted?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line_of_credit_id?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  manage_facilities_list?: InputMaybe<Scalars['String']['input']>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  msp_id?: InputMaybe<Scalars['Int']['input']>;
  net_term_id?: InputMaybe<Scalars['Int']['input']>;
  onboarding_complete?: InputMaybe<Scalars['Boolean']['input']>;
  overtime_hours_frequency?: InputMaybe<Scalars['String']['input']>;
  overtime_hours_threshold?: InputMaybe<Scalars['Int']['input']>;
  parking_cost_cents?: InputMaybe<Scalars['Int']['input']>;
  parking_free?: InputMaybe<Scalars['Boolean']['input']>;
  parking_instructions?: InputMaybe<Scalars['String']['input']>;
  parking_reimbursed?: InputMaybe<Scalars['Boolean']['input']>;
  parking_reimbursement_cents?: InputMaybe<Scalars['Int']['input']>;
  parking_validated?: InputMaybe<Scalars['Boolean']['input']>;
  person_id?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['Int']['input']>;
  position_display_names?: InputMaybe<Scalars['String']['input']>;
  primary_first_name?: InputMaybe<Scalars['String']['input']>;
  primary_last_name?: InputMaybe<Scalars['String']['input']>;
  primary_phone_number?: InputMaybe<Scalars['String']['input']>;
  primary_phone_sms?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  sales_associate_id?: InputMaybe<Scalars['Int']['input']>;
  secondary_email?: InputMaybe<Scalars['String']['input']>;
  secondary_first_name?: InputMaybe<Scalars['String']['input']>;
  secondary_last_name?: InputMaybe<Scalars['String']['input']>;
  secondary_phone_number?: InputMaybe<Scalars['String']['input']>;
  secondary_phone_sms?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_other?: InputMaybe<Scalars['String']['input']>;
  ssn_last_4?: InputMaybe<Scalars['String']['input']>;
  statement_fee_percent?: InputMaybe<Scalars['Float']['input']>;
  stripe_bank_account_token?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  timezone_lookup?: InputMaybe<Scalars['TZ']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  unsubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
  vms_user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidateJobTimesInput = {
  is_w2?: InputMaybe<Scalars['Int']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  job_times: Array<InputMaybe<Job_Time_Ranges>>;
  professional_id: Scalars['Int']['input'];
};

export type VmsAssignment = {
  __typename?: 'VmsAssignment';
  assignments?: Maybe<Array<Assignment>>;
  bullhorn_client_id?: Maybe<Scalars['String']['output']>;
  bullhorn_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  current_data?: Maybe<Scalars['JSON']['output']>;
  current_hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  manual_data: Scalars['JSON']['output'];
  new_data?: Maybe<Scalars['JSON']['output']>;
  new_hash?: Maybe<Scalars['String']['output']>;
  reason_assignment_not_created?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['DateTime']['output'];
  valid_data?: Maybe<Scalars['JSON']['output']>;
  vms_external_id?: Maybe<Scalars['String']['output']>;
  vms_user?: Maybe<VmsUser>;
};

export type VmsAssignmentOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  current_data?: InputMaybe<CurrentDataOrderInput>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  reason_assignment_not_created?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  vms_external_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VmsAssignmentQueryInput = {
  filter?: InputMaybe<VmsAssignmentWhereInput>;
  orderBy?: InputMaybe<VmsAssignmentOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<VmsAssignmentSearchInput>;
};

export type VmsAssignmentSearchInput = {
  assignments?: InputMaybe<Scalars['String']['input']>;
  bullhorn_client_id?: InputMaybe<Scalars['String']['input']>;
  bullhorn_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  updated?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  vms_external_id?: InputMaybe<Scalars['String']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type VmsAssignmentWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  reason_assignment_not_created?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  vms_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type VmsPosition = {
  __typename?: 'VmsPosition';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vms_category_id?: Maybe<Scalars['String']['output']>;
  vms_source_id?: Maybe<Scalars['String']['output']>;
  vms_type?: Maybe<VmsType>;
  vms_type_id?: Maybe<Scalars['Int']['output']>;
};

export type VmsPositionOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  vms_category_id?: InputMaybe<Scalars['Boolean']['input']>;
  vms_source_id?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VmsPositionQueryInput = {
  filter?: InputMaybe<VmsPositionWhereInput>;
  orderBy?: InputMaybe<VmsPositionOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type VmsPositionWhereInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  vms_category_id?: InputMaybe<Scalars['String']['input']>;
  vms_source_id?: InputMaybe<Scalars['String']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type VmsType = {
  __typename?: 'VmsType';
  billable_orientation_hours?: Maybe<Scalars['Float']['output']>;
  bullhorn_id?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<Company>>;
  created_at: Scalars['DateTime']['output'];
  fee_percent: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  non_billable_orientation_burden_hours?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users?: Maybe<Array<User>>;
  vms_assgignments?: Maybe<Array<VmsAssignment>>;
  vms_positions?: Maybe<Array<VmsPosition>>;
};

export type VmsTypeOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VmsTypeQueryInput = {
  filter?: InputMaybe<VmsTypeWhereInput>;
  orderBy?: InputMaybe<VmsTypeOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<DefaultSearchInput>;
};

export type VmsTypeWhereInput = {
  bullhorn_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VmsUser = {
  __typename?: 'VmsUser';
  bullhorn_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  current_data?: Maybe<Scalars['JSON']['output']>;
  current_hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locations?: Maybe<Array<Location>>;
  manual_data?: Maybe<Scalars['JSON']['output']>;
  new_data?: Maybe<Scalars['JSON']['output']>;
  new_hash?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['DateTime']['output'];
  users?: Maybe<Array<User>>;
  valid_data?: Maybe<Scalars['JSON']['output']>;
  vms_external_id?: Maybe<Scalars['String']['output']>;
  vms_type?: Maybe<VmsType>;
  vms_type_id?: Maybe<Scalars['Int']['output']>;
};

export type VmsUserOrderInput = {
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  vms_external_id?: InputMaybe<Scalars['Boolean']['input']>;
  vms_type_id?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VmsUserQueryInput = {
  filter?: InputMaybe<VmsUserWhereInput>;
  orderBy?: InputMaybe<VmsUserOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<VmsUserSearchInput>;
};

export type VmsUserSearchInput = {
  bullhorn_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  updated?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  vms_external_id?: InputMaybe<Scalars['String']['input']>;
  vms_position?: InputMaybe<Scalars['String']['input']>;
  vms_status?: InputMaybe<Scalars['String']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type VmsUserWhereInput = {
  bullhorn_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  vms_external_id?: InputMaybe<Scalars['String']['input']>;
  vms_type_id?: InputMaybe<Scalars['Int']['input']>;
};

export type W2LocalSettings = {
  __typename?: 'W2LocalSettings';
  base_margin_percent_w2?: Maybe<Scalars['Float']['output']>;
  blended_rates?: Maybe<BlendedOrNonBlendedRateSettings>;
  charge_max_weekly_regular_hours?: Maybe<Scalars['Int']['output']>;
  charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  charge_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  non_blended_rates?: Maybe<BlendedOrNonBlendedRateSettings>;
  payout_max_weekly_regular_hours?: Maybe<Scalars['Int']['output']>;
  payout_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  total_margin_percent_w2?: Maybe<Scalars['Float']['output']>;
  use_blended_rate?: Maybe<Scalars['Boolean']['output']>;
};

export type W2Settings = {
  __typename?: 'W2Settings';
  adp_fee_burden_cents?: Maybe<Scalars['Int']['output']>;
  billable_orientation_hours?: Maybe<Scalars['Int']['output']>;
  compliance_burden_cents?: Maybe<Scalars['Int']['output']>;
  federal_unemployment_max_burden_cents?: Maybe<Scalars['Int']['output']>;
  federal_unemployment_percent_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  local?: Maybe<W2LocalSettings>;
  medical_burden_cents?: Maybe<Scalars['Int']['output']>;
  medicare_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  non_billable_orientation_burden_hours?: Maybe<Scalars['Int']['output']>;
  operational_burden_percent?: Maybe<Scalars['Float']['output']>;
  social_security_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  state_unemployment_max_burden_cents?: Maybe<Scalars['Int']['output']>;
  state_unemployment_percent_burden_multiplier?: Maybe<Scalars['Float']['output']>;
  travel?: Maybe<W2TravelSettings>;
};

export type W2TravelSettings = {
  __typename?: 'W2TravelSettings';
  assignment_bonus_tier1_travel_amount_cents?: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier1_travel_amount_tcv_cents?: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_cents?: Maybe<Scalars['Int']['output']>;
  assignment_bonus_tier2_travel_amount_tcv_cents?: Maybe<Scalars['Int']['output']>;
  blended_rates?: Maybe<BlendedOrNonBlendedRateSettings>;
  charge_max_weekly_regular_hours?: Maybe<Scalars['Int']['output']>;
  charge_rate_cents?: Maybe<Scalars['Int']['output']>;
  charge_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  margin_percent_w2_tcv?: Maybe<Scalars['Float']['output']>;
  margin_percent_w2_travel?: Maybe<Scalars['Float']['output']>;
  margin_w2_tcv_cents?: Maybe<Scalars['Int']['output']>;
  non_blended_rates?: Maybe<BlendedOrNonBlendedRateSettings>;
  payout_max_weekly_regular_hours?: Maybe<Scalars['Int']['output']>;
  payout_seventh_day_rule_enabled?: Maybe<Scalars['Boolean']['output']>;
  use_blended_rate?: Maybe<Scalars['Boolean']['output']>;
};

export type WageLog = {
  __typename?: 'WageLog';
  administrator_id?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  facility_type_id?: Maybe<Scalars['Int']['output']>;
  hourly_rate_cents: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  job_type?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Market>;
  market_id?: Maybe<Scalars['Int']['output']>;
  not_wanted_rate_cents?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  professional: Professional;
  professional_id: Scalars['Int']['output'];
  requested_rate_cents?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  work_history?: Maybe<WorkHistory>;
  work_history_id?: Maybe<Scalars['Int']['output']>;
  zip_code: Scalars['String']['output'];
};

export type WageLogOrderInput = {
  city?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  hourly_rate_cents?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  market_id?: InputMaybe<Scalars['Boolean']['input']>;
  position_id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_id?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  work_history_id?: InputMaybe<Scalars['Boolean']['input']>;
  zip_code?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WageLogQueryInput = {
  filter?: InputMaybe<WageLogWhereInput>;
  orderBy?: InputMaybe<WageLogOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<WageLogSearchInput>;
};

export type WageLogSearchInput = {
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
};

export type WageLogWhereInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  hourly_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  market_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  work_history_id?: InputMaybe<Scalars['Int']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type WeeklyTimecardsTotals = {
  __typename?: 'WeeklyTimecardsTotals';
  breaks_hours?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  start_of_week?: Maybe<Scalars['DateTime']['output']>;
};

export type WeeklyTimecardsTotalsFilter = {
  ignored_job_id?: InputMaybe<Scalars['Int']['input']>;
};

export type WeeklyTimecardsTotalsInput = {
  filter?: InputMaybe<WeeklyTimecardsTotalsFilter>;
  search?: InputMaybe<WeeklyTimecardsTotalsSearch>;
};

export type WeeklyTimecardsTotalsSearch = {
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  starts_time_from?: InputMaybe<Scalars['DateTime']['input']>;
  starts_time_to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkGap = {
  __typename?: 'WorkGap';
  created_at: Scalars['DateTime']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  include_in_work_histories: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  professional_profile?: Maybe<ProfessionalProfile>;
  professional_profile_id?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type WorkGapOrderInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkGapQueryInput = {
  filter?: InputMaybe<WorkGapWhereInput>;
  orderBy?: InputMaybe<WorkGapOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<WorkGapSearchInput>;
};

export type WorkGapSearchInput = {
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkGapWhereInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkHistory = {
  __typename?: 'WorkHistory';
  bedside_care?: Maybe<Scalars['Boolean']['output']>;
  clinical: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  currently_work_here: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  employment_type?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  floating?: Maybe<Scalars['Boolean']['output']>;
  floating_details?: Maybe<Scalars['String']['output']>;
  has_missing_information: Scalars['Boolean']['output'];
  hours_per_week?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  location_is_teaching?: Maybe<Scalars['Boolean']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  location_number_of_beds?: Maybe<Scalars['Int']['output']>;
  location_trauma_level?: Maybe<Scalars['String']['output']>;
  location_type?: Maybe<LocationType>;
  location_type_id?: Maybe<Scalars['Int']['output']>;
  missing_information_list: Array<Scalars['String']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Position>;
  position_id?: Maybe<Scalars['Int']['output']>;
  position_title?: Maybe<Scalars['String']['output']>;
  professional_id?: Maybe<Scalars['Int']['output']>;
  professional_profile?: Maybe<ProfessionalProfile>;
  start_date?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']['output']>;
  travel: Scalars['Boolean']['output'];
  travel_agency?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  wage_logs: Array<WageLog>;
};

export type WorkHistoryOrderInput = {
  bedside_care?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  currently_work_here?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['Boolean']['input']>;
  facility_type_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['Boolean']['input']>;
  organization_name?: InputMaybe<Scalars['Boolean']['input']>;
  position_title?: InputMaybe<Scalars['Boolean']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Boolean']['input']>;
  travel?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkHistoryQueryInput = {
  filter?: InputMaybe<WorkHistoryWhereInput>;
  orderBy?: InputMaybe<WorkHistoryOrderInput>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * *Constraints:*
   * * Minimal value: `1`
   *
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<WorkHistorySearchInput>;
};

export type WorkHistorySearchInput = {
  location_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkHistoryWhereInput = {
  bedside_care?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  currently_work_here?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  facility_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  organization_name?: InputMaybe<Scalars['String']['input']>;
  position_title?: InputMaybe<Scalars['String']['input']>;
  professional_id?: InputMaybe<Scalars['Int']['input']>;
  professional_profile_id?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  travel?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Expiring_Conditions_Input = {
  professional_id: Scalars['Int']['input'];
};

export type Job_Time_Ranges = {
  ends_time: Scalars['DateTime']['input'];
  starts_time: Scalars['DateTime']['input'];
};

export type Missing_Conditions_Input = {
  assignment_id?: InputMaybe<Scalars['Int']['input']>;
  for_application: Scalars['Boolean']['input'];
  for_on_boarding: Scalars['Boolean']['input'];
  for_premier_only?: InputMaybe<Scalars['Boolean']['input']>;
  is_w2?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_account_id?: InputMaybe<Scalars['Int']['input']>;
  professional_id: Scalars['Int']['input'];
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Required_Conditions_Input = {
  for_application: Scalars['Boolean']['input'];
  for_on_boarding: Scalars['Boolean']['input'];
  is_w2?: Scalars['Boolean']['input'];
  location_id?: InputMaybe<Scalars['Int']['input']>;
  position_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  professional_id: Scalars['Int']['input'];
  specialty_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type GetFavoritedAssignmentsForFavoriteButtonQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalAssignmentFavoriteQueryInput>;
}>;


export type GetFavoritedAssignmentsForFavoriteButtonQuery = { __typename?: 'Query', professionalAssignmentFavorites?: Array<{ __typename?: 'ProfessionalAssignmentFavorite', id: number, assignment_id: number, assignment: { __typename?: 'Assignment', id: number, is_w2?: boolean | null, is_travel?: boolean | null, starts_date?: any | null, ends_date?: any | null, status: string, call_requirements?: string | null, hours_per_shift?: number | null, number_of_shifts_per_week?: number | null, starts_time?: any | null, ends_time?: any | null, one_time_bonus_burden_cents?: number | null, first_to_apply?: boolean | null, distance_in_miles?: number | null, less_than_300_miles_away?: boolean | null, great_pay?: boolean | null, missing_condition_ids?: Array<number | null> | null, pay_per_week_cents: number, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, primary_location?: { __typename?: 'Location', id: number, name?: string | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, address_zip?: string | null, timezone_lookup?: string | null, state?: { __typename?: 'State', abbreviation?: string | null } | null } | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null } }> | null };

export type GetFavoritedAssignmentsIrpForFavoriteButtonQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalAssignmentFavoriteQueryInput>;
}>;


export type GetFavoritedAssignmentsIrpForFavoriteButtonQuery = { __typename?: 'Query', professionalAssignmentFavorites?: Array<{ __typename?: 'ProfessionalAssignmentFavorite', id: number, assignment_id: number, assignment: { __typename?: 'Assignment', id: number, is_w2?: boolean | null, is_travel?: boolean | null, starts_date?: any | null, ends_date?: any | null, status: string, call_requirements?: string | null, hours_per_shift?: number | null, number_of_shifts_per_week?: number | null, starts_time?: any | null, ends_time?: any | null, missing_condition_ids?: Array<number | null> | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, primary_location?: { __typename?: 'Location', id: number, name?: string | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, address_zip?: string | null, timezone_lookup?: string | null, state?: { __typename?: 'State', abbreviation?: string | null } | null } | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null } }> | null };

export type GetAgencyForNameQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetAgencyForNameQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', name?: string | null } | null };

export type GetAssignmentRequestsForAdditionalDetailsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type GetAssignmentRequestsForAdditionalDetailsQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number, status?: string | null }> | null };

export type GetMissingAssignmentCheckListInformationForAssignmentDetailsHeaderQueryVariables = Exact<{
  has_missing_information?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type GetMissingAssignmentCheckListInformationForAssignmentDetailsHeaderQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', assignment_id?: number | null, has_missing_information?: boolean | null }> | null };

export type GetAssignmentRequestsForAssignmentGeneralInfoQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type GetAssignmentRequestsForAssignmentGeneralInfoQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number, status?: string | null }> | null };

export type AssignmentForAssignmentExtensionDialogFragment = { __typename?: 'Assignment', id: number, ends_date?: any | null, professional?: { __typename?: 'Professional', account: { __typename?: 'Account', first_name?: string | null } } | null, locations?: Array<{ __typename?: 'Location', name?: string | null, id: number }> | null } & { ' $fragmentName'?: 'AssignmentForAssignmentExtensionDialogFragment' };

export type AssignmentForAssignmentDetailsFragment = { __typename?: 'Assignment', id: number, status: string, can_apply?: boolean | null, one_time_bonus_burden_cents?: number | null, vms_partnership?: boolean | null, paused: boolean, missing_condition_ids?: Array<number | null> | null, is_w2?: boolean | null, is_travel?: boolean | null, starts_date?: any | null, ends_date?: any | null, starts_time?: any | null, ends_time?: any | null, number_of_shifts_per_week?: number | null, variable_shift_times?: boolean | null, patient_population?: string | null, posting_field_contents?: any | null, jobs_detail?: string | null, flexible_starts_date: boolean, taxable_amount_cents?: number | null, nontaxable_amount_cents?: number | null, lodging_per_diem_cents?: number | null, mie_per_diem_cents?: number | null, hours_per_shift?: number | null, payout_taxable_hourly_rate_cents?: number | null, payout_overtime_multiplier?: number | null, payout_on_call_hourly_rate_cents?: number | null, track_unpaid_breaks: boolean, estimated_unpaid_break_time_minutes?: number | null, enforce_guaranteed_minimum_hours?: boolean | null, scrubs_provided: boolean, min_years_of_experience?: number | null, call_requirements?: string | null, contract_total_hours?: string | null, guaranteed_hours_string?: string | null, facility_number?: string | null, cancellation_policy?: string | null, needs_item_url: boolean, pay_per_week_cents: number, professional?: { __typename?: 'Professional', has_item_url?: boolean | null } | null, positions?: Array<{ __typename?: 'Position', id: number, kind?: string | null, display_name?: string | null, name?: string | null }> | null, locations?: Array<{ __typename?: 'Location', id: number, name?: string | null, timezone_lookup?: string | null }> | null, clinical_contact?: { __typename?: 'Account', first_name?: string | null, last_name?: string | null } | null, ehr_system?: { __typename?: 'EhrSystem', id: number, label?: string | null } | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null, surgery_types?: Array<{ __typename?: 'SurgeryType', id: number, display_name?: string | null }> | null, primary_location?: { __typename?: 'Location', id: number, covid_requirement?: string | null, name?: string | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, address_zip?: string | null, parking_instructions?: string | null, parking_free: boolean, parking_reimbursed: boolean, parking_reimbursement_cents: number, parking_validated: boolean, parking_cost_cents: number, timezone_lookup?: string | null, market_id?: number | null, drug_screening_required?: boolean | null, ehr_details?: string | null, medication_management_details?: string | null, supplies_ppe_details?: string | null, scrub_colors?: Array<ScrubColors | null> | null, meal_break_details?: string | null, additional_check_in_instructions?: string | null, state?: { __typename?: 'State', abbreviation?: string | null, covid_requirement?: string | null } | null, location_type: { __typename?: 'LocationType', label?: string | null }, market?: { __typename?: 'Market', display_name?: string | null } | null } | null, assignment_profile_for_account_id?: { __typename?: 'AssignmentProfile', payout_double_overtime_multiplier?: number | null, payout_kind: string, payout_max_daily_ot_hours?: number | null, payout_max_daily_regular_hours?: number | null, payout_max_weekly_regular_hours?: number | null, payout_overtime_multiplier: number } | null } & { ' $fragmentName'?: 'AssignmentForAssignmentDetailsFragment' };

export type GetAssignmentForAssignmentDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetAssignmentForAssignmentDetailsQuery = { __typename?: 'Query', assignment?: (
    { __typename?: 'Assignment', id: number, status: string, can_apply?: boolean | null, is_w2?: boolean | null, one_time_bonus_burden_cents?: number | null, is_extension?: boolean | null, pay_per_week_cents: number, professional?: { __typename?: 'Professional', account: { __typename?: 'Account', first_name?: string | null, last_name?: string | null } } | null }
    & { ' $fragmentRefs'?: { 'AssignmentForAssignmentExtensionDialogFragment': AssignmentForAssignmentExtensionDialogFragment;'AssignmentForAssignmentDetailsFragment': AssignmentForAssignmentDetailsFragment } }
  ) | null };

export type GetAvailableAssignmentForAssignmentDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetAvailableAssignmentForAssignmentDetailsQuery = { __typename?: 'Query', availableAssignment?: (
    { __typename?: 'Assignment', id: number, is_extension?: boolean | null, status: string, can_apply?: boolean | null, one_time_bonus_burden_cents?: number | null, pay_per_week_cents: number }
    & { ' $fragmentRefs'?: { 'AssignmentForAssignmentDetailsFragment': AssignmentForAssignmentDetailsFragment } }
  ) | null };

export type GetStatesForEducationFormQueryVariables = Exact<{
  input?: InputMaybe<StateQueryInput>;
}>;


export type GetStatesForEducationFormQuery = { __typename?: 'Query', states?: Array<{ __typename?: 'State', id: number, name?: string | null }> | null };

export type GetCurrentUserForEducationFormQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserForEducationFormQuery = { __typename?: 'Query', me?: { __typename?: 'Account', professional?: { __typename?: 'Professional', id: number } | null } | null };

export type GetAssignmentRequestsForEducationFormQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type GetAssignmentRequestsForEducationFormQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number }> | null };

export type GetEhRsForEhrFormQueryVariables = Exact<{
  input?: InputMaybe<EhrSystemQueryInput>;
}>;


export type GetEhRsForEhrFormQuery = { __typename?: 'Query', ehrSystems?: Array<{ __typename?: 'EhrSystem', id: number, label?: string | null }> | null };

export type GetAssignmentRequestsForEhrFormQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type GetAssignmentRequestsForEhrFormQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number }> | null };

export type GetPermanentRequestsForPermanentPlacementActionQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type GetPermanentRequestsForPermanentPlacementActionQuery = { __typename?: 'Query', permanentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number, status?: string | null }> | null };

export type PermanentPlacementForGeneralInfoFragment = { __typename?: 'Assignment', id: number, ends_time?: any | null, permanent_max_hourly_rate_cents?: number | null, permanent_min_hourly_rate_cents?: number | null, payout_base_hourly_rate_cents?: number | null, schedule_type: string, starts_date?: any | null, starts_time?: any | null, distance_in_miles?: number | null, number_of_shifts_per_week?: number | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, primary_location?: { __typename?: 'Location', id: number, full_address?: string | null, name?: string | null, timezone_lookup?: string | null, unit?: string | null, location_type: { __typename?: 'LocationType', label?: string | null } } | null, assignment_requests?: Array<{ __typename?: 'AssignmentRequest', status?: string | null }> | null } & { ' $fragmentName'?: 'PermanentPlacementForGeneralInfoFragment' };

export type PermanentPlacementForCompensationFragment = { __typename?: 'Assignment', starts_time?: any | null, ends_time?: any | null, number_of_shifts_per_week?: number | null, permanent_max_hourly_rate_cents?: number | null, permanent_min_hourly_rate_cents?: number | null, permanent_signing_bonus_cents?: number | null, payout_base_hourly_rate_cents?: number | null, primary_location?: { __typename?: 'Location', timezone_lookup?: string | null } | null, assignment_requests?: Array<{ __typename?: 'AssignmentRequest', status?: string | null }> | null } & { ' $fragmentName'?: 'PermanentPlacementForCompensationFragment' };

export type PermanentPlacementForOnsiteLogisticsFragment = { __typename?: 'Assignment', status: string, scrubs_provided: boolean, track_unpaid_breaks: boolean, estimated_unpaid_break_time_minutes?: number | null, primary_location?: { __typename?: 'Location', id: number, name?: string | null, full_address?: string | null, parking_instructions?: string | null, parking_free: boolean, parking_reimbursed: boolean, parking_reimbursement_cents: number, parking_validated: boolean, parking_cost_cents: number, additional_check_in_instructions?: string | null, meal_break_details?: string | null, scrub_colors?: Array<ScrubColors | null> | null } | null } & { ' $fragmentName'?: 'PermanentPlacementForOnsiteLogisticsFragment' };

export type GetAvailablePermanentPlacementForPermanentPlacementDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetAvailablePermanentPlacementForPermanentPlacementDetailsQuery = { __typename?: 'Query', availablePlacement?: (
    { __typename?: 'Assignment', id: number, status: string, permanent_qualifications: any, permanent_summary: any, permanent_benefits: any }
    & { ' $fragmentRefs'?: { 'PermanentPlacementForGeneralInfoFragment': PermanentPlacementForGeneralInfoFragment;'PermanentPlacementForCompensationFragment': PermanentPlacementForCompensationFragment;'PermanentPlacementForOnsiteLogisticsFragment': PermanentPlacementForOnsiteLogisticsFragment } }
  ) | null };

export type GetAvailablePermanentPlacementsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentQueryInput>;
}>;


export type GetAvailablePermanentPlacementsQuery = { __typename?: 'Query', availablePlacements?: Array<(
    { __typename?: 'Assignment', id: number }
    & { ' $fragmentRefs'?: { 'PermanentPositionItemOfAvailableAssignmentsFragment': PermanentPositionItemOfAvailableAssignmentsFragment } }
  )> | null, _availablePlacementsMeta?: { __typename?: 'AvailableAssignmentsMeta', count?: number | null } | null };

export type PermanentPositionItemOfAvailableAssignmentsFragment = { __typename?: 'Assignment', starts_date?: any | null, starts_time?: any | null, ends_time?: any | null, hours_per_shift?: number | null, schedule_type: string, number_of_shifts_per_week?: number | null, permanent_min_hourly_rate_cents?: number | null, permanent_max_hourly_rate_cents?: number | null, permanent_signing_bonus_cents?: number | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, specialties?: Array<{ __typename?: 'Specialty', label?: string | null }> | null, primary_location?: { __typename?: 'Location', name?: string | null, full_address?: string | null, timezone_lookup?: string | null, address_city?: string | null, address_zip?: string | null, unit?: string | null, location_type: { __typename?: 'LocationType', label?: string | null } } | null } & { ' $fragmentName'?: 'PermanentPositionItemOfAvailableAssignmentsFragment' };

export type JobIrregularitiesQueryVariables = Exact<{
  input?: InputMaybe<JobIrregularityQueryInput>;
}>;


export type JobIrregularitiesQuery = { __typename?: 'Query', jobIrregularities?: Array<{ __typename?: 'JobIrregularity', id: number, label: string }> | null };

export type JobDetailsFragment = { __typename?: 'Job', id: number, pool_id?: number | null, track_unpaid_breaks: boolean, estimated_unpaid_break_time_minutes?: number | null, cancellation_fee_window?: number | null, cancellation_fee_charge_hours?: number | null, starts_date?: any | null, ends_time?: any | null, detail?: string | null, scrubs_provided: boolean, shift_type: string, posting_field_contents?: any | null, requires_sca_onboarding_condition?: boolean | null, total_payout_bonus_cents?: number | null, status?: JobStatus | null, new_to_facility: boolean, requested_by_facility?: boolean | null, can_book_job?: boolean | null, pro_confirmed_at?: any | null, patient_population?: string | null, current_starts_time?: any | null, current_ends_time?: any | null, starts_time?: any | null, guaranteed_minimum_hours?: number | null, booked_at?: any | null, approved_clock_in?: any | null, approved_clock_out?: any | null, updated_in_cancellation_window?: boolean | null, location_id?: number | null, assignment_id?: number | null, is_w2?: boolean | null, facility_number?: string | null, surgery_types?: Array<{ __typename?: 'SurgeryType', display_name?: string | null, id: number }> | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', amount_cents: number, id: number, taxable_type?: string | null, payout?: { __typename?: 'Payout', amount_cents: number, id: number, status?: string | null, processed_on?: any | null, w2_submit_by_time?: any | null } | null }>, job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null, total_hours?: number | null, total_breaks_minutes?: number | null, payout_callback_amount_cents?: number | null, payout_callback_hours?: number | null, payout_regular_amount_cents?: number | null, payout_regular_hours?: number | null, payout_overtime_amount_cents?: number | null, payout_overtime_hours?: number | null, payout_daily_overtime_amount_cents?: number | null, payout_daily_overtime_hours?: number | null, payout_weekly_overtime_amount_cents?: number | null, payout_weekly_overtime_hours?: number | null, payout_double_amount_cents?: number | null, payout_double_hours?: number | null, total_on_call_hours?: number | null } | null, assignment?: { __typename?: 'Assignment', id: number, is_w2?: boolean | null, track_unpaid_breaks: boolean } | null, clinical_contact?: { __typename?: 'Account', first_name?: string | null, last_name?: string | null } | null, job_profile_for_account_id?: { __typename?: 'JobProfile', active: boolean, payout_facility_bonus_cents: number, payout_kind: string, payout_max_daily_ot_hours?: number | null, payout_max_daily_regular_hours?: number | null, payout_max_weekly_regular_hours?: number | null, payout_base_hourly_rate_cents: number, payout_double_overtime_multiplier?: number | null, payout_on_call_hourly_rate_cents: number, payout_overtime_multiplier: number, payout_taxable_hourly_rate_cents: number } | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null, positions?: Array<{ __typename?: 'Position', name?: string | null, high_risk: boolean, display_name?: string | null }> | null, location?: { __typename?: 'Location', start_clock_in_early_window: number, ehr_details?: string | null, state_id?: number | null, approval_free_late_clock_out_grace_period_minutes: number, maximum_late_clock_out_grace_period_minutes: number, require_facility_timecard_system_photo_on_clock_out: boolean, ignore_signature_when_creating_meal_break: boolean, professional_can_adjust_times: boolean, medication_management_details?: string | null, scrub_colors?: Array<ScrubColors | null> | null, meal_break_details?: string | null, additional_check_in_instructions?: string | null, supplies_ppe_details?: string | null, require_upload_on_clock_out: boolean, parking_instructions?: string | null, parking_cost_cents: number, parking_reimbursed: boolean, parking_reimbursement_cents: number, parking_free: boolean, parking_validated: boolean, company_id?: number | null, address_city?: string | null, address_zip?: string | null, full_address?: string | null, covid_requirement?: string | null, clock_in_early_window: number, enable_geo_fence: boolean, timezone_lookup?: string | null, name?: string | null, market?: { __typename?: 'Market', display_name?: string | null } | null, ehr_system?: { __typename?: 'EhrSystem', label?: string | null } | null, location_type: { __typename?: 'LocationType', label?: string | null }, state?: { __typename?: 'State', abbreviation?: string | null, covid_requirement?: string | null } | null, coordinates?: { __typename?: 'Coordinates', latitude?: number | null, longitude?: number | null } | null } | null, disputes?: Array<{ __typename?: 'Dispute', id: number, status: string }> | null, job_billings: Array<{ __typename?: 'JobBilling', id: number, category?: string | null, payout_total_amount_cents: number, payout?: { __typename?: 'Payout', amount_cents: number, id: number, status?: string | null, processed_on?: any | null, w2_submit_by_time?: any | null } | null, disputed_job_billings: Array<{ __typename?: 'DisputedJobBilling', id: number }> }>, payout?: { __typename?: 'Payout', amount_cents: number, id: number, status?: string | null, processed_on?: any | null, w2_submit_by_time?: any | null } | null } & { ' $fragmentName'?: 'JobDetailsFragment' };

export type GetAvailableJobForAvailableJobDetailsContainerQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  professional_id: Scalars['Int']['input'];
}>;


export type GetAvailableJobForAvailableJobDetailsContainerQuery = { __typename?: 'Query', availableJob?: (
    { __typename?: 'Job', id: number, status?: JobStatus | null }
    & { ' $fragmentRefs'?: { 'JobDetailsFragment': JobDetailsFragment } }
  ) | null };

export type GetJobForJobDetailsContainerQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  professional_id: Scalars['Int']['input'];
}>;


export type GetJobForJobDetailsContainerQuery = { __typename?: 'Query', job?: (
    { __typename?: 'Job', id: number, status?: JobStatus | null, professional_id?: number | null }
    & { ' $fragmentRefs'?: { 'JobDetailsFragment': JobDetailsFragment } }
  ) | null };

export type GetCancellationReasonsForCancelationPolicyQueryVariables = Exact<{
  input?: InputMaybe<CancellationReasonQueryInput>;
}>;


export type GetCancellationReasonsForCancelationPolicyQuery = { __typename?: 'Query', cancellationReasons?: Array<{ __typename?: 'CancellationReason', id: number, label?: string | null }> | null };

export type GetProfileStatsForCancelationPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileStatsForCancelationPolicyQuery = { __typename?: 'Query', profileStats?: { __typename?: 'ProfileStats', no_shows_count?: number | null, late_cancellations_count?: number | null } | null };

export type OrientationJobsListItemJobFragment = { __typename?: 'Job', approved_clock_in?: any | null, approved_clock_out?: any | null, current_ends_time?: any | null, current_starts_time?: any | null, guaranteed_minimum_hours?: number | null, id: number, starts_date?: any | null, status?: JobStatus | null, job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null } | null, location?: { __typename?: 'Location', address_city?: string | null, address_zip?: string | null, name?: string | null, timezone_lookup?: string | null } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, specialties?: Array<{ __typename?: 'Specialty', label?: string | null }> | null } & { ' $fragmentName'?: 'OrientationJobsListItemJobFragment' };

export type GetOrientationJobsQueryVariables = Exact<{
  input?: InputMaybe<JobQueryInput>;
}>;


export type GetOrientationJobsQuery = { __typename?: 'Query', availableJobs?: Array<(
    { __typename?: 'Job', id: number, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null }
    & { ' $fragmentRefs'?: { 'OrientationJobsListItemJobFragment': OrientationJobsListItemJobFragment } }
  )> | null };

export type GetEhrsForResumeBuilderQueryVariables = Exact<{
  input?: InputMaybe<EhrSystemQueryInput>;
}>;


export type GetEhrsForResumeBuilderQuery = { __typename?: 'Query', ehrSystems?: Array<{ __typename?: 'EhrSystem', id: number, label?: string | null }> | null };

export type GetEducationsForResumeBuilderQueryVariables = Exact<{
  input?: InputMaybe<EducationQueryInput>;
}>;


export type GetEducationsForResumeBuilderQuery = { __typename?: 'Query', educations?: Array<(
    { __typename?: 'Education', city?: string | null, degree_type?: string | null, end_date?: any | null, field_of_study?: string | null, id: number, school_name?: string | null, start_date?: any | null, state_id?: number | null }
    & { ' $fragmentRefs'?: { 'EducationItemFragment': EducationItemFragment } }
  )> | null };

export type EducationItemFragment = { __typename?: 'Education', city?: string | null, degree_type?: string | null, end_date?: any | null, field_of_study?: string | null, id: number, school_name?: string | null, start_date?: any | null, state_id?: number | null } & { ' $fragmentName'?: 'EducationItemFragment' };

export type GetWorkHistoriesForResumeBuilderQueryVariables = Exact<{
  input?: InputMaybe<WorkHistoryQueryInput>;
}>;


export type GetWorkHistoriesForResumeBuilderQuery = { __typename?: 'Query', workHistories?: Array<{ __typename?: 'WorkHistory', id: number, clinical: boolean, currently_work_here: boolean, description?: string | null, employment_type?: number | null, end_date?: any | null, floating?: boolean | null, floating_details?: string | null, hours_per_week?: number | null, location?: string | null, location_is_teaching?: boolean | null, location_number_of_beds?: number | null, location_trauma_level?: string | null, location_type_id?: number | null, missing_information_list: Array<string>, organization_name?: string | null, position_id?: number | null, position_title?: string | null, start_date?: any | null, state_id?: number | null, travel_agency?: string | null, unit?: string | null }> | null };

export type GetWorkGapsForResumeBuilderQueryVariables = Exact<{
  input?: InputMaybe<WorkGapQueryInput>;
}>;


export type GetWorkGapsForResumeBuilderQuery = { __typename?: 'Query', workGaps?: Array<{ __typename?: 'WorkGap', id: number, start_date?: any | null, end_date?: any | null, explanation?: string | null, location?: string | null, state_id?: number | null, state?: { __typename?: 'State', abbreviation?: string | null } | null }> | null };

export type GetCurrentUserForExperienceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserForExperienceQuery = { __typename?: 'Query', me?: { __typename?: 'Account', professional?: { __typename?: 'Professional', id: number, kinds: Array<string> } | null } | null };

export type GetAssignmentRequestsForExperienceQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type GetAssignmentRequestsForExperienceQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number }> | null };

export type GetAllPositionsForWorkHistoryFormQueryVariables = Exact<{
  input?: InputMaybe<PositionQueryInput>;
}>;


export type GetAllPositionsForWorkHistoryFormQuery = { __typename?: 'Query', positions?: Array<{ __typename?: 'Position', id: number, display_name?: string | null }> | null };

export type GetLocationTypesForWorkHistoryFormQueryVariables = Exact<{
  input?: InputMaybe<LocationTypeQueryInput>;
}>;


export type GetLocationTypesForWorkHistoryFormQuery = { __typename?: 'Query', locationTypes?: Array<{ __typename?: 'LocationType', id: number, label?: string | null }> | null };

export type GetStatesForWorkHistoryFormQueryVariables = Exact<{
  input?: InputMaybe<StateQueryInput>;
}>;


export type GetStatesForWorkHistoryFormQuery = { __typename?: 'Query', states?: Array<{ __typename?: 'State', id: number, abbreviation?: string | null }> | null };

export type GetAssignmentRequestsForWorkHistoryFormQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type GetAssignmentRequestsForWorkHistoryFormQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number }> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'Account', id: number, agency_id?: number | null, user_hash?: string | null, account_type: string, name?: string | null, first_name?: string | null, middle_name?: string | null, last_name?: string | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, state_id?: number | null, address_zip?: string | null, phone_number?: string | null, email: string, notification_settings: any, account_push_registration_tokens?: Array<string | null> | null, company_id?: number | null, coordinates?: { __typename?: 'Coordinates', latitude?: number | null, longitude?: number | null } | null, state?: { __typename?: 'State', id: number, abbreviation?: string | null, name?: string | null, rectangle_image?: any | null } | null, primary_locations?: Array<{ __typename?: 'Location', timezone_lookup?: string | null }> | null, professional?: { __typename?: 'Professional', last_seen_w2_interest_at?: any | null, application_version: ApplicationVersion, id: number, new_to_medely: boolean, archive_reason?: string | null, signup_assignment_id?: number | null, phone_screen_date_and_time?: any | null, background_check_authorized: boolean, drug_screening_completed: boolean, all_time_total_earnings_cents?: number | null, cancellation_ratio?: number | null, nickname?: string | null, kinds: Array<string>, dob?: any | null, application_status: string, status: string, deactivation_reason?: string | null, has_markets?: boolean | null, has_item?: boolean | null, has_active_funding_source?: boolean | null, required_item_image?: boolean | null, referral_source_id?: number | null, resume?: any | null, satisfied_condition_ids?: Array<number> | null, screening_recruiter_id?: number | null, profile_strength: number, w2_eligible: boolean, w2_enabled: boolean, background_check_pqs: Array<{ __typename?: 'ProfessionalQualification', id: number, status: string, professional_qualification_attributes?: Array<{ __typename?: 'ProfessionalQualificationAttribute', value: any, qualification_attribute?: { __typename?: 'QualificationAttribute', slug?: string | null } | null }> | null, qualification: { __typename?: 'Qualification', id: number, slug: string } }>, markets?: Array<{ __typename?: 'Market', id: number, state_id?: number | null, display_name?: string | null }> | null, professional_positions: Array<{ __typename?: 'ProfessionalPosition', position_id: number, completed_onboarding_at?: any | null, has_recent_experience: boolean, years_of_experience?: number | null, position: { __typename?: 'Position', id: number, display_name?: string | null, name?: string | null } }>, positions: Array<{ __typename?: 'Position', id: number, display_name?: string | null, kind?: string | null }>, specialties: Array<{ __typename?: 'Specialty', id: number, label?: string | null, name?: string | null }>, stripe_accounts?: Array<{ __typename?: 'StripeAccount', id: number, first_name?: string | null, last_name?: string | null, company_name?: string | null, tax_classification_id: number, tax_form_preference?: string | null, active?: boolean | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, state_id?: number | null, address_zip?: string | null, phone_number?: string | null, state?: { __typename?: 'State', id: number, name?: string | null, abbreviation?: string | null } | null, external_accounts?: Array<{ __typename?: 'ExternalAccount', id: number, account_type?: string | null, last4?: string | null, exp_month?: number | null, exp_year?: number | null }> | null, representative?: { __typename?: 'StripeRepresentative', id: number, first_name: string, last_name: string, dob: any, phone: string, ssn_last_4: string, email: string, address_first: string, address_second?: string | null, address_city: string, address_zip: string, title: string, state_id: number } | null }> | null } | null, company?: { __typename?: 'Company', id: number, name: string, logo?: any | null, saas_credentialing_enabled: boolean, saas_scheduling_enabled: boolean } | null } | null };

export type GetSchemaPermisionsForRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchemaPermisionsForRequestsQuery = { __typename?: 'Query', accountRequestPermissions?: any | null };

export type AppVersionQueryVariables = Exact<{
  appName: Scalars['String']['input'];
}>;


export type AppVersionQuery = { __typename?: 'Query', appVersion?: { __typename?: 'AppVersion', appName: string, major: number, minor: number, patch: number } | null };

export type AssignmentFieldsFragment = { __typename?: 'Assignment', id: number, starts_date?: any | null, ends_date?: any | null, starts_time?: any | null, ends_time?: any | null, number_of_shifts_per_week?: number | null, hours_per_shift?: number | null, track_unpaid_breaks: boolean, call_requirements?: string | null, one_time_bonus_burden_cents?: number | null, vms_partnership?: boolean | null, pay_per_week_cents: number, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, primary_location?: { __typename?: 'Location', name?: string | null, address_city?: string | null, address_zip?: string | null, timezone_lookup?: string | null, state?: { __typename?: 'State', id: number, abbreviation?: string | null } | null } | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null } & { ' $fragmentName'?: 'AssignmentFieldsFragment' };

export type AssignmentRequestsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type AssignmentRequestsQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number, status?: string | null, created_at: any, assignment?: (
      { __typename?: 'Assignment', missing_condition_ids?: Array<number | null> | null, is_w2?: boolean | null, is_travel?: boolean | null, primary_location?: { __typename?: 'Location', location_type: { __typename?: 'LocationType', label?: string | null } } | null }
      & { ' $fragmentRefs'?: { 'AssignmentFieldsFragment': AssignmentFieldsFragment } }
    ) | null }> | null, _assignmentRequestsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type PermanentRequestsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type PermanentRequestsQuery = { __typename?: 'Query', permanentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number, status?: string | null, created_at: any, assignment?: (
      { __typename?: 'Assignment', missing_condition_ids?: Array<number | null> | null, is_w2?: boolean | null, is_travel?: boolean | null, permanent_max_hourly_rate_cents?: number | null, permanent_min_hourly_rate_cents?: number | null, primary_location?: { __typename?: 'Location', location_type: { __typename?: 'LocationType', label?: string | null } } | null }
      & { ' $fragmentRefs'?: { 'AssignmentFieldsFragment': AssignmentFieldsFragment } }
    ) | null }> | null, _permanentRequestsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type PendingAssignmentRequestsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type PendingAssignmentRequestsQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number, status?: string | null, assignment?: (
      { __typename?: 'Assignment', missing_condition_ids?: Array<number | null> | null }
      & { ' $fragmentRefs'?: { 'AssignmentFieldsFragment': AssignmentFieldsFragment } }
    ) | null }> | null, _assignmentRequestsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type PendingPermanentRequestsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type PendingPermanentRequestsQuery = { __typename?: 'Query', permanentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number, status?: string | null, assignment?: (
      { __typename?: 'Assignment', missing_condition_ids?: Array<number | null> | null, permanent_min_hourly_rate_cents?: number | null, permanent_max_hourly_rate_cents?: number | null }
      & { ' $fragmentRefs'?: { 'AssignmentFieldsFragment': AssignmentFieldsFragment } }
    ) | null }> | null, _permanentRequestsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type AssignmentChecklistQueryVariables = Exact<{
  has_missing_availability?: InputMaybe<Scalars['Boolean']['input']>;
  has_missing_education?: InputMaybe<Scalars['Boolean']['input']>;
  has_missing_ehr_software?: InputMaybe<Scalars['Boolean']['input']>;
  has_missing_experience?: InputMaybe<Scalars['Boolean']['input']>;
  has_missing_identity?: InputMaybe<Scalars['Boolean']['input']>;
  has_missing_information?: InputMaybe<Scalars['Boolean']['input']>;
  has_missing_references?: InputMaybe<Scalars['Boolean']['input']>;
  has_missing_work_history?: InputMaybe<Scalars['Boolean']['input']>;
  has_unexplained_work_gaps?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type AssignmentChecklistQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', assignment_id?: number | null, has_missing_availability?: boolean | null, has_missing_education?: boolean | null, has_missing_ehr_software?: boolean | null, has_missing_experience?: boolean | null, has_missing_identity?: boolean | null, has_missing_information?: boolean | null, has_missing_references?: boolean | null, has_missing_work_history?: boolean | null, has_unexplained_work_gaps?: boolean | null }> | null };

export type AssignmentRequestsAvailabilityQueryVariables = Exact<{
  input?: InputMaybe<AssignmentRequestQueryInput>;
}>;


export type AssignmentRequestsAvailabilityQuery = { __typename?: 'Query', assignmentRequests?: Array<{ __typename?: 'AssignmentRequest', id: number, status?: string | null, created_at: any, asap: boolean, time_off_request?: string | null, interview_availability?: string | null, preferred_start_date?: any | null, assignment?: { __typename?: 'Assignment', starts_date?: any | null, ends_date?: any | null, primary_location?: { __typename?: 'Location', address_city?: string | null, timezone_lookup?: string | null, state?: { __typename?: 'State', abbreviation?: string | null } | null } | null } | null }> | null, _assignmentRequestsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type AssignmentRequestWorkHistoriesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AssignmentRequestWorkHistoriesQuery = { __typename?: 'Query', assignmentRequest?: { __typename?: 'AssignmentRequest', id: number, assignment?: { __typename?: 'Assignment', positions?: Array<{ __typename?: 'Position', id: number }> | null } | null, professional_position_recent_experience?: Array<{ __typename?: 'ProfessionalRecentExperience', position_id?: number | null, has_experience?: boolean | null } | null> | null } | null };

export type BookedAssignmentsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentQueryInput>;
}>;


export type BookedAssignmentsQuery = { __typename?: 'Query', assignments?: Array<{ __typename?: 'Assignment', id: number, starts_date?: any | null, ends_date?: any | null, hours_per_shift?: number | null, number_of_shifts_per_week?: number | null, starts_time?: any | null, ends_time?: any | null, covid_care: boolean, is_w2?: boolean | null, is_travel?: boolean | null, status: string, onboarding_due_date?: any | null, cancellation_policy?: string | null, contract_total_hours?: string | null, guaranteed_hours_string?: string | null, float_requirements?: string | null, great_pay?: boolean | null, first_to_apply?: boolean | null, distance_in_miles?: number | null, less_than_300_miles_away?: boolean | null, missing_condition_ids?: Array<number | null> | null, one_time_bonus_burden_cents?: number | null, pay_per_week_cents: number, professional?: { __typename?: 'Professional', account: { __typename?: 'Account', first_name?: string | null, last_name?: string | null } } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, jobs?: Array<{ __typename?: 'Job', id: number, shift_type: string, starts_date?: any | null, current_starts_time?: any | null, current_ends_time?: any | null, location?: { __typename?: 'Location', timezone_lookup?: string | null } | null }> | null, primary_location?: { __typename?: 'Location', id: number, name?: string | null, full_address?: string | null, timezone_lookup?: string | null, covid_requirement?: string | null, address_city?: string | null, address_zip?: string | null, state?: { __typename?: 'State', covid_requirement?: string | null, abbreviation?: string | null } | null } | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null, locations?: Array<{ __typename?: 'Location', name?: string | null, id: number }> | null }> | null };

export type OverlappingAssignmentsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentQueryInput>;
}>;


export type OverlappingAssignmentsQuery = { __typename?: 'Query', assignments?: Array<{ __typename?: 'Assignment', id: number }> | null };

export type AssignmentsIrpQueryVariables = Exact<{
  input?: InputMaybe<AssignmentQueryInput>;
}>;


export type AssignmentsIrpQuery = { __typename?: 'Query', availableAssignments?: Array<{ __typename?: 'Assignment', id: number, can_apply?: boolean | null, starts_date?: any | null, ends_date?: any | null, starts_time?: any | null, ends_time?: any | null, hours_per_shift?: number | null, number_of_shifts_per_week?: number | null, covid_care: boolean, is_w2?: boolean | null, is_travel?: boolean | null, missing_condition_ids?: Array<number | null> | null, primary_location?: { __typename?: 'Location', id: number, name?: string | null, full_address?: string | null, timezone_lookup?: string | null, address_city?: string | null, address_zip?: string | null, covid_requirement?: string | null, location_type: { __typename?: 'LocationType', label?: string | null }, state?: { __typename?: 'State', abbreviation?: string | null, covid_requirement?: string | null } | null } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null, id: number }> | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null }> | null, _availableAssignmentsMeta?: { __typename?: 'AvailableAssignmentsMeta', count?: number | null } | null };

export type AssignmentsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentQueryInput>;
}>;


export type AssignmentsQuery = { __typename?: 'Query', availableAssignments?: Array<{ __typename?: 'Assignment', id: number, can_apply?: boolean | null, starts_date?: any | null, ends_date?: any | null, starts_time?: any | null, ends_time?: any | null, hours_per_shift?: number | null, number_of_shifts_per_week?: number | null, covid_care: boolean, is_w2?: boolean | null, is_travel?: boolean | null, great_pay?: boolean | null, first_to_apply?: boolean | null, distance_in_miles?: number | null, less_than_300_miles_away?: boolean | null, one_time_bonus_burden_cents?: number | null, cancellation_policy?: string | null, contract_total_hours?: string | null, guaranteed_hours_string?: string | null, missing_condition_ids?: Array<number | null> | null, pay_per_week_cents: number, primary_location?: { __typename?: 'Location', id: number, name?: string | null, unit?: string | null, full_address?: string | null, timezone_lookup?: string | null, address_city?: string | null, address_zip?: string | null, covid_requirement?: string | null, location_type: { __typename?: 'LocationType', label?: string | null }, state?: { __typename?: 'State', abbreviation?: string | null, covid_requirement?: string | null } | null } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null, id: number }> | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null }> | null, _availableAssignmentsMeta?: { __typename?: 'AvailableAssignmentsMeta', count?: number | null } | null };

export type PermanentPlacementAssignmentsQueryVariables = Exact<{
  input?: InputMaybe<AssignmentQueryInput>;
}>;


export type PermanentPlacementAssignmentsQuery = { __typename?: 'Query', availablePlacements?: Array<{ __typename?: 'Assignment', id: number, starts_date?: any | null, starts_time?: any | null, ends_time?: any | null, hours_per_shift?: number | null, number_of_shifts_per_week?: number | null, permanent_min_hourly_rate_cents?: number | null, permanent_max_hourly_rate_cents?: number | null, permanent_signing_bonus_cents?: number | null, schedule_type: string, primary_location?: { __typename?: 'Location', name?: string | null, full_address?: string | null, timezone_lookup?: string | null, address_city?: string | null, address_zip?: string | null, location_type: { __typename?: 'LocationType', label?: string | null } } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, specialties?: Array<{ __typename?: 'Specialty', label?: string | null }> | null }> | null, _availablePlacementsMeta?: { __typename?: 'AvailableAssignmentsMeta', count?: number | null } | null };

export type FavoritedAssignmentsQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalAssignmentFavoriteQueryInput>;
}>;


export type FavoritedAssignmentsQuery = { __typename?: 'Query', professionalAssignmentFavorites?: Array<{ __typename?: 'ProfessionalAssignmentFavorite', id: number, assignment_id: number, assignment: { __typename?: 'Assignment', id: number, is_w2?: boolean | null, is_travel?: boolean | null, starts_date?: any | null, ends_date?: any | null, status: string, call_requirements?: string | null, hours_per_shift?: number | null, number_of_shifts_per_week?: number | null, starts_time?: any | null, ends_time?: any | null, one_time_bonus_burden_cents?: number | null, first_to_apply?: boolean | null, distance_in_miles?: number | null, less_than_300_miles_away?: boolean | null, great_pay?: boolean | null, missing_condition_ids?: Array<number | null> | null, pay_per_week_cents: number, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, primary_location?: { __typename?: 'Location', id: number, name?: string | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, address_zip?: string | null, timezone_lookup?: string | null, state?: { __typename?: 'State', abbreviation?: string | null } | null } | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null } }> | null };

export type FavoritedAssignmentsIrpQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalAssignmentFavoriteQueryInput>;
}>;


export type FavoritedAssignmentsIrpQuery = { __typename?: 'Query', professionalAssignmentFavorites?: Array<{ __typename?: 'ProfessionalAssignmentFavorite', id: number, assignment_id: number, assignment: { __typename?: 'Assignment', id: number, is_w2?: boolean | null, is_travel?: boolean | null, starts_date?: any | null, ends_date?: any | null, status: string, call_requirements?: string | null, hours_per_shift?: number | null, number_of_shifts_per_week?: number | null, starts_time?: any | null, ends_time?: any | null, missing_condition_ids?: Array<number | null> | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, primary_location?: { __typename?: 'Location', id: number, name?: string | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, address_zip?: string | null, timezone_lookup?: string | null, state?: { __typename?: 'State', abbreviation?: string | null } | null } | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null } }> | null };

export type AssignmentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AssignmentQuery = { __typename?: 'Query', assignment?: { __typename?: 'Assignment', id: number, covid_care: boolean, facility_number?: string | null, professional_number?: string | null, status: string, created_at: any, starts_date?: any | null, ends_date?: any | null, charge_base_hourly_rate_cents?: number | null, hours_per_shift?: number | null, starts_time?: any | null, ends_time?: any | null, is_extension?: boolean | null, number_of_shifts_per_week?: number | null, schedule_type: string, patient_population?: string | null, scrubs_provided: boolean, jobs_detail?: string | null, paused: boolean, is_w2?: boolean | null, is_travel?: boolean | null, clinical_contact_account_id?: number | null, one_time_bonus_burden_cents?: number | null, payout_taxable_hourly_rate_cents?: number | null, payout_overtime_multiplier?: number | null, payout_on_call_hourly_rate_cents?: number | null, mie_per_diem_cents?: number | null, lodging_per_diem_cents?: number | null, referral_reward_cents?: number | null, nontaxable_amount_cents?: number | null, taxable_amount_cents?: number | null, flexible_starts_date: boolean, variable_shift_times?: boolean | null, per_diem: boolean, guaranteed_minimum_hours?: number | null, enforce_guaranteed_minimum_hours?: boolean | null, estimated_unpaid_break_time_minutes?: number | null, track_unpaid_breaks: boolean, can_apply?: boolean | null, min_years_of_experience?: number | null, mileage_requirement?: number | null, onboarding_due_date?: any | null, cancellation_policy?: string | null, contract_total_hours?: string | null, guaranteed_hours_string?: string | null, posting_field_contents?: any | null, first_to_apply?: boolean | null, distance_in_miles?: number | null, less_than_300_miles_away?: boolean | null, great_pay?: boolean | null, missing_condition_ids?: Array<number | null> | null, vms_partnership?: boolean | null, pay_per_week_cents: number, professional?: { __typename?: 'Professional', account: { __typename?: 'Account', first_name?: string | null, last_name?: string | null } } | null, clinical_contact?: { __typename?: 'Account', first_name?: string | null, last_name?: string | null, id: number } | null, positions?: Array<{ __typename?: 'Position', id: number, kind?: string | null, display_name?: string | null, name?: string | null }> | null, surgery_types?: Array<{ __typename?: 'SurgeryType', id: number, display_name?: string | null }> | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null, locations?: Array<{ __typename?: 'Location', id: number, name?: string | null, timezone_lookup?: string | null }> | null, primary_location?: { __typename?: 'Location', id: number, name?: string | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, address_zip?: string | null, parking_instructions?: string | null, parking_free: boolean, parking_reimbursed: boolean, parking_reimbursement_cents: number, parking_validated: boolean, parking_cost_cents: number, timezone_lookup?: string | null, market_id?: number | null, drug_screening_required?: boolean | null, state?: { __typename?: 'State', abbreviation?: string | null } | null, location_type: { __typename?: 'LocationType', label?: string | null }, market?: { __typename?: 'Market', display_name?: string | null } | null } | null, ehr_system?: { __typename?: 'EhrSystem', id: number, label?: string | null } | null } | null };

export type AvailableAssignmentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AvailableAssignmentQuery = { __typename?: 'Query', availableAssignment?: { __typename?: 'Assignment', id: number, covid_care: boolean, call_requirements?: string | null, professional_number?: string | null, facility_number?: string | null, status: string, created_at: any, starts_date?: any | null, ends_date?: any | null, charge_base_hourly_rate_cents?: number | null, hours_per_shift?: number | null, starts_time?: any | null, ends_time?: any | null, is_extension?: boolean | null, number_of_shifts_per_week?: number | null, schedule_type: string, patient_population?: string | null, scrubs_provided: boolean, jobs_detail?: string | null, paused: boolean, is_travel?: boolean | null, clinical_contact_account_id?: number | null, one_time_bonus_burden_cents?: number | null, payout_taxable_hourly_rate_cents?: number | null, payout_overtime_multiplier?: number | null, payout_on_call_hourly_rate_cents?: number | null, mie_per_diem_cents?: number | null, lodging_per_diem_cents?: number | null, referral_reward_cents?: number | null, nontaxable_amount_cents?: number | null, taxable_amount_cents?: number | null, flexible_starts_date: boolean, variable_shift_times?: boolean | null, per_diem: boolean, guaranteed_minimum_hours?: number | null, enforce_guaranteed_minimum_hours?: boolean | null, estimated_unpaid_break_time_minutes?: number | null, track_unpaid_breaks: boolean, can_apply?: boolean | null, min_years_of_experience?: number | null, mileage_requirement?: number | null, cancellation_policy?: string | null, contract_total_hours?: string | null, guaranteed_hours_string?: string | null, posting_field_contents?: any | null, first_to_apply?: boolean | null, distance_in_miles?: number | null, less_than_300_miles_away?: boolean | null, great_pay?: boolean | null, missing_condition_ids?: Array<number | null> | null, vms_partnership?: boolean | null, is_w2: boolean, pay_per_week_cents: number, professional?: { __typename?: 'Professional', account: { __typename?: 'Account', first_name?: string | null, last_name?: string | null } } | null, clinical_contact?: { __typename?: 'Account', first_name?: string | null, last_name?: string | null, id: number } | null, positions?: Array<{ __typename?: 'Position', id: number, kind?: string | null, display_name?: string | null, name?: string | null }> | null, surgery_types?: Array<{ __typename?: 'SurgeryType', id: number, display_name?: string | null }> | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null, locations?: Array<{ __typename?: 'Location', id: number, name?: string | null, timezone_lookup?: string | null }> | null, primary_location?: { __typename?: 'Location', id: number, name?: string | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, address_zip?: string | null, parking_instructions?: string | null, parking_free: boolean, parking_reimbursed: boolean, parking_reimbursement_cents: number, parking_validated: boolean, parking_cost_cents: number, timezone_lookup?: string | null, market_id?: number | null, drug_screening_required?: boolean | null, phone_number?: string | null, state_id?: number | null, ehr_details?: string | null, medication_management_details?: string | null, meal_break_details?: string | null, supplies_ppe_details?: string | null, additional_check_in_instructions?: string | null, scrub_colors?: Array<ScrubColors | null> | null, state?: { __typename?: 'State', abbreviation?: string | null } | null, location_type: { __typename?: 'LocationType', label?: string | null }, market?: { __typename?: 'Market', display_name?: string | null } | null } | null, ehr_system?: { __typename?: 'EhrSystem', id: number, label?: string | null } | null } | null };

export type AssignmentMetaQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AssignmentMetaQuery = { __typename?: 'Query', _assignmentMeta?: { __typename?: 'AssignmentMeta', is_travel?: boolean | null, is_w2?: boolean | null, local_only?: boolean | null } | null };

export type CancellationReasonsQueryVariables = Exact<{
  input?: InputMaybe<CancellationReasonQueryInput>;
}>;


export type CancellationReasonsQuery = { __typename?: 'Query', cancellationReasons?: Array<{ __typename?: 'CancellationReason', id: number, label?: string | null }> | null };

export type MissingConditionsQueryVariables = Exact<{
  input?: InputMaybe<ConditionQueryInput>;
}>;


export type MissingConditionsQuery = { __typename?: 'Query', conditions?: Array<{ __typename?: 'Condition', id: number, slug: string, label: string, payload: any, condition_type: string, display_category?: string | null, display_description?: string | null, condition_documents?: Array<{ __typename?: 'ConditionDocument', id: number, name?: string | null, category?: string | null, file: any }> | null, qualifications?: Array<{ __typename?: 'Qualification', id: number, input_source: string, instructions?: any | null, long_name: string, slug: string, admin_view_only: boolean, qualification_type: string, status: string, default_verification_title?: string | null, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, field_type: string, required: boolean, data: any, input_source: string, active: boolean, slug?: string | null }> | null, qualification_automations?: Array<{ __typename?: 'QualificationAutomation', id: number, description: string, name: string, loading_text?: string | null, is_active?: boolean | null, qualification_automation_attributes?: Array<{ __typename?: 'QualificationAutomationAttribute', id: number, required?: boolean | null, qualification_attribute?: { __typename?: 'QualificationAttribute', id: number, field_type: string, slug?: string | null, name?: string | null, data: any, input_source: string, active: boolean } | null }> | null }> | null }> | null }> | null };

export type RequiredConditionsQueryVariables = Exact<{
  input?: InputMaybe<ConditionQueryInput>;
}>;


export type RequiredConditionsQuery = { __typename?: 'Query', conditions?: Array<{ __typename?: 'Condition', id: number, slug: string, label: string, payload: any, condition_type: string, display_category?: string | null, display_description?: string | null, condition_documents?: Array<{ __typename?: 'ConditionDocument', id: number, name?: string | null, category?: string | null, file: any }> | null, qualifications?: Array<{ __typename?: 'Qualification', id: number, input_source: string, instructions?: any | null, long_name: string, slug: string, admin_view_only: boolean, qualification_type: string, status: string, short_name: string, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, field_type: string, required: boolean, data: any, input_source: string, active: boolean }> | null }> | null }> | null };

export type MissingApplicationConditionsQueryVariables = Exact<{
  input?: InputMaybe<ConditionQueryInput>;
}>;


export type MissingApplicationConditionsQuery = { __typename?: 'Query', conditions?: Array<{ __typename?: 'Condition', id: number, label: string, slug: string, condition_type: string, qualifications?: Array<{ __typename?: 'Qualification', id: number, instructions?: any | null, input_source: string, long_name: string, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, field_type: string, required: boolean, data: any, input_source: string, active: boolean }> | null }> | null }> | null };

export type MissingOnboardingConditionsQueryVariables = Exact<{
  input?: InputMaybe<ConditionQueryInput>;
}>;


export type MissingOnboardingConditionsQuery = { __typename?: 'Query', conditions?: Array<{ __typename?: 'Condition', id: number, slug: string, payload: any, qualifications?: Array<{ __typename?: 'Qualification', id: number, input_source: string, slug: string, qualification_type: string, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, slug?: string | null }> | null }> | null }> | null };

export type ExpiringConditionsQueryVariables = Exact<{
  input?: InputMaybe<ConditionQueryInput>;
}>;


export type ExpiringConditionsQuery = { __typename?: 'Query', conditions?: Array<{ __typename?: 'Condition', id: number, slug: string, label: string, payload: any, condition_type: string, display_category?: string | null, display_description?: string | null, condition_documents?: Array<{ __typename?: 'ConditionDocument', id: number, name?: string | null, category?: string | null, file: any }> | null, qualifications?: Array<{ __typename?: 'Qualification', id: number, input_source: string, instructions?: any | null, long_name: string, slug: string, admin_view_only: boolean, qualification_type: string, status: string, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, field_type: string, required: boolean, data: any, input_source: string, active: boolean, slug?: string | null }> | null }> | null }> | null };

export type ConditionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ConditionQuery = { __typename?: 'Query', condition?: { __typename?: 'Condition', id: number, slug: string, label: string, payload: any, condition_type: string, display_category?: string | null, display_description?: string | null, condition_documents?: Array<{ __typename?: 'ConditionDocument', id: number, name?: string | null, category?: string | null, file: any }> | null, qualifications?: Array<{ __typename?: 'Qualification', id: number, input_source: string, instructions?: any | null, long_name: string, slug: string, admin_view_only: boolean, qualification_type: string, status: string, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, field_type: string, required: boolean, data: any, input_source: string, active: boolean, slug?: string | null }> | null }> | null } | null };

export type ContractsQueryVariables = Exact<{
  input?: InputMaybe<ContractQueryInput>;
}>;


export type ContractsQuery = { __typename?: 'Query', contracts?: Array<{ __typename?: 'Contract', id: number, contract_type: string, signed_at?: any | null }> | null };

export type PremierQualificationsQueryVariables = Exact<{
  input?: InputMaybe<QualificationQueryInput>;
}>;


export type PremierQualificationsQuery = { __typename?: 'Query', qualifications?: Array<{ __typename?: 'Qualification', id: number, slug: string, short_name: string, qualification_type: string, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, data: any, input_source: string, field_type: string, active: boolean }> | null }> | null };

export type SkillsAssemssmentsQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalQualificationQueryInput>;
}>;


export type SkillsAssemssmentsQuery = { __typename?: 'Query', professionalQualifications?: Array<{ __typename?: 'ProfessionalQualification', id: number, status: string, professional_qualification_attributes?: Array<{ __typename?: 'ProfessionalQualificationAttribute', id: number, type: string, value: any, qualification_attribute?: { __typename?: 'QualificationAttribute', id: number, name?: string | null, input_source: string, field_type: string, active: boolean, data: any } | null }> | null, qualification: { __typename?: 'Qualification', id: number, long_name: string, qualification_type: string } }> | null };

export type MarketplaceDisputesFragmentFragment = { __typename?: 'Dispute', job?: { __typename?: 'Job', job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null } | null } | null } & { ' $fragmentName'?: 'MarketplaceDisputesFragmentFragment' };

export type DisputesQueryVariables = Exact<{
  input?: InputMaybe<DisputeQueryInput>;
}>;


export type DisputesQuery = { __typename?: 'Query', disputes?: Array<{ __typename?: 'Dispute', id: number, job?: { __typename?: 'Job', id: number, starts_date?: any | null, job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null } | null, location?: { __typename?: 'Location', name?: string | null } | null } | null }> | null, _disputesMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type MarketplaceDisputeFragmentFragment = { __typename?: 'Dispute', adjusted_total_payout_cents?: number | null, original_total_payout_cents?: number | null, job?: { __typename?: 'Job', job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null } | null } | null } & { ' $fragmentName'?: 'MarketplaceDisputeFragmentFragment' };

export type DisputeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DisputeQuery = { __typename?: 'Query', dispute?: { __typename?: 'Dispute', adjusted_clock_in?: any | null, adjusted_clock_out?: any | null, adjusted_meal_break_minutes?: number | null, created_at: any, id: number, reason: string, original_clock_in?: any | null, original_clock_out?: any | null, original_meal_break_minutes?: number | null, professional_notes?: string | null, status: string, total_adjusted_minutes?: number | null, updated_at: any, job?: { __typename?: 'Job', approved_clock_in?: any | null, approved_clock_out?: any | null, current_ends_time?: any | null, current_starts_time?: any | null, ends_time?: any | null, facility_number?: string | null, id: number, shift_type: string, starts_date?: any | null, starts_time?: any | null, status?: JobStatus | null, job_billing_sums?: { __typename?: 'JobBillingSum', total_hours?: number | null } | null, location?: { __typename?: 'Location', name?: string | null, timezone_lookup?: string | null } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null } | null } | null };

export type EhRsQueryVariables = Exact<{
  input?: InputMaybe<EhrSystemQueryInput>;
}>;


export type EhRsQuery = { __typename?: 'Query', ehrSystems?: Array<{ __typename?: 'EhrSystem', id: number, label?: string | null }> | null };

export type EmergencyContactsQueryVariables = Exact<{
  input?: InputMaybe<EmergencyContactQueryInput>;
}>;


export type EmergencyContactsQuery = { __typename?: 'Query', emergencyContacts?: Array<{ __typename?: 'EmergencyContact', id: number, first_name?: string | null, last_name?: string | null, phone_number?: string | null, professional_id?: number | null }> | null };

export type UnpaidTimecardAdjustmentsQueryVariables = Exact<{
  input?: InputMaybe<ExpenseAdjustmentQueryInput>;
}>;


export type UnpaidTimecardAdjustmentsQuery = { __typename?: 'Query', unpaidTimecardAdjustments?: Array<{ __typename?: 'ExpenseAdjustment', amount_cents: number, created_at: any, id: number, job_id?: number | null, make_payable_at?: any | null, taxable_type?: string | null }> | null };

export type ExpenseAdjustmentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ExpenseAdjustmentQuery = { __typename?: 'Query', expenseAdjustment?: { __typename?: 'ExpenseAdjustment', amount_cents: number, created_at: any, id: number, taxable_type?: string | null, payout?: { __typename?: 'Payout', ends_time?: any | null, id: number, status?: string | null, starts_time?: any | null, w2_submit_by_time?: any | null, processed_on?: any | null } | null } | null };

export type MarketplaceAvailableJobsFragmentFragment = { __typename?: 'Job', great_pay?: boolean | null, guaranteed_minimum_hours?: number | null, status?: JobStatus | null, total_payout_bonus_cents?: number | null, job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null } | null, job_price_differentials?: Array<{ __typename?: 'JobPriceDifferential', slug: string, recommendation_used: boolean }> | null, job_profile_for_account_id?: { __typename?: 'JobProfile', payout_facility_bonus_cents: number, active: boolean } | null } & { ' $fragmentName'?: 'MarketplaceAvailableJobsFragmentFragment' };

export type AvailablePerDiemJobsQueryVariables = Exact<{
  input?: InputMaybe<JobQueryInput>;
  professional_id: Scalars['Int']['input'];
}>;


export type AvailablePerDiemJobsQuery = { __typename?: 'Query', availableJobs?: Array<{ __typename?: 'Job', can_book_job?: boolean | null, current_ends_time?: any | null, current_starts_time?: any | null, distance_in_miles?: number | null, id: number, location_id?: number | null, missing_condition_ids?: Array<number | null> | null, requested_by_facility?: boolean | null, starts_date?: any | null, location?: { __typename?: 'Location', medication_management_details?: string | null, ehr_details?: string | null, supplies_ppe_details?: string | null, additional_check_in_instructions?: string | null, meal_break_details?: string | null, scrub_colors?: Array<ScrubColors | null> | null, address_city?: string | null, address_zip?: string | null, company_id?: number | null, name?: string | null, timezone_lookup?: string | null, ehr_system?: { __typename?: 'EhrSystem', label?: string | null } | null, state?: { __typename?: 'State', abbreviation?: string | null } | null } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null, specialties?: Array<{ __typename?: 'Specialty', label?: string | null }> | null }> | null, _availableJobsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type WeekJobsQueryVariables = Exact<{
  input?: InputMaybe<JobQueryInput>;
}>;


export type WeekJobsQuery = { __typename?: 'Query', jobs?: Array<{ __typename?: 'Job', starts_date?: any | null }> | null };

export type MarketplaceJobFragmentFragment = { __typename?: 'Job', bonus_one_time_cents_for_account_id?: number | null, bonus_one_time_cents?: number | null, payout_base_hourly_rate_cents_for_account_id?: number | null, payout_base_hourly_rate_cents?: number | null, payout_double_overtime_multiplier?: number | null, payout_on_call_hourly_rate_cents?: number | null, payout_overtime_multiplier?: number | null, payout_taxable_hourly_rate_cents?: number | null, status?: JobStatus | null, total_payout_bonus_cents?: number | null, assignment?: { __typename?: 'Assignment', is_travel?: boolean | null } | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', amount_cents: number, payout?: { __typename?: 'Payout', amount_cents: number, id: number, status?: string | null, w2_submit_by_time?: any | null, processed_on?: any | null } | null }>, job_billing_sums?: { __typename?: 'JobBillingSum', payout_callback_amount_cents?: number | null, payout_callback_hours?: number | null, payout_daily_overtime_amount_cents?: number | null, payout_daily_overtime_hours?: number | null, payout_double_amount_cents?: number | null, payout_double_hours?: number | null, payout_overtime_amount_cents?: number | null, payout_overtime_hours?: number | null, payout_regular_amount_cents?: number | null, payout_regular_hours?: number | null, payout_total_amount_cents?: number | null, payout_weekly_overtime_amount_cents?: number | null, payout_weekly_overtime_hours?: number | null, total_breaks_minutes?: number | null, total_hours?: number | null, total_on_call_hours?: number | null } | null, job_billings: Array<{ __typename?: 'JobBilling', payout_total_amount_cents: number, category?: string | null, payout?: { __typename?: 'Payout', amount_cents: number, id: number, status?: string | null, w2_submit_by_time?: any | null, processed_on?: any | null } | null, disputed_job_billings: Array<{ __typename?: 'DisputedJobBilling', id: number }> }>, job_profile_for_account_id?: { __typename?: 'JobProfile', payout_double_overtime_multiplier?: number | null, payout_facility_bonus_cents: number, payout_kind: string, payout_max_daily_ot_hours?: number | null, payout_max_daily_regular_hours?: number | null, payout_max_weekly_regular_hours?: number | null, payout_overtime_multiplier: number, active: boolean } | null } & { ' $fragmentName'?: 'MarketplaceJobFragmentFragment' };

export type JobQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  professional_id: Scalars['Int']['input'];
}>;


export type JobQuery = { __typename?: 'Query', job?: { __typename?: 'Job', new_to_facility: boolean, professional_id?: number | null, approved_clock_in?: any | null, approved_clock_out?: any | null, pool_id?: number | null, booked_at?: any | null, can_book_job?: boolean | null, cancellation_fee_charge_hours?: number | null, cancellation_fee_window?: number | null, condition_ids?: Array<number> | null, covid_care: boolean, current_ends_time?: any | null, current_starts_time?: any | null, detail?: string | null, did_user_modify_time?: boolean | null, ends_time?: any | null, estimated_unpaid_break_time_minutes?: number | null, facility_number?: string | null, guaranteed_minimum_hours?: number | null, id: number, is_w2?: boolean | null, location_id?: number | null, patient_population?: string | null, posting_field_contents?: any | null, pro_confirmed_at?: any | null, professional_submitted_time?: any | null, requested_by_facility?: boolean | null, requires_sca_onboarding_condition?: boolean | null, scrubs_provided: boolean, shift_type: string, starts_date?: any | null, starts_time?: any | null, status?: JobStatus | null, track_unpaid_breaks: boolean, updated_in_cancellation_window?: boolean | null, assignment?: { __typename?: 'Assignment', id: number, is_w2?: boolean | null, track_unpaid_breaks: boolean } | null, breaks?: Array<{ __typename?: 'Break', duration_minutes: number, id: number, waived?: boolean | null }> | null, clinical_contact?: { __typename?: 'Account', first_name?: string | null, last_name?: string | null, phone_number?: string | null } | null, custom_onboarding_docs?: Array<{ __typename?: 'ConditionDocument', category?: string | null, file: any, id: number, name?: string | null } | null> | null, disputes?: Array<{ __typename?: 'Dispute', id: number, status: string }> | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', created_at: any, id: number, taxable_type?: string | null }>, job_billing_sums?: { __typename?: 'JobBillingSum', total_breaks_minutes?: number | null, total_hours?: number | null } | null, job_billings: Array<{ __typename?: 'JobBilling', id: number }>, location?: { __typename?: 'Location', medication_management_details?: string | null, ehr_details?: string | null, supplies_ppe_details?: string | null, additional_check_in_instructions?: string | null, meal_break_details?: string | null, scrub_colors?: Array<ScrubColors | null> | null, address_city?: string | null, address_first?: string | null, address_second?: string | null, address_zip?: string | null, approval_free_late_clock_out_grace_period_minutes: number, clock_in_early_window: number, company_id?: number | null, covid_requirement?: string | null, drug_screening_required?: boolean | null, enable_geo_fence: boolean, full_address?: string | null, geo_fence_radius?: number | null, id: number, ignore_signature_when_creating_meal_break: boolean, market_id?: number | null, maximum_late_clock_out_grace_period_minutes: number, name?: string | null, parking_cost_cents: number, parking_free: boolean, parking_instructions?: string | null, parking_reimbursed: boolean, parking_reimbursement_cents: number, parking_validated: boolean, professional_can_adjust_times: boolean, require_facility_timecard_system_photo_on_clock_in: boolean, require_facility_timecard_system_photo_on_clock_out: boolean, require_upload_on_clock_out: boolean, start_clock_in_early_window: number, state_id?: number | null, timezone_lookup?: string | null, ehr_system?: { __typename?: 'EhrSystem', label?: string | null } | null, coordinates?: { __typename?: 'Coordinates', latitude?: number | null, longitude?: number | null } | null, location_type: { __typename?: 'LocationType', label?: string | null }, market?: { __typename?: 'Market', display_name?: string | null } | null, state?: { __typename?: 'State', abbreviation?: string | null, covid_requirement?: string | null } | null } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null, id: number, name?: string | null }> | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null, surgery_types?: Array<{ __typename?: 'SurgeryType', display_name?: string | null, id: number }> | null } | null };

export type MarketplaceAvailableJobFragmentFragment = { __typename?: 'Job', bonus_one_time_cents_for_account_id?: number | null, bonus_one_time_cents?: number | null, payout_base_hourly_rate_cents_for_account_id?: number | null, payout_double_overtime_multiplier?: number | null, payout_on_call_hourly_rate_cents?: number | null, payout_overtime_multiplier?: number | null, total_payout_bonus_cents?: number | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', amount_cents: number }>, job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null, total_hours?: number | null } | null, job_profile_for_account_id?: { __typename?: 'JobProfile', payout_double_overtime_multiplier?: number | null, payout_facility_bonus_cents: number, payout_kind: string, payout_max_daily_ot_hours?: number | null, payout_max_daily_regular_hours?: number | null, payout_max_weekly_regular_hours?: number | null, payout_overtime_multiplier: number, active: boolean } | null } & { ' $fragmentName'?: 'MarketplaceAvailableJobFragmentFragment' };

export type AvailableJobQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  professional_id: Scalars['Int']['input'];
}>;


export type AvailableJobQuery = { __typename?: 'Query', availableJob?: { __typename?: 'Job', approved_clock_in?: any | null, approved_clock_out?: any | null, booked_at?: any | null, can_book_job?: boolean | null, cancellation_fee_charge_hours?: number | null, cancellation_fee_window?: number | null, condition_ids?: Array<number> | null, covid_care: boolean, current_ends_time?: any | null, current_starts_time?: any | null, detail?: string | null, did_user_modify_time?: boolean | null, estimated_unpaid_break_time_minutes?: number | null, facility_number?: string | null, guaranteed_minimum_hours?: number | null, id: number, is_w2?: boolean | null, location_id?: number | null, patient_population?: string | null, pool_id?: number | null, posting_field_contents?: any | null, professional_submitted_time?: any | null, requested_by_facility?: boolean | null, requires_sca_onboarding_condition?: boolean | null, scrubs_provided: boolean, starts_date?: any | null, status?: JobStatus | null, track_unpaid_breaks: boolean, updated_in_cancellation_window?: boolean | null, assignment?: { __typename?: 'Assignment', id: number, is_w2?: boolean | null, track_unpaid_breaks: boolean } | null, breaks?: Array<{ __typename?: 'Break', duration_minutes: number, id: number, waived?: boolean | null }> | null, custom_onboarding_docs?: Array<{ __typename?: 'ConditionDocument', category?: string | null, file: any, id: number, name?: string | null } | null> | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', created_at: any, taxable_type?: string | null }>, location?: { __typename?: 'Location', medication_management_details?: string | null, ehr_details?: string | null, supplies_ppe_details?: string | null, additional_check_in_instructions?: string | null, meal_break_details?: string | null, scrub_colors?: Array<ScrubColors | null> | null, address_city?: string | null, address_first?: string | null, address_second?: string | null, address_zip?: string | null, approval_free_late_clock_out_grace_period_minutes: number, clock_in_early_window: number, company_id?: number | null, covid_requirement?: string | null, drug_screening_required?: boolean | null, enable_geo_fence: boolean, geo_fence_radius?: number | null, id: number, ignore_signature_when_creating_meal_break: boolean, market_id?: number | null, maximum_late_clock_out_grace_period_minutes: number, name?: string | null, parking_cost_cents: number, parking_free: boolean, parking_instructions?: string | null, parking_reimbursed: boolean, parking_reimbursement_cents: number, parking_validated: boolean, professional_can_adjust_times: boolean, require_facility_timecard_system_photo_on_clock_in: boolean, require_facility_timecard_system_photo_on_clock_out: boolean, require_upload_on_clock_out: boolean, start_clock_in_early_window: number, state_id?: number | null, timezone_lookup?: string | null, ehr_system?: { __typename?: 'EhrSystem', label?: string | null } | null, coordinates?: { __typename?: 'Coordinates', latitude?: number | null, longitude?: number | null } | null, location_type: { __typename?: 'LocationType', label?: string | null }, market?: { __typename?: 'Market', display_name?: string | null } | null, state?: { __typename?: 'State', abbreviation?: string | null, covid_requirement?: string | null } | null } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null, id: number, high_risk: boolean }> | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null, surgery_types?: Array<{ __typename?: 'SurgeryType', display_name?: string | null, id: number }> | null } | null };

export type MarketplaceJobsFragmentFragment = { __typename?: 'Job', bonus_one_time_cents?: number | null, estimated_unpaid_break_time_minutes?: number | null, total_payout_bonus_cents?: number | null, assignment?: { __typename?: 'Assignment', is_travel?: boolean | null } | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', amount_cents: number, payout_id?: number | null }>, job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null, total_hours?: number | null } | null, job_profile_for_account_id?: { __typename?: 'JobProfile', payout_facility_bonus_cents: number, active: boolean } | null } & { ' $fragmentName'?: 'MarketplaceJobsFragmentFragment' };

export type JobsQueryVariables = Exact<{
  input?: InputMaybe<JobQueryInput>;
}>;


export type JobsQuery = { __typename?: 'Query', jobs?: Array<{ __typename?: 'Job', approved_clock_in?: any | null, approved_clock_out?: any | null, booked_at?: any | null, assignment_id?: number | null, cancellation_fee_charge_hours?: number | null, cancellation_fee_window?: number | null, covid_care: boolean, current_ends_time?: any | null, current_starts_time?: any | null, detail?: string | null, did_user_modify_time?: boolean | null, ends_date?: any | null, ends_time?: any | null, facility_number?: string | null, guaranteed_minimum_hours?: number | null, id: number, is_w2?: boolean | null, job_type: JobTypeList, location_id?: number | null, patient_population?: string | null, pool_id?: number | null, posting_field_contents?: any | null, pro_confirmed_at?: any | null, professional_submitted_time?: any | null, scrubs_provided: boolean, shift_type: string, starts_date?: any | null, starts_time?: any | null, status?: JobStatus | null, track_unpaid_breaks: boolean, assignment?: { __typename?: 'Assignment', id: number, is_w2?: boolean | null, track_unpaid_breaks: boolean, primary_location?: { __typename?: 'Location', timezone_lookup?: string | null } | null } | null, breaks?: Array<{ __typename?: 'Break', duration_minutes: number, id: number, waived?: boolean | null }> | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', created_at: any, id: number, job_id?: number | null, taxable_type?: string | null }>, location?: { __typename?: 'Location', medication_management_details?: string | null, ehr_details?: string | null, supplies_ppe_details?: string | null, additional_check_in_instructions?: string | null, meal_break_details?: string | null, scrub_colors?: Array<ScrubColors | null> | null, address_city?: string | null, address_first?: string | null, address_second?: string | null, address_zip?: string | null, approval_free_late_clock_out_grace_period_minutes: number, clock_in_early_window: number, company_id?: number | null, covid_requirement?: string | null, enable_geo_fence: boolean, full_address?: string | null, geo_fence_radius?: number | null, id: number, ignore_signature_when_creating_meal_break: boolean, maximum_late_clock_out_grace_period_minutes: number, name?: string | null, professional_can_adjust_times: boolean, require_facility_timecard_system_photo_on_clock_in: boolean, require_facility_timecard_system_photo_on_clock_out: boolean, require_upload_on_clock_out: boolean, start_clock_in_early_window: number, state_id?: number | null, timezone_lookup?: string | null, ehr_system?: { __typename?: 'EhrSystem', label?: string | null } | null, coordinates?: { __typename?: 'Coordinates', latitude?: number | null, longitude?: number | null } | null, location_type: { __typename?: 'LocationType', label?: string | null }, state?: { __typename?: 'State', abbreviation?: string | null, covid_requirement?: string | null } | null } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null, id: number }> | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null, surgery_types?: Array<{ __typename?: 'SurgeryType', display_name?: string | null, id: number }> | null }> | null, _jobsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type RequestedJobsQueryVariables = Exact<{
  input?: InputMaybe<JobQueryInput>;
}>;


export type RequestedJobsQuery = { __typename?: 'Query', availableJobs?: Array<{ __typename?: 'Job', id: number, location?: { __typename?: 'Location', id: number, name?: string | null, unit?: string | null, address_first?: string | null, address_second?: string | null, address_city?: string | null, address_zip?: string | null, state?: { __typename?: 'State', abbreviation?: string | null } | null } | null }> | null };

export type MarketplaceGetJobsWithoutPayoutFragmentFragment = { __typename?: 'Job', expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', amount_cents: number, payout_id?: number | null, payout?: { __typename?: 'Payout', id: number, status?: string | null } | null }>, job_billings: Array<{ __typename?: 'JobBilling', payout_total_amount_cents: number, payout_weekly_overtime_amount_cents: number, payout?: { __typename?: 'Payout', id: number, status?: string | null } | null }> } & { ' $fragmentName'?: 'MarketplaceGetJobsWithoutPayoutFragmentFragment' };

export type JobsWithoutPayoutQueryVariables = Exact<{
  input?: InputMaybe<JobQueryInput>;
}>;


export type JobsWithoutPayoutQuery = { __typename?: 'Query', jobsWithoutPayout?: Array<{ __typename?: 'Job', assignment_id?: number | null, current_ends_time?: any | null, current_starts_time?: any | null, ends_date?: any | null, id: number, is_w2?: boolean | null, shift_type: string, starts_date?: any | null, status?: JobStatus | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', created_at: any, id: number, job_id?: number | null, taxable_type?: string | null }>, job_billings: Array<{ __typename?: 'JobBilling', category?: string | null, id: number, make_payable_at?: any | null, total_hours?: number | null, disputed_job_billings: Array<{ __typename?: 'DisputedJobBilling', id: number }> }>, location?: { __typename?: 'Location', id: number, timezone_lookup?: string | null } | null }> | null };

export type MarketplaceGetPayoutJobsFragmentFragment = { __typename?: 'Job', expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', amount_cents: number }>, job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null } | null } & { ' $fragmentName'?: 'MarketplaceGetPayoutJobsFragmentFragment' };

export type PayoutJobsQueryVariables = Exact<{
  input?: InputMaybe<JobQueryInput>;
  payout_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PayoutJobsQuery = { __typename?: 'Query', jobs?: Array<{ __typename?: 'Job', current_ends_time?: any | null, current_starts_time?: any | null, id: number, is_w2?: boolean | null, shift_type: string, starts_date?: any | null, status?: JobStatus | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', created_at: any, taxable_type?: string | null }>, job_billing_sums?: { __typename?: 'JobBillingSum', total_hours?: number | null } | null, location?: { __typename?: 'Location', id: number, name?: string | null, timezone_lookup?: string | null, unit?: string | null } | null }> | null };

export type UserCoordinatesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;


export type UserCoordinatesQuery = { __typename?: 'Query', job?: { __typename?: 'Job', id: number, location?: { __typename?: 'Location', id: number, in_geo_fence_range?: boolean | null, timezone_lookup?: string | null } | null } | null };

export type LocationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: number, name?: string | null, state?: { __typename?: 'State', abbreviation?: string | null } | null } | null };

export type LocationTypesQueryVariables = Exact<{
  input?: InputMaybe<LocationTypeQueryInput>;
}>;


export type LocationTypesQuery = { __typename?: 'Query', locationTypes?: Array<{ __typename?: 'LocationType', id: number, label?: string | null }> | null };

export type MarketPositionRateSettingsQueryVariables = Exact<{
  input?: InputMaybe<MarketPositionRateSettingQueryInput>;
}>;


export type MarketPositionRateSettingsQuery = { __typename?: 'Query', marketPositionRateSettings?: Array<{ __typename?: 'MarketPositionRateSetting', specialty_id?: number | null, professional_rate: Array<number> }> | null };

export type MarketsQueryVariables = Exact<{
  input?: InputMaybe<MarketQueryInput>;
}>;


export type MarketsQuery = { __typename?: 'Query', markets?: Array<{ __typename?: 'Market', id: number, display_name?: string | null, market_locations?: Array<{ __typename?: 'MarketLocation', zip_code: string }> | null }> | null };

export type MarketplacePayoutFragmentFragment = { __typename?: 'Payout', amount_cents: number, assignment?: { __typename?: 'Assignment', payout_base_hourly_rate_cents?: number | null } | null, payments?: Array<{ __typename?: 'Payment', amount_cents: number }> | null, jobs?: Array<{ __typename?: 'Job', job_billing_sums?: { __typename?: 'JobBillingSum', payout_total_amount_cents?: number | null } | null }> | null, job_billings: Array<{ __typename?: 'JobBilling', payout_total_amount_cents: number }> } & { ' $fragmentName'?: 'MarketplacePayoutFragmentFragment' };

export type PayoutQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PayoutQuery = { __typename?: 'Query', payout?: { __typename?: 'Payout', arrival_date?: any | null, assignment_id?: number | null, ends_time?: any | null, id: number, kind?: string | null, starts_time?: any | null, status?: string | null, w2_submit_by_time?: any | null, processed_on?: any | null, assignment?: { __typename?: 'Assignment', ends_date?: any | null, hours_per_shift?: number | null, is_travel?: boolean | null, is_w2?: boolean | null, number_of_shifts_per_week?: number | null, require_physical_signature: boolean, starts_date?: any | null, track_unpaid_breaks: boolean, primary_location?: { __typename?: 'Location', id: number, name?: string | null, timezone_lookup?: string | null } | null } | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', amount_cents: number, created_at: any, id: number, job_id?: number | null, taxable_type?: string | null, job?: { __typename?: 'Job', current_ends_time?: any | null, current_starts_time?: any | null, is_w2?: boolean | null, shift_type: string, starts_date?: any | null, status?: JobStatus | null, location?: { __typename?: 'Location', timezone_lookup?: string | null } | null } | null }>, job_billings: Array<{ __typename?: 'JobBilling', category?: string | null, id: number, job_id?: number | null, total_hours?: number | null, job?: { __typename?: 'Job', current_ends_time?: any | null, current_starts_time?: any | null, is_w2?: boolean | null, shift_type: string, starts_date?: any | null, status?: JobStatus | null, location?: { __typename?: 'Location', timezone_lookup?: string | null } | null } | null }>, payments?: Array<{ __typename?: 'Payment', arrival_date?: any | null, id: number, status?: string | null }> | null } | null };

export type MarketplacePayoutsFragmentFragment = { __typename?: 'Payout', amount_cents: number } & { ' $fragmentName'?: 'MarketplacePayoutsFragmentFragment' };

export type PayoutsQueryVariables = Exact<{
  input?: InputMaybe<PayoutQueryInput>;
}>;


export type PayoutsQuery = { __typename?: 'Query', payouts?: Array<{ __typename?: 'Payout', assignment_id?: number | null, ends_time?: any | null, id: number, kind?: string | null, starts_time?: any | null, status?: string | null, w2_submit_by_time?: any | null, processed_on?: any | null, assignment?: { __typename?: 'Assignment', ends_date?: any | null, ends_time?: any | null, float_requirements?: string | null, is_travel?: boolean | null, is_w2?: boolean | null, require_physical_signature: boolean, starts_date?: any | null, starts_time?: any | null, status: string, track_unpaid_breaks: boolean, locations?: Array<{ __typename?: 'Location', id: number, name?: string | null, unit?: string | null }> | null, primary_location?: { __typename?: 'Location', full_address?: string | null, id: number, name?: string | null, timezone_lookup?: string | null } | null } | null, job_billings: Array<{ __typename?: 'JobBilling', id: number, job_id?: number | null, total_hours?: number | null }>, jobs?: Array<{ __typename?: 'Job', current_ends_time?: any | null, current_starts_time?: any | null, ends_date?: any | null, ends_time?: any | null, id: number, shift_type: string, starts_date?: any | null, starts_time?: any | null, status?: JobStatus | null, timecard_id?: number | null, location?: { __typename?: 'Location', name?: string | null } | null }> | null, expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', id: number }> }> | null, _payoutsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type LocationPositionRateSettingsQueryVariables = Exact<{
  input?: InputMaybe<LocationPositionRateSettingQueryInput>;
}>;


export type LocationPositionRateSettingsQuery = { __typename?: 'Query', locationPositionRateSettings?: Array<{ __typename?: 'LocationPositionRateSetting', id?: string | null, position?: { __typename?: 'Position', id: number, display_name?: string | null, kind?: string | null, requires_specialty: boolean } | null, specialty?: { __typename?: 'Specialty', id: number, label?: string | null, name?: string | null } | null }> | null };

export type AllPositionsQueryVariables = Exact<{
  input?: InputMaybe<PositionQueryInput>;
}>;


export type AllPositionsQuery = { __typename?: 'Query', positions?: Array<{ __typename?: 'Position', id: number, display_name?: string | null, lead_description?: string | null, name?: string | null, qualifications_group_id?: number | null, recommended_positions: Array<{ __typename?: 'Position', id: number, display_name?: string | null, lead_description?: string | null, name?: string | null, qualifications_group_id?: number | null }>, specialties?: Array<{ __typename?: 'Specialty', active: boolean, id: number, label?: string | null }> | null }> | null };

export type AllPositionsForMarketsQueryVariables = Exact<{
  input?: InputMaybe<PositionQueryInput>;
  market_ids: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type AllPositionsForMarketsQuery = { __typename?: 'Query', positions?: Array<{ __typename?: 'Position', id: number, display_name?: string | null, lead_description?: string | null, name?: string | null, qualifications_group_id?: number | null, incrementality?: string | null, recommended_positions: Array<{ __typename?: 'Position', id: number, display_name?: string | null, lead_description?: string | null, name?: string | null, qualifications_group_id?: number | null }>, specialties?: Array<{ __typename?: 'Specialty', active: boolean, id: number, label?: string | null }> | null }> | null };

export type PositionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PositionQuery = { __typename?: 'Query', position?: { __typename?: 'Position', display_name?: string | null, id: number, lead_question?: string | null, lead_description?: string | null, requires_specialty: boolean, recommended_positions: Array<{ __typename?: 'Position', id: number, lead_question?: string | null, lead_description?: string | null, requires_specialty: boolean, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null, active: boolean }> | null }>, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null, active: boolean }> | null } | null };

export type ProfilePositionsWithSpecialtiesQueryVariables = Exact<{
  input?: InputMaybe<PositionQueryInput>;
}>;


export type ProfilePositionsWithSpecialtiesQuery = { __typename?: 'Query', positions?: Array<{ __typename?: 'Position', id: number, display_name?: string | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null }> | null };

export type ProfessionalPositionsQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalPositionQueryInput>;
}>;


export type ProfessionalPositionsQuery = { __typename?: 'Query', professionalPositions?: Array<{ __typename?: 'ProfessionalPosition', id: number, professional_id: number, position_id: number, years_of_experience?: number | null, completed_onboarding_at?: any | null, has_recent_experience: boolean }> | null };

export type ProfessionalPositionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProfessionalPositionQuery = { __typename?: 'Query', professionalPosition?: { __typename?: 'ProfessionalPosition', id: number, professional_id: number, position_id: number, years_of_experience?: number | null, completed_onboarding_at?: any | null, has_recent_experience: boolean } | null };

export type ProfessionalQualificationsQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalQualificationQueryInput>;
}>;


export type ProfessionalQualificationsQuery = { __typename?: 'Query', professionalQualifications?: Array<{ __typename?: 'ProfessionalQualification', id: number, status: string, created_at: any, additional_rejection_context?: string | null, credential_rejected_reason?: { __typename?: 'CredentialRejectedReason', label?: string | null } | null, professional_qualification_attributes?: Array<{ __typename?: 'ProfessionalQualificationAttribute', id: number, type: string, value: any, state?: string | null, qualification_attribute_id?: number | null, professional_qualification_id: number, qualification_attribute?: { __typename?: 'QualificationAttribute', active: boolean, field_type: string, id: number, input_source: string, name?: string | null, required: boolean, slug?: string | null, data: any } | null }> | null, qualification: { __typename?: 'Qualification', id: number, long_name: string, slug: string, default_verification_title?: string | null, qualification_type: string, instructions?: any | null, qualification_automations?: Array<{ __typename?: 'QualificationAutomation', id: number, description: string, name: string, loading_text?: string | null, is_active?: boolean | null, qualification_automation_attributes?: Array<{ __typename?: 'QualificationAutomationAttribute', id: number, required?: boolean | null, qualification_attribute?: { __typename?: 'QualificationAttribute', id: number, field_type: string, slug?: string | null, name?: string | null, data: any, input_source: string, active: boolean } | null }> | null }> | null, conditions?: Array<{ __typename?: 'Condition', id: number, condition_documents?: Array<{ __typename?: 'ConditionDocument', id: number, name?: string | null, category?: string | null, file: any }> | null }> | null, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, data: any, input_source: string, field_type: string, active: boolean }> | null } }> | null };

export type ProfessionalQualificationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProfessionalQualificationQuery = { __typename?: 'Query', professionalQualification?: { __typename?: 'ProfessionalQualification', id: number, status: string, created_at: any, additional_rejection_context?: string | null, credential_rejected_reason?: { __typename?: 'CredentialRejectedReason', label?: string | null } | null, professional_qualification_attributes?: Array<{ __typename?: 'ProfessionalQualificationAttribute', id: number, type: string, value: any, state?: string | null, qualification_attribute_id?: number | null, professional_qualification_id: number, metadata?: any | null, qualification_attribute?: { __typename?: 'QualificationAttribute', id: number, slug?: string | null, name?: string | null, input_source: string, field_type: string, active: boolean, data: any } | null }> | null, qualification: { __typename?: 'Qualification', id: number, long_name: string, slug: string, qualification_type: string, instructions?: any | null, conditions?: Array<{ __typename?: 'Condition', id: number, condition_documents?: Array<{ __typename?: 'ConditionDocument', id: number, name?: string | null, category?: string | null, file: any }> | null }> | null, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, data: any, input_source: string, field_type: string, active: boolean }> | null } } | null };

export type ProfessionalQualificationAttributeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProfessionalQualificationAttributeQuery = { __typename?: 'Query', professionalQualificationAttribute?: { __typename?: 'ProfessionalQualificationAttribute', id: number, type: string, value: any, state?: string | null, qualification_attribute_id?: number | null, professional_qualification_id: number, metadata?: any | null, qualification_attribute?: { __typename?: 'QualificationAttribute', id: number, slug?: string | null, name?: string | null, input_source: string, field_type: string, active: boolean, data: any } | null } | null };

export type ProfileStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileStatsQuery = { __typename?: 'Query', profileStats?: { __typename?: 'ProfileStats', no_shows_count?: number | null, late_cancellations_count?: number | null, do_not_sends_count?: number | null, favorites_count?: number | null, jobs_completed_count?: number | null, status?: string | null } | null };

export type QualificationsQueryVariables = Exact<{
  input?: InputMaybe<QualificationQueryInput>;
}>;


export type QualificationsQuery = { __typename?: 'Query', qualifications?: Array<{ __typename?: 'Qualification', id: number, long_name: string, admin_view_only: boolean }> | null };

export type QualificationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type QualificationQuery = { __typename?: 'Query', qualification?: { __typename?: 'Qualification', id: number, instructions?: any | null, long_name: string, qualification_type: string, default_verification_title?: string | null, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', active: boolean, data: any, field_type: string, id: number, input_source: string, name?: string | null, required: boolean, slug?: string | null }> | null, qualification_automations?: Array<{ __typename?: 'QualificationAutomation', id: number, description: string, name: string, loading_text?: string | null, is_active?: boolean | null, qualification_automation_attributes?: Array<{ __typename?: 'QualificationAutomationAttribute', id: number, required?: boolean | null, qualification_attribute?: { __typename?: 'QualificationAttribute', id: number, field_type: string, slug?: string | null, name?: string | null, data: any, input_source: string, active: boolean } | null }> | null }> | null } | null };

export type RecruitersQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RecruitersQuery = { __typename?: 'Query', administrator?: { __typename?: 'Administrator', id?: number | null, account_id?: number | null, account?: { __typename?: 'Account', id: number, first_name?: string | null } | null } | null };

export type ProfessionalReferenceFieldsFragment = { __typename?: 'ProfessionalReference', id: number, first_name?: string | null, last_name?: string | null, title?: string | null, department?: string | null, location?: string | null, start_date?: any | null, end_date?: any | null, current_position?: boolean | null, email?: string | null, phone_number?: string | null, created_at: any, uuid?: string | null, work_history_id?: number | null, work_history?: { __typename?: 'WorkHistory', id: number, organization_name?: string | null, unit?: string | null } | null } & { ' $fragmentName'?: 'ProfessionalReferenceFieldsFragment' };

export type ProfessionalReferencesQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalReferenceQueryInput>;
}>;


export type ProfessionalReferencesQuery = { __typename?: 'Query', professionalReferences?: Array<(
    { __typename?: 'ProfessionalReference', status?: string | null }
    & { ' $fragmentRefs'?: { 'ProfessionalReferenceFieldsFragment': ProfessionalReferenceFieldsFragment } }
  )> | null };

export type ProfessionalReferenceQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProfessionalReferenceQuery = { __typename?: 'Query', professionalReference?: (
    { __typename?: 'ProfessionalReference' }
    & { ' $fragmentRefs'?: { 'ProfessionalReferenceFieldsFragment': ProfessionalReferenceFieldsFragment } }
  ) | null };

export type ReferralSourcesQueryVariables = Exact<{
  input?: InputMaybe<ReferralSourceQueryInput>;
}>;


export type ReferralSourcesQuery = { __typename?: 'Query', referralSources?: Array<{ __typename?: 'ReferralSource', id: number, label?: string | null }> | null };

export type WorkHistoriesQueryVariables = Exact<{
  input?: InputMaybe<WorkHistoryQueryInput>;
}>;


export type WorkHistoriesQuery = { __typename?: 'Query', workHistories?: Array<{ __typename?: 'WorkHistory', id: number, clinical: boolean, currently_work_here: boolean, description?: string | null, employment_type?: number | null, end_date?: any | null, floating?: boolean | null, floating_details?: string | null, hours_per_week?: number | null, location?: string | null, location_is_teaching?: boolean | null, location_number_of_beds?: number | null, location_trauma_level?: string | null, location_type_id?: number | null, missing_information_list: Array<string>, organization_name?: string | null, position_title?: string | null, start_date?: any | null, state_id?: number | null, travel_agency?: string | null, unit?: string | null, position?: { __typename?: 'Position', id: number } | null }> | null };

export type WorkGapsQueryVariables = Exact<{
  input?: InputMaybe<WorkGapQueryInput>;
}>;


export type WorkGapsQuery = { __typename?: 'Query', workGaps?: Array<{ __typename?: 'WorkGap', id: number, start_date?: any | null, end_date?: any | null, explanation?: string | null, location?: string | null, state_id?: number | null, state?: { __typename?: 'State', abbreviation?: string | null } | null }> | null };

export type UnexplainedWorkGapsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnexplainedWorkGapsQuery = { __typename?: 'Query', unexplainedWorkGaps: Array<{ __typename?: 'UnexplainedWorkGap', earlier_experience_id: number, earlier_experience_type: string }> };

export type EducationsQueryVariables = Exact<{
  input?: InputMaybe<EducationQueryInput>;
}>;


export type EducationsQuery = { __typename?: 'Query', educations?: Array<{ __typename?: 'Education', city?: string | null, degree_type?: string | null, end_date?: any | null, field_of_study?: string | null, id: number, school_name?: string | null, start_date?: any | null, state_id?: number | null }> | null };

export type SocialProofMarketActivityQueryVariables = Exact<{
  availableJobsInput?: InputMaybe<JobQueryInput>;
  marketIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  positionIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type SocialProofMarketActivityQuery = { __typename?: 'Query', socialProofMarketActivity?: { __typename?: 'SocialProofMarketActivity', shifts_count: number, min_pay_amount_cents: number, max_pay_amount_cents: number } | null, _availableJobsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type SpecialitiesQueryVariables = Exact<{
  input?: InputMaybe<SpecialtyQueryInput>;
}>;


export type SpecialitiesQuery = { __typename?: 'Query', specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null, name?: string | null }> | null };

export type SpecialtiesByPositionQueryVariables = Exact<{ [key: string]: never; }>;


export type SpecialtiesByPositionQuery = { __typename?: 'Query', positions?: Array<{ __typename?: 'Position', id: number, display_name?: string | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null, name?: string | null }> | null }> | null };

export type StatesQueryVariables = Exact<{
  input?: InputMaybe<StateQueryInput>;
}>;


export type StatesQuery = { __typename?: 'Query', states?: Array<{ __typename?: 'State', id: number, abbreviation?: string | null, name?: string | null, square_image?: any | null, rectangle_image?: any | null, google_place_id?: string | null }> | null };

export type StateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type StateQuery = { __typename?: 'Query', state?: { __typename?: 'State', id: number, name?: string | null } | null };

export type SurgeryTypesQueryVariables = Exact<{
  input?: InputMaybe<SurgeryTypeQueryInput>;
}>;


export type SurgeryTypesQuery = { __typename?: 'Query', surgeryTypes?: Array<{ __typename?: 'SurgeryType', id: number, display_name?: string | null }> | null };

export type TaxClassificationsQueryVariables = Exact<{
  input?: InputMaybe<TaxClassificationQueryInput>;
}>;


export type TaxClassificationsQuery = { __typename?: 'Query', taxClassifications?: Array<{ __typename?: 'TaxClassification', id: number, label?: string | null }> | null };

export type TaxFormsQueryVariables = Exact<{
  input?: InputMaybe<TaxFormQueryInput>;
}>;


export type TaxFormsQuery = { __typename?: 'Query', taxForms?: Array<{ __typename?: 'TaxForm', id: number, year: number }> | null };

export type TaxFormQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TaxFormQuery = { __typename?: 'Query', taxForm?: { __typename?: 'TaxForm', tax_form?: any | null } | null };

export type MarketplaceTimecardFragmentFragment = { __typename?: 'Timecard', assignment?: { __typename?: 'Assignment', payout_base_hourly_rate_cents?: number | null } | null, jobs: Array<{ __typename?: 'Job', expense_adjustments: Array<{ __typename?: 'ExpenseAdjustment', amount_cents: number, created_at: any, taxable_type?: string | null }> }> } & { ' $fragmentName'?: 'MarketplaceTimecardFragmentFragment' };

export type TimecardQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TimecardQuery = { __typename?: 'Query', timecard?: { __typename?: 'Timecard', assignment_id?: number | null, ends_time: any, id: number, starts_time: any, status: string, submit_by: any, assignment?: { __typename?: 'Assignment', ends_date?: any | null, hours_per_shift?: number | null, is_travel?: boolean | null, is_w2?: boolean | null, number_of_shifts_per_week?: number | null, require_physical_signature: boolean, starts_date?: any | null, track_unpaid_breaks: boolean, primary_location?: { __typename?: 'Location', id: number, name?: string | null, timezone_lookup?: string | null } | null } | null, jobs: Array<{ __typename?: 'Job', cancellation_fee_charge_hours?: number | null, cancellation_reason_id?: number | null, created_by_account_id?: number | null, current_ends_time?: any | null, current_starts_time?: any | null, guaranteed_minimum_hours?: number | null, id: number, shift_type: string, starts_date?: any | null, status?: JobStatus | null, assignment?: { __typename?: 'Assignment', float_requirements?: string | null, is_w2?: boolean | null, primary_location?: { __typename?: 'Location', id: number } | null } | null, breaks?: Array<{ __typename?: 'Break', duration_minutes: number, id: number, starts_time?: any | null, waived?: boolean | null }> | null, job_billing_sums?: { __typename?: 'JobBillingSum', total_hours?: number | null } | null, last_cancellation?: { __typename?: 'LastCancellation', other_reason?: string | null } | null, location?: { __typename?: 'Location', id: number, name?: string | null, timezone_lookup?: string | null, unit?: string | null } | null }> } | null };

export type TimecardsQueryVariables = Exact<{
  input?: InputMaybe<TimecardQueryInput>;
}>;


export type TimecardsQuery = { __typename?: 'Query', timecards?: Array<{ __typename?: 'Timecard', assignment_id?: number | null, ends_time: any, id: number, saas_company_id?: number | null, starts_time: any, status: string, submit_by: any, assignment?: { __typename?: 'Assignment', ends_date?: any | null, ends_time?: any | null, float_requirements?: string | null, hours_per_shift?: number | null, is_travel?: boolean | null, is_w2?: boolean | null, number_of_shifts_per_week?: number | null, require_physical_signature: boolean, starts_date?: any | null, starts_time?: any | null, status: string, track_unpaid_breaks: boolean, locations?: Array<{ __typename?: 'Location', id: number, name?: string | null, unit?: string | null }> | null, primary_location?: { __typename?: 'Location', full_address?: string | null, id: number, name?: string | null, timezone_lookup?: string | null } | null } | null, jobs: Array<{ __typename?: 'Job', current_ends_time?: any | null, current_starts_time?: any | null, ends_date?: any | null, ends_time?: any | null, id: number, shift_type: string, starts_date?: any | null, starts_time?: any | null, status?: JobStatus | null, breaks?: Array<{ __typename?: 'Break', duration_minutes: number, id: number, starts_time?: any | null, waived?: boolean | null }> | null, job_billing_sums?: { __typename?: 'JobBillingSum', total_hours?: number | null } | null, location?: { __typename?: 'Location', name?: string | null } | null }> }> | null, _timecardsMeta?: { __typename?: 'ListMeta', count?: number | null } | null };

export type ConditionsQueryVariables = Exact<{
  input?: InputMaybe<ConditionQueryInput>;
}>;


export type ConditionsQuery = { __typename?: 'Query', conditions?: Array<{ __typename?: 'Condition', id: number, condition_type: string, display_category?: string | null, label: string, payload: any, slug: string, qualifications?: Array<{ __typename?: 'Qualification', id: number, input_source: string, instructions?: any | null, long_name: string, short_name: string, slug: string, admin_view_only: boolean, qualification_type: string, status: string, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, field_type: string, required: boolean, data: any, input_source: string, active: boolean, slug?: string | null }> | null, qualification_automations?: Array<{ __typename?: 'QualificationAutomation', id: number, description: string, name: string, loading_text?: string | null, is_active?: boolean | null, qualification_automation_attributes?: Array<{ __typename?: 'QualificationAutomationAttribute', id: number, required?: boolean | null, qualification_attribute?: { __typename?: 'QualificationAttribute', id: number, field_type: string, slug?: string | null, name?: string | null, data: any, input_source: string, active: boolean } | null }> | null }> | null }> | null }> | null };

export type ProfessionalQualificationsAttributesQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalQualificationQueryInput>;
}>;


export type ProfessionalQualificationsAttributesQuery = { __typename?: 'Query', professionalQualifications?: Array<{ __typename?: 'ProfessionalQualification', id: number, professional_qualification_attributes?: Array<{ __typename?: 'ProfessionalQualificationAttribute', id: number, metadata?: any | null }> | null }> | null };

export type GetMissingConditionsQueryVariables = Exact<{
  input?: InputMaybe<ConditionQueryInput>;
}>;


export type GetMissingConditionsQuery = { __typename?: 'Query', conditions?: Array<{ __typename?: 'Condition', id: number, slug: string, label: string, payload: any, condition_type: string, display_category?: string | null, display_description?: string | null, condition_documents?: Array<{ __typename?: 'ConditionDocument', id: number, name?: string | null, category?: string | null, file: any }> | null, qualifications?: Array<{ __typename?: 'Qualification', display_category?: string | null, id: number, input_source: string, instructions?: any | null, long_name: string, slug: string, admin_view_only: boolean, qualification_type: string, status: string, short_name: string, default_verification_title?: string | null, conditions?: Array<{ __typename?: 'Condition', id: number }> | null, qualification_attributes?: Array<{ __typename?: 'QualificationAttribute', id: number, name?: string | null, field_type: string, required: boolean, data: any, input_source: string, active: boolean, slug?: string | null }> | null, qualification_automations?: Array<{ __typename?: 'QualificationAutomation', id: number, description: string, name: string, loading_text?: string | null, is_active?: boolean | null, qualification_automation_attributes?: Array<{ __typename?: 'QualificationAutomationAttribute', id: number, required?: boolean | null, qualification_attribute?: { __typename?: 'QualificationAttribute', id: number, field_type: string, slug?: string | null, name?: string | null, data: any, input_source: string, active: boolean } | null }> | null }> | null }> | null }> | null };

export type GetProfessionalCohortQueryVariables = Exact<{
  jobId: Scalars['Int']['input'];
}>;


export type GetProfessionalCohortQuery = { __typename?: 'Query', me?: { __typename?: 'Account', professional?: { __typename?: 'Professional', cohort_reminder?: string | null } | null } | null };

export type GetProfessionalTodosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfessionalTodosQuery = { __typename?: 'Query', professionalTodos?: { __typename?: 'ProfessionalTodos', campaigns_status: Array<any>, available_for_extensions?: Array<number> | null, active_jobs_requesting_to_work_facility_ids?: Array<number> | null, has_position_with_completed_onboarding?: boolean | null, assignments_missing_conditions?: Array<number> | null, assignment_offers?: Array<number> | null, extension_offers?: Array<number> | null, days_until_debit_card_expires?: number | null, booked_jobs_count?: number | null, finished_jobs_count?: number | null, unsigned_addendum_assignment_ids?: Array<number> | null, missing_premier_credentials?: boolean | null, missing_w2_per_diem_onboarding?: boolean | null, disputes_waiting_on_professional?: Array<number> | null, permanent_placement_offers?: Array<number> | null, w2_interest_card?: boolean | null, rescreening: boolean, pending_pro_pool_invites: Array<{ __typename?: 'PoolInviteTodo', professional_qualification_id: number, location_id: number, location_name: string, plan: string }>, pending_pro_pool_onboarding: Array<{ __typename?: 'PoolOnboardingTodo', location_id: number, location_name: string }>, pending_pro_pool_orientation: Array<{ __typename?: 'PoolOrientationTodo', pool_id: number, location_id: number, location_name: string, position_names: Array<string>, shift_type: string }> } | null };

export type GetCurrentUserForMarketsStepQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserForMarketsStepQuery = { __typename?: 'Query', me?: { __typename?: 'Account', address_zip?: string | null, professional?: { __typename?: 'Professional', w2_interest?: boolean | null, markets?: Array<{ __typename?: 'Market', id: number, state_id?: number | null, display_name?: string | null }> | null } | null } | null };

export type GetProfessionalScreeningsForPhoneScreeningScheduledQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalScreeningQueryInput>;
}>;


export type GetProfessionalScreeningsForPhoneScreeningScheduledQuery = { __typename?: 'Query', professionalScreenings?: Array<{ __typename?: 'ProfessionalScreening', scheduled_time?: any | null, screener_account_id: number, id: number, screener_account: { __typename?: 'Account', first_name?: string | null } } | null> | null };

export type GetRecruitersForPhoneScreeningScheduledQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetRecruitersForPhoneScreeningScheduledQuery = { __typename?: 'Query', administrator?: { __typename?: 'Administrator', id?: number | null, account_id?: number | null, account?: { __typename?: 'Account', first_name?: string | null } | null } | null };

export type GetCurrentUserForPhoneScreeningScheduledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserForPhoneScreeningScheduledQuery = { __typename?: 'Query', me?: { __typename?: 'Account', professional?: { __typename?: 'Professional', id: number, enable_rescreening_automation: boolean, screening_recruiter_id?: number | null, phone_screen_date_and_time?: any | null } | null } | null };

export type GetCurrentUserForPositionsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  location_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetCurrentUserForPositionsQuery = { __typename?: 'Query', me?: { __typename?: 'Account', professional?: { __typename?: 'Professional', professional_positions: Array<{ __typename?: 'ProfessionalPosition', position_id: number, years_of_experience?: number | null }>, specialties: Array<{ __typename?: 'Specialty', id: number }> } | null } | null };

export type AddMoreMonthsOfWorkExperienceWorkHistoryFragment = { __typename?: 'WorkHistory', id: number, currently_work_here: boolean, employment_type?: number | null, end_date?: any | null, location_type_id?: number | null, start_date?: any | null, position?: { __typename?: 'Position', id: number } | null, wage_logs: Array<{ __typename?: 'WageLog', hourly_rate_cents: number }> } & { ' $fragmentName'?: 'AddMoreMonthsOfWorkExperienceWorkHistoryFragment' };

export type AddMoreMonthsOfWorkExperienceCurrentUserFragment = (
  { __typename?: 'Account', id: number, professional?: { __typename?: 'Professional', professional_positions: Array<{ __typename?: 'ProfessionalPosition', has_recent_experience: boolean, position: { __typename?: 'Position', display_name?: string | null, id: number } }> } | null }
  & { ' $fragmentRefs'?: { 'WorkExperienceFormCurrentUserFragment': WorkExperienceFormCurrentUserFragment;'UseWorkExperienceCurrentUserFragment': UseWorkExperienceCurrentUserFragment } }
) & { ' $fragmentName'?: 'AddMoreMonthsOfWorkExperienceCurrentUserFragment' };

export type WorkExperienceFormCurrentUserFragment = { __typename?: 'Account', id: number, address_zip?: string | null, professional?: { __typename?: 'Professional', markets?: Array<{ __typename?: 'Market', id: number, market_locations?: Array<{ __typename?: 'MarketLocation', zip_code: string }> | null }> | null, professional_positions: Array<{ __typename?: 'ProfessionalPosition', years_of_experience?: number | null, position: { __typename?: 'Position', id: number } }> } | null } & { ' $fragmentName'?: 'WorkExperienceFormCurrentUserFragment' };

export type WorkExperiencePrimaryFormCurrentUserFragment = (
  { __typename?: 'Account', id: number }
  & { ' $fragmentRefs'?: { 'WorkExperienceFormCurrentUserFragment': WorkExperienceFormCurrentUserFragment;'UseWorkExperienceCurrentUserFragment': UseWorkExperienceCurrentUserFragment } }
) & { ' $fragmentName'?: 'WorkExperiencePrimaryFormCurrentUserFragment' };

export type EditWorkExperienceFormModalInfoCurrentUserFragment = (
  { __typename?: 'Account', id: number, professional?: { __typename?: 'Professional', professional_positions: Array<{ __typename?: 'ProfessionalPosition', has_recent_experience: boolean, position: { __typename?: 'Position', display_name?: string | null, id: number } }> } | null }
  & { ' $fragmentRefs'?: { 'WorkExperienceFormCurrentUserFragment': WorkExperienceFormCurrentUserFragment;'UseWorkExperienceCurrentUserFragment': UseWorkExperienceCurrentUserFragment } }
) & { ' $fragmentName'?: 'EditWorkExperienceFormModalInfoCurrentUserFragment' };

export type ExperienceSummaryCardWorkHistoryFragment = { __typename?: 'WorkHistory', created_at: any, currently_work_here: boolean, end_date?: any | null, id: number, start_date?: any | null } & { ' $fragmentName'?: 'ExperienceSummaryCardWorkHistoryFragment' };

export type ExperienceSummaryCardPositionFragment = { __typename?: 'Position', id: number, display_name?: string | null, incrementality?: string | null } & { ' $fragmentName'?: 'ExperienceSummaryCardPositionFragment' };

export type GetInitialCurrentUserForExperienceSummaryViewQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  location_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetInitialCurrentUserForExperienceSummaryViewQuery = { __typename?: 'Query', me?: { __typename?: 'Account', professional?: { __typename?: 'Professional', markets?: Array<{ __typename?: 'Market', id: number }> | null } | null } | null };

export type GetCurrentUserForExperienceSummaryViewQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  location_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  market_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetCurrentUserForExperienceSummaryViewQuery = { __typename?: 'Query', me?: { __typename?: 'Account', id: number, professional?: { __typename?: 'Professional', professional_positions: Array<{ __typename?: 'ProfessionalPosition', position: (
          { __typename?: 'Position', id: number }
          & { ' $fragmentRefs'?: { 'ExperienceSummaryCardPositionFragment': ExperienceSummaryCardPositionFragment } }
        ) }> } | null } | null };

export type GetWorkHistoriesForExperienceSummaryViewQueryVariables = Exact<{
  input?: InputMaybe<WorkHistoryQueryInput>;
}>;


export type GetWorkHistoriesForExperienceSummaryViewQuery = { __typename?: 'Query', workHistories?: Array<(
    { __typename?: 'WorkHistory', position_id?: number | null }
    & { ' $fragmentRefs'?: { 'ExperienceSummaryCardWorkHistoryFragment': ExperienceSummaryCardWorkHistoryFragment } }
  )> | null };

export type GetLocationTypesForWorkExperienceQueryVariables = Exact<{
  input?: InputMaybe<LocationTypeQueryInput>;
}>;


export type GetLocationTypesForWorkExperienceQuery = { __typename?: 'Query', locationTypes?: Array<{ __typename?: 'LocationType', id: number, label?: string | null }> | null };

export type GetCurrentUserForWorkExperienceQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  location_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetCurrentUserForWorkExperienceQuery = { __typename?: 'Query', me?: (
    { __typename?: 'Account', id: number, professional?: { __typename?: 'Professional', professional_positions: Array<{ __typename?: 'ProfessionalPosition', has_recent_experience: boolean, years_of_experience?: number | null, position: { __typename?: 'Position', id: number, display_name?: string | null } }>, markets?: Array<{ __typename?: 'Market', id: number }> | null } | null }
    & { ' $fragmentRefs'?: { 'WorkExperiencePrimaryFormCurrentUserFragment': WorkExperiencePrimaryFormCurrentUserFragment;'AddMoreMonthsOfWorkExperienceCurrentUserFragment': AddMoreMonthsOfWorkExperienceCurrentUserFragment;'WorkExperienceFormCurrentUserFragment': WorkExperienceFormCurrentUserFragment;'UseWorkExperienceCurrentUserFragment': UseWorkExperienceCurrentUserFragment;'EditWorkExperienceFormModalInfoCurrentUserFragment': EditWorkExperienceFormModalInfoCurrentUserFragment } }
  ) | null };

export type GetWorkHistoryForWorkExperienceQueryVariables = Exact<{
  input?: InputMaybe<WorkHistoryQueryInput>;
}>;


export type GetWorkHistoryForWorkExperienceQuery = { __typename?: 'Query', workHistories?: Array<(
    { __typename?: 'WorkHistory', id: number, bedside_care?: boolean | null, currently_work_here: boolean, employment_type?: number | null, location_type_id?: number | null, end_date?: any | null, start_date?: any | null, position?: { __typename?: 'Position', id: number, display_name?: string | null } | null, wage_logs: Array<{ __typename?: 'WageLog', hourly_rate_cents: number }> }
    & { ' $fragmentRefs'?: { 'AddMoreMonthsOfWorkExperienceWorkHistoryFragment': AddMoreMonthsOfWorkExperienceWorkHistoryFragment;'UseWorkExperienceWorkHistoryFragment': UseWorkExperienceWorkHistoryFragment } }
  )> | null };

export type GetMarketPositionRateSettingsForWorkExperienceQueryVariables = Exact<{
  input?: InputMaybe<MarketPositionRateSettingQueryInput>;
}>;


export type GetMarketPositionRateSettingsForWorkExperienceQuery = { __typename?: 'Query', marketPositionRateSettings?: Array<{ __typename?: 'MarketPositionRateSetting', specialty_id?: number | null, professional_rate: Array<number> }> | null };

export type UseWorkExperienceWorkHistoryFragment = { __typename?: 'WorkHistory', id: number, currently_work_here: boolean, employment_type?: number | null, end_date?: any | null, location_type_id?: number | null, start_date?: any | null, position?: { __typename?: 'Position', id: number } | null, wage_logs: Array<{ __typename?: 'WageLog', hourly_rate_cents: number }> } & { ' $fragmentName'?: 'UseWorkExperienceWorkHistoryFragment' };

export type UseWorkExperienceCurrentUserFragment = { __typename?: 'Account', professional?: { __typename?: 'Professional', professional_positions: Array<{ __typename?: 'ProfessionalPosition', years_of_experience?: number | null, position: { __typename?: 'Position', id: number, display_name?: string | null } }> } | null } & { ' $fragmentName'?: 'UseWorkExperienceCurrentUserFragment' };

export type GetStatesForPersonalFormQueryVariables = Exact<{
  input?: InputMaybe<StateQueryInput>;
}>;


export type GetStatesForPersonalFormQuery = { __typename?: 'Query', states?: Array<{ __typename?: 'State', id: number, name?: string | null }> | null };

export type GetCurrentUserForPersonalFormQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  location_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetCurrentUserForPersonalFormQuery = { __typename?: 'Query', me?: { __typename?: 'Account', id: number, address_first?: string | null, address_second?: string | null, address_city?: string | null, state_id?: number | null, address_zip?: string | null, phone_number?: string | null, professional?: { __typename?: 'Professional', id: number, nickname?: string | null } | null } | null };

export type GetEmergencyContactForPersonalFormQueryVariables = Exact<{
  input?: InputMaybe<EmergencyContactQueryInput>;
}>;


export type GetEmergencyContactForPersonalFormQuery = { __typename?: 'Query', emergencyContacts?: Array<{ __typename?: 'EmergencyContact', id: number, first_name?: string | null, last_name?: string | null, phone_number?: string | null, professional_id?: number | null }> | null };

export type GetCurrentUserForPositionsAndSpecialtiesViewQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  location_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetCurrentUserForPositionsAndSpecialtiesViewQuery = { __typename?: 'Query', me?: { __typename?: 'Account', professional?: { __typename?: 'Professional', positions: Array<{ __typename?: 'Position', id: number, display_name?: string | null, kind?: string | null }>, specialties: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> } | null } | null };

export type GetPositionsWithSpecialtiesForPositionsAndSpecialtiesViewQueryVariables = Exact<{
  input?: InputMaybe<PositionQueryInput>;
}>;


export type GetPositionsWithSpecialtiesForPositionsAndSpecialtiesViewQuery = { __typename?: 'Query', positions?: Array<{ __typename?: 'Position', id: number, display_name?: string | null, specialties?: Array<{ __typename?: 'Specialty', id: number, label?: string | null }> | null }> | null };

export type TrackingItemInfoAssignmentFragmentFragment = { __typename?: 'Assignment', id: number, can_apply?: boolean | null, pay_per_week_cents?: number | null, one_time_bonus_burden_cents?: number | null, primary_location?: { __typename?: 'Location', address_city?: string | null, market?: { __typename?: 'Market', display_name?: string | null } | null, state?: { __typename?: 'State', abbreviation?: string | null } | null } | null, positions?: Array<{ __typename?: 'Position', display_name?: string | null }> | null } & { ' $fragmentName'?: 'TrackingItemInfoAssignmentFragmentFragment' };

export const AssignmentForAssignmentExtensionDialogFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentForAssignmentExtensionDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AssignmentForAssignmentExtensionDialogFragment, unknown>;
export const AssignmentForAssignmentDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentForAssignmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"variable_shift_times"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"jobs_detail"}},{"kind":"Field","name":{"kind":"Name","value":"flexible_starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"nontaxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"lodging_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"mie_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"payout_taxable_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"lodging_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"enforce_guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"min_years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"contract_total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_hours_string"}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"}},{"kind":"Field","name":{"kind":"Name","value":"needs_item_url"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_item_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"market_id"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drug_screening_required"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_kind"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_ot_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_weekly_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}}]}}]}}]} as unknown as DocumentNode<AssignmentForAssignmentDetailsFragment, unknown>;
export const PermanentPlacementForGeneralInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PermanentPlacementForGeneralInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_max_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_min_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_miles"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<PermanentPlacementForGeneralInfoFragment, unknown>;
export const PermanentPlacementForCompensationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PermanentPlacementForCompensation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_max_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_min_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_signing_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<PermanentPlacementForCompensationFragment, unknown>;
export const PermanentPlacementForOnsiteLogisticsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PermanentPlacementForOnsiteLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}}]}}]} as unknown as DocumentNode<PermanentPlacementForOnsiteLogisticsFragment, unknown>;
export const PermanentPositionItemOfAvailableAssignmentsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PermanentPositionItemOfAvailableAssignments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"schedule_type"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_min_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_max_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_signing_bonus_cents"}}]}}]} as unknown as DocumentNode<PermanentPositionItemOfAvailableAssignmentsFragment, unknown>;
export const JobDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pool_id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_charge_hours"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"requires_sca_onboarding_condition"}},{"kind":"Field","name":{"kind":"Name","value":"total_payout_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"new_to_facility"}},{"kind":"Field","name":{"kind":"Name","value":"requested_by_facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professional_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}}}]},{"kind":"Field","name":{"kind":"Name","value":"can_book_job"}},{"kind":"Field","name":{"kind":"Name","value":"pro_confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"booked_at"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"updated_in_cancellation_window"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"payout_facility_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_kind"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_ot_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_weekly_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_taxable_hourly_rate_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"high_risk"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"approval_free_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"maximum_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"require_facility_timecard_system_photo_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ignore_signature_when_creating_meal_break"}},{"kind":"Field","name":{"kind":"Name","value":"professional_can_adjust_times"}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"require_upload_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"enable_geo_fence"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_callback_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_regular_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_daily_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_daily_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_weekly_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_weekly_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputed_job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}}]}}]}}]} as unknown as DocumentNode<JobDetailsFragment, unknown>;
export const OrientationJobsListItemJobFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrientationJobsListItemJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<OrientationJobsListItemJobFragment, unknown>;
export const EducationItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EducationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Education"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"degree_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"field_of_study"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school_name"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}}]}}]} as unknown as DocumentNode<EducationItemFragment, unknown>;
export const AssignmentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"assignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}}]}}]} as unknown as DocumentNode<AssignmentFieldsFragment, unknown>;
export const MarketplaceDisputesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceDisputesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Dispute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}}]}}]}}]}}]} as unknown as DocumentNode<MarketplaceDisputesFragmentFragment, unknown>;
export const MarketplaceDisputeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceDisputeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Dispute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjusted_total_payout_cents"}},{"kind":"Field","name":{"kind":"Name","value":"original_total_payout_cents"}}]}}]} as unknown as DocumentNode<MarketplaceDisputeFragmentFragment, unknown>;
export const MarketplaceAvailableJobsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceAvailableJobsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"great_pay"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_price_differentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"recommendation_used"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_facility_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_payout_bonus_cents"}}]}}]} as unknown as DocumentNode<MarketplaceAvailableJobsFragmentFragment, unknown>;
export const MarketplaceJobFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceJobFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_travel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_callback_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_daily_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_daily_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_regular_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_weekly_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_weekly_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"disputed_job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_taxable_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"job_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_facility_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_kind"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_ot_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_weekly_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_payout_bonus_cents"}}]}}]} as unknown as DocumentNode<MarketplaceJobFragmentFragment, unknown>;
export const MarketplaceAvailableJobFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceAvailableJobFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"job_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_facility_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_kind"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_ot_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_weekly_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total_payout_bonus_cents"}}]}}]} as unknown as DocumentNode<MarketplaceAvailableJobFragmentFragment, unknown>;
export const MarketplaceJobsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceJobsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_travel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bonus_one_time_cents"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_facility_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total_payout_bonus_cents"}}]}}]} as unknown as DocumentNode<MarketplaceJobsFragmentFragment, unknown>;
export const MarketplaceGetJobsWithoutPayoutFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceGetJobsWithoutPayoutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payout_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_weekly_overtime_amount_cents"}}]}}]}}]} as unknown as DocumentNode<MarketplaceGetJobsWithoutPayoutFragmentFragment, unknown>;
export const MarketplaceGetPayoutJobsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceGetPayoutJobsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"job_billing_sums"},"name":{"kind":"Name","value":"job_billing_sums_for_payout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payout_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payout_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}}]}}]}}]} as unknown as DocumentNode<MarketplaceGetPayoutJobsFragmentFragment, unknown>;
export const MarketplacePayoutFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplacePayoutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Payout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"job_billing_sums"},"name":{"kind":"Name","value":"job_billing_sums_for_payout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payout_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}}]}}]}}]} as unknown as DocumentNode<MarketplacePayoutFragmentFragment, unknown>;
export const MarketplacePayoutsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplacePayoutsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Payout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}}]}}]} as unknown as DocumentNode<MarketplacePayoutsFragmentFragment, unknown>;
export const ProfessionalReferenceFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"professionalReferenceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"current_position"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"work_history_id"}},{"kind":"Field","name":{"kind":"Name","value":"work_history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization_name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<ProfessionalReferenceFieldsFragment, unknown>;
export const MarketplaceTimecardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplaceTimecardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Timecard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}}]}}]}}]}}]} as unknown as DocumentNode<MarketplaceTimecardFragmentFragment, unknown>;
export const AddMoreMonthsOfWorkExperienceWorkHistoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddMoreMonthsOfWorkExperienceWorkHistory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currently_work_here"}},{"kind":"Field","name":{"kind":"Name","value":"employment_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"location_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wage_logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hourly_rate_cents"}}]}}]}}]} as unknown as DocumentNode<AddMoreMonthsOfWorkExperienceWorkHistoryFragment, unknown>;
export const WorkExperienceFormCurrentUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zip_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkExperienceFormCurrentUserFragment, unknown>;
export const UseWorkExperienceCurrentUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UseWorkExperienceCurrentUserFragment, unknown>;
export const AddMoreMonthsOfWorkExperienceCurrentUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddMoreMonthsOfWorkExperienceCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_recent_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zip_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddMoreMonthsOfWorkExperienceCurrentUserFragment, unknown>;
export const WorkExperiencePrimaryFormCurrentUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkExperiencePrimaryFormCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zip_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkExperiencePrimaryFormCurrentUserFragment, unknown>;
export const EditWorkExperienceFormModalInfoCurrentUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditWorkExperienceFormModalInfoCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_recent_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zip_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditWorkExperienceFormModalInfoCurrentUserFragment, unknown>;
export const ExperienceSummaryCardWorkHistoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceSummaryCardWorkHistory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"currently_work_here"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}}]} as unknown as DocumentNode<ExperienceSummaryCardWorkHistoryFragment, unknown>;
export const ExperienceSummaryCardPositionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceSummaryCardPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"incrementality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"market_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"market_ids"}}}]}]}}]} as unknown as DocumentNode<ExperienceSummaryCardPositionFragment, unknown>;
export const UseWorkExperienceWorkHistoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseWorkExperienceWorkHistory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currently_work_here"}},{"kind":"Field","name":{"kind":"Name","value":"employment_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"location_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wage_logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hourly_rate_cents"}}]}}]}}]} as unknown as DocumentNode<UseWorkExperienceWorkHistoryFragment, unknown>;
export const TrackingItemInfoAssignmentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"trackingItemInfoAssignmentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professional_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}}}]},{"kind":"Field","name":{"kind":"Name","value":"pay_per_week_cents"}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]} as unknown as DocumentNode<TrackingItemInfoAssignmentFragmentFragment, unknown>;
export const GetFavoritedAssignmentsForFavoriteButtonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFavoritedAssignmentsForFavoriteButton"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalAssignmentFavoriteQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalAssignmentFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"first_to_apply"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_miles"}},{"kind":"Field","name":{"kind":"Name","value":"less_than_300_miles_away"}},{"kind":"Field","name":{"kind":"Name","value":"great_pay"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}}]}}]}}]}}]} as unknown as DocumentNode<GetFavoritedAssignmentsForFavoriteButtonQuery, GetFavoritedAssignmentsForFavoriteButtonQueryVariables>;
export const GetFavoritedAssignmentsIrpForFavoriteButtonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFavoritedAssignmentsIRPForFavoriteButton"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalAssignmentFavoriteQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalAssignmentFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}}]}}]}}]}}]} as unknown as DocumentNode<GetFavoritedAssignmentsIrpForFavoriteButtonQuery, GetFavoritedAssignmentsIrpForFavoriteButtonQueryVariables>;
export const GetAgencyForNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyForName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAgencyForNameQuery, GetAgencyForNameQueryVariables>;
export const GetAssignmentRequestsForAdditionalDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignmentRequestsForAdditionalDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetAssignmentRequestsForAdditionalDetailsQuery, GetAssignmentRequestsForAdditionalDetailsQueryVariables>;
export const GetMissingAssignmentCheckListInformationForAssignmentDetailsHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMissingAssignmentCheckListInformationForAssignmentDetailsHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_information"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_missing_information"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_information"}}}]}]}]}}]}}]} as unknown as DocumentNode<GetMissingAssignmentCheckListInformationForAssignmentDetailsHeaderQuery, GetMissingAssignmentCheckListInformationForAssignmentDetailsHeaderQueryVariables>;
export const GetAssignmentRequestsForAssignmentGeneralInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignmentRequestsForAssignmentGeneralInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetAssignmentRequestsForAssignmentGeneralInfoQuery, GetAssignmentRequestsForAssignmentGeneralInfoQueryVariables>;
export const GetAssignmentForAssignmentDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignmentForAssignmentDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_extension"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentForAssignmentExtensionDialog"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentForAssignmentDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentForAssignmentExtensionDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentForAssignmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"variable_shift_times"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"jobs_detail"}},{"kind":"Field","name":{"kind":"Name","value":"flexible_starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"nontaxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"lodging_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"mie_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"payout_taxable_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"lodging_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"enforce_guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"min_years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"contract_total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_hours_string"}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"}},{"kind":"Field","name":{"kind":"Name","value":"needs_item_url"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_item_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"market_id"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drug_screening_required"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_kind"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_ot_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_weekly_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}}]}}]}}]} as unknown as DocumentNode<GetAssignmentForAssignmentDetailsQuery, GetAssignmentForAssignmentDetailsQueryVariables>;
export const GetAvailableAssignmentForAssignmentDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableAssignmentForAssignmentDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_extension"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentForAssignmentDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentForAssignmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"variable_shift_times"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"jobs_detail"}},{"kind":"Field","name":{"kind":"Name","value":"flexible_starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"nontaxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"lodging_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"mie_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"payout_taxable_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"lodging_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"enforce_guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"min_years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"contract_total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_hours_string"}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"}},{"kind":"Field","name":{"kind":"Name","value":"needs_item_url"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_item_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"market_id"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drug_screening_required"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_kind"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_ot_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_weekly_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}}]}}]}}]} as unknown as DocumentNode<GetAvailableAssignmentForAssignmentDetailsQuery, GetAvailableAssignmentForAssignmentDetailsQueryVariables>;
export const GetStatesForEducationFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatesForEducationForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StateQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"states"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetStatesForEducationFormQuery, GetStatesForEducationFormQueryVariables>;
export const GetCurrentUserForEducationFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserForEducationForm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserForEducationFormQuery, GetCurrentUserForEducationFormQueryVariables>;
export const GetAssignmentRequestsForEducationFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignmentRequestsForEducationForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAssignmentRequestsForEducationFormQuery, GetAssignmentRequestsForEducationFormQueryVariables>;
export const GetEhRsForEhrFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEHRsForEHRForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EhrSystemQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ehrSystems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetEhRsForEhrFormQuery, GetEhRsForEhrFormQueryVariables>;
export const GetAssignmentRequestsForEhrFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignmentRequestsForEHRForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAssignmentRequestsForEhrFormQuery, GetAssignmentRequestsForEhrFormQueryVariables>;
export const GetPermanentRequestsForPermanentPlacementActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPermanentRequestsForPermanentPlacementAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permanentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetPermanentRequestsForPermanentPlacementActionQuery, GetPermanentRequestsForPermanentPlacementActionQueryVariables>;
export const GetAvailablePermanentPlacementForPermanentPlacementDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailablePermanentPlacementForPermanentPlacementDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availablePlacement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_qualifications"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_summary"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_benefits"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PermanentPlacementForGeneralInfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PermanentPlacementForCompensation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PermanentPlacementForOnsiteLogistics"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PermanentPlacementForGeneralInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_max_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_min_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_miles"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PermanentPlacementForCompensation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_max_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_min_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_signing_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PermanentPlacementForOnsiteLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}}]}}]} as unknown as DocumentNode<GetAvailablePermanentPlacementForPermanentPlacementDetailsQuery, GetAvailablePermanentPlacementForPermanentPlacementDetailsQueryVariables>;
export const GetAvailablePermanentPlacementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailablePermanentPlacements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availablePlacements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PermanentPositionItemOfAvailableAssignments"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_availablePlacementsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PermanentPositionItemOfAvailableAssignments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"schedule_type"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_min_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_max_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_signing_bonus_cents"}}]}}]} as unknown as DocumentNode<GetAvailablePermanentPlacementsQuery, GetAvailablePermanentPlacementsQueryVariables>;
export const JobIrregularitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobIrregularities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobIrregularityQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobIrregularities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<JobIrregularitiesQuery, JobIrregularitiesQueryVariables>;
export const GetAvailableJobForAvailableJobDetailsContainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableJobForAvailableJobDetailsContainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pool_id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_charge_hours"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"requires_sca_onboarding_condition"}},{"kind":"Field","name":{"kind":"Name","value":"total_payout_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"new_to_facility"}},{"kind":"Field","name":{"kind":"Name","value":"requested_by_facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professional_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}}}]},{"kind":"Field","name":{"kind":"Name","value":"can_book_job"}},{"kind":"Field","name":{"kind":"Name","value":"pro_confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"booked_at"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"updated_in_cancellation_window"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"payout_facility_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_kind"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_ot_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_weekly_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_taxable_hourly_rate_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"high_risk"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"approval_free_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"maximum_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"require_facility_timecard_system_photo_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ignore_signature_when_creating_meal_break"}},{"kind":"Field","name":{"kind":"Name","value":"professional_can_adjust_times"}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"require_upload_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"enable_geo_fence"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_callback_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_regular_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_daily_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_daily_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_weekly_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_weekly_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputed_job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}}]}}]}}]} as unknown as DocumentNode<GetAvailableJobForAvailableJobDetailsContainerQuery, GetAvailableJobForAvailableJobDetailsContainerQueryVariables>;
export const GetJobForJobDetailsContainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobForJobDetailsContainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pool_id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_charge_hours"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"requires_sca_onboarding_condition"}},{"kind":"Field","name":{"kind":"Name","value":"total_payout_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"new_to_facility"}},{"kind":"Field","name":{"kind":"Name","value":"requested_by_facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professional_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}}}]},{"kind":"Field","name":{"kind":"Name","value":"can_book_job"}},{"kind":"Field","name":{"kind":"Name","value":"pro_confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"booked_at"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"updated_in_cancellation_window"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_profile_for_account_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"payout_facility_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_kind"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_ot_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_daily_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_max_weekly_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_taxable_hourly_rate_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"high_risk"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"approval_free_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"maximum_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"require_facility_timecard_system_photo_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"ignore_signature_when_creating_meal_break"}},{"kind":"Field","name":{"kind":"Name","value":"professional_can_adjust_times"}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"require_upload_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"enable_geo_fence"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_callback_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_callback_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_regular_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_regular_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_daily_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_daily_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_weekly_overtime_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_weekly_overtime_hours"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_double_hours"}},{"kind":"Field","name":{"kind":"Name","value":"total_on_call_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputed_job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}}]}}]}}]} as unknown as DocumentNode<GetJobForJobDetailsContainerQuery, GetJobForJobDetailsContainerQueryVariables>;
export const GetCancellationReasonsForCancelationPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCancellationReasonsForCancelationPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CancellationReasonQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancellationReasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetCancellationReasonsForCancelationPolicyQuery, GetCancellationReasonsForCancelationPolicyQueryVariables>;
export const GetProfileStatsForCancelationPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfileStatsForCancelationPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"no_shows_count"}},{"kind":"Field","name":{"kind":"Name","value":"late_cancellations_count"}}]}}]}}]} as unknown as DocumentNode<GetProfileStatsForCancelationPolicyQuery, GetProfileStatsForCancelationPolicyQueryVariables>;
export const GetOrientationJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrientationJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrientationJobsListItemJob"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrientationJobsListItemJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Job"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetOrientationJobsQuery, GetOrientationJobsQueryVariables>;
export const GetEhrsForResumeBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEhrsForResumeBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EhrSystemQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ehrSystems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetEhrsForResumeBuilderQuery, GetEhrsForResumeBuilderQueryVariables>;
export const GetEducationsForResumeBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEducationsForResumeBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EducationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"educations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"degree_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"field_of_study"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school_name"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EducationItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EducationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Education"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"degree_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"field_of_study"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school_name"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}}]}}]} as unknown as DocumentNode<GetEducationsForResumeBuilderQuery, GetEducationsForResumeBuilderQueryVariables>;
export const GetWorkHistoriesForResumeBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkHistoriesForResumeBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistoryQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workHistories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clinical"}},{"kind":"Field","name":{"kind":"Name","value":"currently_work_here"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"employment_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"floating"}},{"kind":"Field","name":{"kind":"Name","value":"floating_details"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"location_is_teaching"}},{"kind":"Field","name":{"kind":"Name","value":"location_number_of_beds"}},{"kind":"Field","name":{"kind":"Name","value":"location_trauma_level"}},{"kind":"Field","name":{"kind":"Name","value":"location_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"missing_information_list"}},{"kind":"Field","name":{"kind":"Name","value":"organization_name"}},{"kind":"Field","name":{"kind":"Name","value":"position_id"}},{"kind":"Field","name":{"kind":"Name","value":"position_title"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"travel_agency"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"clinical"}}]}}]}}]} as unknown as DocumentNode<GetWorkHistoriesForResumeBuilderQuery, GetWorkHistoriesForResumeBuilderQueryVariables>;
export const GetWorkGapsForResumeBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkGapsForResumeBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkGapQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workGaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkGapsForResumeBuilderQuery, GetWorkGapsForResumeBuilderQueryVariables>;
export const GetCurrentUserForExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserForExperience"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kinds"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserForExperienceQuery, GetCurrentUserForExperienceQueryVariables>;
export const GetAssignmentRequestsForExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignmentRequestsForExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAssignmentRequestsForExperienceQuery, GetAssignmentRequestsForExperienceQueryVariables>;
export const GetAllPositionsForWorkHistoryFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPositionsForWorkHistoryForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PositionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]} as unknown as DocumentNode<GetAllPositionsForWorkHistoryFormQuery, GetAllPositionsForWorkHistoryFormQueryVariables>;
export const GetLocationTypesForWorkHistoryFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationTypesForWorkHistoryForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationTypeQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetLocationTypesForWorkHistoryFormQuery, GetLocationTypesForWorkHistoryFormQueryVariables>;
export const GetStatesForWorkHistoryFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatesForWorkHistoryForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StateQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"states"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]} as unknown as DocumentNode<GetStatesForWorkHistoryFormQuery, GetStatesForWorkHistoryFormQueryVariables>;
export const GetAssignmentRequestsForWorkHistoryFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignmentRequestsForWorkHistoryForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAssignmentRequestsForWorkHistoryFormQuery, GetAssignmentRequestsForWorkHistoryFormQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_hash"}},{"kind":"Field","name":{"kind":"Name","value":"account_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"middle_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"notification_settings"}},{"kind":"Field","name":{"kind":"Name","value":"account_push_registration_tokens"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rectangle_image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last_seen_w2_interest_at"}},{"kind":"Field","name":{"kind":"Name","value":"application_version"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"new_to_medely"}},{"kind":"Field","name":{"kind":"Name","value":"archive_reason"}},{"kind":"Field","name":{"kind":"Name","value":"signup_assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_screen_date_and_time"}},{"kind":"Field","name":{"kind":"Name","value":"background_check_authorized"}},{"kind":"Field","name":{"kind":"Name","value":"drug_screening_completed"}},{"kind":"Field","name":{"kind":"Name","value":"all_time_total_earnings_cents"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_ratio"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"kinds"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"application_status"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deactivation_reason"}},{"kind":"Field","name":{"kind":"Name","value":"has_markets"}},{"kind":"Field","name":{"kind":"Name","value":"has_item"}},{"kind":"Field","name":{"kind":"Name","value":"has_active_funding_source"}},{"kind":"Field","name":{"kind":"Name","value":"required_item_image"}},{"kind":"Field","name":{"kind":"Name","value":"referral_source_id"}},{"kind":"Field","name":{"kind":"Name","value":"resume"}},{"kind":"Field","name":{"kind":"Name","value":"satisfied_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"screening_recruiter_id"}},{"kind":"Field","name":{"kind":"Name","value":"background_check_pqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position_id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_onboarding_at"}},{"kind":"Field","name":{"kind":"Name","value":"has_recent_experience"}},{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_strength"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripe_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"tax_classification_id"}},{"kind":"Field","name":{"kind":"Name","value":"tax_form_preference"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"external_accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account_type"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"account_type"}},{"kind":"Field","name":{"kind":"Name","value":"exp_month"}},{"kind":"Field","name":{"kind":"Name","value":"exp_year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"representative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"ssn_last_4"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"w2_eligible"}},{"kind":"Field","name":{"kind":"Name","value":"w2_enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"saas_credentialing_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"saas_scheduling_enabled"}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const GetSchemaPermisionsForRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSchemaPermisionsForRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountRequestPermissions"}}]}}]} as unknown as DocumentNode<GetSchemaPermisionsForRequestsQuery, GetSchemaPermisionsForRequestsQueryVariables>;
export const AppVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appName"}},{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"patch"}}]}}]}}]} as unknown as DocumentNode<AppVersionQuery, AppVersionQueryVariables>;
export const AssignmentRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignmentRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"assignmentFields"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_assignmentRequestsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"assignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}}]}}]} as unknown as DocumentNode<AssignmentRequestsQuery, AssignmentRequestsQueryVariables>;
export const PermanentRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PermanentRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permanentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"assignmentFields"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_max_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_min_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_permanentRequestsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"assignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}}]}}]} as unknown as DocumentNode<PermanentRequestsQuery, PermanentRequestsQueryVariables>;
export const PendingAssignmentRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PendingAssignmentRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"assignmentFields"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_assignmentRequestsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"assignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}}]}}]} as unknown as DocumentNode<PendingAssignmentRequestsQuery, PendingAssignmentRequestsQueryVariables>;
export const PendingPermanentRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PendingPermanentRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permanentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"assignmentFields"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_min_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_max_hourly_rate_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_permanentRequestsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"assignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}}]}}]} as unknown as DocumentNode<PendingPermanentRequestsQuery, PendingPermanentRequestsQueryVariables>;
export const AssignmentChecklistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignmentChecklist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_availability"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_education"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_ehr_software"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_experience"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_identity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_information"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_references"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_work_history"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_unexplained_work_gaps"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_missing_availability"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_availability"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"has_missing_education"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_education"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"has_missing_ehr_software"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_ehr_software"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"has_missing_experience"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_experience"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"has_missing_identity"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_identity"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"has_missing_information"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_information"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"has_missing_references"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_references"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"has_missing_work_history"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_missing_work_history"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"has_unexplained_work_gaps"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_unexplained_work_gaps"}}}]}]}]}}]}}]} as unknown as DocumentNode<AssignmentChecklistQuery, AssignmentChecklistQueryVariables>;
export const AssignmentRequestsAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignmentRequestsAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentRequestQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"asap"}},{"kind":"Field","name":{"kind":"Name","value":"time_off_request"}},{"kind":"Field","name":{"kind":"Name","value":"interview_availability"}},{"kind":"Field","name":{"kind":"Name","value":"preferred_start_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_assignmentRequestsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<AssignmentRequestsAvailabilityQuery, AssignmentRequestsAvailabilityQueryVariables>;
export const AssignmentRequestWorkHistoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignmentRequestWorkHistories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_position_recent_experience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"within_past_years"},"value":{"kind":"IntValue","value":"3"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_experience"}}]}}]}}]}}]} as unknown as DocumentNode<AssignmentRequestWorkHistoriesQuery, AssignmentRequestWorkHistoriesQueryVariables>;
export const BookedAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookedAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboarding_due_date"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"}},{"kind":"Field","name":{"kind":"Name","value":"contract_total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_hours_string"}},{"kind":"Field","name":{"kind":"Name","value":"float_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"great_pay"}},{"kind":"Field","name":{"kind":"Name","value":"first_to_apply"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_miles"}},{"kind":"Field","name":{"kind":"Name","value":"less_than_300_miles_away"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}}]}}]}}]} as unknown as DocumentNode<BookedAssignmentsQuery, BookedAssignmentsQueryVariables>;
export const OverlappingAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverlappingAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OverlappingAssignmentsQuery, OverlappingAssignmentsQueryVariables>;
export const AssignmentsIrpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignmentsIRP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_availableAssignmentsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<AssignmentsIrpQuery, AssignmentsIrpQueryVariables>;
export const AssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Assignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"great_pay"}},{"kind":"Field","name":{"kind":"Name","value":"first_to_apply"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_miles"}},{"kind":"Field","name":{"kind":"Name","value":"less_than_300_miles_away"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"}},{"kind":"Field","name":{"kind":"Name","value":"contract_total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_hours_string"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_availableAssignmentsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<AssignmentsQuery, AssignmentsQueryVariables>;
export const PermanentPlacementAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PermanentPlacementAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignmentQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availablePlacements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_min_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_max_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"permanent_signing_bonus_cents"}},{"kind":"Field","name":{"kind":"Name","value":"schedule_type"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_availablePlacementsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<PermanentPlacementAssignmentsQuery, PermanentPlacementAssignmentsQueryVariables>;
export const FavoritedAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FavoritedAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalAssignmentFavoriteQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalAssignmentFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"first_to_apply"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_miles"}},{"kind":"Field","name":{"kind":"Name","value":"less_than_300_miles_away"}},{"kind":"Field","name":{"kind":"Name","value":"great_pay"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}}]}}]}}]}}]} as unknown as DocumentNode<FavoritedAssignmentsQuery, FavoritedAssignmentsQueryVariables>;
export const FavoritedAssignmentsIrpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FavoritedAssignmentsIRP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalAssignmentFavoriteQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalAssignmentFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}}]}}]}}]}}]} as unknown as DocumentNode<FavoritedAssignmentsIrpQuery, FavoritedAssignmentsIrpQueryVariables>;
export const AssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Assignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"professional_number"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"market_id"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drug_screening_required"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_extension"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"schedule_type"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"jobs_detail"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_taxable_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"mie_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"lodging_per_diem_cents"}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"referral_reward_cents"}},{"kind":"Field","name":{"kind":"Name","value":"nontaxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"flexible_starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"variable_shift_times"}},{"kind":"Field","name":{"kind":"Name","value":"per_diem"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"enforce_guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"}},{"kind":"Field","name":{"kind":"Name","value":"min_years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"mileage_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboarding_due_date"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"}},{"kind":"Field","name":{"kind":"Name","value":"contract_total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_hours_string"}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"first_to_apply"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_miles"}},{"kind":"Field","name":{"kind":"Name","value":"less_than_300_miles_away"}},{"kind":"Field","name":{"kind":"Name","value":"great_pay"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}}]}}]}}]} as unknown as DocumentNode<AssignmentQuery, AssignmentQueryVariables>;
export const AvailableAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailableAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"call_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_number"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"charge_base_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"market_id"}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drug_screening_required"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_extension"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"schedule_type"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"jobs_detail"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","alias":{"kind":"Name","value":"is_w2"},"name":{"kind":"Name","value":"is_w2_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"one_time_bonus_burden_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_taxable_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"payout_overtime_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"payout_on_call_hourly_rate_cents"}},{"kind":"Field","name":{"kind":"Name","value":"mie_per_diem_cents"}},{"kind":"Field","name":{"kind":"Name","value":"lodging_per_diem_cents"}},{"kind":"Field","alias":{"kind":"Name","value":"pay_per_week_cents"},"name":{"kind":"Name","value":"pay_per_week_cents_for_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"referral_reward_cents"}},{"kind":"Field","name":{"kind":"Name","value":"nontaxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"flexible_starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"variable_shift_times"}},{"kind":"Field","name":{"kind":"Name","value":"per_diem"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"enforce_guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"can_apply"}},{"kind":"Field","name":{"kind":"Name","value":"min_years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"mileage_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_policy"}},{"kind":"Field","name":{"kind":"Name","value":"contract_total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_hours_string"}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"first_to_apply"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_miles"}},{"kind":"Field","name":{"kind":"Name","value":"less_than_300_miles_away"}},{"kind":"Field","name":{"kind":"Name","value":"great_pay"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"vms_partnership"}}]}}]}}]} as unknown as DocumentNode<AvailableAssignmentQuery, AvailableAssignmentQueryVariables>;
export const AssignmentMetaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignmentMeta"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_assignmentMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"local_only"}}]}}]}}]} as unknown as DocumentNode<AssignmentMetaQuery, AssignmentMetaQueryVariables>;
export const CancellationReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CancellationReasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CancellationReasonQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancellationReasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<CancellationReasonsQuery, CancellationReasonsQueryVariables>;
export const MissingConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MissingConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConditionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"condition_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_category"}},{"kind":"Field","name":{"kind":"Name","value":"display_description"}},{"kind":"Field","name":{"kind":"Name","value":"condition_documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"admin_view_only"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_verification_title"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"loading_text"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automation_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MissingConditionsQuery, MissingConditionsQueryVariables>;
export const RequiredConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RequiredConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConditionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"condition_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_category"}},{"kind":"Field","name":{"kind":"Name","value":"display_description"}},{"kind":"Field","name":{"kind":"Name","value":"condition_documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"admin_view_only"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RequiredConditionsQuery, RequiredConditionsQueryVariables>;
export const MissingApplicationConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MissingApplicationConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConditionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"condition_type"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MissingApplicationConditionsQuery, MissingApplicationConditionsQueryVariables>;
export const MissingOnboardingConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MissingOnboardingConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConditionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MissingOnboardingConditionsQuery, MissingOnboardingConditionsQueryVariables>;
export const ExpiringConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExpiringConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConditionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"condition_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_category"}},{"kind":"Field","name":{"kind":"Name","value":"display_description"}},{"kind":"Field","name":{"kind":"Name","value":"condition_documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"admin_view_only"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExpiringConditionsQuery, ExpiringConditionsQueryVariables>;
export const ConditionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Condition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"condition_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_category"}},{"kind":"Field","name":{"kind":"Name","value":"display_description"}},{"kind":"Field","name":{"kind":"Name","value":"condition_documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"admin_view_only"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConditionQuery, ConditionQueryVariables>;
export const ContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Contracts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract_type"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}}]}}]}}]} as unknown as DocumentNode<ContractsQuery, ContractsQueryVariables>;
export const PremierQualificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PremierQualifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QualificationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<PremierQualificationsQuery, PremierQualificationsQueryVariables>;
export const SkillsAssemssmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SkillsAssemssments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalQualificationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalQualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}}]}}]}}]}}]} as unknown as DocumentNode<SkillsAssemssmentsQuery, SkillsAssemssmentsQueryVariables>;
export const DisputesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Disputes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DisputeQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disputes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout_total_amount_cents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_disputesMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DisputesQuery, DisputesQueryVariables>;
export const DisputeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Dispute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dispute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adjusted_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"adjusted_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"adjusted_meal_break_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"original_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"original_meal_break_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"professional_notes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_adjusted_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<DisputeQuery, DisputeQueryVariables>;
export const EhRsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EHRs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EhrSystemQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ehrSystems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<EhRsQuery, EhRsQueryVariables>;
export const EmergencyContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmergencyContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmergencyContactQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emergencyContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}}]}}]}}]} as unknown as DocumentNode<EmergencyContactsQuery, EmergencyContactsQueryVariables>;
export const UnpaidTimecardAdjustmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnpaidTimecardAdjustments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExpenseAdjustmentQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpaidTimecardAdjustments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_id"}},{"kind":"Field","name":{"kind":"Name","value":"make_payable_at"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}}]}}]}}]} as unknown as DocumentNode<UnpaidTimecardAdjustmentsQuery, UnpaidTimecardAdjustmentsQueryVariables>;
export const ExpenseAdjustmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExpenseAdjustment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expenseAdjustment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}}]}}]}}]}}]} as unknown as DocumentNode<ExpenseAdjustmentQuery, ExpenseAdjustmentQueryVariables>;
export const AvailablePerDiemJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailablePerDiemJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"can_book_job"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_miles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professional_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"missing_condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requested_by_facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professional_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}}}]},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_availableJobsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<AvailablePerDiemJobsQuery, AvailablePerDiemJobsQueryVariables>;
export const WeekJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WeekJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"starts_date"}}]}}]}}]} as unknown as DocumentNode<WeekJobsQuery, WeekJobsQueryVariables>;
export const JobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Job"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"new_to_facility"}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"pool_id"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booked_at"}},{"kind":"Field","name":{"kind":"Name","value":"breaks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"waived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"can_book_job"}},{"kind":"Field","name":{"kind":"Name","value":"can_book_job"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_charge_hours"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"clinical_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"custom_onboarding_docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"disputes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"did_user_modify_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_breaks_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"approval_free_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"drug_screening_required"}},{"kind":"Field","name":{"kind":"Name","value":"enable_geo_fence"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"geo_fence_radius"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ignore_signature_when_creating_meal_break"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"market_id"}},{"kind":"Field","name":{"kind":"Name","value":"maximum_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"professional_can_adjust_times"}},{"kind":"Field","name":{"kind":"Name","value":"require_facility_timecard_system_photo_on_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"require_facility_timecard_system_photo_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"require_upload_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"start_clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"pro_confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"professional_submitted_time"}},{"kind":"Field","name":{"kind":"Name","value":"requested_by_facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professional_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}}}]},{"kind":"Field","name":{"kind":"Name","value":"requires_sca_onboarding_condition"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"updated_in_cancellation_window"}}]}}]}}]} as unknown as DocumentNode<JobQuery, JobQueryVariables>;
export const AvailableJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailableJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booked_at"}},{"kind":"Field","name":{"kind":"Name","value":"breaks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"waived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"can_book_job"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_charge_hours"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"condition_ids"}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"custom_onboarding_docs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"did_user_modify_time"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_unpaid_break_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"approval_free_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"drug_screening_required"}},{"kind":"Field","name":{"kind":"Name","value":"enable_geo_fence"}},{"kind":"Field","name":{"kind":"Name","value":"geo_fence_radius"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ignore_signature_when_creating_meal_break"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"market_id"}},{"kind":"Field","name":{"kind":"Name","value":"maximum_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parking_cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_free"}},{"kind":"Field","name":{"kind":"Name","value":"parking_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursed"}},{"kind":"Field","name":{"kind":"Name","value":"parking_reimbursement_cents"}},{"kind":"Field","name":{"kind":"Name","value":"parking_validated"}},{"kind":"Field","name":{"kind":"Name","value":"professional_can_adjust_times"}},{"kind":"Field","name":{"kind":"Name","value":"require_facility_timecard_system_photo_on_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"require_facility_timecard_system_photo_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"require_upload_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"start_clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"high_risk"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pool_id"}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"professional_submitted_time"}},{"kind":"Field","name":{"kind":"Name","value":"requested_by_facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professional_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professional_id"}}}]},{"kind":"Field","name":{"kind":"Name","value":"requires_sca_onboarding_condition"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"updated_in_cancellation_window"}}]}}]}}]} as unknown as DocumentNode<AvailableJobQuery, AvailableJobQueryVariables>;
export const JobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Jobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"approved_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"booked_at"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"breaks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"waived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_charge_hours"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_window"}},{"kind":"Field","name":{"kind":"Name","value":"covid_care"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"did_user_modify_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_id"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility_number"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"job_type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ehr_system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medication_management_details"}},{"kind":"Field","name":{"kind":"Name","value":"ehr_details"}},{"kind":"Field","name":{"kind":"Name","value":"supplies_ppe_details"}},{"kind":"Field","name":{"kind":"Name","value":"additional_check_in_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"meal_break_details"}},{"kind":"Field","name":{"kind":"Name","value":"scrub_colors"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"approval_free_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"company_id"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}},{"kind":"Field","name":{"kind":"Name","value":"enable_geo_fence"}},{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"geo_fence_radius"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ignore_signature_when_creating_meal_break"}},{"kind":"Field","name":{"kind":"Name","value":"location_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maximum_late_clock_out_grace_period_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"professional_can_adjust_times"}},{"kind":"Field","name":{"kind":"Name","value":"require_facility_timecard_system_photo_on_clock_in"}},{"kind":"Field","name":{"kind":"Name","value":"require_facility_timecard_system_photo_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"require_upload_on_clock_out"}},{"kind":"Field","name":{"kind":"Name","value":"start_clock_in_early_window"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"covid_requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"patient_population"}},{"kind":"Field","name":{"kind":"Name","value":"pool_id"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posting_field_contents"}},{"kind":"Field","name":{"kind":"Name","value":"pro_confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"professional_submitted_time"}},{"kind":"Field","name":{"kind":"Name","value":"scrubs_provided"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"surgery_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_jobsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<JobsQuery, JobsQueryVariables>;
export const RequestedJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RequestedJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RequestedJobsQuery, RequestedJobsQueryVariables>;
export const JobsWithoutPayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsWithoutPayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsWithoutPayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_id"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"disputed_job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"make_payable_at"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<JobsWithoutPayoutQuery, JobsWithoutPayoutQueryVariables>;
export const PayoutJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PayoutJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payout_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","alias":{"kind":"Name","value":"job_billing_sums"},"name":{"kind":"Name","value":"job_billing_sums_for_payout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payout_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payout_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<PayoutJobsQuery, PayoutJobsQueryVariables>;
export const UserCoordinatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserCoordinates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"in_geo_fence_range"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lon"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}},{"kind":"Argument","name":{"kind":"Name","value":"lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}}]},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}}]}}]}}]} as unknown as DocumentNode<UserCoordinatesQuery, UserCoordinatesQueryVariables>;
export const LocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Location"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}}]} as unknown as DocumentNode<LocationQuery, LocationQueryVariables>;
export const LocationTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationTypeQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<LocationTypesQuery, LocationTypesQueryVariables>;
export const MarketPositionRateSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketPositionRateSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketPositionRateSettingQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketPositionRateSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialty_id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_rate"}}]}}]}}]} as unknown as DocumentNode<MarketPositionRateSettingsQuery, MarketPositionRateSettingsQueryVariables>;
export const MarketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Markets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"market_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zip_code"}}]}}]}}]}}]} as unknown as DocumentNode<MarketsQuery, MarketsQueryVariables>;
export const PayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Payout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arrival_date"}},{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"require_physical_signature"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_id"}},{"kind":"Field","name":{"kind":"Name","value":"taxable_type"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_id"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arrival_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}}]}}]}}]} as unknown as DocumentNode<PayoutQuery, PayoutQueryVariables>;
export const PayoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Payouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payouts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"float_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"require_physical_signature"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_billings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_id"}},{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timecard_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expense_adjustments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"w2_submit_by_time"}},{"kind":"Field","name":{"kind":"Name","value":"processed_on"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_payoutsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<PayoutsQuery, PayoutsQueryVariables>;
export const LocationPositionRateSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationPositionRateSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationPositionRateSettingQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationPositionRateSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"requires_specialty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LocationPositionRateSettingsQuery, LocationPositionRateSettingsQueryVariables>;
export const AllPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PositionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"lead_description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"lead_description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications_group_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<AllPositionsQuery, AllPositionsQueryVariables>;
export const AllPositionsForMarketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllPositionsForMarkets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PositionQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"market_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"lead_description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"incrementality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"market_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"market_ids"}}}]},{"kind":"Field","name":{"kind":"Name","value":"recommended_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"lead_description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications_group_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<AllPositionsForMarketsQuery, AllPositionsForMarketsQueryVariables>;
export const PositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Position"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_question"}},{"kind":"Field","name":{"kind":"Name","value":"lead_description"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_question"}},{"kind":"Field","name":{"kind":"Name","value":"lead_description"}},{"kind":"Field","name":{"kind":"Name","value":"requires_specialty"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requires_specialty"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<PositionQuery, PositionQueryVariables>;
export const ProfilePositionsWithSpecialtiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfilePositionsWithSpecialties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PositionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<ProfilePositionsWithSpecialtiesQuery, ProfilePositionsWithSpecialtiesQueryVariables>;
export const ProfessionalPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfessionalPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalPositionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalPositions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"position_id"}},{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"completed_onboarding_at"}},{"kind":"Field","name":{"kind":"Name","value":"has_recent_experience"}}]}}]}}]} as unknown as DocumentNode<ProfessionalPositionsQuery, ProfessionalPositionsQueryVariables>;
export const ProfessionalPositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfessionalPosition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalPosition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}},{"kind":"Field","name":{"kind":"Name","value":"position_id"}},{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"completed_onboarding_at"}},{"kind":"Field","name":{"kind":"Name","value":"has_recent_experience"}}]}}]}}]} as unknown as DocumentNode<ProfessionalPositionQuery, ProfessionalPositionQueryVariables>;
export const ProfessionalQualificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfessionalQualifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalQualificationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalQualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"additional_rejection_context"}},{"kind":"Field","name":{"kind":"Name","value":"credential_rejected_reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute_id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"default_verification_title"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"loading_text"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automation_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"condition_documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfessionalQualificationsQuery, ProfessionalQualificationsQueryVariables>;
export const ProfessionalQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfessionalQualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalQualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"additional_rejection_context"}},{"kind":"Field","name":{"kind":"Name","value":"credential_rejected_reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute_id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"condition_documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfessionalQualificationQuery, ProfessionalQualificationQueryVariables>;
export const ProfessionalQualificationAttributeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfessionalQualificationAttribute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalQualificationAttribute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute_id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<ProfessionalQualificationAttributeQuery, ProfessionalQualificationAttributeQueryVariables>;
export const ProfileStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"no_shows_count"}},{"kind":"Field","name":{"kind":"Name","value":"late_cancellations_count"}},{"kind":"Field","name":{"kind":"Name","value":"do_not_sends_count"}},{"kind":"Field","name":{"kind":"Name","value":"favorites_count"}},{"kind":"Field","name":{"kind":"Name","value":"jobs_completed_count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ProfileStatsQuery, ProfileStatsQueryVariables>;
export const QualificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Qualifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QualificationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"admin_view_only"}}]}}]}}]} as unknown as DocumentNode<QualificationsQuery, QualificationsQueryVariables>;
export const QualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Qualification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qualification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_verification_title"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"loading_text"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automation_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QualificationQuery, QualificationQueryVariables>;
export const RecruitersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Recruiters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"administrator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}}]}}]}}]} as unknown as DocumentNode<RecruitersQuery, RecruitersQueryVariables>;
export const ProfessionalReferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfessionalReferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalReferenceQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalReferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"professionalReferenceFields"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"professionalReferenceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"current_position"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"work_history_id"}},{"kind":"Field","name":{"kind":"Name","value":"work_history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization_name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<ProfessionalReferencesQuery, ProfessionalReferencesQueryVariables>;
export const ProfessionalReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfessionalReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalReference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"professionalReferenceFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"professionalReferenceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"current_position"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"work_history_id"}},{"kind":"Field","name":{"kind":"Name","value":"work_history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization_name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<ProfessionalReferenceQuery, ProfessionalReferenceQueryVariables>;
export const ReferralSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReferralSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralSourceQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<ReferralSourcesQuery, ReferralSourcesQueryVariables>;
export const WorkHistoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkHistories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistoryQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workHistories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clinical"}},{"kind":"Field","name":{"kind":"Name","value":"currently_work_here"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"employment_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"floating"}},{"kind":"Field","name":{"kind":"Name","value":"floating_details"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"location_is_teaching"}},{"kind":"Field","name":{"kind":"Name","value":"location_number_of_beds"}},{"kind":"Field","name":{"kind":"Name","value":"location_trauma_level"}},{"kind":"Field","name":{"kind":"Name","value":"location_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"missing_information_list"}},{"kind":"Field","name":{"kind":"Name","value":"organization_name"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position_title"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"travel_agency"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"clinical"}}]}}]}}]} as unknown as DocumentNode<WorkHistoriesQuery, WorkHistoriesQueryVariables>;
export const WorkGapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkGaps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkGapQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workGaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}}]} as unknown as DocumentNode<WorkGapsQuery, WorkGapsQueryVariables>;
export const UnexplainedWorkGapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnexplainedWorkGaps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unexplainedWorkGaps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earlier_experience_id"}},{"kind":"Field","name":{"kind":"Name","value":"earlier_experience_type"}}]}}]}}]} as unknown as DocumentNode<UnexplainedWorkGapsQuery, UnexplainedWorkGapsQueryVariables>;
export const EducationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Educations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EducationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"educations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"degree_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"field_of_study"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school_name"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}}]}}]}}]} as unknown as DocumentNode<EducationsQuery, EducationsQueryVariables>;
export const SocialProofMarketActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SocialProofMarketActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availableJobsInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"positionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"socialProofMarketActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shifts_count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"market_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"position_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"positionIds"}}}]},{"kind":"Field","name":{"kind":"Name","value":"min_pay_amount_cents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"market_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"position_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"positionIds"}}}]},{"kind":"Field","name":{"kind":"Name","value":"max_pay_amount_cents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"market_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"position_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"positionIds"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"_availableJobsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableJobsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<SocialProofMarketActivityQuery, SocialProofMarketActivityQueryVariables>;
export const SpecialitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Specialities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialtyQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SpecialitiesQuery, SpecialitiesQueryVariables>;
export const SpecialtiesByPositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpecialtiesByPosition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SpecialtiesByPositionQuery, SpecialtiesByPositionQueryVariables>;
export const StatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"States"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StateQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"states"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"square_image"}},{"kind":"Field","name":{"kind":"Name","value":"rectangle_image"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}}]}}]}}]} as unknown as DocumentNode<StatesQuery, StatesQueryVariables>;
export const StateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"State"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<StateQuery, StateQueryVariables>;
export const SurgeryTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurgeryTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurgeryTypeQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surgeryTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]} as unknown as DocumentNode<SurgeryTypesQuery, SurgeryTypesQueryVariables>;
export const TaxClassificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaxClassifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaxClassificationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxClassifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<TaxClassificationsQuery, TaxClassificationsQueryVariables>;
export const TaxFormsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaxForms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaxFormQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxForms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]} as unknown as DocumentNode<TaxFormsQuery, TaxFormsQueryVariables>;
export const TaxFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaxForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tax_form"}}]}}]}}]} as unknown as DocumentNode<TaxFormQuery, TaxFormQueryVariables>;
export const TimecardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Timecard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timecard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"require_physical_signature"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"float_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"breaks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"waived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_fee_charge_hours"}},{"kind":"Field","name":{"kind":"Name","value":"cancellation_reason_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed_minimum_hours"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_cancellation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"other_reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"submit_by"}}]}}]}}]} as unknown as DocumentNode<TimecardQuery, TimecardQueryVariables>;
export const TimecardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Timecards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimecardQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timecards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"float_requirements"}},{"kind":"Field","name":{"kind":"Name","value":"hours_per_shift"}},{"kind":"Field","name":{"kind":"Name","value":"is_travel"}},{"kind":"Field","name":{"kind":"Name","value":"is_w2"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_shifts_per_week"}},{"kind":"Field","name":{"kind":"Name","value":"primary_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_address"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone_lookup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"require_physical_signature"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"track_unpaid_breaks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breaks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"waived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"current_ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"current_starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"ends_date"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"job_billing_sums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}},{"kind":"Field","name":{"kind":"Name","value":"starts_date"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignment_id"}},{"kind":"Field","name":{"kind":"Name","value":"ends_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"saas_company_id"}},{"kind":"Field","name":{"kind":"Name","value":"starts_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"submit_by"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_timecardsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<TimecardsQuery, TimecardsQueryVariables>;
export const ConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Conditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConditionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"condition_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_category"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"admin_view_only"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"loading_text"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automation_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConditionsQuery, ConditionsQueryVariables>;
export const ProfessionalQualificationsAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfessionalQualificationsAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalQualificationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalQualifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<ProfessionalQualificationsAttributesQuery, ProfessionalQualificationsAttributesQueryVariables>;
export const GetMissingConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMissingConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConditionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"condition_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_category"}},{"kind":"Field","name":{"kind":"Name","value":"display_description"}},{"kind":"Field","name":{"kind":"Name","value":"condition_documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_category"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"long_name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"admin_view_only"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_verification_title"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"loading_text"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_automation_attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification_attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"input_source"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMissingConditionsQuery, GetMissingConditionsQueryVariables>;
export const GetProfessionalCohortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfessionalCohort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cohort_reminder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"job_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}]}]}}]}}]}}]} as unknown as DocumentNode<GetProfessionalCohortQuery, GetProfessionalCohortQueryVariables>;
export const GetProfessionalTodosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfessionalTodos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalTodos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns_status"}},{"kind":"Field","name":{"kind":"Name","value":"available_for_extensions"}},{"kind":"Field","name":{"kind":"Name","value":"active_jobs_requesting_to_work_facility_ids"}},{"kind":"Field","name":{"kind":"Name","value":"has_position_with_completed_onboarding"}},{"kind":"Field","name":{"kind":"Name","value":"assignments_missing_conditions"}},{"kind":"Field","name":{"kind":"Name","value":"assignment_offers"}},{"kind":"Field","name":{"kind":"Name","value":"extension_offers"}},{"kind":"Field","name":{"kind":"Name","value":"days_until_debit_card_expires"}},{"kind":"Field","name":{"kind":"Name","value":"booked_jobs_count"}},{"kind":"Field","name":{"kind":"Name","value":"finished_jobs_count"}},{"kind":"Field","name":{"kind":"Name","value":"unsigned_addendum_assignment_ids"}},{"kind":"Field","name":{"kind":"Name","value":"missing_premier_credentials"}},{"kind":"Field","name":{"kind":"Name","value":"missing_w2_per_diem_onboarding"}},{"kind":"Field","name":{"kind":"Name","value":"disputes_waiting_on_professional"}},{"kind":"Field","name":{"kind":"Name","value":"pending_pro_pool_invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_qualification_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pending_pro_pool_onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pending_pro_pool_orientation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pool_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_id"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"position_names"}},{"kind":"Field","name":{"kind":"Name","value":"shift_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permanent_placement_offers"}},{"kind":"Field","name":{"kind":"Name","value":"w2_interest_card"}},{"kind":"Field","name":{"kind":"Name","value":"rescreening"}}]}}]}}]} as unknown as DocumentNode<GetProfessionalTodosQuery, GetProfessionalTodosQueryVariables>;
export const GetCurrentUserForMarketsStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserForMarketsStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"w2_interest"}},{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserForMarketsStepQuery, GetCurrentUserForMarketsStepQueryVariables>;
export const GetProfessionalScreeningsForPhoneScreeningScheduledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfessionalScreeningsForPhoneScreeningScheduled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalScreeningQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalScreenings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduled_time"}},{"kind":"Field","name":{"kind":"Name","value":"screener_account_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"screener_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetProfessionalScreeningsForPhoneScreeningScheduledQuery, GetProfessionalScreeningsForPhoneScreeningScheduledQueryVariables>;
export const GetRecruitersForPhoneScreeningScheduledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecruitersForPhoneScreeningScheduled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"administrator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetRecruitersForPhoneScreeningScheduledQuery, GetRecruitersForPhoneScreeningScheduledQueryVariables>;
export const GetCurrentUserForPhoneScreeningScheduledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserForPhoneScreeningScheduled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enable_rescreening_automation"}},{"kind":"Field","name":{"kind":"Name","value":"screening_recruiter_id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_screen_date_and_time"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserForPhoneScreeningScheduledQuery, GetCurrentUserForPhoneScreeningScheduledQueryVariables>;
export const GetCurrentUserForPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserForPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position_id"}},{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserForPositionsQuery, GetCurrentUserForPositionsQueryVariables>;
export const GetInitialCurrentUserForExperienceSummaryViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInitialCurrentUserForExperienceSummaryView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInitialCurrentUserForExperienceSummaryViewQuery, GetInitialCurrentUserForExperienceSummaryViewQueryVariables>;
export const GetCurrentUserForExperienceSummaryViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserForExperienceSummaryView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"market_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceSummaryCardPosition"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceSummaryCardPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"incrementality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"market_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"market_ids"}}}]}]}}]} as unknown as DocumentNode<GetCurrentUserForExperienceSummaryViewQuery, GetCurrentUserForExperienceSummaryViewQueryVariables>;
export const GetWorkHistoriesForExperienceSummaryViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkHistoriesForExperienceSummaryView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistoryQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workHistories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceSummaryCardWorkHistory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceSummaryCardWorkHistory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"currently_work_here"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}}]} as unknown as DocumentNode<GetWorkHistoriesForExperienceSummaryViewQuery, GetWorkHistoriesForExperienceSummaryViewQueryVariables>;
export const GetLocationTypesForWorkExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationTypesForWorkExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationTypeQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetLocationTypesForWorkExperienceQuery, GetLocationTypesForWorkExperienceQueryVariables>;
export const GetCurrentUserForWorkExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserForWorkExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"has_recent_experience"}},{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}}]}},{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkExperiencePrimaryFormCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddMoreMonthsOfWorkExperienceCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditWorkExperienceFormModalInfoCurrentUser"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market_locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zip_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years_of_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkExperiencePrimaryFormCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddMoreMonthsOfWorkExperienceCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_recent_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditWorkExperienceFormModalInfoCurrentUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_recent_experience"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkExperienceFormCurrentUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseWorkExperienceCurrentUser"}}]}}]} as unknown as DocumentNode<GetCurrentUserForWorkExperienceQuery, GetCurrentUserForWorkExperienceQueryVariables>;
export const GetWorkHistoryForWorkExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkHistoryForWorkExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistoryQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workHistories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bedside_care"}},{"kind":"Field","name":{"kind":"Name","value":"currently_work_here"}},{"kind":"Field","name":{"kind":"Name","value":"employment_type"}},{"kind":"Field","name":{"kind":"Name","value":"location_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"bedside_care"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"bedside_care"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wage_logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hourly_rate_cents"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddMoreMonthsOfWorkExperienceWorkHistory"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseWorkExperienceWorkHistory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddMoreMonthsOfWorkExperienceWorkHistory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currently_work_here"}},{"kind":"Field","name":{"kind":"Name","value":"employment_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"location_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wage_logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hourly_rate_cents"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseWorkExperienceWorkHistory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkHistory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currently_work_here"}},{"kind":"Field","name":{"kind":"Name","value":"employment_type"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"location_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wage_logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hourly_rate_cents"}}]}}]}}]} as unknown as DocumentNode<GetWorkHistoryForWorkExperienceQuery, GetWorkHistoryForWorkExperienceQueryVariables>;
export const GetMarketPositionRateSettingsForWorkExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMarketPositionRateSettingsForWorkExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketPositionRateSettingQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketPositionRateSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialty_id"}},{"kind":"Field","name":{"kind":"Name","value":"professional_rate"}}]}}]}}]} as unknown as DocumentNode<GetMarketPositionRateSettingsForWorkExperienceQuery, GetMarketPositionRateSettingsForWorkExperienceQueryVariables>;
export const GetStatesForPersonalFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatesForPersonalForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StateQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"states"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetStatesForPersonalFormQuery, GetStatesForPersonalFormQueryVariables>;
export const GetCurrentUserForPersonalFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserForPersonalForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address_first"}},{"kind":"Field","name":{"kind":"Name","value":"address_second"}},{"kind":"Field","name":{"kind":"Name","value":"address_city"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"address_zip"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserForPersonalFormQuery, GetCurrentUserForPersonalFormQueryVariables>;
export const GetEmergencyContactForPersonalFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmergencyContactForPersonalForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmergencyContactQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emergencyContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"professional_id"}}]}}]}}]} as unknown as DocumentNode<GetEmergencyContactForPersonalFormQuery, GetEmergencyContactForPersonalFormQueryVariables>;
export const GetCurrentUserForPositionsAndSpecialtiesViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserForPositionsAndSpecialtiesView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professional"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserForPositionsAndSpecialtiesViewQuery, GetCurrentUserForPositionsAndSpecialtiesViewQueryVariables>;
export const GetPositionsWithSpecialtiesForPositionsAndSpecialtiesViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPositionsWithSpecialtiesForPositionsAndSpecialtiesView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PositionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<GetPositionsWithSpecialtiesForPositionsAndSpecialtiesViewQuery, GetPositionsWithSpecialtiesForPositionsAndSpecialtiesViewQueryVariables>;